import {
  DEFAULT_PLATFORM_SETTINGS,
  DISPUTE_EVIDENCE_MAX_BYTES,
  DISPUTE_EVIDENCE_MAX_FILES,
  DISPUTE_EVIDENCE_MIME_TYPES,
  LISTING_RIGHTS_LIMIT,
  LISTING_THUMBNAIL_HEIGHT,
  LISTING_THUMBNAIL_MAX_BYTES,
  LISTING_THUMBNAIL_MIME_TYPES,
  LISTING_THUMBNAIL_WIDTH,
  ORDER_LIST_PAGE,
  ORDER_STATUS_GROUPS,
  PLATFORM_ASSET_KEYS,
  PLATFORM_ASSET_RULES,
  PLATFORM_SETTINGS_KEY,
  POLICY_COMPANY_PLACEHOLDERS,
  SOCIAL_CHANNEL_APP_SCHEMES,
  SOCIAL_LINK_KEYS,
  SOCIAL_LINK_LABELS,
  SOCIAL_LINK_LABELS_I18N,
  SPONSORSHIP_BENEFIT_MAX,
  SPONSORSHIP_BUSINESS_NAME_MAX,
  SPONSORSHIP_DESCRIPTION_MAX,
  SPONSORSHIP_IMAGE_MAX_BYTES,
  SPONSORSHIP_IMAGE_MIME_TYPES,
  SPONSORSHIP_LOCATION_MAX,
  SPONSORSHIP_MESSAGE_MAX,
  SPONSORSHIP_MINE_FIRST_PAGE,
  SPONSORSHIP_MINE_PAGE,
  SPONSORSHIP_RECEIVED_PAGE,
  SPONSORSHIP_RECEIVED_STAGES,
  SPONSORSHIP_REJECT_REASON_MAX,
  SPONSORSHIP_SEARCH_MAX,
  SPONSORSHIP_TITLE_MAX,
  SPONSORSHIP_VISIT_MAX_DAYS_AHEAD,
  SUPPORT_INQUIRY_PAGE,
  TIKTOK_APP_REDIRECT_PATH,
  VERIFIABLE_SOCIAL_PLATFORMS,
  addonPaymentSchema,
  appSemverSchema,
  appVersionResponseSchema,
  applySponsorshipRequestSchema,
  brandScopeSchema,
  cancelMyOrderRequestSchema,
  catalogOptionSchema,
  changeSimplePinRequestSchema,
  channelMinFollowersSchema,
  compareAppVersions,
  completeOauthSignupRequestSchema,
  confirmLicenseDraftRequestSchema,
  contractTermsSchema,
  createListingRequestSchema,
  createOrderItemSchema,
  createOrderRequestSchema,
  createRoyaltyReportRequestSchema,
  createSimplePinRequestSchema,
  createSocialChannelRequestSchema,
  createSupportInquiryRequestSchema,
  createSupportInquiryResponseSchema,
  declineLicenseAmendmentRequestSchema,
  devSignInAccountsResponseSchema,
  devSignInRequestSchema,
  disputeEvidenceMimeSchema,
  disputeEvidencePresignRequestSchema,
  disputeEvidencePresignResponseSchema,
  disputeEvidenceSchema,
  disputeOrderRequestSchema,
  emailSchema,
  fillCompanyPlaceholders,
  forbiddenIndustriesInputSchema,
  formatFollowerBoundary,
  formatFollowerCount,
  handoffSignInRequestSchema,
  instagramBioCodeRequestSchema,
  instagramBioCodeResponseSchema,
  instagramUsernameSchema,
  issueLicenseRequestSchema,
  issueLicenseResponseSchema,
  licenseAmendmentListResponseSchema,
  licenseAmendmentSchema,
  licenseAmendmentTermsSchema,
  licenseDraftFormSpecSchema,
  licenseDraftResponseSchema,
  licenseDraftSchema,
  licenseSuspensionListResponseSchema,
  licenseSuspensionSchema,
  listListingsQuerySchema,
  listMyListingScrapsQuerySchema,
  listMyOrdersQuerySchema,
  listMySponsorshipsQuerySchema,
  listReceivedApplicationsQuerySchema,
  listSponsorshipScrapsQuerySchema,
  listSponsorshipsQuerySchema,
  listSupportInquiriesQuerySchema,
  listingDetailSchema,
  listingOfferInputSchema,
  listingOfferResponseSchema,
  listingOfferStateSchema,
  listingPageSchema,
  listingSummarySchema,
  listingThumbnailInputSchema,
  listingThumbnailPath,
  logoutOthersResponseSchema,
  lowestMinFollowers,
  manualSocialPlatformSchema,
  meResponseSchema,
  myListingSchema,
  myRoyaltiesResponseSchema,
  mySocialChannelRequestSchema,
  oauthNeedsAgreementResponseSchema,
  oauthProviderSchema,
  oauthReauthCredentialSchema,
  oauthSignInRequestSchema,
  oauthSignInResponseSchema,
  offerDurationOptionSchema,
  offerDurationSchema,
  orderDepositReturnSchema,
  orderGroupMemberSchema,
  orderGroupResponseSchema,
  orderIssueRowSchema,
  orderRefundSummarySchema,
  orderResponseSchema,
  orderTerminationSummarySchema,
  orderViolationReportSummarySchema,
  ordersSummarySchema,
  paymentResponseSchema,
  payoutAccountSchema,
  platformAssetKeySchema,
  platformAssetMetaSchema,
  platformAssetPath,
  platformBankAccountSchema,
  platformCatalogSchema,
  platformCommunitySettingsSchema,
  platformCompanySettingsSchema,
  platformListingSettingsSchema,
  platformPaymentSettingsSchema,
  platformSettingsSchema,
  platformSiteSettingsSchema,
  platformSiteTextSchema,
  platformSocialLinksSchema,
  platformSponsorshipSettingsSchema,
  proposalFormSpecSchema,
  proposalPricingSchema,
  purchaseAddonsSchema,
  refreshRequestSchema,
  rejectSponsorshipApplicationRequestSchema,
  reportViolationRequestSchema,
  requestAddonPaymentSchema,
  requestRefundRequestSchema,
  resolveCommunityTier,
  royaltyContractSchema,
  royaltyDepositNoticeRequestSchema,
  royaltyDepositNoticeResponseSchema,
  royaltyObjectionSchema,
  royaltyReportFileSchema,
  royaltyReportResponseSchema,
  royaltyTodoSchema,
  saveSponsorshipRequestSchema,
  scrapStateSchema,
  sellerOrderResponseSchema,
  sellerVoidRoyaltyReportRequestSchema,
  signInRequestSchema,
  signUpRequestSchema,
  simplePinSchema,
  siteConfigResponseSchema,
  socialChannelAuthorizeQuerySchema,
  socialChannelAuthorizeResponseSchema,
  socialChannelRequestStatusSchema,
  socialChannelSchema,
  socialChannelsResponseSchema,
  socialLinksSchema,
  socialPlatformSchema,
  sponsorshipAddressSchema,
  sponsorshipAddressSearchQuerySchema,
  sponsorshipAddressSearchResponseSchema,
  sponsorshipApplicationDetailSchema,
  sponsorshipApplicationResponseSchema,
  sponsorshipCategoryListSchema,
  sponsorshipCategorySchema,
  sponsorshipCoordsSchema,
  sponsorshipEligibilitySchema,
  sponsorshipImageInputSchema,
  sponsorshipMineSummarySchema,
  sponsorshipMyStateSchema,
  sponsorshipPageSchema,
  sponsorshipReceivedStageOf,
  sponsorshipReceivedStageSchema,
  sponsorshipReceivedTodoSchema,
  sponsorshipRequirementsSchema,
  sponsorshipResponseSchema,
  sponsorshipScrapStateSchema,
  sponsorshipSummarySchema,
  sponsorshipUnseenApprovalsSchema,
  submitSponsorshipMissionSchema,
  supportInquiryDetailSchema,
  supportInquiryMessageSchema,
  supportInquiryOrderSchema,
  supportInquiryReplyRequestSchema,
  supportInquirySummarySchema,
  supportUnseenCountSchema,
  tiktokAppVerifyRequestSchema,
  tokenPairResponseSchema,
  updateAppVersionRequestSchema,
  updateCommunitySettingsRequestSchema,
  updateCompanySettingsRequestSchema,
  updateDepositorNameRequestSchema,
  updateDepositorNameResponseSchema,
  updateListingRequestSchema,
  updateListingSettingsRequestSchema,
  updateMyProfileRequestSchema,
  updatePaymentSettingsRequestSchema,
  updatePayoutAccountRequestSchema,
  updatePlatformSocialLinksRequestSchema,
  updateRefundAccountRequestSchema,
  updateRoyaltyReportRequestSchema,
  updateSiteSettingsRequestSchema,
  updateSocialLinksRequestSchema,
  updateSponsorshipSettingsRequestSchema,
  upsertLicenseDraftRequestSchema,
  usageScopeSchema,
  verifiableSocialPlatformSchema
} from "../chunk-6R76EN3W.js";
import {
  ZOD_MESSAGES,
  __name,
  noteItemsTextSchema,
  offerTermRowSchema,
  offerTermsRowsSchema,
  orderTransitionActorSchema,
  pageQuerySchema,
  pageResponseSchema,
  sentAsReceived,
  zodErrorMap
} from "../chunk-N7LSWMIW.js";

// src/user/users.schema.ts
import { IpRightType, OrderStatus } from "@inflip/shared";
import { z } from "zod";
var USER_AVATAR_MAX_BYTES = 2 * 1024 * 1024;
var USER_AVATAR_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif"
];
var withdrawalEligibilityResponseSchema = z.object({
  eligible: z.boolean(),
  /** 공개/심사 중인 판매 글 수 — 있으면 먼저 내려야 탈퇴 가능 */
  activeListingCount: z.number().int(),
  /** 진행 중 구매 주문 수 (입금 대기 ~ 정산 전) — 완료/취소/환불 제외 */
  buyingInProgressCount: z.number().int(),
  /** 진행 중 판매 주문 수 — 내 리스팅에 걸린 미완료 주문 */
  sellingInProgressCount: z.number().int(),
  /** 정산은 끝났지만 로열티 의무가 남은 계약 수 (구매·판매 모두) — 계약 기간 종료 + 마지막 달 지급까지 */
  royaltyInProgressCount: z.number().int(),
  /** 진행 중 환불(요청됨·승인됨) 수 — 구매·판매 모두. 환불이 끝나거나 거절돼야 탈퇴 가능 */
  refundInProgressCount: z.number().int().optional(),
  /** 판매자가 아직 돌려주지 않은 정산 회수(대기·기한 경과) 수 */
  clawbackOutstandingCount: z.number().int().optional(),
  /** 해지된 계약의 지급 전 정산 수 (판매자) */
  settlementUnpaidCount: z.number().int().optional(),
  /** 돌려받을 입금(반환 대기) 수 (구매자) */
  depositReturnPendingCount: z.number().int().optional(),
  /** 심사 대기·모집 중인 내 협찬 + 끝나지 않은 협찬 지원(승인 대기·확정) 수 */
  sponsorshipInProgressCount: z.number().int().optional(),
  /** 탈퇴 시 접근을 잃는 유효 라이선스 수 (고지용) */
  activeLicenseCount: z.number().int()
});
var tradeWithMeEntrySchema = z.object({
  orderId: z.string().uuid(),
  listingId: z.string().uuid(),
  listingTitle: z.string(),
  /** 이 거래에서 나의 역할 */
  myRole: z.enum([
    "BUYER",
    "SELLER"
  ]),
  rightType: z.nativeEnum(IpRightType),
  status: z.nativeEnum(OrderStatus),
  /** 취소 주체 — SYSTEM 이면 입금 기한 만료(미입금 취소) */
  cancelledBy: orderTransitionActorSchema.nullable().optional(),
  totalAmount: z.number().int(),
  currency: z.string(),
  createdAt: z.string().datetime()
});
var tradesWithMeResponseSchema = z.object({
  user: z.object({
    id: z.string().uuid(),
    name: z.string(),
    avatarUrl: z.string().nullable(),
    joinedAt: z.string().datetime(),
    /** 나와 성사(결제 확인 이후)된 거래 수 */
    tradesWithMe: z.number().int(),
    /** 협의 성사 후 미입금·주문취소로 파기한 수 — 구매자로서, 플랫폼 전체 */
    brokenDealCount: z.number().int(),
    /** 결제 후 라이선스 발급 전에 환불로 나간 수 — 거래 도중 파기 (구매자, 플랫폼 전체) */
    refundedMidTradeCount: z.number().int(),
    /** 라이선스 발급 이후 분쟁·차지백 등으로 환불된 수 (구매자, 플랫폼 전체) */
    refundedAfterCompletionCount: z.number().int()
  }),
  orders: z.array(tradeWithMeEntrySchema)
});
var withdrawMeRequestSchema = z.object({
  agreeLicenseLoss: z.literal(true, {
    error: "\uB77C\uC774\uC120\uC2A4 \uC811\uADFC \uC0C1\uC2E4 \uC548\uB0B4\uC5D0 \uB3D9\uC758\uD574 \uC8FC\uC138\uC694"
  }),
  pin: simplePinSchema.optional(),
  reauth: oauthReauthCredentialSchema.optional()
}).refine((v) => Boolean(v.pin) !== Boolean(v.reauth), {
  message: "\uAC04\uD3B8\uBE44\uBC00\uBC88\uD638\uB098 \uC18C\uC15C \uACC4\uC815 \uB85C\uADF8\uC778\uC73C\uB85C \uBCF8\uC778 \uD655\uC778\uC774 \uD544\uC694\uD574\uC694"
});
var updateAvatarResponseSchema = z.object({
  avatarUrl: z.string()
});
var unblockUserResponseSchema = z.object({
  blocked: z.literal(false)
});

// src/user/licenses.schema.ts
import { IpRightType as IpRightType2, LICENSE_VIEW_STATES, LicenseStatus } from "@inflip/shared";
import { z as z2 } from "zod";
var licenseViewStateSchema = z2.enum(LICENSE_VIEW_STATES);
var licenseResponseSchema = z2.object({
  id: z2.string().uuid(),
  orderId: z2.string().uuid(),
  listingId: z2.string().uuid(),
  rightType: z2.nativeEnum(IpRightType2),
  status: z2.nativeEnum(LicenseStatus),
  licenseKey: z2.string(),
  issuedAt: z2.string().datetime(),
  /** 계약 시간대 (IANA) — 주문 시점 판매자 시간대로 고정. 계약 날짜는 이 시간대로 계산·표시 */
  timeZone: z2.string(),
  /** 계약 효력 시작일 — 판매자가 발급 시 지정 */
  startsAt: z2.string().datetime(),
  expiresAt: z2.string().datetime().nullable(),
  /** 이 라이선스로 허락된 것 — 계약 조건 전체 (주문 시점 동결본) */
  terms: contractTermsSchema.nullable(),
  /** 이 구매자에게만 적용되는 개별 합의 사항 (판매자가 발급 시 입력) */
  specialTerms: z2.string().nullable(),
  /** 이 라이선스를 받은 거래의 상품 제목 — 상품이 지워졌으면 null */
  listingTitle: z2.string().nullable(),
  /** 판매자 닉네임 — 탈퇴했으면 null */
  sellerName: z2.string().nullable(),
  /** 구매자 닉네임 — 탈퇴했으면 null */
  buyerName: z2.string().nullable(),
  /** 화면 상태 (shared licenseViewStateOf, 응답 시각 기준) — 상태 칩·목록 필터와 같은 규칙 */
  viewState: licenseViewStateSchema.optional()
});
var LICENSE_LIST_PAGE = 20;
var listLicensesQuerySchema = z2.object({
  state: licenseViewStateSchema.optional(),
  before: z2.string().uuid().optional(),
  limit: z2.coerce.number().int().min(1).max(100).default(LICENSE_LIST_PAGE)
});
var licenseSideSummarySchema = z2.object({
  total: z2.number().int(),
  states: z2.partialRecord(licenseViewStateSchema, z2.number().int())
});
var licensesSummarySchema = z2.object({
  received: licenseSideSummarySchema,
  issued: licenseSideSummarySchema
});

// src/user/chat.schema.ts
import { ChatMessageShortcut, ChatMessageType, ChatParticipantRole, ChatReportReason, ChatRoomStatus, ChatRoomType, IpRightType as IpRightType3, OrderStatus as OrderStatus2 } from "@inflip/shared";
import { z as z3 } from "zod";
var chatParticipantResponseSchema = z3.object({
  id: z3.string().uuid(),
  roomId: z3.string().uuid(),
  userId: z3.string().uuid(),
  role: z3.nativeEnum(ChatParticipantRole),
  joinedAt: z3.string().datetime(),
  leftAt: z3.string().datetime().nullable(),
  lastReadMessageId: z3.string().uuid().nullable(),
  lastReadAt: z3.string().datetime().nullable()
});
var chatMessageResponseSchema = z3.object({
  id: z3.string().uuid(),
  roomId: z3.string().uuid(),
  senderId: z3.string().uuid().nullable(),
  type: z3.nativeEnum(ChatMessageType),
  /** 회원이 쓴 본문 또는 SYSTEM 문구(한국어 원본) */
  content: z3.string(),
  /**
  * SYSTEM 문구의 언어별 { ko, en, ja } — 화면은 자기 언어를 고르고 없으면 content.
  * 회원이 쓴 메시지·다국어 이전 SYSTEM 메시지는 null
  */
  contentI18n: z3.object({
    ko: z3.string(),
    en: z3.string(),
    ja: z3.string()
  }).nullable().optional(),
  attachmentS3Key: z3.string().nullable(),
  attachmentMime: z3.string().nullable(),
  attachmentSizeBytes: z3.number().int().nullable(),
  attachmentFilename: z3.string().nullable(),
  systemEvent: z3.string().nullable(),
  /** 상품 문의 시작 카드(SYSTEM)면 그 상품 id — 화면은 이 칸으로 상품 카드를 그린다 (systemEvent 를 해석하지 않는다) */
  inquiryListingId: z3.string().uuid().nullable(),
  /** SYSTEM 메시지에 붙일 주문 바로가기 — ROYALTY 는 [로열티 보기], ORDER 는 [주문 보기]. 없으면 null (shared chatMessageShortcutOf) */
  orderShortcut: z3.nativeEnum(ChatMessageShortcut).nullable(),
  /** 이 회원에게만 보이는 SYSTEM 메시지면 그 회원 ID (예: 판매자에게만 보이는 발급 지연 안내). 모두에게 보이면 null */
  visibleToUserId: z3.string().uuid().nullable(),
  createdAt: z3.string().datetime()
});
var chatRoomListingSummarySchema = z3.object({
  id: z3.string().uuid(),
  title: z3.string(),
  priceAmount: z3.number().int(),
  priceCurrency: z3.string(),
  sellerId: z3.string().uuid(),
  sellerName: z3.string().nullable(),
  /** 썸네일 — 없으면 null (이모지 표지) */
  thumbnailPath: z3.string().nullable()
});
var chatRoomOrderSummarySchema = z3.object({
  id: z3.string().uuid(),
  status: z3.nativeEnum(OrderStatus2),
  rightType: z3.nativeEnum(IpRightType3),
  /** 계약 기간(개월) — 발급 예정 내용 카드의 사용 종료일 미리보기용. 기간 없는 계약은 null */
  durationMonths: z3.number().int().nullable().optional(),
  /** 발급 전에 추가 합의 사항을 적어야 하는 계약인지 (이름·브랜드 외 권리) — 채팅 발급 확인 창용 */
  requiresAgreement: z3.boolean().optional(),
  /** 계약 시간대 (IANA) — 주문 시점 판매자 시간대로 고정. 계약 날짜는 이 시간대로 계산·표시 */
  timeZone: z3.string(),
  totalAmount: z3.number().int(),
  currency: z3.string(),
  /** 구매자 환불이 진행 중(신청됨·승인됨) — 발급 예정 내용 작성·발급 불가 */
  refundInProgress: z3.boolean().optional(),
  /** 판매자 위반 신고가 처리 중 — 묶음 주문 고르기 창의 표시용 */
  violationReportOpen: z3.boolean().optional()
});
var chatRoomCounterpartSchema = z3.object({
  id: z3.string().uuid(),
  /** 탈퇴한 회원이면 "기존닉네임(탈퇴한 회원)", 보관 기간이 지나 익명화됐으면 "탈퇴한 회원" */
  name: z3.string().nullable(),
  avatarUrl: z3.string().nullable(),
  /** 상대가 탈퇴했는지 — 1:1 방이면 입력 줄 대신 안내를 보인다 */
  withdrawn: z3.boolean().optional()
});
var chatRoomResponseSchema = z3.object({
  id: z3.string().uuid(),
  type: z3.nativeEnum(ChatRoomType),
  /** 그룹 없는 주문(제안 수락)의 ORDER 방만 값. DIRECT/그룹방은 null. */
  orderId: z3.string().uuid().nullable(),
  /** 체크아웃 주문 묶음의 ORDER 방만 값 — 결제 1건당 방 1개. */
  orderGroupId: z3.string().uuid().nullable(),
  status: z3.nativeEnum(ChatRoomStatus),
  disputeAdminJoinedAt: z3.string().datetime().nullable(),
  /** ORDER 방은 항상 존재. DIRECT 방은 "최근 문의 상품" — 프로필발 방이면 null. */
  listing: chatRoomListingSummarySchema.nullable(),
  /** 방에 걸린 주문들 (그룹방은 N건, 단건 방은 1건). DIRECT 방은 빈 배열. */
  orders: z3.array(chatRoomOrderSummarySchema),
  /** 요청자 기준 상대방 (어드민 제외). 헤더/목록의 프로필 폴백. */
  counterpart: chatRoomCounterpartSchema.nullable(),
  /** 내가 상대방을 차단했는지 — 케밥 메뉴 "차단하기/차단 해제" 토글 상태. */
  counterpartBlockedByMe: z3.boolean(),
  participants: z3.array(chatParticipantResponseSchema),
  unreadCount: z3.number().int().min(0),
  lastMessage: chatMessageResponseSchema.nullable(),
  createdAt: z3.string().datetime()
});
var CHAT_ROOM_PAGE_SIZE = 20;
var listMyChatRoomsQuerySchema = z3.object({
  before: z3.string().uuid().optional(),
  limit: z3.coerce.number().int().min(1).max(50).default(CHAT_ROOM_PAGE_SIZE)
});
var chatUnreadCountResponseSchema = z3.object({
  count: z3.number().int()
});
var getChatRoomHistoryQuerySchema = z3.object({
  beforeId: z3.string().uuid().optional(),
  limit: z3.coerce.number().int().min(1).max(50).default(50)
});
var listChatRoomAttachmentsQuerySchema = z3.object({
  type: z3.enum([
    ChatMessageType.IMAGE,
    ChatMessageType.FILE
  ]).optional(),
  beforeId: z3.string().uuid().optional(),
  limit: z3.coerce.number().int().min(1).max(60).default(30)
});
var searchChatMessagesQuerySchema = z3.object({
  q: z3.string().trim().min(1).max(100),
  beforeId: z3.string().uuid().optional(),
  limit: z3.coerce.number().int().min(1).max(50).default(30)
});
var sendChatMessageRequestSchema = z3.object({
  roomId: z3.string().uuid(),
  type: z3.nativeEnum(ChatMessageType).refine((t) => t !== ChatMessageType.SYSTEM, {
    message: "SYSTEM \uD0C0\uC785\uC740 \uD074\uB77C\uC774\uC5B8\uD2B8\uAC00 \uBCF4\uB0BC \uC218 \uC5C6\uC74C"
  }),
  content: z3.string().max(4e3).optional(),
  attachmentKey: z3.string().max(500).optional(),
  attachmentMime: z3.string().max(100).optional(),
  attachmentSizeBytes: z3.number().int().min(0).optional(),
  attachmentFilename: z3.string().max(255).optional(),
  /** 클라 생성 uuid v4. 같은 키로 재전송 시 dedup. */
  clientIdempotencyKey: z3.string().uuid()
}).superRefine((v, ctx) => {
  if (v.type === ChatMessageType.TEXT && !v.content?.trim()) {
    ctx.addIssue({
      code: z3.ZodIssueCode.custom,
      message: "TEXT \uBA54\uC2DC\uC9C0\uB294 content \uD544\uC218"
    });
  }
  if ((v.type === ChatMessageType.IMAGE || v.type === ChatMessageType.FILE) && !v.attachmentKey) {
    ctx.addIssue({
      code: z3.ZodIssueCode.custom,
      message: "\uCCA8\uBD80 \uBA54\uC2DC\uC9C0\uB294 attachmentKey \uD544\uC218"
    });
  }
});
var markChatReadRequestSchema = z3.object({
  lastReadMessageId: z3.string().uuid()
});
var firstMessageFields = {
  /** 첫 문의 메시지 본문. */
  message: z3.string().trim().min(1).max(4e3).optional(),
  /** message 재전송 dedup 용 클라 생성 uuid — message 가 있으면 필수. */
  messageClientKey: z3.string().uuid().optional()
};
var requireKeyWithMessage = /* @__PURE__ */ __name((v, ctx) => {
  if (v.message && !v.messageClientKey) {
    ctx.addIssue({
      code: z3.ZodIssueCode.custom,
      message: "message \uAC00 \uC788\uC73C\uBA74 messageClientKey \uD544\uC218",
      path: [
        "messageClientKey"
      ]
    });
  }
}, "requireKeyWithMessage");
var createInquiryRoomRequestSchema = z3.object({
  listingId: z3.string().uuid(),
  ...firstMessageFields
}).superRefine(requireKeyWithMessage);
var createDirectRoomRequestSchema = z3.object({
  sellerId: z3.string().uuid(),
  ...firstMessageFields
}).superRefine(requireKeyWithMessage);
var chatRoomLookupResponseSchema = z3.object({
  room: chatRoomResponseSchema.nullable()
});
var setChatBlockRequestSchema = z3.object({
  blocked: z3.boolean()
});
var chatBlockStateResponseSchema = z3.object({
  blocked: z3.boolean()
});
var reportChatRoomRequestSchema = z3.object({
  reason: z3.nativeEnum(ChatReportReason),
  detail: z3.string().trim().max(1e3).optional()
});
var chatPresignRequestSchema = z3.object({
  roomId: z3.string().uuid(),
  filename: z3.string().min(1).max(255),
  mime: z3.string().min(1).max(100),
  sizeBytes: z3.number().int().min(1).max(50 * 1024 * 1024)
});
var chatPresignResponseSchema = z3.object({
  uploadUrl: z3.string().url(),
  key: z3.string(),
  headers: z3.record(z3.string(), z3.string()),
  expiresIn: z3.number().int().positive()
});
var chatAttachmentDownloadRequestSchema = z3.object({
  roomId: z3.string().uuid(),
  key: z3.string().min(1).max(500)
});
var chatAttachmentDownloadResponseSchema = z3.object({
  url: z3.string().url(),
  expiresIn: z3.number().int().positive()
});
var chatRoomJoinedEventSchema = z3.object({
  roomId: z3.string().uuid(),
  history: z3.array(chatMessageResponseSchema),
  participants: z3.array(chatParticipantResponseSchema),
  unreadCount: z3.number().int().min(0)
});
var chatReadUpdateEventSchema = z3.object({
  roomId: z3.string().uuid(),
  userId: z3.string().uuid(),
  lastReadMessageId: z3.string().uuid(),
  lastReadAt: z3.string().datetime()
});
var chatTypingEventSchema = z3.object({
  roomId: z3.string().uuid(),
  userId: z3.string().uuid(),
  typing: z3.boolean()
});
var chatPresenceEventSchema = z3.object({
  roomId: z3.string().uuid(),
  userId: z3.string().uuid(),
  online: z3.boolean()
});
var chatRoomActivityEventSchema = z3.object({
  roomId: z3.string().uuid(),
  message: chatMessageResponseSchema
});

// src/user/notifications.schema.ts
import { NotificationCategory, NotificationType, PushPlatform } from "@inflip/shared";
import { z as z4 } from "zod";
var NOTIFICATION_PAGE_SIZE = 20;
var INBOX_NOTIFICATION_CATEGORIES = [
  NotificationCategory.TRADE,
  NotificationCategory.PROPOSAL,
  NotificationCategory.REVIEW,
  NotificationCategory.SPONSORSHIP,
  NotificationCategory.COMMUNITY
];
var inboxNotificationCategorySchema = z4.enum(INBOX_NOTIFICATION_CATEGORIES);
var listNotificationsQuerySchema = z4.object({
  before: z4.string().uuid().optional(),
  /** 이 묶음만 — 없으면 전부 */
  category: inboxNotificationCategorySchema.optional(),
  limit: z4.coerce.number().int().min(1).max(50).default(NOTIFICATION_PAGE_SIZE)
});
var notificationResponseSchema = z4.object({
  id: z4.string().uuid(),
  type: z4.nativeEnum(NotificationType),
  /** 알림함 묶음 (칩) */
  category: inboxNotificationCategorySchema,
  title: z4.string(),
  body: z4.string(),
  link: z4.string().nullable(),
  readAt: z4.string().datetime().nullable(),
  createdAt: z4.string().datetime()
});
var deleteNotificationsRequestSchema = z4.object({
  ids: z4.array(z4.string().uuid()).min(1).max(100)
});
var unreadCountResponseSchema = z4.object({
  count: z4.number().int()
});
var registerPushDeviceRequestSchema = z4.object({
  platform: z4.nativeEnum(PushPlatform),
  token: z4.string().min(8).max(512)
});
var notificationPreferencesSchema = z4.object({
  PROPOSAL: z4.boolean(),
  REVIEW: z4.boolean(),
  SPONSORSHIP: z4.boolean(),
  /** 내 글·댓글에 달린 댓글·답글·좋아요 */
  COMMUNITY: z4.boolean(),
  /** 채팅 메시지 푸시 (보고 있지 않은 방의 새 메시지) */
  CHAT: z4.boolean()
});
var updateNotificationPreferencesRequestSchema = notificationPreferencesSchema.partial();

// src/user/proposals.schema.ts
import { MERCHANDISE_MAX_QUANTITY, ProposalListTab, ProposalStatus } from "@inflip/shared";
import { z as z5 } from "zod";
var proposalTermsInputSchema = z5.object({
  durationMonths: offerDurationSchema,
  /** 협의할 기본 사용료. 선택 옵션 금액은 서버가 별도로 더한다. */
  upfrontAmount: z5.number().int().min(0).max(1e9),
  addons: purchaseAddonsSchema.optional(),
  campaignCount: z5.number().int().min(1).max(100).optional(),
  royaltyRateBp: z5.number().int().min(0).max(1e4).nullable(),
  /** 로열티 지급일 — 매달 N일까지 전월 매출 보고 + 로열티 입금 (로열티 계약이면 필수) */
  royaltyPaymentDay: z5.number().int().min(1).max(28).nullable(),
  /**
   * 협의한 분량 — 사진(장)·영상(건)·음성(개)·굿즈(제작 수량). 없으면 상품 값(수정 제안이면 직전 제안 값).
   * 권리별 범위는 서버가 proposalQuantityFields 로 다시 본다
   */
  includedQuantity: z5.number().int().min(1).max(MERCHANDISE_MAX_QUANTITY).optional(),
  /** 협의한 음성 총 길이(초) — 음성 권리만 */
  totalSeconds: z5.number().int().min(1).max(36e3).optional()
}).superRefine((terms, ctx) => {
  if (terms.royaltyRateBp && !terms.royaltyPaymentDay) {
    ctx.addIssue({
      code: z5.ZodIssueCode.custom,
      path: [
        "royaltyPaymentDay"
      ],
      message: "\uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC740 \uC9C0\uAE09\uC77C(\uB9E4\uB2EC N\uC77C) \uD569\uC758\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4"
    });
  }
});
var createProposalRequestSchema = z5.object({
  offerId: z5.string().uuid(),
  terms: proposalTermsInputSchema,
  message: z5.string().max(1e3).optional()
});
var counterProposalRequestSchema = z5.object({
  terms: proposalTermsInputSchema,
  message: z5.string().max(1e3).optional()
});
var amendProposalRequestSchema = counterProposalRequestSchema;
var acceptProposalRequestSchema = z5.object({
  seenRound: z5.number().int().positive()
});
var acceptProposalResponseSchema = z5.object({
  orderId: z5.string().uuid()
});
var PROPOSAL_LIST_PAGE = 10;
var listMyProposalsQuerySchema = z5.object({
  tab: z5.nativeEnum(ProposalListTab).optional(),
  before: z5.string().uuid().optional(),
  limit: z5.coerce.number().int().min(1).max(50).default(PROPOSAL_LIST_PAGE)
});
var proposalsSummaryResponseSchema = z5.object({
  todo: z5.number().int(),
  waiting: z5.number().int(),
  accepted: z5.number().int(),
  ended: z5.number().int()
});
var proposalPendingCountResponseSchema = z5.object({
  count: z5.number().int()
});
var proposalCounterpartySchema = z5.object({
  id: z5.string().uuid(),
  name: z5.string(),
  avatarUrl: z5.string().nullable(),
  /** 나와 성사(결제 확인 이후)된 거래 수 */
  tradesWithMe: z5.number().int(),
  /** 협의 성사 후 미입금·주문취소로 파기한 수 — 구매자로서, 플랫폼 전체 */
  brokenDealCount: z5.number().int()
});
var proposalResponseSchema = z5.object({
  id: z5.string().uuid(),
  listingId: z5.string().uuid(),
  listingTitle: z5.string(),
  offerId: z5.string().uuid(),
  buyerId: z5.string().uuid(),
  sellerId: z5.string().uuid(),
  /** 협의 상대 (요청자 기준) — 탈퇴한 사용자면 null */
  counterparty: proposalCounterpartySchema.nullable(),
  status: z5.nativeEnum(ProposalStatus),
  /** 마지막 제안자 — 이 사람의 "상대"만 수락/수정/거절 가능 */
  proposedBy: z5.string().uuid(),
  /** 내 차례인지 (요청자 기준 계산됨) */
  myTurn: z5.boolean(),
  terms: contractTermsSchema,
  /** 조건 줄 (shared offerTermsRows) */
  termRows: offerTermsRowsSchema.optional(),
  /** 결제 금액 줄 (shared proposalPriceRows) — 수락 확인에 보인다. 옵션 가격표가 없는 옛 제안이면 null */
  priceRows: z5.array(offerTermRowSchema).nullable().optional(),
  /** 수정 제안·내 제안 고치기 입력 칸 (shared proposalFormOfTerms) */
  editForm: proposalFormSpecSchema.optional(),
  message: z5.string().nullable(),
  round: z5.number().int(),
  orderId: z5.string().uuid().nullable(),
  /** 응답 기한 — 진행 중일 때만 */
  expiresAt: z5.string().datetime().nullable(),
  /** 끝낸 때 — 수락·거절·취소·만료·종료 */
  decidedAt: z5.string().datetime().nullable(),
  /** 어드민 종료 사유 */
  closeReason: z5.string().nullable(),
  updatedAt: z5.string().datetime(),
  createdAt: z5.string().datetime()
});

// src/user/sellers.schema.ts
import { z as z6 } from "zod";
var sellerProfileSchema = z6.object({
  id: z6.string().uuid(),
  name: z6.string(),
  avatarUrl: z6.string().nullable(),
  /** 등록된 SNS/방송 채널 — 등록한 것만 노출 */
  socialLinks: socialLinksSchema.nullable(),
  joinedAt: z6.string().datetime(),
  /** 공개 중인 listing 수 */
  listingCount: z6.number().int(),
  /** 성사된 거래 수 (결제 확인 이후) */
  salesCount: z6.number().int(),
  /** 협찬 미션 완료 수 — 지원자로 미션까지 마친(COMPLETED) 지원 */
  sponsorshipCompletedCount: z6.number().int(),
  listings: z6.array(listingSummarySchema)
});

// src/user/policies.schema.ts
import { PolicyLanguage } from "@inflip/shared";
import { z as z7 } from "zod";
var policyLanguageQuerySchema = z7.object({
  lang: z7.string().trim().max(35).optional()
});
var publicPolicySummarySchema = z7.object({
  slug: z7.string(),
  /** 응답 언어의 제목 */
  title: z7.string(),
  /** 실제로 준 언어 — 요청한 언어 번역이 없으면 한국어 */
  language: z7.nativeEnum(PolicyLanguage),
  isRequired: z7.boolean(),
  /** false 면 동의 없이 게시만 하는 문서 (개인정보 처리방침 등) — 가입·동의 창의 체크 항목에서 뺀다 */
  needsConsent: z7.boolean(),
  version: z7.number().int(),
  publishedAt: z7.string().datetime(),
  /** 시행일 — 게시(공고)부터 이날 전까지는 이전 버전이 적용된다 */
  effectiveAt: z7.string().datetime()
});
var policyInlineSchema = z7.object({
  text: z7.string(),
  bold: z7.boolean().optional(),
  italic: z7.boolean().optional(),
  underline: z7.boolean().optional(),
  strike: z7.boolean().optional(),
  /** 바깥 주소 — 브라우저로 연다 */
  href: z7.string().optional(),
  /** 다른 약관 slug — 그 약관 화면으로 */
  policySlug: z7.string().optional()
});
var policyTableCellSchema = z7.object({
  inlines: z7.array(policyInlineSchema)
});
var policyTableRowSchema = z7.object({
  /** 머리 줄(th) */
  header: z7.boolean(),
  cells: z7.array(policyTableCellSchema)
});
var policyBlockSchema = z7.object({
  type: z7.enum([
    "heading",
    "paragraph",
    "listItem",
    "table",
    "rule"
  ]),
  level: z7.number().int().min(1).max(3).optional(),
  ordered: z7.boolean().optional(),
  /** 목록 들여쓰기 깊이 (0부터) */
  depth: z7.number().int().min(0).optional(),
  /** 번호 목록의 번호 (1부터) */
  index: z7.number().int().min(1).optional(),
  inlines: z7.array(policyInlineSchema).optional(),
  rows: z7.array(policyTableRowSchema).optional()
});
var publicPolicyDetailSchema = publicPolicySummarySchema.extend({
  /** 본문 HTML (허용 태그만) — 웹이 그린다 */
  content: z7.string(),
  /** 같은 본문을 앱용 블록으로 */
  blocks: z7.array(policyBlockSchema),
  /** 이 버전에 번역이 있는 언어 — 언어 탭에 쓴다 (한국어는 늘 있다) */
  availableLanguages: z7.array(z7.nativeEnum(PolicyLanguage))
});
var pendingPolicyConsentSchema = z7.object({
  versionId: z7.string().uuid(),
  slug: z7.string(),
  title: z7.string(),
  version: z7.number().int(),
  effectiveAt: z7.string().datetime(),
  overdue: z7.boolean()
});
var pendingPolicyConsentsResponseSchema = z7.object({
  items: z7.array(pendingPolicyConsentSchema)
});
var agreePoliciesRequestSchema = z7.object({
  versionIds: z7.array(z7.string().uuid()).min(1).max(20),
  /** 동의할 때 본 언어 — 동의 기록에 남는다 (없으면 한국어) */
  language: z7.nativeEnum(PolicyLanguage).optional()
});
var optionalPolicyConsentSchema = z7.object({
  slug: z7.string(),
  /** 응답 언어의 제목 */
  title: z7.string(),
  agreed: z7.boolean(),
  /** 마지막 유효 동의 시각 — 동의하지 않았거나 철회했으면 null */
  agreedAt: z7.string().datetime().nullable(),
  /** 재확인할 때 — agreedAt 의 달력 2년 뒤 (회원 시간대). 동의하지 않았으면 null */
  reconfirmAt: z7.string().datetime().nullable(),
  /** 재확인할 때가 됐다 — [계속 받기]는 다시 동의, [그만 받기]는 철회 */
  reconfirmDue: z7.boolean()
});
var optionalPolicyConsentsResponseSchema = z7.object({
  items: z7.array(optionalPolicyConsentSchema)
});
var updateOptionalPolicyConsentRequestSchema = z7.object({
  agreed: z7.boolean(),
  /** 동의할 때 본 언어 — 동의 기록에 남는다 (없으면 한국어) */
  language: z7.nativeEnum(PolicyLanguage).optional()
});

// src/common/guide-content.ts
import { ACTIVE_IP_RIGHT_TYPES as ACTIVE_IP_RIGHT_TYPES3, BUSINESS as BUSINESS3, feeRateLabel, IP_RIGHT_LABELS, SPECIAL_TERMS_PLACEHOLDERS } from "@inflip/shared";
import { z as z8 } from "zod";

// src/common/guide-content.en.ts
import { ACTIVE_IP_RIGHT_TYPES, BUSINESS } from "@inflip/shared";
var SPECIAL_TERMS_EXAMPLES_EN = {
  NAME_BRAND: {
    label: "Name/brand usage rights",
    text: "e.g. Name display: limited to one Korean spelling of 'OOO' (logo and English spelling negotiated separately)\ne.g. Where used: product detail pages and packaging copy\ne.g. Quantity: 1 product (up to 3 SKUs), up to 2 ad creatives\ne.g. Trademark filing or business-name registration of the brand name is prohibited"
  },
  FACE_PHOTO: {
    label: "Photo usage rights",
    text: "e.g. Scope: shots A, B, C agreed in chat, 3 final photos\ne.g. Changed from 1 base photo to 3, \u20A9100,000 for 2 extra / product detail page for 3 months\ne.g. Retouching and cropping allowed; face compositing and AI training prohibited\ne.g. Ads requiring review (medical, financial, etc.) are checked before posting"
  },
  CONTENT_SECONDARY: {
    label: "Video usage rights",
    text: "e.g. Scope: 1 video chosen by the buyer in chat, 00:10\u201300:30\ne.g. Changed from brand repost to include paid brand ads, \u20A950,000 extra\ne.g. Cut edits and subtitles allowed; edits that distort what was said are prohibited\ne.g. Re-uploading to third-party platforms is prohibited"
  },
  AI_VOICE: {
    label: "Voice usage rights",
    text: "e.g. Scope: agreed voice file A or final script, 1 clip, 30 seconds total or less\ne.g. New recording: script confirmation date, draft delivery date, agreed revisions\ne.g. Where used and edits are confirmed within the purchase terms\ne.g. Buyer AI generation: confirm the voice, service, access date, generation period, and allowed languages"
  },
  CO_BRANDING: {
    label: "Co-branding",
    text: "e.g. Partner brand and campaign: agreed brand A, 1 fall co-campaign\ne.g. How both brands appear: 'Brand A \xD7 Brand B', final logo layout draft v2\ne.g. Used in purchased regular SNS posts and website; final copy and drafts checked before release\ne.g. After the end, follow the contract terms. If kept for the record, mark it as an ended campaign"
  },
  MERCHANDISE: {
    label: "Merchandise rights",
    text: "e.g. Materials and final draft: character file and keyring draft v2 agreed in chat\ne.g. 500 made in total: 390 for sale, 100 giveaways, 10 approval samples (no sales if non-sale only)\ne.g. Sales and distribution: agreed online stores and events; final draft and sample checked before mass production\ne.g. After the term ends: handle stock per the purchased clearance terms; no new production\ne.g. If there is a sales royalty, confirm the settlement basis and proof for units sold"
  },
  COLLABORATION: {
    label: "Collaboration product rights",
    text: "e.g. Collaboration product scope: 1 OO edition\ne.g. Both sides confirm the final design before launch\ne.g. Reorders are negotiated separately"
  },
  APPEARANCE: {
    label: "Appearance rights",
    text: "e.g. Date, time, and place or how to join: agreed date, Seoul event venue or online meeting link\ne.g. Activity and time: interview and photo shoot, once, within 60 minutes; confirm whether rehearsal is included\ne.g. Record what was actually agreed on travel and lodging, extensions, and extra costs\ne.g. Where and how long footage is used follows the purchase terms; confirm who shoots, delivers originals, and edits\ne.g. Confirm the terms for schedule changes or cancellations"
  }
};
var SPECIAL_TERMS_EXAMPLE_BLOCKS = ACTIVE_IP_RIGHT_TYPES.map((t) => ({
  type: "example",
  ...SPECIAL_TERMS_EXAMPLES_EN[t]
}));
var GUIDE_SECTIONS_EN = [
  {
    title: "Getting started",
    pages: [
      {
        slug: "intro",
        title: "About Inflip",
        description: "A marketplace for safely buying and selling usage rights to influencer and creator IP.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "What is Inflip?"
          },
          {
            type: "p",
            text: "Inflip is a trading platform where influencers and creators list usage rights to their IP (name, face, content, and more) along with terms, and buyers pick the rights they need and receive them as a license. Payment is made by bank transfer, and every term is recorded on the license certificate."
          },
          {
            type: "h2",
            id: "rights",
            text: "Rights you can trade"
          },
          {
            type: "list",
            items: [
              "Name/brand usage rights \u2014 use a name or brand on products and in marketing",
              "Photo usage rights \u2014 use existing profile or shoot photos within the agreed scope. New shoots or production are agreed separately",
              "Video usage rights \u2014 use existing Reels, Shorts, or YouTube videos within the agreed scope. New shoots or production are agreed separately",
              "Voice usage rights \u2014 use existing voice recordings, have new voice content made and delivered, or allow the buyer's AI voice generation",
              "Co-branding \u2014 a joint campaign featuring both sides' brands. Includes use of names and logos within that scope",
              "Merchandise rights \u2014 make merchandise with the agreed elements to sell or hand out for free",
              "Appearance rights \u2014 take part once in an event, shoot, etc., either on site or online (video or voice appearance)"
            ]
          },
          {
            type: "h2",
            id: "flow",
            text: "How a deal works"
          },
          {
            type: "steps",
            items: [
              "The buyer picks the rights and terms they want from a listing and places an order.",
              "The buyer pays by bank transfer to the account shown, and an admin confirms the payment.",
              "The buyer and seller agree on details in chat, and the seller issues the license.",
              "The license certificate is delivered to the buyer right away and the deal is complete."
            ]
          },
          {
            type: "callout",
            text: "The terms at the time of the order (period, region, exclusivity, etc.) are locked in as a snapshot. Even if the seller later edits the listing, the contract that's already been made doesn't change."
          }
        ]
      },
      {
        slug: "account",
        title: "Sign up and log in",
        description: "Get started with your Google, Apple, or Kakao account.",
        blocks: [
          {
            type: "h2",
            id: "signup",
            text: "How to sign up"
          },
          {
            type: "p",
            text: "Get started easily with a Google, Apple, or Kakao account. One account works for both buying and selling."
          },
          {
            type: "h2",
            id: "withdraw",
            text: "Delete account"
          },
          {
            type: "p",
            text: `You can delete your account from My page \u2192 My info.
You can't delete your account while you have listings on sale or deals (as a buyer or seller) that haven't been paid out yet.
For royalty contracts, both buyer and seller can delete their accounts only after the contract period ends and the last month's royalty has been paid.
You won't be able to see your licenses after deleting your account, so download any certificates you need beforehand.
Transaction and payout records and license certificates are kept for up to ${BUSINESS.TRADE_RECORD_RETENTION_YEARS} years and then destroyed.`
          }
        ]
      },
      {
        slug: "influencer-verification",
        title: "Influencer verification",
        description: "Verify your social channels to use sponsorships and the community.",
        blocks: [
          {
            type: "h2",
            id: "why",
            text: "What verification unlocks"
          },
          {
            type: "p",
            text: "Verify your social channel and its subscriber or follower count to become a verified influencer."
          },
          {
            type: "list",
            items: [
              "Sponsorships \u2014 if one of your channels meets the viewing threshold, you can see sponsorship details and apply.",
              "Community \u2014 you need a verified channel to write posts and comments.",
              "Badge \u2014 your community posts and comments show the verified platform and your subscriber/follower tier (e.g. 20K+).",
              "Profile \u2014 the social links on your public profile switch to your verified channel addresses."
            ]
          },
          {
            type: "callout",
            text: "The thresholds for viewing sponsorships, writing in the community, and badge tiers may change with our operating policy. If you don't meet the sponsorship viewing threshold, you can check it in the notice on the sponsorship screen."
          },
          {
            type: "h2",
            id: "where",
            text: "Where to verify"
          },
          {
            type: "p",
            text: "You can verify right during sign-up, or anytime afterward from My page \u2192 Influencer verification. You verify one channel per platform."
          },
          {
            type: "h2",
            id: "oauth",
            text: "Verify by connecting your account \u2014 YouTube, Instagram, TikTok"
          },
          {
            type: "steps",
            items: [
              "On the influencer verification screen, tap the platform you want to verify.",
              "In the window that opens, log in with that platform account and agree to share your info.",
              "Once verified, your channel and its subscriber/follower count at that moment are recorded right away."
            ]
          },
          {
            type: "p",
            text: "You need to finish the login window within 10 minutes. Inflip doesn't store your platform login info\u2014only the numbers at the time you verified. If your numbers have grown, you can verify again to update them.\nYou can remove account-connected verification yourself."
          },
          {
            type: "h2",
            id: "manual",
            text: "Request verification by URL \u2014 Threads, SOOP, PandaTV"
          },
          {
            type: "p",
            text: "For platforms that don't support account connection, leave your channel URL and our team will check the channel and verify it for you."
          },
          {
            type: "steps",
            items: [
              "On the influencer verification screen, enter your channel URL and tap Request verification.",
              "Our team checks the channel and verifies it along with the subscriber/follower count. We may contact you at your registered phone number if needed.",
              "We'll let you know the result by notification. If it's rejected, you can check the reason and request again."
            ]
          },
          {
            type: "list",
            items: [
              "Only members with a registered phone number can make a request. If you don't have one, you can register it right when you request.",
              "Please enter your channel profile URL.",
              "Short URLs, link-in-bio pages, or other social URLs can't be used.",
              "You can't remove a URL-verified channel yourself. If you need it removed, please contact the Help center."
            ]
          },
          {
            type: "h2",
            id: "one-account",
            text: "One channel, one account"
          },
          {
            type: "p",
            text: "The same channel can't be verified on multiple accounts.\nIf the channel is already connected to another account, remove it from that account first and then verify again. Verified channels on a deleted account are removed when the account is deleted."
          },
          {
            type: "callout",
            text: "If we find a verification was made with someone else's channel, our team may remove it."
          }
        ]
      }
    ]
  },
  {
    title: "Buyer guide",
    pages: [
      {
        slug: "buying",
        title: "Find IP and order",
        description: "How to check the terms for each right and place an order.",
        blocks: [
          {
            type: "h2",
            id: "explore",
            text: "Explore IP"
          },
          {
            type: "p",
            text: "Use Explore IP at the top to find the IP you want by category or search. On a seller's profile, you can also see their other listings."
          },
          {
            type: "h2",
            id: "offer",
            text: "How to read the terms"
          },
          {
            type: "p",
            text: "Each right sold in a listing has its own set of terms, and even within the same right, prices vary by period and options.\nBe sure to check the terms below before ordering."
          },
          {
            type: "list",
            items: [
              "Usage period \u2014 1, 3, 6, or 12 months (one-off rights like appearances have no period)",
              "Usage region \u2014 Korea only or global",
              "Exclusivity \u2014 non-exclusive / category exclusive / fully exclusive",
              "Allowed modifications \u2014 whether cropping or color changes are allowed, no AI edits, etc.",
              "Prohibited industries \u2014 fields where use is not allowed, such as gambling, adult, politics, medical, investment, and alcohol",
              "Pricing type \u2014 fixed price / sales royalty / fixed price + sales royalty"
            ]
          },
          {
            type: "h2",
            id: "order",
            text: "Place an order"
          },
          {
            type: "p",
            text: "When you choose a right and options and order, the terms at that moment become the contract.\nFor 'rights handled by negotiation' on a listing (sales-royalty rights or rights marked as price negotiable), instead of ordering right away you send a negotiation offer proposing the period, amount, royalty rate, and payment day, and settle them back and forth with the seller. Other terms can't be changed through an offer. Whichever side accepts the other's offer, an order is created on those terms.\nAfter sending an offer, you can edit or cancel it until the other side responds. You can decline an offer you receive, and either way the negotiation ends then. If the other side doesn't respond within {{proposalExpiryDays}} days of an offer, the negotiation expires."
          }
        ]
      },
      {
        slug: "payment",
        title: "Paying by bank transfer",
        description: "After ordering, transfer to the account shown and an admin will confirm it.",
        blocks: [
          {
            type: "h2",
            id: "how",
            text: "How to pay"
          },
          {
            type: "p",
            text: "Once you complete an order, you'll see the account, amount, and depositor name. Please transfer exactly the amount shown, under the depositor name shown."
          },
          {
            type: "h2",
            id: "deadline",
            text: "Payment deadline"
          },
          {
            type: "p",
            text: "If payment isn't confirmed within {{depositDueHours}} hours of ordering, the order is cancelled automatically. If it was cancelled because the deadline passed, please order again."
          },
          {
            type: "h2",
            id: "bundle",
            text: "Paying for several rights at once"
          },
          {
            type: "p",
            text: "If you order several rights from one listing together, you get a single payment notice. Transfer the total once, and payment for all the rights ordered together is confirmed at the same time.\nA separate contract is created for each right, so license issuance, purchase confirmation, and refunds happen per right."
          },
          {
            type: "h2",
            id: "addon",
            text: "Additional payments"
          },
          {
            type: "p",
            text: "If the amount goes up through negotiation after payment is confirmed but before issuance, the seller can request an additional payment on the same order. When a request comes in, you'll see payment instructions in your notifications and the order details.\nPlease pay the additional amount within {{addonDepositDueHours}} hours of the request. If the deadline passes, only the additional payment request expires and the order stays as is."
          },
          {
            type: "h2",
            id: "confirm",
            text: "Payment confirmation"
          },
          {
            type: "p",
            text: "When an admin confirms your payment, the order changes to paid and we'll notify you. The seller can then go ahead with issuing the license."
          },
          {
            type: "callout",
            text: "If the sender's name differs from the depositor name, confirmation may take longer.\nIf you plan to transfer under a different name, change it before paying with the Change button next to the depositor name in the payment instructions.\nIf you've already transferred under a different name, please let the Help center know."
          },
          {
            type: "h2",
            id: "wrong-amount",
            text: "If you sent the wrong amount"
          },
          {
            type: "list",
            items: [
              "If you sent too much: payment is confirmed for the order amount, and an admin returns the excess.",
              "If you sent too little: payment isn't confirmed. We'll return what we received and the order is cancelled, so after getting it back, please order again with the exact amount. If an additional payment was short, we return only what we received and the additional payment request stays open.",
              "For returns, let the Help center know which account to send it to. You can see the amount to be returned, the reason, and whether it's been sent in the order details and notifications."
            ]
          },
          {
            type: "h2",
            id: "late",
            text: "If you paid after the deadline"
          },
          {
            type: "p",
            text: "If you paid after the order was cancelled for missing the deadline, please let the Help center know. If the right can still be bought on the same terms, an admin will restore the order and confirm the payment.\nIf it can no longer be bought\u2014for example, sales were paused or another buyer signed a fully exclusive contract in the meantime\u2014we'll return the amount we received."
          }
        ]
      },
      {
        slug: "license",
        title: "Check your license",
        description: "How to view issued licenses and certificates.",
        blocks: [
          {
            type: "h2",
            id: "issue",
            text: "How issuance works"
          },
          {
            type: "p",
            text: "Once payment is complete, the seller issues the license. Before issuance, you can preview the start date and additional agreements on the 'License draft' card at the top of the chat room."
          },
          {
            type: "h2",
            id: "cert",
            text: "License certificate"
          },
          {
            type: "p",
            text: "When issued, a certificate is created with the rights, usage terms, effective period, and any additional agreements made with the seller.\nIn My page \u2192 Licenses, you can see all the licenses you've received and download PDF certificates. Tapping a license opens the details of the deal it came from.\nSellers can download the same certificate from the Issued licenses tab on the same screen and from the sales order details."
          },
          {
            type: "h2",
            id: "download",
            text: "Download the certificate"
          },
          {
            type: "p",
            text: "Tap the PDF certificate button in the order details or in My page \u2192 Licenses to download it anytime. It's generated fresh each time with the status at that moment.\nCertificates for licenses whose period has ended are marked expired, and those for terminated contracts are marked terminated. Certificates aren't available for revoked licenses."
          },
          {
            type: "h2",
            id: "repurchase",
            text: "Buying the same IP again"
          },
          {
            type: "p",
            text: "Even if you already hold a license, you can buy the same right again to extend the period or for another project.\nHowever, if there's still an order awaiting payment or paid for that right, you can buy again after that order is finished.\nIf another buyer is using that right under a fully exclusive contract, you can't buy it on any terms, and you can't buy a right fully exclusively while another buyer is using it."
          }
        ]
      },
      {
        slug: "refund",
        title: "Refunds and disputes",
        description: "How to request a refund and how disputes are handled.",
        blocks: [
          {
            type: "h2",
            id: "request",
            text: "Request a refund"
          },
          {
            type: "p",
            text: "After payment is confirmed and before the license is issued (paid), you can request a full refund of the payment with the Request refund button in the order details.\nIf payment hasn't been confirmed yet, please cancel the order instead of requesting a refund.\nAfter the license is issued, please file a dispute instead of a refund request.\nFor bank transfer orders, refund account details are required, and you can't make a new request while one is in progress."
          },
          {
            type: "h2",
            id: "partial",
            text: "Partial refunds"
          },
          {
            type: "p",
            text: "Refunds requested by the buyer are always full refunds. Partial refunds, where only part of the amount is returned, are made by an admin after reviewing the situation, such as a dispute.\nTotal refunds can't exceed the amount paid (including confirmed additional payments).\nFor deals where the payout has already been sent to the seller, the refund is paid after the payout is recovered from the seller."
          },
          {
            type: "h2",
            id: "full",
            text: "What happens to the license after a full refund"
          },
          {
            type: "p",
            text: "When a full refund is complete, the order becomes refunded and any issued license is revoked (loses its effect)."
          },
          {
            type: "h2",
            id: "dispute",
            text: "File a dispute"
          },
          {
            type: "p",
            text: "If a problem comes up after the license is issued that doesn't match the contract, you can file a dispute from the order details. Even after purchase confirmation, you can file one until the seller's payout is sent.\nOnce a dispute is filed, an admin joins the deal chat, and purchase confirmation and the seller's payout are paused in the meantime.\nAfter hearing both sides, the admin either refunds (fully or partially) or, if there are no grounds or the parties have settled, dismisses the dispute and resumes the payout. If the contract can't reasonably continue, the admin can also terminate it to close the dispute (see Termination and disputes). The outcome and reason are shared with both sides in the order details and notifications.\nA dispute dismissed by an admin can't be filed again. If a new problem comes up, please let the Help center know."
          }
        ]
      },
      {
        slug: "termination",
        title: "Termination and disputes",
        description: "Ending a contract early, and how upfront payments are handled when it ends.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "What is contract termination?"
          },
          {
            type: "p",
            text: "Termination ends a contract with an issued license before its period is over. An admin terminates it when both sides agree, when one side doesn't keep the contract, or when the seller can no longer provide the rights.\nUse up to the termination date is recognized as legitimate, and the license can't be used from then on.\nRoyalty contracts with no upfront amount (\u20A90 upfront) can be ended by termination even before the license is issued."
          },
          {
            type: "h2",
            id: "vs-refund",
            text: "Termination vs. full refund"
          },
          {
            type: "list",
            items: [
              "Termination: use up to the termination date is recognized. The order becomes terminated, and you can still download the license certificate with a terminated mark.",
              "Full refund: the contract is treated as if it never existed. The order becomes refunded, and the license is revoked so the certificate isn't available.",
              "To end a contract before the license is issued, cancel the order (before payment) or request a refund (after payment) instead of terminating. Only \u20A90-upfront contracts are terminated before issuance as an exception."
            ]
          },
          {
            type: "h2",
            id: "upfront",
            text: "Handling the upfront payment on termination"
          },
          {
            type: "p",
            text: "When terminating, how to split the upfront amount already paid is decided at the same time. The order details show how it was handled next to the terminated mark."
          },
          {
            type: "list",
            items: [
              "Termination \xB7 no refund: the upfront amount isn't returned, and the seller receives it as the sale payout.",
              "Termination \xB7 partial refund (upfront): part of the upfront amount is returned to the buyer, and the seller receives the rest.",
              "Termination \xB7 full refund (upfront): the entire upfront amount is returned to the buyer. The contract is still terminated, so use up to the termination date is recognized and royalties up to then must be paid."
            ]
          },
          {
            type: "p",
            text: "The refund is complete once an admin finishes the transfer. Bank transfer orders need a refund account. The seller's payout isn't sent until the refund is complete."
          },
          {
            type: "h2",
            id: "royalty",
            text: "Royalties after termination"
          },
          {
            type: "p",
            text: "For royalty contracts, sales must be reported and royalties paid through the month that contains the termination date. For that month, include only sales from the 1st through the termination date.\nFor example, if terminated on October 15, report October sales (1st\u201315th) by the November payment day, and nothing from November on.\nRoyalties already paid aren't returned on termination. If reported sales were wrong, please use the royalty report correction process."
          },
          {
            type: "h2",
            id: "request",
            text: "Requesting termination"
          },
          {
            type: "p",
            text: "If you need to terminate, first talk with the other side in the deal chat about whether to terminate and how to handle the upfront payment, then let the Help center know.\nAn admin reviews both opinions and the deal history, decides the reason and how to handle the upfront payment, and processes it. The outcome and reason are shared with both sides in the order details, notifications, and deal chat."
          },
          {
            type: "h2",
            id: "dispute",
            text: "Termination during a dispute"
          },
          {
            type: "p",
            text: "If the admin reviewing a dispute decides the contract can no longer reasonably continue, they can terminate it to close the dispute. The upfront handling (no refund, partial refund, full refund) is decided at the same time, and the dispute outcome shows that it was closed by contract termination."
          },
          {
            type: "h2",
            id: "after",
            text: "After termination"
          },
          {
            type: "list",
            items: [
              "A terminated license can't be used after the termination date. To keep using it, you need to buy it again.",
              "When a fully exclusive contract is terminated, other buyers can buy that right.",
              "The deal chat room doesn't close. You can continue talking about remaining royalty reports or refunds.",
              "A royalty contract is considered ended once royalties through the termination month are paid, after which you can delete your account."
            ]
          }
        ]
      },
      {
        slug: "contract-end",
        title: "When a contract ends",
        description: "What to expect when a license's usage period ends, and how to keep using it afterward.",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "When the contract period ends"
          },
          {
            type: "p",
            text: "A license can be used during the usage period on the certificate (start date to last day of use). After the last day of use, it expires at 00:00 the next day and can't be used from that day.\nDates are based on the contract time zone set at the time of the order, so the buyer and seller see the same dates.\nAppearance rights are one-time contracts, so they have no expiration date."
          },
          {
            type: "h2",
            id: "notice",
            text: "Notices before and after the end"
          },
          {
            type: "list",
            items: [
              "When 7 days and 3 days are left until the last day of use, we send notifications and push alerts to both buyer and seller. Tapping a notification opens that deal\u2019s order details.",
              "When the period ends, we send an end notice to both sides, and the deal chat room gets the message \u201CThe IP contract period has ended. To renew, please place a new IP order.\u201D",
              "These are contract notices, so they can't be turned off in notification settings."
            ]
          },
          {
            type: "h2",
            id: "renew",
            text: "If you want to keep using it"
          },
          {
            type: "p",
            text: "There's no separate extension. Order the same IP again to continue under a new contract (see Buying the same IP again in Check your license).\nTo avoid a gap, order again before the period ends and agree with the seller in chat to set the new contract's start date to the day after the current one ends.\nIf another buyer is using that right under a fully exclusive contract, you can't buy it again."
          },
          {
            type: "h2",
            id: "after",
            text: "After it ends"
          },
          {
            type: "list",
            items: [
              "You can't use the IP any further with an expired license.",
              "You can still download the certificate with an expired mark.",
              "For royalty contracts, sales must be reported and royalties paid through the month containing the last day of use. For that month, include only sales from the 1st through the last day of use.",
              "The deal chat room doesn't close. You can continue talking about remaining royalty reports or ordering again.",
              "To end a contract before its period is over, see Termination and disputes."
            ]
          }
        ]
      }
    ]
  },
  {
    title: "Seller guide",
    pages: [
      {
        slug: "selling",
        title: "Create a listing",
        description: "How to choose the rights to sell and set the terms.",
        blocks: [
          {
            type: "h2",
            id: "listing",
            text: "Create a listing"
          },
          {
            type: "p",
            text: "In Sell IP, choose the types of rights to sell and write a title, description, and notes.\nSet one set of terms for each right you choose; within the same right, you can split terms by price per period, appearance type, and add-on options.\nIf you want to sell with other terms that differ, please create a separate listing."
          },
          {
            type: "h2",
            id: "terms",
            text: "Setting terms"
          },
          {
            type: "list",
            items: [
              "Price per usage period \u2014 choose which of 1, 3, 6, or 12 months to sell and set the price.",
              "Usage region \u2014 Korea only or global.",
              "Exclusivity \u2014 non-exclusive / category exclusive / fully exclusive. The more exclusive, the higher the price you can charge.",
              "Allowed modifications and prohibited industries \u2014 block unwanted uses in advance."
            ]
          },
          {
            type: "h2",
            id: "pricing",
            text: "Pricing types"
          },
          {
            type: "p",
            text: "Choose from fixed price, sales royalty, or fixed price + sales royalty.\nIf you choose a royalty type, set the royalty rate and a payment day (the Nth of each month) \u2014 the buyer reports the previous month's sales and pays the royalty by that date every month.\nAppearance rights support only a fixed price per appearance and base duration. An extra fee for using footage is added if selected.\nFor travel and lodging (on-site), choose between included in the base price or negotiated separately.\nFor extensions, choose not available, time and cost negotiated separately, or a set extra fee (amount per N minutes); extension costs aren't included in the base payment."
          },
          {
            type: "h2",
            id: "considerations",
            text: "Things to consider when actually selling"
          },
          {
            type: "p",
            text: "Many details can't be fully captured by the terms on a listing and need more specific discussion for each right.\nSetting your standards before selling makes negotiations much faster."
          },
          {
            type: "list",
            items: [
              "Name/brand \u2014 which forms (Korean, English, logo) to allow, limits on use such as products and ad creatives, and whether to block trademark filing or business-name registration.",
              "Photo usage rights \u2014 which shots to provide, how far retouching and cropping are allowed, and whether to block compositing and AI training.",
              "Video usage rights \u2014 the range of source footage allowed, and whether edits that distort what was said or re-uploads to other platforms are allowed.",
              "Voice usage rights \u2014 depending on the agreed method (file use, new recording, or buyer AI generation), confirm the target voice, script, and length, plus production terms or the generation method, period, and service costs.",
              "Co-branding \u2014 brand elements and copy to show together, price per campaign, number of campaigns the buyer chooses, where it's used and per-use add-on fees, draft approval before release, and handling of posts after the end. The actual partner brand, campaign, and drafts are recorded in the additional agreements. Name and logo use within the same scope is included; product planning, production, and sales, or the seller's own posts and appearances, are separate.",
              "Merchandise \u2014 allow for-sale and free-distribution uses separately or together. Set the items, elements used, total production quantity, sales and distribution channels, draft and sample approval, additional production, and stock handling after the term. Units sold, giveaways, and samples count toward the total, and non-sale-only uses are priced without a sales royalty.",
              "Appearance \u2014 you can register on-site, online video, and online voice options together in one listing. For each, set the activity, base duration per appearance, price, extension terms, scope of recording use, and schedule change and cancellation terms; the buyer chooses one. Visit region and travel/lodging are set only for on-site. Video means joining live as yourself or an avatar, and voice means joining live with your voice only. The actual schedule and how to join are recorded in the additional agreements."
            ]
          },
          {
            type: "callout",
            text: "Negotiate these details in chat after the order, and register what you agreed as additional agreements so they appear on the certificate. For details, see Chat negotiation and Additional agreements (special terms)."
          }
        ]
      },
      {
        slug: "chat",
        title: "Chat negotiation",
        description: "How to negotiate details with the buyer in the order chat room.",
        blocks: [
          {
            type: "h2",
            id: "room",
            text: "Order chat room"
          },
          {
            type: "p",
            text: "Once the buyer's payment is confirmed, a deal chat room with the buyer opens automatically. No chat room opens for orders cancelled before payment.\nNegotiate details like scope of use, material delivery, and schedule here."
          },
          {
            type: "h2",
            id: "draft",
            text: "Saving the license draft"
          },
          {
            type: "p",
            text: `Keep what you've agreed in chat on the 'License draft' card at the top of the chat room. You can set the start date (from today up to ${BUSINESS.LICENSE_START_MAX_DAYS_AHEAD} days ahead) and additional agreements, and once saved the buyer can see them right away. You can keep editing until issuance.
Chat rooms for bundle orders, where several rights were paid for at once, don't have this card. In that case, enter the start date and additional agreements for each right in the order details and issue from there.`
          },
          {
            type: "callout",
            text: "If you only agree verbally, you may remember things differently later. Update the license draft each time you agree on something, and it will go onto the certificate exactly as written."
          }
        ]
      },
      {
        slug: "issuing",
        title: "Issuing a license",
        description: "How to issue a license exactly as negotiated.",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "When you can issue"
          },
          {
            type: "p",
            text: "Once the buyer's payment (deposit confirmation) is complete, the Issue button becomes available in the chat room and the order details.\nIf the amount went up through negotiation, you can request an additional payment from the order details before issuing. You can't issue while an additional payment is pending, so issue after it's confirmed or cancel the additional payment request."
          },
          {
            type: "h2",
            id: "how",
            text: "Issue the license"
          },
          {
            type: "p",
            text: "The license is issued with exactly the start date and additional agreements saved in the license draft. If you leave the start date blank, it starts today.\nFor rights other than name/brand usage rights, you must write what you confirmed in conversation\u2014such as targets, quantities, and schedule\u2014in the additional agreements before you can issue."
          },
          {
            type: "h2",
            id: "after",
            text: "After issuing"
          },
          {
            type: "p",
            text: "The license certificate is delivered to the buyer right away and the order changes to complete. When the buyer confirms the purchase, the payout process begins; even if they don't, it's confirmed automatically {{purchaseConfirmDays}} days after the start date. The buyer can also confirm before the start date."
          },
          {
            type: "callout",
            text: "Issuance can't be undone. Please make sure negotiation is finished and the license draft is up to date before issuing."
          }
        ]
      },
      {
        slug: "special-terms",
        title: "Additional agreements (special terms)",
        description: "How to record terms that apply only to this buyer on the certificate.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "What are additional agreements?"
          },
          {
            type: "p",
            text: `This is where you write anything agreed only with this buyer, beyond the terms set on the listing (period, region, exclusivity, etc.). It appears on the certificate as "Additional agreements (special terms)" and becomes part of the contract. You can write up to 2,000 characters.
The field name may look different depending on the right, such as "Confirmed appearance terms," but it's the same field.`
          },
          {
            type: "h2",
            id: "tips",
            text: "Writing tips"
          },
          {
            type: "list",
            items: [
              "Be specific about what is allowed \u2014 state which material (links, quantity) is used where (platform, placement).",
              "Prior review \u2014 if something needs to be checked before posting, write down that process.",
              "Prohibitions \u2014 block unwanted edits, re-uploads, and resale in advance.",
              "Time-bound terms \u2014 write promises with a timeline, such as stock handling after expiry or how long posts stay up, with dates."
            ]
          },
          {
            type: "h2",
            id: "examples",
            text: "Examples by type"
          },
          {
            type: "p",
            text: "Here are common additional agreements for each right. You can also see the same examples with the Guide button to the right of the field label. When trading several rights together, refer to the example for each right."
          },
          ...SPECIAL_TERMS_EXAMPLE_BLOCKS
        ]
      },
      {
        slug: "settlement",
        title: "Getting paid out",
        description: "How payouts work after a license is issued.",
        blocks: [
          {
            type: "h2",
            id: "flow",
            text: "Payout flow"
          },
          {
            type: "steps",
            items: [
              "After the license is issued, the buyer checks the materials received and confirms the purchase. The buyer can file a dispute until the payout is sent, and the payout is paused during a dispute.",
              "Once the purchase is confirmed (or automatically confirmed after the deadline), the payout becomes pending.",
              "When an admin completes the payout, it\u2019s deposited to your registered payout account."
            ]
          },
          {
            type: "h2",
            id: "fee",
            text: "Fees"
          },
          {
            type: "p",
            text: "You receive the sale amount minus the {{platformFee}} platform fee. The fee rate is fixed at the time of the order, and later rate changes don't affect deals already made."
          },
          {
            type: "h2",
            id: "account",
            text: "Register a payout account"
          },
          {
            type: "p",
            text: "Register your payout account in My page in advance. Without an account, payouts may be delayed."
          },
          {
            type: "h2",
            id: "history",
            text: "View payout history"
          },
          {
            type: "p",
            text: "In My page > Payouts, you can see sale payouts and royalties together, split into scheduled, paid, deducted, and recovered. All amounts are the actual payout after fees.\nIf an admin briefly pauses a payout to check something, it shows as on hold. Amounts reduced by royalty corrections are deducted from the next payout, and payouts you need to return after a refund are shown as amounts to return."
          },
          {
            type: "callout",
            text: "Deals with an ongoing dispute or a refund in progress aren't paid out until they're resolved."
          },
          {
            type: "h2",
            id: "clawback",
            text: "If a refund happens after payout \u2014 returning the payout"
          },
          {
            type: "p",
            text: `Even after you've been paid out, an admin may decide on a refund if a rights issue or contract breach is confirmed. In that case, you need to send back the refunded share of the payout (all of it for a full refund) to Inflip's account.
The amount, reason, account, and deadline are shown in notifications and My page > Payouts. The deadline is ${BUSINESS.PAYOUT_CLAWBACK_DUE_DAYS} days from when you receive the notice, and the buyer is refunded once your payment is confirmed.`
          },
          {
            type: "callout",
            text: "If you don't pay by the deadline, your account access is suspended and you may face legal action under the license contract and terms of service. Even after suspension, it's lifted once your payment is confirmed."
          }
        ]
      },
      {
        slug: "royalty",
        title: "Royalty reports",
        description: "How reporting and payment work for sales-royalty deals.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "What is a sales royalty?"
          },
          {
            type: "p",
            text: "Instead of (or on top of) a fixed price, you receive a share of the buyer's sales as a royalty. The royalty rate and payment day (the Nth of each month) are fixed when the contract is made \u2014 either the values set on the listing or adjusted through a negotiation offer."
          },
          {
            type: "h2",
            id: "payment-day",
            text: "Payment day \u2014 when to pay each month"
          },
          {
            type: "p",
            text: "Every royalty contract includes a payment day (one day from the 1st to the 28th of each month). Each month, by the payment day, the buyer reports the previous month's sales (1st to last day) and pays the calculated royalty.\nReports cover the month containing the start date through the month containing the last day of use. For the first and last months, report only sales on dates within the contract period.\nFor example, for a 3-month contract starting May 15 (through August 14), May covers sales from the 15th\u201331st and August covers the 1st\u201314th."
          },
          {
            type: "h2",
            id: "report",
            text: "Reporting and payment"
          },
          {
            type: "steps",
            items: [
              "Each month, the buyer reports the previous month's sales and pays the royalty by the payment day.",
              "An admin confirms the payment.",
              "The confirmed royalty, minus the platform fee, is paid to the seller."
            ]
          },
          {
            type: "p",
            text: "You can attach proof of sales (PDF, JPG, PNG, 10MB per file) when reporting. After paying, tap Request quick confirmation and an admin will check it first. Payment is confirmed even if you don't tap it."
          },
          {
            type: "h2",
            id: "fix",
            text: "If a report is wrong"
          },
          {
            type: "list",
            items: [
              "Before payment is confirmed \u2014 the buyer can edit the reported sales directly; the royalty is recalculated and the seller is notified.",
              "Before payment is confirmed \u2014 the seller can reject a report that differs from actual sales. The buyer reports that month again.",
              "After payment is confirmed \u2014 the seller can file an objection with a reason and supporting files. An admin gets additional proof from the buyer, then corrects or dismisses it.",
              "Once corrected, the difference between the corrected sales and the amount already paid is either paid additionally or deducted from the seller\u2019s payout."
            ]
          },
          {
            type: "callout",
            text: `Starting ${BUSINESS.ROYALTY_REPORT_REMINDER_DAYS} days before the payment day, the buyer gets report reminder notifications. If no report is made by the payment day, the buyer gets an overdue notice and the seller gets a delay notice.
Both sides can see report history and payment status in the royalty section at the bottom of the order details. If you have several royalty contracts, My page > Royalties shows the months to report and royalties to receive at a glance.`
          }
        ]
      }
    ]
  },
  {
    title: "Sponsorship guide",
    pages: [
      {
        slug: "sponsorship",
        title: "Sponsorships at a glance",
        description: "Businesses post sponsorships, and verified influencers apply, try them out, and verify with content.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "What is a sponsorship?"
          },
          {
            type: "p",
            text: "A recruiting service where a business (the sponsor) offers a product, service, or visit experience, and a verified influencer (the applicant) tries it and verifies with content like a social post.\nAccounts aren't split into businesses and influencers. With one account, you can post sponsorships and apply to others."
          },
          {
            type: "h2",
            id: "flow",
            text: "How a sponsorship works"
          },
          {
            type: "steps",
            items: [
              "The business uses [Post sponsorship] in the Sponsorship tab to write what\u2019s offered, requests, approval type, and application requirements, then submits it for review.",
              "Once our team reviews and approves it, the sponsorship goes live as recruiting.",
              "Verified influencers who meet the requirements apply from the sponsorship details. For visit sponsorships, they also enter a planned visit date.",
              "Depending on the approval type, the business approves applicants (Confirm after approval), or applications are confirmed instantly (Confirm on apply).",
              "Confirmed influencers visit or try it and post content as requested.",
              "The influencer leaves a review and content links with [Submit mission] in the application details, and the business taps [Confirm mission] to wrap up the sponsorship."
            ]
          },
          {
            type: "h2",
            id: "where",
            text: "Where to find things"
          },
          {
            type: "list",
            items: [
              "Sponsorship tab \u2014 sponsorships that are recruiting. Filter by category and region, and search by title, business name, or location.",
              "Shortcuts above the Sponsorship tab \u2014 [Received applications] appears if you've posted a sponsorship, and [My applications] if you have applications in progress.",
              "My page \u2192 My sponsorships \u2014 manage sponsorships you posted and applications you received.",
              "My page \u2192 Sponsorship applications \u2014 see the status and missions for sponsorships you applied to."
            ]
          },
          {
            type: "callout",
            text: "A sponsorship is an agreement between the business and the influencer. Inflip helps with recruiting and progress, but each party is responsible for the products and services provided and for completing the mission."
          }
        ]
      },
      {
        slug: "sponsorship-posting",
        title: "Post a sponsorship",
        description: "How to write a sponsorship, request review, and get it published.",
        blocks: [
          {
            type: "h2",
            id: "phone",
            text: "Register your phone number first"
          },
          {
            type: "p",
            text: "Only members with a registered phone number can post sponsorships, so our team can contact the business during review.\nIf you tap [Post sponsorship] without a phone number, a registration prompt appears first. Once you register, you go straight to the writing screen."
          },
          {
            type: "h2",
            id: "fields",
            text: "What to fill in"
          },
          {
            type: "list",
            items: [
              "Cover image (optional) \u2014 shown in the list and details. JPG, PNG, or WebP, up to 2MB.",
              "Title \u2014 e.g. New menu visit sponsorship at a Seongsu dessert caf\xE9",
              "Business name \u2014 the business or brand name",
              "Category and region \u2014 used for filtering in the list. Choose a region from Nationwide, Online, and the 17 provinces and cities.",
              "Visit \u2014 choose [In person] if a visit is needed, like a store or lodging, or [No visit] if not, like delivery or online. For visit sponsorships, search and pick the address, and applicants provide a planned visit date.",
              "What's offered \u2014 e.g. dessert set for 2 + drinks, 1 free product. Also note how many people can come along.",
              "Description and requests \u2014 write about the business and the content and schedule you want. For details, see Writing requests.",
              "Approval type and requirements \u2014 set who can apply and how applications are confirmed. See Approval type and requirements."
            ]
          },
          {
            type: "h2",
            id: "review",
            text: "Review and publishing"
          },
          {
            type: "steps",
            items: [
              "Tap [Submit for review] and it goes into review.",
              "Once our team checks and approves it, it's published as recruiting and you're notified.",
              "If it's rejected, you're notified with the reason. You can edit it and request review again."
            ]
          },
          {
            type: "list",
            items: [
              "The sponsorship list shows only the cover, title, and business name. What's offered, the description, and requirements are visible only to verified influencers who meet the platform viewing threshold.",
              "Editing a published sponsorship sends it back for review. Pending applications are then all cancelled, since they were made based on the earlier content, and applicants are notified. Confirmed applications stay as they are.",
              "Changing only the cover image doesn't trigger another review.",
              "A sponsorship that's never been published and never received applications can be removed with [Delete] in the details. Published sponsorships are closed instead of deleted."
            ]
          }
        ]
      },
      {
        slug: "sponsorship-approval",
        title: "Approval type and requirements",
        description: "Choose whether applications are confirmed instantly or by your approval, and who is eligible.",
        blocks: [
          {
            type: "h2",
            id: "mode",
            text: "Approval type \u2014 choose one"
          },
          {
            type: "example",
            label: "Confirm after approval",
            text: "Only applicants you approve after reviewing their channel are confirmed.\nYou're notified when an application comes in, and in [Received applications] you review the channel, follower count, message, and planned visit date, then approve or decline.\nGood when you have a set number of spots or want to choose based on channel style."
          },
          {
            type: "example",
            label: "Confirm on apply",
            text: "Influencers who meet the requirements are confirmed instantly when they apply, without approval.\nIt's fast since you don't have to choose one by one, but anyone who meets the requirements is confirmed, so set them carefully.\nGood when you want to gather many people without a limit. Once you have enough, close applications with [Close recruiting]."
          },
          {
            type: "h2",
            id: "requirements",
            text: "Requirements \u2014 minimum subscribers/followers per platform"
          },
          {
            type: "p",
            text: "These are the subscriber/follower thresholds for influencers who can apply. Turn on one or more of YouTube, Instagram, TikTok, Threads, SOOP, and PandaTV, and enter a minimum for each (in units of 10,000).\nIf several platforms are on, meeting any one of them is enough to apply. Eligibility is based on the numbers of the applicant's verified channels. Channels that hide their follower count are counted as 0."
          },
          {
            type: "example",
            label: "Example",
            text: "If you turn on Instagram 10K \xB7 YouTube 20K\n\u2192 Verified influencers with 10K+ on Instagram or 20K+ on YouTube can apply.\n\u2192 Someone with 8K on Instagram and no verified YouTube can't apply."
          },
          {
            type: "h2",
            id: "platform-standard",
            text: "Platform viewing threshold"
          },
          {
            type: "p",
            text: "To view sponsorship details and apply, you also need to meet Inflip's platform viewing threshold, separate from the requirements. One of your verified channels meeting the threshold is enough.\nIf a member below the threshold taps a sponsorship, they can see the threshold for each channel in a notice."
          },
          {
            type: "callout",
            text: "In short, to apply you need all three: \u2460 a verified social channel \u2461 the platform viewing threshold \u2462 this sponsorship's requirements. In the list, sponsorships you can apply to show a green dot, and ones you don't qualify for show a red dot."
          }
        ]
      },
      {
        slug: "sponsorship-request",
        title: "Writing requests",
        description: "How to clearly tell influencers what content you want.",
        blocks: [
          {
            type: "h2",
            id: "why",
            text: "Your requests are the mission"
          },
          {
            type: "p",
            text: 'What you write in "Description and requests" becomes the mission the influencer has to do. Confirmed influencers create content based on it and, when done, verify the result as mission complete.\nThe more specific it is, the more your expectations line up, and the easier it is to check the mission.'
          },
          {
            type: "h2",
            id: "checklist",
            text: "Be sure to include"
          },
          {
            type: "list",
            items: [
              "Content type and quantity \u2014 how many feed photos, Reels/Shorts, or blog reviews",
              "Where to post \u2014 Instagram feed or stories, YouTube, blog, etc.",
              "Must-haves \u2014 business account tag, hashtags, location tag, menu items or products to show",
              "Schedule \u2014 days and times available to visit, posting deadline (e.g. within 7 days of the visit)",
              "How long posts stay up \u2014 e.g. at least 3 months",
              "What not to do \u2014 mentioning competitors, areas you don't want filmed, etc."
            ]
          },
          {
            type: "h2",
            id: "examples",
            text: "Example requests"
          },
          {
            type: "example",
            label: "SNS photo post",
            text: 'Please post 3 or more photos of the store and menu on your Instagram feed.\nInclude the @business tag, the #SeongsuCafe #NewMenu hashtags, and a location tag.\nPost within 7 days of your visit and keep it up for at least 3 months.\nPlease mark the post as "Sponsored" or "Ad".'
          },
          {
            type: "example",
            label: "Reels/Shorts video",
            text: "1 Reel of 15\u201330 seconds \u2014 show everything from the store entrance to the signature menu.\nAny background music is fine; please include menu names in the captions.\nYou don't need to show it to us before posting (if you do, note it here)."
          },
          {
            type: "example",
            label: "Product review",
            text: "Please post 1 blog review (5+ photos) within 14 days of receiving the product.\nInclude before-and-after photos.\nWe\u2019d appreciate an honest review. Please leave out exaggerated claims."
          },
          {
            type: "callout",
            text: `Sponsored posts must disclose that they were compensated, such as with "Sponsored" or "Ad" (Korean labeling and advertising laws and the KFTC endorsement guidelines). Sponsorships that ask for false or exaggerated reviews, or for content legally restricted in ads (such as medical or health supplement claims), can't be posted.`
          }
        ]
      },
      {
        slug: "sponsorship-managing",
        title: "Managing applicants",
        description: "How to approve or decline applications, close recruiting, and confirm missions.",
        blocks: [
          {
            type: "h2",
            id: "received",
            text: "Received applications"
          },
          {
            type: "p",
            text: "In My page \u2192 My sponsorships \u2192 [Received applications], handle applications for all your sponsorships in one place. You can do the same from the applicant list in the sponsorship details."
          },
          {
            type: "list",
            items: [
              "Pending approval \u2014 applications you need to decide on (Confirm after approval sponsorships)",
              "Mission review \u2014 applications where the influencer submitted the mission and is waiting for your confirmation",
              "In progress \u2014 confirmed applications waiting for the visit or mission",
              "Done \u2014 applications that were completed, declined, cancelled, or auto-cancelled"
            ]
          },
          {
            type: "p",
            text: `Each applicant row shows their channel, subscriber/follower count, message, and planned visit date. If they've completed a mission on your sponsorships before, you'll also see "This sponsorship N times \xB7 Your sponsorships N times".`
          },
          {
            type: "h2",
            id: "decide",
            text: "Approve and decline"
          },
          {
            type: "list",
            items: [
              "Approving confirms the applicant right away and notifies them. Approvals can't be undone.",
              "When declining, a reason is required. The applicant sees the reason as written.",
              "Declined applicants can't apply to the same sponsorship again."
            ]
          },
          {
            type: "h2",
            id: "auto-cancel",
            text: "Applications cancelled automatically"
          },
          {
            type: "list",
            items: [
              "Applications not approved by the planned visit date are cancelled automatically the next day.",
              "Editing the sponsorship cancels all pending applications.",
              'Tapping [Close recruiting] declines all pending applications ("Recruiting has closed."). Confirmed applications stay as they are.'
            ]
          },
          {
            type: "h2",
            id: "close",
            text: "Closing and reopening recruiting"
          },
          {
            type: "p",
            text: "Once you have enough, tap [Close recruiting] in the sponsorship details. Closed sponsorships leave the list and don't accept new applications.\nTap [Reopen recruiting] to start recruiting again without review."
          },
          {
            type: "h2",
            id: "confirm-mission",
            text: "Confirming missions"
          },
          {
            type: "steps",
            items: [
              "When an influencer submits a mission, you're notified and it shows under the Mission review chip in [Received applications].",
              "Open their review and content links and check that they posted as requested.",
              "Tap [Confirm mission] to complete the mission and notify the influencer."
            ]
          },
          {
            type: "callout",
            text: "If they posted something different from your requests, ask for changes via 1:1 chat before confirming. Influencers can edit their mission until the business confirms it."
          }
        ]
      },
      {
        slug: "sponsorship-applying",
        title: "Apply to a sponsorship",
        description: "How verified influencers find sponsorships, apply, and get confirmed.",
        blocks: [
          {
            type: "h2",
            id: "before",
            text: "Before you apply"
          },
          {
            type: "p",
            text: `To view sponsorship details and apply, you need a verified social channel. One of your verified channels must meet the platform viewing threshold and that sponsorship's requirements. For how to verify, see Influencer verification.
Turn on "Only sponsorships I qualify for" in the Sponsorship tab to see only the ones you can apply to.`
          },
          {
            type: "h2",
            id: "apply",
            text: "Apply"
          },
          {
            type: "steps",
            items: [
              "Read what's offered, the description, and requests carefully in the sponsorship details. The requests are your mission.",
              "Tap [Apply] and write a message to the business (optional).",
              `For visit sponsorships, pick a planned visit date. You can choose within 180 days from today.`,
              "Confirm-on-apply sponsorships are confirmed on the spot, and confirm-after-approval sponsorships wait for the business\u2019s decision."
            ]
          },
          {
            type: "h2",
            id: "status",
            text: "Check your application status"
          },
          {
            type: "p",
            text: "In My page \u2192 Sponsorship applications, you can see them split into in progress, pending approval, and done. Tap an application to open its details and check what you submitted and the sponsorship content at the time you applied. If the business edited the sponsorship after you applied, we'll let you know."
          },
          {
            type: "list",
            items: [
              "If you're declined, you're notified with the reason. You can't reapply to a sponsorship that declined you.",
              "If the business doesn't approve by the planned visit date, your application is cancelled automatically. You can apply again."
            ]
          },
          {
            type: "h2",
            id: "cancel",
            text: "Cancel and reapply"
          },
          {
            type: "list",
            items: [
              "While pending approval or confirmed, you can cancel with [Cancel application] in the application details. You can't cancel after submitting the mission.",
              "After cancelling, auto-cancellation, or completing the mission, you can apply to the same sponsorship again. Each application is recorded as a new one."
            ]
          },
          {
            type: "callout",
            text: "If visiting or creating content becomes difficult after you're confirmed, cancel your application right away or let the business know. Not keeping a confirmed commitment may restrict your use under our operating policy."
          }
        ]
      },
      {
        slug: "sponsorship-mission",
        title: "Sponsorship verification (mission complete)",
        description: "How to verify the content you posted as requested after the experience.",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "When to verify"
          },
          {
            type: "p",
            text: `For visit sponsorships, you can verify from the planned visit date; for no-visit sponsorships, as soon as you're confirmed.
Once confirmed, the application details show "Your sponsorship is confirmed. When you finish the mission, submit it below," and the mission section opens below.`
          },
          {
            type: "h2",
            id: "how",
            text: "How to verify"
          },
          {
            type: "steps",
            items: [
              'Create content as requested and post it on social media. Be sure to mark the post as "Sponsored" or "Ad".',
              "Go to My page \u2192 Sponsorship applications and tap that application to open its details.",
              "In the mission section, write a visit review or describe the content you posted, and add the post URLs as links (up to 5, full URLs starting with https://).",
              "Tap [Submit mission] and the business is notified.",
              `When the business confirms it, it changes to "The business confirmed your mission. The sponsorship is successfully complete." and you're notified.`
            ]
          },
          {
            type: "p",
            text: "You can submit with just text or just links, but we recommend leaving both so the business can check easily."
          },
          {
            type: "h2",
            id: "example",
            text: "Verification example \u2014 SNS photo post"
          },
          {
            type: "example",
            label: "Requests",
            text: "3+ store and menu photos on Instagram feed, @business tag, #SeongsuCafe hashtag, within 7 days of the visit"
          },
          {
            type: "example",
            label: "Mission submission",
            text: 'Text: Visited on October 26. I posted 4 photos of the 2 new menu items and the interior to my feed, with the @business tag, #SeongsuCafe #NewMenu hashtags, and a location tag. I marked "Sponsored" in the first line of the post.\nLink: https://www.instagram.com/p/\u2026'
          },
          {
            type: "h2",
            id: "edit",
            text: "Editing and after completion"
          },
          {
            type: "list",
            items: [
              "Until the business confirms, you can edit the text and links with [Save changes]. If the business asks for changes, update your content and then update this too.",
              "You can't cancel your application after submitting the mission.",
              "Even after completing the mission, you can apply to the same sponsorship again."
            ]
          },
          {
            type: "callout",
            text: "Please keep your posts up for the period stated in the requests. Deleting them or making them private right after verifying may restrict your use under our operating policy."
          }
        ]
      }
    ]
  }
];

// src/common/guide-content.ja.ts
import { ACTIVE_IP_RIGHT_TYPES as ACTIVE_IP_RIGHT_TYPES2, BUSINESS as BUSINESS2 } from "@inflip/shared";
var SPECIAL_TERMS_EXAMPLES_JA = {
  NAME_BRAND: {
    label: "\u540D\u524D\uFF0F\u30D6\u30E9\u30F3\u30C9\u4F7F\u7528\u6A29",
    text: "\u4F8B\uFF09\u8868\u8A18\uFF1A'OOO' \u306E\u30CF\u30F3\u30B0\u30EB\u8868\u8A181\u7A2E\u306B\u9650\u308B\uFF08\u30ED\u30B4\u30FB\u82F1\u8A9E\u8868\u8A18\u306F\u5225\u9014\u5354\u8B70\uFF09\n\u4F8B\uFF09\u4F7F\u7528\u7B87\u6240\uFF1A\u5546\u54C1\u8A73\u7D30\u30DA\u30FC\u30B8\u30FB\u30D1\u30C3\u30B1\u30FC\u30B8\u306E\u6587\u8A00\n\u4F8B\uFF09\u4F7F\u7528\u6570\u91CF\uFF1A\u5BFE\u8C61\u5546\u54C11\u7A2E\uFF08SKU 3\u500B\u4EE5\u5185\uFF09\u3001\u5E83\u544A\u7D20\u67502\u4EF6\u4EE5\u5185\n\u4F8B\uFF09\u30D6\u30E9\u30F3\u30C9\u540D\u306E\u5546\u6A19\u51FA\u9858\u30FB\u5546\u53F7\u767B\u9332\u306F\u7981\u6B62"
  },
  FACE_PHOTO: {
    label: "\u5199\u771F\u4F7F\u7528\u6A29",
    text: "\u4F8B\uFF09\u5BFE\u8C61\uFF1A\u30C1\u30E3\u30C3\u30C8\u3067\u5408\u610F\u3057\u305F\u64AE\u5F71\u30C7\u30FC\u30BFA\u30FBB\u30FBC\u3001\u6700\u7D423\u679A\n\u4F8B\uFF09\u57FA\u672C1\u679A \u2192 3\u679A\u306B\u5909\u66F4\u3001\u8FFD\u52A02\u679A 10\u4E07\u30A6\u30A9\u30F3\uFF0F\u8A73\u7D30\u30DA\u30FC\u30B83\u304B\u6708\n\u4F8B\uFF09\u88DC\u6B63\u30FB\u30C8\u30EA\u30DF\u30F3\u30B0\u53EF\u3001\u9854\u306E\u5408\u6210\u30FBAI\u5B66\u7FD2\u3078\u306E\u5229\u7528\u306F\u7981\u6B62\n\u4F8B\uFF09\u533B\u7642\u30FB\u91D1\u878D\u306A\u3069\u5BE9\u67FB\u304C\u5FC5\u8981\u306A\u5E83\u544A\u306F\u63B2\u8F09\u524D\u306B\u78BA\u8A8D"
  },
  CONTENT_SECONDARY: {
    label: "\u52D5\u753B\u4F7F\u7528\u6A29",
    text: "\u4F8B\uFF09\u5BFE\u8C61\uFF1A\u8CFC\u5165\u8005\u304C\u30C1\u30E3\u30C3\u30C8\u3067\u6307\u5B9A\u3057\u305F\u52D5\u753B1\u672C\u300100:10\u301C00:30\u306E\u533A\u9593\n\u4F8B\uFF09\u30D6\u30E9\u30F3\u30C9\u3067\u306E\u518D\u63B2\u8F09 \u2192 \u30D6\u30E9\u30F3\u30C9\u306E\u6709\u6599\u5E83\u544A\u3092\u542B\u3080\u306B\u5909\u66F4\u3001\u8FFD\u52A0\u6599\u91D15\u4E07\u30A6\u30A9\u30F3\n\u4F8B\uFF09\u30AB\u30C3\u30C8\u7DE8\u96C6\u30FB\u5B57\u5E55\u53EF\u3001\u767A\u8A00\u306E\u8DA3\u65E8\u3092\u3086\u304C\u3081\u308B\u7DE8\u96C6\u306F\u7981\u6B62\n\u4F8B\uFF09\u7B2C\u4E09\u8005\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u518D\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306F\u7981\u6B62"
  },
  AI_VOICE: {
    label: "\u97F3\u58F0\u4F7F\u7528\u6A29",
    text: "\u4F8B\uFF09\u5BFE\u8C61\uFF1A\u5408\u610F\u3057\u305F\u97F3\u58F0\u30D5\u30A1\u30A4\u30EBA\u307E\u305F\u306F\u6700\u7D42\u30BB\u30EA\u30D5\u30011\u672C\u30FB\u5408\u8A0830\u79D2\u4EE5\u5185\n\u4F8B\uFF09\u65B0\u898F\u5236\u4F5C\uFF1A\u30BB\u30EA\u30D5\u78BA\u5B9A\u65E5\u30FB\u521D\u7A3F\u306E\u7D0D\u54C1\u65E5\u30FB\u5408\u610F\u3057\u305F\u4FEE\u6B63\u5185\u5BB9\n\u4F8B\uFF09\u4F7F\u7528\u7B87\u6240\u30FB\u7DE8\u96C6\u5185\u5BB9\u306F\u8CFC\u5165\u6761\u4EF6\u306E\u7BC4\u56F2\u5185\u3067\u78BA\u5B9A\n\u4F8B\uFF09\u8CFC\u5165\u8005\u306EAI\u751F\u6210\uFF1A\u4F7F\u7528\u3059\u308B\u58F0\u30FB\u30B5\u30FC\u30D3\u30B9\u30FB\u30A2\u30AF\u30BB\u30B9\u63D0\u4F9B\u65E5\u30FB\u751F\u6210\u3067\u304D\u308B\u671F\u9593\u30FB\u4F7F\u7528\u3067\u304D\u308B\u8A00\u8A9E\u3092\u78BA\u5B9A"
  },
  CO_BRANDING: {
    label: "\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0",
    text: "\u4F8B\uFF09\u76F8\u624B\u30D6\u30E9\u30F3\u30C9\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\uFF1A\u5408\u610F\u3057\u305F\u30D6\u30E9\u30F3\u30C9A\u3001\u79CB\u306E\u5171\u540C\u30AD\u30E3\u30F3\u30DA\u30FC\u30F31\u4EF6\n\u4F8B\uFF09\u4E21\u30D6\u30E9\u30F3\u30C9\u306E\u8868\u793A\u65B9\u6CD5\uFF1A'\u30D6\u30E9\u30F3\u30C9A \xD7 \u30D6\u30E9\u30F3\u30C9B'\u3001\u6700\u7D42\u30ED\u30B4\u914D\u7F6E\u6848 v2\n\u4F8B\uFF09\u8CFC\u5165\u3057\u305FSNS\u901A\u5E38\u6295\u7A3F\u30FB\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u4F7F\u7528\u3001\u516C\u958B\u524D\u306B\u6700\u7D42\u6587\u8A00\u30FB\u30C7\u30B6\u30A4\u30F3\u6848\u3092\u78BA\u8A8D\n\u4F8B\uFF09\u7D42\u4E86\u5F8C\u306E\u6271\u3044\u306F\u5951\u7D04\u6761\u4EF6\u306B\u5F93\u3046\u3002\u8A18\u9332\u3068\u3057\u3066\u6B8B\u3059\u5834\u5408\u306F\u7D42\u4E86\u3057\u305F\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u3067\u3042\u308B\u3053\u3068\u3092\u8868\u793A"
  },
  MERCHANDISE: {
    label: "\u30B0\u30C3\u30BA\u5236\u4F5C\u6A29",
    text: "\u4F8B\uFF09\u4F7F\u7528\u3059\u308B\u7D20\u6750\u30FB\u6700\u7D42\u30C7\u30B6\u30A4\u30F3\u6848\uFF1A\u30C1\u30E3\u30C3\u30C8\u3067\u5408\u610F\u3057\u305F\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u30D5\u30A1\u30A4\u30EB\u3068\u30AD\u30FC\u30DB\u30EB\u30C0\u30FC\u6848 v2\n\u4F8B\uFF09\u7DCF\u5236\u4F5C\u6570500\u500B\uFF1A\u8CA9\u58F2390\u500B\u30FB\u30D7\u30EC\u30BC\u30F3\u30C8100\u500B\u30FB\u627F\u8A8D\u7528\u30B5\u30F3\u30D7\u30EB10\u500B\uFF08\u975E\u58F2\u54C1\u306E\u307F\u306A\u3089\u8CA9\u58F2\u306A\u3057\uFF09\n\u4F8B\uFF09\u8CA9\u58F2\u30FB\u914D\u5E03\u5148\uFF1A\u5408\u610F\u3057\u305F\u30AA\u30F3\u30E9\u30A4\u30F3\u30B7\u30E7\u30C3\u30D7\u30FB\u30A4\u30D9\u30F3\u30C8\u3001\u91CF\u7523\u524D\u306B\u6700\u7D42\u30C7\u30B6\u30A4\u30F3\u6848\u30FB\u30B5\u30F3\u30D7\u30EB\u3092\u78BA\u8A8D\n\u4F8B\uFF09\u671F\u9593\u7D42\u4E86\u5F8C\uFF1A\u8CFC\u5165\u3057\u305F\u5728\u5EAB\u51E6\u7406\u6761\u4EF6\u306B\u5F93\u3063\u3066\u51E6\u7406\u3001\u65B0\u305F\u306A\u751F\u7523\u306F\u7981\u6B62\n\u4F8B\uFF09\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u8CA9\u58F2\u5206\u306E\u7CBE\u7B97\u57FA\u6E96\u30FB\u8A3C\u6191\u3092\u78BA\u5B9A"
  },
  COLLABORATION: {
    label: "\u30B3\u30E9\u30DC\u5546\u54C1\u6A29",
    text: "\u4F8B\uFF09\u30B3\u30E9\u30DC\u5546\u54C1\u306E\u7BC4\u56F2\uFF1AOO\u30A8\u30C7\u30A3\u30B7\u30E7\u30F31\u7A2E\n\u4F8B\uFF09\u767A\u58F2\u524D\u306B\u6700\u7D42\u30C7\u30B6\u30A4\u30F3\u3092\u76F8\u4E92\u78BA\u8A8D\n\u4F8B\uFF09\u518D\u767A\u6CE8\uFF08\u30EA\u30AA\u30FC\u30C0\u30FC\uFF09\u306F\u5225\u9014\u5354\u8B70"
  },
  APPEARANCE: {
    label: "\u51FA\u6F14\u6A29",
    text: "\u4F8B\uFF09\u51FA\u6F14\u65E5\u6642\u30FB\u5834\u6240\u307E\u305F\u306F\u53C2\u52A0\u65B9\u6CD5\uFF1A\u5408\u610F\u3057\u305F\u65E5\u4ED8\u30FB\u30BD\u30A6\u30EB\u306E\u30A4\u30D9\u30F3\u30C8\u4F1A\u5834\u307E\u305F\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u53C2\u52A0\u30EA\u30F3\u30AF\n\u4F8B\uFF09\u6D3B\u52D5\u30FB\u6642\u9593\uFF1A\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC\u3068\u5199\u771F\u64AE\u5F71\u30011\u56DE\u30FB60\u5206\u4EE5\u5185\u3001\u30EA\u30CF\u30FC\u30B5\u30EB\u3092\u542B\u3080\u304B\u3092\u78BA\u5B9A\n\u4F8B\uFF09\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u3068\u5EF6\u9577\u306E\u6709\u7121\u30FB\u8FFD\u52A0\u8CBB\u7528\u306F\u5B9F\u969B\u306B\u5408\u610F\u3057\u305F\u5185\u5BB9\u3092\u8A18\u9332\n\u4F8B\uFF09\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u7B87\u6240\u30FB\u671F\u9593\u306F\u8CFC\u5165\u6761\u4EF6\u306B\u5F93\u3044\u3001\u64AE\u5F71\u30FB\u5143\u30C7\u30FC\u30BF\u306E\u53D7\u3051\u6E21\u3057\u30FB\u7DE8\u96C6\u306E\u62C5\u5F53\u8005\u3092\u78BA\u5B9A\n\u4F8B\uFF09\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u6642\u306B\u9069\u7528\u3059\u308B\u6761\u4EF6\u3092\u78BA\u5B9A"
  }
};
var SPECIAL_TERMS_EXAMPLE_BLOCKS2 = ACTIVE_IP_RIGHT_TYPES2.map((t) => ({
  type: "example",
  ...SPECIAL_TERMS_EXAMPLES_JA[t]
}));
var GUIDE_SECTIONS_JA = [
  {
    title: "\u306F\u3058\u3081\u306B",
    pages: [
      {
        slug: "intro",
        title: "Inflip\u306B\u3064\u3044\u3066",
        description: "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u30FB\u30AF\u30EA\u30A8\u30A4\u30BF\u30FC\u306EIP\u4F7F\u7528\u6A29\u3092\u5B89\u5168\u306B\u58F2\u8CB7\u3067\u304D\u308B\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "Inflip\u306F\u3069\u3093\u306A\u30B5\u30FC\u30D3\u30B9\u3067\u3059\u304B\uFF1F"
          },
          {
            type: "p",
            text: "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u3084\u30AF\u30EA\u30A8\u30A4\u30BF\u30FC\u304C\u6301\u3064IP\uFF08\u540D\u524D\u3001\u9854\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u306A\u3069\uFF09\u306E\u4F7F\u7528\u6A29\u3092\u6761\u4EF6\u3068\u3068\u3082\u306B\u767B\u9332\u3057\u3001\u8CFC\u5165\u8005\u306F\u5FC5\u8981\u306A\u6A29\u5229\u3092\u9078\u3093\u3067\u30E9\u30A4\u30BB\u30F3\u30B9\u3068\u3057\u3066\u53D7\u3051\u53D6\u308B\u53D6\u5F15\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067\u3059\u3002\u304A\u652F\u6255\u3044\u306F\u9280\u884C\u632F\u8FBC\u3067\u884C\u3044\u3001\u3059\u3079\u3066\u306E\u6761\u4EF6\u306F\u30E9\u30A4\u30BB\u30F3\u30B9\u8A3C\u66F8\u306B\u6B8B\u308A\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "rights",
            text: "\u53D6\u5F15\u3067\u304D\u308B\u6A29\u5229"
          },
          {
            type: "list",
            items: [
              "\u540D\u524D\uFF0F\u30D6\u30E9\u30F3\u30C9\u4F7F\u7528\u6A29 \u2014 \u5546\u54C1\u30FB\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u306B\u540D\u524D\u3084\u30D6\u30E9\u30F3\u30C9\u3092\u4F7F\u7528",
              "\u5199\u771F\u4F7F\u7528\u6A29 \u2014 \u65E2\u5B58\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u5199\u771F\u30FB\u64AE\u5F71\u5199\u771F\u3092\u5408\u610F\u3057\u305F\u7BC4\u56F2\u3067\u4F7F\u7528\u3002\u65B0\u898F\u64AE\u5F71\u30FB\u5236\u4F5C\u306F\u5225\u9014\u5408\u610F",
              "\u52D5\u753B\u4F7F\u7528\u6A29 \u2014 \u65E2\u5B58\u306E\u30EA\u30FC\u30EB\u30FB\u30B7\u30E7\u30FC\u30C8\u30FBYouTube\u52D5\u753B\u3092\u5408\u610F\u3057\u305F\u7BC4\u56F2\u3067\u4F7F\u7528\u3002\u65B0\u898F\u64AE\u5F71\u30FB\u5236\u4F5C\u306F\u5225\u9014\u5408\u610F",
              "\u97F3\u58F0\u4F7F\u7528\u6A29 \u2014 \u65E2\u5B58\u306E\u97F3\u58F0\u306E\u4F7F\u7528\u3001\u65B0\u3057\u3044\u97F3\u58F0\u306E\u5236\u4F5C\u30FB\u7D0D\u54C1\u3001\u307E\u305F\u306F\u8CFC\u5165\u8005\u306B\u3088\u308BAI\u97F3\u58F0\u751F\u6210\u306E\u8A31\u53EF",
              "\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0 \u2014 \u53CC\u65B9\u306E\u30D6\u30E9\u30F3\u30C9\u3092\u6253\u3061\u51FA\u3059\u5171\u540C\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u3002\u305D\u306E\u7BC4\u56F2\u3067\u306E\u540D\u524D\u30FB\u30ED\u30B4\u306E\u4F7F\u7528\u3092\u542B\u3080",
              "\u30B0\u30C3\u30BA\u5236\u4F5C\u6A29 \u2014 \u5408\u610F\u3057\u305F\u8981\u7D20\u3067\u30B0\u30C3\u30BA\u3092\u5236\u4F5C\u3057\u3066\u8CA9\u58F2\u3001\u307E\u305F\u306F\u975E\u58F2\u54C1\u3068\u3057\u3066\u914D\u5E03",
              "\u51FA\u6F14\u6A29 \u2014 \u73FE\u5730\u8A2A\u554F\u307E\u305F\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u53C2\u52A0\uFF08\u6620\u50CF\u30FB\u97F3\u58F0\u51FA\u6F14\uFF09\u3067\u30A4\u30D9\u30F3\u30C8\u30FB\u64AE\u5F71\u306A\u3069\u306B1\u56DE\u53C2\u52A0"
            ]
          },
          {
            type: "h2",
            id: "flow",
            text: "\u53D6\u5F15\u306E\u6D41\u308C"
          },
          {
            type: "steps",
            items: [
              "\u8CFC\u5165\u8005\u304C\u5546\u54C1\u304B\u3089\u5E0C\u671B\u3059\u308B\u6A29\u5229\u3068\u6761\u4EF6\u3092\u9078\u3093\u3067\u6CE8\u6587\u3057\u307E\u3059\u3002",
              "\u6848\u5185\u3055\u308C\u305F\u53E3\u5EA7\u306B\u9280\u884C\u632F\u8FBC\u3059\u308B\u3068\u3001\u7BA1\u7406\u8005\u304C\u5165\u91D1\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002",
              "\u8CA9\u58F2\u8005\u3068\u30C1\u30E3\u30C3\u30C8\u3067\u7D30\u304B\u306A\u6761\u4EF6\u3092\u4EA4\u6E09\u3057\u3001\u8CA9\u58F2\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3057\u307E\u3059\u3002",
              "\u767A\u884C\u3068\u540C\u6642\u306B\u8CFC\u5165\u8005\u3078\u30E9\u30A4\u30BB\u30F3\u30B9\u8A3C\u66F8\u304C\u5C4A\u304D\u3001\u53D6\u5F15\u304C\u5B8C\u4E86\u3057\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: "\u6CE8\u6587\u6642\u70B9\u306E\u6761\u4EF6\uFF08\u671F\u9593\u30FB\u5730\u57DF\u30FB\u72EC\u5360\u306E\u6709\u7121\u306A\u3069\uFF09\u306F\u30B9\u30CA\u30C3\u30D7\u30B7\u30E7\u30C3\u30C8\u3068\u3057\u3066\u56FA\u5B9A\u3055\u308C\u307E\u3059\u3002\u305D\u306E\u5F8C\u306B\u8CA9\u58F2\u8005\u304C\u5546\u54C1\u3092\u4FEE\u6B63\u3057\u3066\u3082\u3001\u3059\u3067\u306B\u7DE0\u7D50\u3055\u308C\u305F\u5951\u7D04\u5185\u5BB9\u306F\u5909\u308F\u308A\u307E\u305B\u3093\u3002"
          }
        ]
      },
      {
        slug: "account",
        title: "\u4F1A\u54E1\u767B\u9332\u3068\u30ED\u30B0\u30A4\u30F3",
        description: "Google\u30FBApple\u30FBKakao\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u59CB\u3081\u3089\u308C\u307E\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "signup",
            text: "\u767B\u9332\u65B9\u6CD5"
          },
          {
            type: "p",
            text: "Google\u30FBApple\u30FBKakao\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u3044\u305A\u308C\u304B\u3067\u7C21\u5358\u306B\u59CB\u3081\u3089\u308C\u307E\u3059\u3002\u8CFC\u5165\u3082\u8CA9\u58F2\u3082\u3072\u3068\u3064\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u5229\u7528\u3057\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "withdraw",
            text: "\u9000\u4F1A"
          },
          {
            type: "p",
            text: `\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u4F1A\u54E1\u60C5\u5831\u304B\u3089\u9000\u4F1A\u3067\u304D\u307E\u3059\u3002
\u8CA9\u58F2\u4E2D\u306E\u5546\u54C1\u304C\u3042\u308B\u5834\u5408\u3084\u3001\u7CBE\u7B97\u307E\u3067\u7D42\u308F\u3063\u3066\u3044\u306A\u3044\u53D6\u5F15\uFF08\u8CFC\u5165\u30FB\u8CA9\u58F2\u3069\u3061\u3089\u3082\uFF09\u304C\u3042\u308B\u5834\u5408\u306F\u9000\u4F1A\u3067\u304D\u307E\u305B\u3093\u3002
\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u306F\u3001\u5951\u7D04\u671F\u9593\u304C\u7D42\u308F\u308A\u6700\u7D42\u6708\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u307E\u3067\u652F\u6255\u308F\u308C\u308B\u3068\u3001\u8CFC\u5165\u8005\u30FB\u8CA9\u58F2\u8005\u3068\u3082\u306B\u9000\u4F1A\u3067\u304D\u307E\u3059\u3002
\u4FDD\u6709\u3057\u3066\u3044\u308B\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u9000\u4F1A\u5F8C\u306B\u78BA\u8A8D\u3067\u304D\u306A\u304F\u306A\u308B\u305F\u3081\u3001\u5FC5\u8981\u306A\u8A3C\u66F8\u306F\u4E8B\u524D\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002
\u53D6\u5F15\u30FB\u7CBE\u7B97\u306E\u8A18\u9332\u3068\u30E9\u30A4\u30BB\u30F3\u30B9\u8A3C\u66F8\u306F\u6700\u5927${BUSINESS2.TRADE_RECORD_RETENTION_YEARS}\u5E74\u9593\u4FDD\u7BA1\u3057\u305F\u5F8C\u306B\u7834\u68C4\u3055\u308C\u307E\u3059\u3002`
          }
        ]
      },
      {
        slug: "influencer-verification",
        title: "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u8A8D\u8A3C",
        description: "SNS\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u8A8D\u8A3C\u3057\u3066\u3001\u6848\u4EF6\u30FB\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3092\u5229\u7528\u3067\u304D\u307E\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "why",
            text: "\u8A8D\u8A3C\u3059\u308B\u3068\u3067\u304D\u308B\u3053\u3068"
          },
          {
            type: "p",
            text: "SNS\u30C1\u30E3\u30F3\u30CD\u30EB\u3068\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u3092\u8A8D\u8A3C\u3059\u308B\u3068\u3001\u8A8D\u8A3C\u6E08\u307F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u3068\u3057\u3066\u6D3B\u52D5\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "list",
            items: [
              "\u6848\u4EF6 \u2014 \u95B2\u89A7\u57FA\u6E96\u3092\u8D85\u3048\u308B\u30C1\u30E3\u30F3\u30CD\u30EB\u304C\u3042\u308C\u3070\u3001\u6848\u4EF6\u306E\u8A73\u7D30\u3092\u898B\u3066\u5FDC\u52DF\u3067\u304D\u307E\u3059\u3002",
              "\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3 \u2014 \u8A8D\u8A3C\u30C1\u30E3\u30F3\u30CD\u30EB\u304C\u3042\u308B\u3068\u6295\u7A3F\u30FB\u30B3\u30E1\u30F3\u30C8\u3092\u66F8\u3051\u307E\u3059\u3002",
              "\u30D0\u30C3\u30B8 \u2014 \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u6295\u7A3F\u30FB\u30B3\u30E1\u30F3\u30C8\u306B\u3001\u8A8D\u8A3C\u3057\u305F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3068\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u306E\u533A\u5206\uFF08\u4F8B\uFF1A2\u4E07+\uFF09\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
              "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB \u2014 \u516C\u958B\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306ESNS\u30EA\u30F3\u30AF\u304C\u8A8D\u8A3C\u3057\u305F\u30C1\u30E3\u30F3\u30CD\u30EB\u306EURL\u306B\u5909\u308F\u308A\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: "\u6848\u4EF6\u306E\u95B2\u89A7\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3078\u306E\u6295\u7A3F\u3001\u30D0\u30C3\u30B8\u533A\u5206\u306E\u57FA\u6E96\u5024\u306F\u904B\u55B6\u30DD\u30EA\u30B7\u30FC\u306B\u3088\u308A\u5909\u308F\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u6848\u4EF6\u306E\u95B2\u89A7\u57FA\u6E96\u306F\u3001\u57FA\u6E96\u306B\u5C4A\u304B\u306A\u304B\u3063\u305F\u3068\u304D\u306B\u6848\u4EF6\u753B\u9762\u306E\u6848\u5185\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "where",
            text: "\u8A8D\u8A3C\u3059\u308B\u5834\u6240"
          },
          {
            type: "p",
            text: "\u4F1A\u54E1\u767B\u9332\u306E\u9014\u4E2D\u3067\u3059\u3050\u306B\u8A8D\u8A3C\u3059\u308B\u304B\u3001\u767B\u9332\u5F8C\u306B\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u8A8D\u8A3C\u304B\u3089\u3044\u3064\u3067\u3082\u8A8D\u8A3C\u3067\u304D\u307E\u3059\u3002\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3054\u3068\u306B\u30C1\u30E3\u30F3\u30CD\u30EB\u30921\u3064\u305A\u3064\u8A8D\u8A3C\u3057\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "oauth",
            text: "\u30A2\u30AB\u30A6\u30F3\u30C8\u9023\u643A\u3067\u8A8D\u8A3C \u2014 YouTube\u30FBInstagram\u30FBTikTok"
          },
          {
            type: "steps",
            items: [
              "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u8A8D\u8A3C\u753B\u9762\u3067\u3001\u8A8D\u8A3C\u3059\u308B\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002",
              "\u958B\u3044\u305F\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u305D\u306E\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30ED\u30B0\u30A4\u30F3\u3057\u3001\u60C5\u5831\u63D0\u4F9B\u306B\u540C\u610F\u3057\u307E\u3059\u3002",
              "\u8A8D\u8A3C\u304C\u7D42\u308F\u308B\u3068\u3001\u30C1\u30E3\u30F3\u30CD\u30EB\u3068\u305D\u306E\u6642\u70B9\u306E\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u304C\u3059\u3050\u306B\u8A18\u9332\u3055\u308C\u307E\u3059\u3002"
            ]
          },
          {
            type: "p",
            text: "\u30ED\u30B0\u30A4\u30F3\u30A6\u30A3\u30F3\u30C9\u30A6\u306F10\u5206\u4EE5\u5185\u306B\u5B8C\u4E86\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002Inflip\u306F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E\u30ED\u30B0\u30A4\u30F3\u60C5\u5831\u3092\u4FDD\u5B58\u305B\u305A\u3001\u8A8D\u8A3C\u3057\u305F\u6642\u70B9\u306E\u6570\u5024\u3060\u3051\u3092\u8A18\u9332\u3057\u307E\u3059\u3002\u6570\u5024\u304C\u5897\u3048\u305F\u3089\u3001\u518D\u5EA6\u8A8D\u8A3C\u3057\u3066\u65B0\u3057\u3044\u6570\u5024\u306B\u66F4\u65B0\u3067\u304D\u307E\u3059\u3002\n\u30A2\u30AB\u30A6\u30F3\u30C8\u9023\u643A\u306B\u3088\u308B\u8A8D\u8A3C\u306F\u81EA\u5206\u3067\u89E3\u9664\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "manual",
            text: "URL\u3067\u8A8D\u8A3C\u3092\u30EA\u30AF\u30A8\u30B9\u30C8 \u2014 Threads\u30FBSOOP\u30FBPandaTV"
          },
          {
            type: "p",
            text: "\u30A2\u30AB\u30A6\u30F3\u30C8\u9023\u643A\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u306A\u3044\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306F\u3001\u30C1\u30E3\u30F3\u30CD\u30EBURL\u3092\u9001\u308B\u3068\u904B\u55B6\u8005\u304C\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u76F4\u63A5\u78BA\u8A8D\u3057\u3066\u8A8D\u8A3C\u3057\u307E\u3059\u3002"
          },
          {
            type: "steps",
            items: [
              "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u8A8D\u8A3C\u753B\u9762\u3067\u30C1\u30E3\u30F3\u30CD\u30EBURL\u3092\u5165\u529B\u3057\u3001\u8A8D\u8A3C\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002",
              "\u904B\u55B6\u8005\u304C\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u78BA\u8A8D\u3057\u3001\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u3068\u3068\u3082\u306B\u8A8D\u8A3C\u3057\u307E\u3059\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u767B\u9332\u3055\u308C\u305F\u9023\u7D61\u5148\u306B\u3054\u9023\u7D61\u3057\u307E\u3059\u3002",
              "\u7D50\u679C\u306F\u901A\u77E5\u3067\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002\u5374\u4E0B\u3055\u308C\u305F\u5834\u5408\u306F\u7406\u7531\u3092\u78BA\u8A8D\u3057\u3066\u518D\u5EA6\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "list",
            items: [
              "\u9023\u7D61\u5148\u3092\u767B\u9332\u3057\u305F\u4F1A\u54E1\u306E\u307F\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u304D\u307E\u3059\u3002\u9023\u7D61\u5148\u304C\u306A\u3044\u5834\u5408\u306F\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u6642\u306B\u305D\u306E\u5834\u3067\u767B\u9332\u3067\u304D\u307E\u3059\u3002",
              "\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EBURL\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
              "\u77ED\u7E2EURL\u3001\u30EA\u30F3\u30AF\u307E\u3068\u3081\u3001\u4ED6\u306ESNS\u306EURL\u3067\u306F\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u304D\u307E\u305B\u3093\u3002",
              "URL\u3067\u8A8D\u8A3C\u3057\u305F\u30C1\u30E3\u30F3\u30CD\u30EB\u306F\u81EA\u5206\u3067\u89E3\u9664\u3067\u304D\u307E\u305B\u3093\u3002\u89E3\u9664\u304C\u5FC5\u8981\u306A\u5834\u5408\u306F\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"
            ]
          },
          {
            type: "h2",
            id: "one-account",
            text: "1\u3064\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u306F1\u3064\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3060\u3051"
          },
          {
            type: "p",
            text: "\u540C\u3058\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u8907\u6570\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u8A8D\u8A3C\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\n\u3059\u3067\u306B\u5225\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u9023\u643A\u3055\u308C\u3066\u3044\u308B\u30C1\u30E3\u30F3\u30CD\u30EB\u306F\u3001\u305D\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u9023\u643A\u3092\u89E3\u9664\u3057\u3066\u304B\u3089\u518D\u5EA6\u8A8D\u8A3C\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9000\u4F1A\u3057\u305F\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u8A8D\u8A3C\u30C1\u30E3\u30F3\u30CD\u30EB\u306F\u3001\u9000\u4F1A\u6642\u306B\u4E00\u7DD2\u306B\u524A\u9664\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "callout",
            text: "\u4ED6\u4EBA\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u3067\u8A8D\u8A3C\u3057\u305F\u3053\u3068\u304C\u78BA\u8A8D\u3055\u308C\u305F\u5834\u5408\u3001\u904B\u55B6\u8005\u304C\u8A8D\u8A3C\u3092\u89E3\u9664\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002"
          }
        ]
      }
    ]
  },
  {
    title: "\u8CFC\u5165\u8005\u30AC\u30A4\u30C9",
    pages: [
      {
        slug: "buying",
        title: "IP\u3092\u63A2\u3057\u3066\u6CE8\u6587\u3059\u308B",
        description: "\u6A29\u5229\u3054\u3068\u306E\u6761\u4EF6\u3092\u78BA\u8A8D\u3057\u3066\u6CE8\u6587\u3059\u308B\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "explore",
            text: "IP\u3092\u63A2\u3059"
          },
          {
            type: "p",
            text: "\u4E0A\u90E8\u306E\u300CIP\u3092\u63A2\u3059\u300D\u304B\u3089\u3001\u30AB\u30C6\u30B4\u30EA\u30FC\u30FB\u691C\u7D22\u3067\u5E0C\u671B\u306EIP\u3092\u63A2\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002\u8CA9\u58F2\u8005\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3067\u306F\u3001\u305D\u306E\u8CA9\u58F2\u8005\u306E\u4ED6\u306E\u5546\u54C1\u3082\u898B\u3089\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "offer",
            text: "\u6761\u4EF6\u306E\u898B\u65B9"
          },
          {
            type: "p",
            text: "\u5546\u54C1\u306B\u306F\u8CA9\u58F2\u3059\u308B\u6A29\u5229\u3054\u3068\u306B\u6761\u4EF6\u304C1\u3064\u305A\u3064\u3042\u308A\u3001\u540C\u3058\u6A29\u5229\u306E\u4E2D\u3067\u3082\u671F\u9593\u30FB\u30AA\u30D7\u30B7\u30E7\u30F3\u306B\u3088\u3063\u3066\u4FA1\u683C\u304C\u5909\u308F\u308A\u307E\u3059\u3002\n\u6CE8\u6587\u524D\u306B\u4EE5\u4E0B\u306E\u6761\u4EF6\u3092\u5FC5\u305A\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "list",
            items: [
              "\u4F7F\u7528\u671F\u9593 \u2014 1\u30FB3\u30FB6\u30FB12\u304B\u6708\uFF08\u51FA\u6F14\u6A29\u306A\u30691\u56DE\u9650\u308A\u306E\u6A29\u5229\u306F\u671F\u9593\u306A\u3057\uFF09",
              "\u4F7F\u7528\u5730\u57DF \u2014 \u56FD\u5185\uFF08\u97D3\u56FD\uFF09\u9650\u5B9A\u307E\u305F\u306F\u30B0\u30ED\u30FC\u30D0\u30EB",
              "\u72EC\u5360\u306E\u6709\u7121 \u2014 \u975E\u72EC\u5360\uFF0F\u30AB\u30C6\u30B4\u30EA\u30FC\u72EC\u5360\uFF0F\u5B8C\u5168\u72EC\u5360",
              "\u4FEE\u6B63\u306E\u8A31\u5BB9\u7BC4\u56F2 \u2014 \u30C8\u30EA\u30DF\u30F3\u30B0\u30FB\u8272\u5909\u66F4\u306E\u53EF\u5426\u3001AI\u306B\u3088\u308B\u4FEE\u6B63\u306E\u7981\u6B62\u306A\u3069",
              "\u7981\u6B62\u696D\u7A2E \u2014 \u30AE\u30E3\u30F3\u30D6\u30EB\u30FB\u6210\u4EBA\u30FB\u653F\u6CBB\u30FB\u533B\u7642\u30FB\u6295\u8CC7\u30FB\u9152\u985E\u306A\u3069\u4F7F\u7528\u3067\u304D\u306A\u3044\u5206\u91CE",
              "\u4FA1\u683C\u65B9\u5F0F \u2014 \u56FA\u5B9A\u4FA1\u683C\uFF0F\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\uFF0F\u56FA\u5B9A\u4FA1\u683C\uFF0B\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3"
            ]
          },
          {
            type: "h2",
            id: "order",
            text: "\u6CE8\u6587\u3059\u308B"
          },
          {
            type: "p",
            text: "\u6A29\u5229\u3068\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u3093\u3067\u6CE8\u6587\u3059\u308B\u3068\u3001\u305D\u306E\u6642\u70B9\u306E\u6761\u4EF6\u304C\u5951\u7D04\u5185\u5BB9\u3068\u3057\u3066\u56FA\u5B9A\u3055\u308C\u307E\u3059\u3002\n\u5546\u54C1\u753B\u9762\u306E\u300C\u4EA4\u6E09\u3067\u9032\u3081\u308B\u6A29\u5229\u300D\uFF08\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u65B9\u5F0F\u3001\u307E\u305F\u306F\u4FA1\u683C\u4EA4\u6E09\u3068\u8868\u793A\u3055\u308C\u305F\u6A29\u5229\uFF09\u306F\u3001\u3059\u3050\u306B\u6CE8\u6587\u3059\u308B\u4EE3\u308F\u308A\u306B\u4EA4\u6E09\u306E\u63D0\u6848\u3092\u9001\u3063\u3066\u671F\u9593\u30FB\u91D1\u984D\u30FB\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u7387\u30FB\u652F\u6255\u65E5\u3092\u63D0\u6848\u3057\u3001\u8CA9\u58F2\u8005\u3068\u3084\u308A\u53D6\u308A\u3057\u306A\u304C\u3089\u6C7A\u3081\u307E\u3059\u3002\u305D\u308C\u4EE5\u5916\u306E\u6761\u4EF6\u306F\u63D0\u6848\u3067\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002\u3069\u3061\u3089\u304C\u76F8\u624B\u306E\u63D0\u6848\u3092\u627F\u8AFE\u3057\u3066\u3082\u3001\u305D\u306E\u6761\u4EF6\u3067\u6CE8\u6587\u304C\u4F5C\u6210\u3055\u308C\u307E\u3059\u3002\n\u63D0\u6848\u3092\u9001\u3063\u305F\u5F8C\u3001\u76F8\u624B\u304C\u5FDC\u7B54\u3059\u308B\u524D\u3067\u3042\u308C\u3070\u81EA\u5206\u306E\u63D0\u6848\u3092\u4FEE\u6B63\u30FB\u53D6\u308A\u6D88\u3057\u3067\u304D\u307E\u3059\u3002\u53D7\u3051\u53D6\u3063\u305F\u63D0\u6848\u306F\u62D2\u5426\u3067\u304D\u3001\u3069\u3061\u3089\u306E\u5834\u5408\u3082\u305D\u306E\u6642\u70B9\u3067\u4EA4\u6E09\u304C\u7D42\u308F\u308A\u307E\u3059\u3002\u63D0\u6848\u304B\u3089{{proposalExpiryDays}}\u65E5\u4EE5\u5185\u306B\u76F8\u624B\u304C\u5FDC\u7B54\u3057\u306A\u3044\u3068\u3001\u4EA4\u6E09\u306F\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "payment",
        title: "\u9280\u884C\u632F\u8FBC\u3067\u306E\u304A\u652F\u6255\u3044",
        description: "\u6CE8\u6587\u5F8C\u306B\u6848\u5185\u53E3\u5EA7\u3078\u632F\u308A\u8FBC\u3080\u3068\u3001\u7BA1\u7406\u8005\u304C\u78BA\u8A8D\u3057\u307E\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "how",
            text: "\u632F\u8FBC\u65B9\u6CD5"
          },
          {
            type: "p",
            text: "\u6CE8\u6587\u3092\u5B8C\u4E86\u3059\u308B\u3068\u3001\u632F\u8FBC\u5148\u53E3\u5EA7\u30FB\u91D1\u984D\u30FB\u632F\u8FBC\u540D\u7FA9\u304C\u6848\u5185\u3055\u308C\u307E\u3059\u3002\u6848\u5185\u3055\u308C\u305F\u91D1\u984D\u3092\u6B63\u78BA\u306B\u3001\u6848\u5185\u3055\u308C\u305F\u632F\u8FBC\u540D\u7FA9\u3067\u632F\u308A\u8FBC\u3093\u3067\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "h2",
            id: "deadline",
            text: "\u5165\u91D1\u671F\u9650"
          },
          {
            type: "p",
            text: "\u6CE8\u6587\u5F8C{{depositDueHours}}\u6642\u9593\u4EE5\u5185\u306B\u5165\u91D1\u304C\u78BA\u8A8D\u3067\u304D\u306A\u3044\u5834\u5408\u3001\u6CE8\u6587\u306F\u81EA\u52D5\u7684\u306B\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3059\u3002\u671F\u9650\u5207\u308C\u3067\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u305F\u5834\u5408\u306F\u3001\u3082\u3046\u4E00\u5EA6\u6CE8\u6587\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "h2",
            id: "bundle",
            text: "\u8907\u6570\u306E\u6A29\u5229\u3092\u307E\u3068\u3081\u3066\u652F\u6255\u3046\u5834\u5408"
          },
          {
            type: "p",
            text: "1\u3064\u306E\u5546\u54C1\u304B\u3089\u8907\u6570\u306E\u6A29\u5229\u3092\u307E\u3068\u3081\u3066\u6CE8\u6587\u3059\u308B\u3068\u3001\u5165\u91D1\u6848\u5185\u306F1\u4EF6\u306B\u307E\u3068\u307E\u308A\u307E\u3059\u3002\u5408\u8A08\u91D1\u984D\u3092\u4E00\u5EA6\u632F\u308A\u8FBC\u3081\u3070\u3001\u307E\u3068\u3081\u3066\u6CE8\u6587\u3057\u305F\u6A29\u5229\u3059\u3079\u3066\u306E\u5165\u91D1\u304C\u4E00\u7DD2\u306B\u78BA\u8A8D\u3055\u308C\u307E\u3059\u3002\n\u5951\u7D04\u306F\u6A29\u5229\u3054\u3068\u306B\u5225\u3005\u306B\u4F5C\u6210\u3055\u308C\u308B\u305F\u3081\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u30FB\u8CFC\u5165\u78BA\u5B9A\u30FB\u8FD4\u91D1\u306F\u6A29\u5229\u3054\u3068\u306B\u9032\u307F\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "addon",
            text: "\u8FFD\u52A0\u6599\u91D1\u306E\u5165\u91D1"
          },
          {
            type: "p",
            text: "\u5165\u91D1\u78BA\u8A8D\u5F8C\u3001\u767A\u884C\u524D\u306B\u4EA4\u6E09\u3067\u91D1\u984D\u304C\u5897\u3048\u305F\u5834\u5408\u3001\u8CA9\u58F2\u8005\u306F\u540C\u3058\u6CE8\u6587\u306B\u8FFD\u52A0\u6599\u91D1\u3092\u8ACB\u6C42\u3067\u304D\u307E\u3059\u3002\u8ACB\u6C42\u304C\u5C4A\u304F\u3068\u3001\u901A\u77E5\u3068\u6CE8\u6587\u8A73\u7D30\u306B\u5165\u91D1\u6848\u5185\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\n\u8FFD\u52A0\u6599\u91D1\u306F\u8ACB\u6C42\u304B\u3089{{addonDepositDueHours}}\u6642\u9593\u4EE5\u5185\u306B\u632F\u308A\u8FBC\u3093\u3067\u304F\u3060\u3055\u3044\u3002\u671F\u9650\u304C\u904E\u304E\u308B\u3068\u8FFD\u52A0\u6599\u91D1\u306E\u8ACB\u6C42\u306E\u307F\u304C\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u3001\u6CE8\u6587\u306F\u305D\u306E\u307E\u307E\u7DAD\u6301\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "confirm",
            text: "\u5165\u91D1\u78BA\u8A8D"
          },
          {
            type: "p",
            text: "\u7BA1\u7406\u8005\u304C\u5165\u91D1\u3092\u78BA\u8A8D\u3059\u308B\u3068\u3001\u6CE8\u6587\u304C\u6C7A\u6E08\u5B8C\u4E86\u306B\u306A\u308A\u901A\u77E5\u3092\u304A\u9001\u308A\u3057\u307E\u3059\u3002\u305D\u306E\u5F8C\u3001\u8CA9\u58F2\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u767A\u884C\u3092\u9032\u3081\u3089\u308C\u307E\u3059\u3002"
          },
          {
            type: "callout",
            text: "\u632F\u8FBC\u4EBA\u306E\u540D\u524D\u304C\u632F\u8FBC\u540D\u7FA9\u3068\u7570\u306A\u308B\u3068\u3001\u78BA\u8A8D\u304C\u9045\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\n\u5225\u306E\u540D\u524D\u3067\u632F\u308A\u8FBC\u3080\u4E88\u5B9A\u306E\u5834\u5408\u306F\u3001\u632F\u8FBC\u524D\u306B\u5165\u91D1\u6848\u5185\u306E\u632F\u8FBC\u540D\u7FA9\u306E\u6A2A\u306B\u3042\u308B\u5909\u66F4\u30DC\u30BF\u30F3\u3067\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u3059\u3067\u306B\u5225\u306E\u540D\u524D\u3067\u632F\u308A\u8FBC\u3093\u3060\u5834\u5408\u306F\u3001\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u306B\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "h2",
            id: "wrong-amount",
            text: "\u91D1\u984D\u3092\u9593\u9055\u3048\u3066\u632F\u308A\u8FBC\u3093\u3060\u3068\u304D"
          },
          {
            type: "list",
            items: [
              "\u591A\u304F\u632F\u308A\u8FBC\u3093\u3060\u5834\u5408\uFF1A\u6CE8\u6587\u91D1\u984D\u5206\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u3001\u8D85\u904E\u3057\u305F\u91D1\u984D\u306F\u7BA1\u7406\u8005\u304C\u8FD4\u91D1\u3057\u307E\u3059\u3002",
              "\u4E0D\u8DB3\u3057\u3066\u3044\u305F\u5834\u5408\uFF1A\u5165\u91D1\u306F\u78BA\u8A8D\u3055\u308C\u307E\u305B\u3093\u3002\u53D7\u3051\u53D6\u3063\u305F\u91D1\u984D\u3092\u8FD4\u91D1\u3057\u6CE8\u6587\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u308B\u305F\u3081\u3001\u8FD4\u91D1\u3092\u53D7\u3051\u305F\u5F8C\u306B\u6B63\u78BA\u306A\u91D1\u984D\u3067\u518D\u5EA6\u6CE8\u6587\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8FFD\u52A0\u6599\u91D1\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u305F\u5834\u5408\u306F\u3001\u53D7\u3051\u53D6\u3063\u305F\u91D1\u984D\u306E\u307F\u3092\u8FD4\u91D1\u3057\u3001\u8FFD\u52A0\u6599\u91D1\u306E\u8ACB\u6C42\u306F\u305D\u306E\u307E\u307E\u6B8B\u308A\u307E\u3059\u3002",
              "\u8FD4\u91D1\u306E\u969B\u306F\u3001\u53D7\u53D6\u53E3\u5EA7\u3092\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u306B\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002\u8FD4\u91D1\u4E88\u5B9A\u306E\u91D1\u984D\u3068\u7406\u7531\u3001\u632F\u8FBC\u5B8C\u4E86\u306E\u6709\u7121\u306F\u6CE8\u6587\u8A73\u7D30\u3068\u901A\u77E5\u3067\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "late",
            text: "\u671F\u9650\u5F8C\u306B\u632F\u308A\u8FBC\u3093\u3060\u3068\u304D"
          },
          {
            type: "p",
            text: "\u5165\u91D1\u671F\u9650\u304C\u904E\u304E\u3066\u6CE8\u6587\u304C\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u305F\u5F8C\u306B\u632F\u308A\u8FBC\u3093\u3060\u5834\u5408\u306F\u3001\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u306B\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002\u305D\u306E\u6A29\u5229\u3092\u307E\u3060\u540C\u3058\u6761\u4EF6\u3067\u8CFC\u5165\u3067\u304D\u308B\u5834\u5408\u306F\u3001\u7BA1\u7406\u8005\u304C\u6CE8\u6587\u3092\u5FA9\u5143\u3057\u3066\u5165\u91D1\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002\n\u305D\u306E\u9593\u306B\u8CA9\u58F2\u304C\u505C\u6B62\u3055\u308C\u305F\u3001\u4ED6\u306E\u8CFC\u5165\u8005\u304C\u5B8C\u5168\u72EC\u5360\u3067\u5951\u7D04\u3057\u305F\u306A\u3069\u306E\u7406\u7531\u3067\u8CFC\u5165\u3067\u304D\u306A\u304F\u306A\u3063\u305F\u5834\u5408\u306F\u3001\u53D7\u3051\u53D6\u3063\u305F\u91D1\u984D\u3092\u8FD4\u91D1\u3057\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "license",
        title: "\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u78BA\u8A8D\u3059\u308B",
        description: "\u767A\u884C\u3055\u308C\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u3068\u8A3C\u66F8\u3092\u78BA\u8A8D\u3059\u308B\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "issue",
            text: "\u767A\u884C\u306E\u6D41\u308C"
          },
          {
            type: "p",
            text: "\u6C7A\u6E08\u304C\u5B8C\u4E86\u3059\u308B\u3068\u3001\u8CA9\u58F2\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3057\u307E\u3059\u3002\u767A\u884C\u524D\u306F\u3001\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u4E0A\u90E8\u306E\u300C\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u300D\u30AB\u30FC\u30C9\u3067\u4F7F\u7528\u958B\u59CB\u65E5\u3068\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u3092\u4E8B\u524D\u306B\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "cert",
            text: "\u30E9\u30A4\u30BB\u30F3\u30B9\u8A3C\u66F8"
          },
          {
            type: "p",
            text: "\u767A\u884C\u3055\u308C\u308B\u3068\u3001\u6A29\u5229\u306E\u5185\u5BB9\u3001\u4F7F\u7528\u6761\u4EF6\u3001\u6709\u52B9\u671F\u9593\u3001\u8CA9\u58F2\u8005\u3068\u5408\u610F\u3057\u305F\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u304C\u8A18\u8F09\u3055\u308C\u305F\u8A3C\u66F8\u304C\u4F5C\u6210\u3055\u308C\u307E\u3059\u3002\n\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u30E9\u30A4\u30BB\u30F3\u30B9\u3067\u53D7\u3051\u53D6\u3063\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u307E\u3068\u3081\u3066\u78BA\u8A8D\u3057\u3001PDF\u8A3C\u66F8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u30BF\u30C3\u30D7\u3059\u308B\u3068\u3001\u305D\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u53D7\u3051\u53D6\u3063\u305F\u53D6\u5F15\u306E\u8A73\u7D30\u753B\u9762\u304C\u958B\u304D\u307E\u3059\u3002\n\u8CA9\u58F2\u8005\u3082\u540C\u3058\u753B\u9762\u306E\u300C\u767A\u884C\u3057\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u300D\u30BF\u30D6\u3068\u8CA9\u58F2\u6CE8\u6587\u306E\u8A73\u7D30\u304B\u3089\u540C\u3058\u8A3C\u66F8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "download",
            text: "\u8A3C\u66F8\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"
          },
          {
            type: "p",
            text: "\u6CE8\u6587\u8A73\u7D30\u307E\u305F\u306F\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u30E9\u30A4\u30BB\u30F3\u30B9\u306EPDF\u8A3C\u66F8\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068\u3001\u3044\u3064\u3067\u3082\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002\u62BC\u3059\u305F\u3073\u306B\u305D\u306E\u6642\u70B9\u306E\u72B6\u614B\u3067\u65B0\u3057\u304F\u4F5C\u6210\u3055\u308C\u307E\u3059\u3002\n\u671F\u9593\u304C\u7D42\u4E86\u3057\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u8A3C\u66F8\u306B\u306F\u671F\u9650\u5207\u308C\u306E\u8868\u793A\u304C\u3001\u5951\u7D04\u89E3\u9664\u3055\u308C\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u306F\u89E3\u9664\u306E\u8868\u793A\u304C\u4ED8\u304D\u307E\u3059\u3002\u56DE\u53CE\u3055\u308C\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u8A3C\u66F8\u3092\u53D7\u3051\u53D6\u308C\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "repurchase",
            text: "\u540C\u3058IP\u3092\u3082\u3046\u4E00\u5EA6\u8CFC\u5165\u3059\u308B"
          },
          {
            type: "p",
            text: "\u3059\u3067\u306B\u4FDD\u6709\u4E2D\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u3042\u3063\u3066\u3082\u3001\u671F\u9593\u306E\u5EF6\u9577\u3084\u8FFD\u52A0\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u305F\u3081\u306B\u540C\u3058\u6A29\u5229\u3092\u3082\u3046\u4E00\u5EA6\u8CFC\u5165\u3067\u304D\u307E\u3059\u3002\n\u305F\u3060\u3057\u3001\u540C\u3058\u6A29\u5229\u306B\u5165\u91D1\u5F85\u3061\u30FB\u6C7A\u6E08\u5B8C\u4E86\u306E\u6CE8\u6587\u304C\u6B8B\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u305D\u306E\u6CE8\u6587\u304C\u7D42\u308F\u3063\u3066\u304B\u3089\u518D\u5EA6\u8CFC\u5165\u3067\u304D\u307E\u3059\u3002\n\u4ED6\u306E\u8CFC\u5165\u8005\u304C\u305D\u306E\u6A29\u5229\u3092\u5B8C\u5168\u72EC\u5360\u3067\u5951\u7D04\u3057\u3066\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3069\u306E\u6761\u4EF6\u3067\u3082\u8CFC\u5165\u3067\u304D\u305A\u3001\u4ED6\u306E\u8CFC\u5165\u8005\u304C\u4F7F\u7528\u4E2D\u306E\u6A29\u5229\u306F\u5B8C\u5168\u72EC\u5360\u3067\u8CFC\u5165\u3067\u304D\u307E\u305B\u3093\u3002"
          }
        ]
      },
      {
        slug: "refund",
        title: "\u8FD4\u91D1\u3068\u7D1B\u4E89",
        description: "\u8FD4\u91D1\u7533\u8ACB\u306E\u624B\u9806\u3068\u7D1B\u4E89\u51E6\u7406\u306E\u57FA\u6E96\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "request",
            text: "\u8FD4\u91D1\u7533\u8ACB"
          },
          {
            type: "p",
            text: "\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u305F\u5F8C\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u308B\u524D\uFF08\u6C7A\u6E08\u5B8C\u4E86\uFF09\u3067\u3042\u308C\u3070\u3001\u6CE8\u6587\u8A73\u7D30\u306E\u8FD4\u91D1\u7533\u8ACB\u30DC\u30BF\u30F3\u3067\u6C7A\u6E08\u91D1\u984D\u306E\u5168\u984D\u8FD4\u91D1\u3092\u7533\u8ACB\u3067\u304D\u307E\u3059\u3002\n\u5165\u91D1\u78BA\u8A8D\u524D\u306E\u5834\u5408\u306F\u3001\u8FD4\u91D1\u3067\u306F\u306A\u304F\u6CE8\u6587\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\n\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u305F\u5F8C\u306F\u3001\u8FD4\u91D1\u7533\u8ACB\u3067\u306F\u306A\u304F\u7D1B\u4E89\u3092\u7533\u3057\u7ACB\u3066\u3066\u304F\u3060\u3055\u3044\u3002\n\u9280\u884C\u632F\u8FBC\u306E\u6CE8\u6587\u306F\u8FD4\u91D1\u5148\u306E\u53E3\u5EA7\u60C5\u5831\u304C\u5FC5\u9808\u3067\u3001\u9032\u884C\u4E2D\u306E\u8FD4\u91D1\u7533\u8ACB\u304C\u3042\u308B\u5834\u5408\u306F\u65B0\u305F\u306B\u7533\u8ACB\u3067\u304D\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "partial",
            text: "\u4E00\u90E8\u8FD4\u91D1"
          },
          {
            type: "p",
            text: "\u8CFC\u5165\u8005\u304C\u81EA\u5206\u3067\u7533\u8ACB\u3059\u308B\u8FD4\u91D1\u306F\u5E38\u306B\u5168\u984D\u3067\u3059\u3002\u91D1\u984D\u306E\u4E00\u90E8\u3060\u3051\u3092\u8FD4\u91D1\u3059\u308B\u4E00\u90E8\u8FD4\u91D1\u306F\u3001\u7BA1\u7406\u8005\u304C\u7D1B\u4E89\u306A\u3069\u306E\u72B6\u6CC1\u3092\u78BA\u8A8D\u3057\u3066\u884C\u3044\u307E\u3059\u3002\n\u8FD4\u91D1\u306E\u5408\u8A08\u306F\u652F\u6255\u3063\u305F\u91D1\u984D\uFF08\u78BA\u8A8D\u6E08\u307F\u306E\u8FFD\u52A0\u6599\u91D1\u3092\u542B\u3080\uFF09\u3092\u8D85\u3048\u3089\u308C\u307E\u305B\u3093\u3002\n\u8CA9\u58F2\u8005\u306B\u3059\u3067\u306B\u7CBE\u7B97\u91D1\u304C\u652F\u6255\u308F\u308C\u305F\u53D6\u5F15\u306F\u3001\u8CA9\u58F2\u8005\u304B\u3089\u7CBE\u7B97\u91D1\u3092\u56DE\u53CE\u3057\u305F\u5F8C\u306B\u8FD4\u91D1\u304C\u632F\u308A\u8FBC\u307E\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "full",
            text: "\u5168\u984D\u8FD4\u91D1\u6642\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6271\u3044"
          },
          {
            type: "p",
            text: "\u5168\u984D\u8FD4\u91D1\u304C\u5B8C\u4E86\u3059\u308B\u3068\u6CE8\u6587\u306F\u8FD4\u91D1\u6E08\u307F\u306B\u306A\u308A\u3001\u767A\u884C\u3055\u308C\u3066\u3044\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u56DE\u53CE\uFF08\u5931\u52B9\uFF09\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "dispute",
            text: "\u7D1B\u4E89\u306E\u7533\u3057\u7ACB\u3066"
          },
          {
            type: "p",
            text: "\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u5F8C\u306B\u5951\u7D04\u5185\u5BB9\u3068\u7570\u306A\u308B\u554F\u984C\u304C\u8D77\u304D\u305F\u5834\u5408\u306F\u3001\u6CE8\u6587\u8A73\u7D30\u304B\u3089\u7D1B\u4E89\u3092\u7533\u3057\u7ACB\u3066\u3089\u308C\u307E\u3059\u3002\u8CFC\u5165\u78BA\u5B9A\u5F8C\u3067\u3082\u3001\u8CA9\u58F2\u8005\u3078\u306E\u7CBE\u7B97\u304C\u652F\u6255\u308F\u308C\u308B\u307E\u3067\u306F\u7533\u3057\u7ACB\u3066\u3067\u304D\u307E\u3059\u3002\n\u7D1B\u4E89\u304C\u7533\u3057\u7ACB\u3066\u3089\u308C\u308B\u3068\u7BA1\u7406\u8005\u304C\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8\u306B\u53C2\u52A0\u3057\u3001\u305D\u306E\u9593\u306F\u8CFC\u5165\u78BA\u5B9A\u3068\u8CA9\u58F2\u8005\u3078\u306E\u7CBE\u7B97\u304C\u6B62\u307E\u308A\u307E\u3059\u3002\n\u7BA1\u7406\u8005\u306F\u53CC\u65B9\u306E\u8A71\u3092\u78BA\u8A8D\u3057\u305F\u3046\u3048\u3067\u8FD4\u91D1\uFF08\u5168\u984D\u307E\u305F\u306F\u4E00\u90E8\uFF09\u3059\u308B\u304B\u3001\u6839\u62E0\u304C\u306A\u3044\u3001\u307E\u305F\u306F\u5408\u610F\u6E08\u307F\u306E\u5834\u5408\u306F\u7D1B\u4E89\u3092\u68C4\u5374\u3057\u3066\u7CBE\u7B97\u3092\u518D\u958B\u3057\u307E\u3059\u3002\u5951\u7D04\u306E\u7D99\u7D9A\u304C\u96E3\u3057\u3044\u5834\u5408\u306F\u3001\u5951\u7D04\u3092\u89E3\u9664\u3057\u3066\u7D1B\u4E89\u3092\u7D42\u3048\u308B\u3053\u3068\u3082\u3042\u308A\u307E\u3059\uFF08\u300C\u5951\u7D04\u89E3\u9664\u3068\u7D1B\u4E89\u300D\u53C2\u7167\uFF09\u3002\u51E6\u7406\u7D50\u679C\u3068\u7406\u7531\u306F\u6CE8\u6587\u8A73\u7D30\u3068\u901A\u77E5\u3067\u53CC\u65B9\u306B\u6848\u5185\u3055\u308C\u307E\u3059\u3002\n\u7BA1\u7406\u8005\u304C\u68C4\u5374\u3057\u305F\u7D1B\u4E89\u306F\u518D\u5EA6\u7533\u3057\u7ACB\u3066\u3067\u304D\u307E\u305B\u3093\u3002\u65B0\u305F\u306A\u554F\u984C\u304C\u8D77\u304D\u305F\u5834\u5408\u306F\u3001\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u306B\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002"
          }
        ]
      },
      {
        slug: "termination",
        title: "\u5951\u7D04\u89E3\u9664\u3068\u7D1B\u4E89",
        description: "\u5951\u7D04\u3092\u9014\u4E2D\u3067\u7D42\u3048\u308B\u5951\u7D04\u89E3\u9664\u3068\u3001\u89E3\u9664\u6642\u306E\u524D\u6255\u3044\u91D1\u306E\u6271\u3044\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\u5951\u7D04\u89E3\u9664\u3068\u306F"
          },
          {
            type: "p",
            text: "\u5951\u7D04\u89E3\u9664\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u305F\u5951\u7D04\u3092\u671F\u9593\u7D42\u4E86\u524D\u306B\u7D42\u3048\u308B\u3053\u3068\u3067\u3059\u3002\u53CC\u65B9\u304C\u5408\u610F\u3057\u305F\u5834\u5408\u3001\u4E00\u65B9\u304C\u5951\u7D04\u3092\u5B88\u3089\u306A\u304B\u3063\u305F\u5834\u5408\u3001\u307E\u305F\u306F\u8CA9\u58F2\u8005\u304C\u6A29\u5229\u3092\u63D0\u4F9B\u3067\u304D\u306A\u304F\u306A\u3063\u305F\u5834\u5408\u306B\u3001\u7BA1\u7406\u8005\u304C\u89E3\u9664\u3057\u307E\u3059\u3002\n\u89E3\u9664\u3059\u308B\u3068\u3001\u89E3\u9664\u65E5\u307E\u3067\u306E\u4F7F\u7528\u306F\u6B63\u5F53\u306A\u4F7F\u7528\u3068\u3057\u3066\u8A8D\u3081\u3089\u308C\u3001\u305D\u308C\u4EE5\u964D\u306F\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\n\u524D\u6255\u3044\u91D1\u984D\u306E\u306A\u3044\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\uFF08\u524D\u6255\u30440\u30A6\u30A9\u30F3\uFF09\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u524D\u3067\u3082\u89E3\u9664\u3067\u7D42\u3048\u3089\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "vs-refund",
            text: "\u5951\u7D04\u89E3\u9664\u3068\u5168\u984D\u8FD4\u91D1\u306E\u9055\u3044"
          },
          {
            type: "list",
            items: [
              "\u5951\u7D04\u89E3\u9664\uFF1A\u89E3\u9664\u65E5\u307E\u3067\u306E\u4F7F\u7528\u306F\u8A8D\u3081\u3089\u308C\u307E\u3059\u3002\u6CE8\u6587\u306F\u5951\u7D04\u89E3\u9664\u306B\u306A\u308A\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u8A3C\u66F8\u306F\u89E3\u9664\u306E\u8868\u793A\u4ED8\u304D\u3067\u5F15\u304D\u7D9A\u304D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002",
              "\u5168\u984D\u8FD4\u91D1\uFF1A\u6700\u521D\u304B\u3089\u306A\u304B\u3063\u305F\u5951\u7D04\u3068\u3057\u3066\u6271\u308F\u308C\u307E\u3059\u3002\u6CE8\u6587\u306F\u8FD4\u91D1\u6E08\u307F\u306B\u306A\u308A\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u56DE\u53CE\u3055\u308C\u3066\u8A3C\u66F8\u3092\u53D7\u3051\u53D6\u308C\u307E\u305B\u3093\u3002",
              "\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u524D\u306B\u5951\u7D04\u3092\u7D42\u3048\u305F\u3044\u5834\u5408\u306F\u3001\u89E3\u9664\u3067\u306F\u306A\u304F\u6CE8\u6587\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\uFF08\u5165\u91D1\u524D\uFF09\u307E\u305F\u306F\u8FD4\u91D1\uFF08\u5165\u91D1\u5F8C\uFF09\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\u524D\u6255\u30440\u30A6\u30A9\u30F3\u306E\u5951\u7D04\u306E\u307F\u4F8B\u5916\u3068\u3057\u3066\u767A\u884C\u524D\u3067\u3082\u89E3\u9664\u3057\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "upfront",
            text: "\u89E3\u9664\u6642\u306E\u524D\u6255\u3044\u91D1\u306E\u6271\u3044"
          },
          {
            type: "p",
            text: "\u89E3\u9664\u3059\u308B\u969B\u306F\u3001\u3059\u3067\u306B\u652F\u6255\u3063\u305F\u524D\u6255\u3044\u91D1\u3092\u3069\u3046\u5206\u3051\u308B\u304B\u3082\u4E00\u7DD2\u306B\u6C7A\u3081\u307E\u3059\u3002\u6CE8\u6587\u8A73\u7D30\u306B\u306F\u3001\u5951\u7D04\u89E3\u9664\u306E\u8868\u793A\u306E\u6A2A\u306B\u3069\u306E\u65B9\u5F0F\u3067\u51E6\u7406\u3055\u308C\u305F\u304B\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "list",
            items: [
              "\u89E3\u9664\u30FB\u8FD4\u91D1\u306A\u3057\uFF1A\u524D\u6255\u3044\u91D1\u306F\u8FD4\u91D1\u3055\u308C\u305A\u3001\u8CA9\u58F2\u8005\u304C\u8CA9\u58F2\u4EE3\u91D1\u3068\u3057\u3066\u7CBE\u7B97\u3092\u53D7\u3051\u307E\u3059\u3002",
              "\u89E3\u9664\u30FB\u4E00\u90E8\u8FD4\u91D1\uFF08\u524D\u6255\u3044\uFF09\uFF1A\u524D\u6255\u3044\u91D1\u306E\u4E00\u90E8\u3092\u8CFC\u5165\u8005\u306B\u8FD4\u91D1\u3057\u3001\u6B8B\u308A\u306F\u8CA9\u58F2\u8005\u304C\u7CBE\u7B97\u3092\u53D7\u3051\u307E\u3059\u3002",
              "\u89E3\u9664\u30FB\u5168\u984D\u8FD4\u91D1\uFF08\u524D\u6255\u3044\uFF09\uFF1A\u524D\u6255\u3044\u91D1\u306E\u5168\u984D\u3092\u8CFC\u5165\u8005\u306B\u8FD4\u91D1\u3057\u307E\u3059\u3002\u305D\u308C\u3067\u3082\u5951\u7D04\u306F\u89E3\u9664\u306E\u72B6\u614B\u306E\u305F\u3081\u3001\u89E3\u9664\u65E5\u307E\u3067\u306E\u4F7F\u7528\u306F\u8A8D\u3081\u3089\u308C\u3001\u305D\u308C\u307E\u3067\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306F\u652F\u6255\u3046\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"
            ]
          },
          {
            type: "p",
            text: "\u8FD4\u91D1\u306F\u7BA1\u7406\u8005\u304C\u9001\u91D1\u3092\u7D42\u3048\u308B\u3068\u5B8C\u4E86\u3057\u307E\u3059\u3002\u9280\u884C\u632F\u8FBC\u306E\u6CE8\u6587\u306F\u8FD4\u91D1\u5148\u306E\u53E3\u5EA7\u304C\u5FC5\u8981\u3067\u3059\u3002\u8FD4\u91D1\u304C\u7D42\u308F\u308B\u307E\u3067\u306F\u8CA9\u58F2\u8005\u3078\u306E\u7CBE\u7B97\u3082\u652F\u6255\u308F\u308C\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "royalty",
            text: "\u89E3\u9664\u5F8C\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3"
          },
          {
            type: "p",
            text: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u306F\u3001\u89E3\u9664\u65E5\u304C\u3042\u308B\u6708\u307E\u3067\u58F2\u4E0A\u3092\u5831\u544A\u3057\u3066\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u652F\u6255\u3046\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u89E3\u9664\u3057\u305F\u6708\u306F\u30011\u65E5\u304B\u3089\u89E3\u9664\u65E5\u307E\u3067\u306E\u58F2\u4E0A\u3060\u3051\u3092\u542B\u3081\u307E\u3059\u3002\n\u305F\u3068\u3048\u307010\u670815\u65E5\u306B\u89E3\u9664\u3057\u305F\u5834\u5408\u300110\u6708\u5206\uFF081\u301C15\u65E5\uFF09\u306E\u58F2\u4E0A\u309211\u6708\u306E\u652F\u6255\u65E5\u307E\u3067\u306B\u5831\u544A\u3059\u308C\u3070\u3088\u304F\u300111\u6708\u4EE5\u964D\u306F\u5831\u544A\u3057\u307E\u305B\u3093\u3002\n\u3059\u3067\u306B\u652F\u6255\u3063\u305F\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306F\u89E3\u9664\u306B\u3088\u3063\u3066\u8FD4\u91D1\u3055\u308C\u307E\u305B\u3093\u3002\u5831\u544A\u3057\u305F\u58F2\u4E0A\u304C\u9593\u9055\u3063\u3066\u3044\u305F\u5834\u5408\u306F\u3001\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5831\u544A\u306E\u8A02\u6B63\u624B\u7D9A\u304D\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "h2",
            id: "request",
            text: "\u5951\u7D04\u89E3\u9664\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B"
          },
          {
            type: "p",
            text: "\u89E3\u9664\u304C\u5FC5\u8981\u306A\u5834\u5408\u306F\u3001\u307E\u305A\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8\u3067\u76F8\u624B\u3068\u89E3\u9664\u3059\u308B\u304B\u3069\u3046\u304B\u3068\u524D\u6255\u3044\u91D1\u306E\u6271\u3044\u306B\u3064\u3044\u3066\u8A71\u3057\u5408\u3063\u3066\u304B\u3089\u3001\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u306B\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002\n\u7BA1\u7406\u8005\u304C\u53CC\u65B9\u306E\u610F\u898B\u3068\u53D6\u5F15\u8A18\u9332\u3092\u78BA\u8A8D\u3057\u3001\u89E3\u9664\u306E\u7406\u7531\u3068\u524D\u6255\u3044\u91D1\u306E\u6271\u3044\u3092\u6C7A\u3081\u3066\u51E6\u7406\u3057\u307E\u3059\u3002\u51E6\u7406\u7D50\u679C\u3068\u7406\u7531\u306F\u6CE8\u6587\u8A73\u7D30\u3001\u901A\u77E5\u3001\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8\u3067\u53CC\u65B9\u306B\u6848\u5185\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "dispute",
            text: "\u7D1B\u4E89\u4E2D\u306E\u5951\u7D04\u89E3\u9664"
          },
          {
            type: "p",
            text: "\u7D1B\u4E89\u3092\u78BA\u8A8D\u3057\u305F\u7BA1\u7406\u8005\u304C\u5951\u7D04\u306E\u7D99\u7D9A\u306F\u96E3\u3057\u3044\u3068\u5224\u65AD\u3057\u305F\u5834\u5408\u3001\u5951\u7D04\u3092\u89E3\u9664\u3057\u3066\u7D1B\u4E89\u3092\u7D42\u3048\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u3082\u524D\u6255\u3044\u91D1\u306E\u6271\u3044\uFF08\u8FD4\u91D1\u306A\u3057\u3001\u4E00\u90E8\u8FD4\u91D1\u3001\u5168\u984D\u8FD4\u91D1\uFF09\u3092\u4E00\u7DD2\u306B\u6C7A\u3081\u3001\u7D1B\u4E89\u306E\u51E6\u7406\u7D50\u679C\u306B\u5951\u7D04\u89E3\u9664\u3067\u7D42\u7D50\u3057\u305F\u3068\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "after",
            text: "\u89E3\u9664\u3055\u308C\u305F\u5F8C\u306F"
          },
          {
            type: "list",
            items: [
              "\u89E3\u9664\u3055\u308C\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u89E3\u9664\u65E5\u4EE5\u964D\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u5F15\u304D\u7D9A\u304D\u4F7F\u7528\u3059\u308B\u306B\u306F\u65B0\u305F\u306B\u8CFC\u5165\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
              "\u5B8C\u5168\u72EC\u5360\u5951\u7D04\u304C\u89E3\u9664\u3055\u308C\u308B\u3068\u3001\u305D\u306E\u6A29\u5229\u3092\u4ED6\u306E\u8CFC\u5165\u8005\u304C\u8CFC\u5165\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002",
              "\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u306F\u9589\u3058\u3089\u308C\u307E\u305B\u3093\u3002\u6B8B\u308A\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5831\u544A\u3084\u8FD4\u91D1\u306B\u3064\u3044\u3066\u306E\u8A71\u3092\u7D9A\u3051\u3089\u308C\u307E\u3059\u3002",
              "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u306F\u3001\u89E3\u9664\u3057\u305F\u6708\u307E\u3067\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u652F\u6255\u3044\u304C\u7D42\u308F\u308B\u3068\u5951\u7D04\u7D42\u4E86\u3068\u307F\u306A\u3055\u308C\u3001\u305D\u306E\u5F8C\u306F\u9000\u4F1A\u3067\u304D\u307E\u3059\u3002"
            ]
          }
        ]
      },
      {
        slug: "contract-end",
        title: "\u5951\u7D04\u306E\u7D42\u4E86",
        description: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u671F\u9593\u304C\u7D42\u308F\u308B\u3068\u304D\u306E\u6848\u5185\u3068\u3001\u7D42\u4E86\u5F8C\u3082\u4F7F\u3044\u7D9A\u3051\u308B\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "\u5951\u7D04\u671F\u9593\u304C\u7D42\u308F\u308B\u3068\u304D"
          },
          {
            type: "p",
            text: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u8A3C\u66F8\u306B\u8A18\u8F09\u3055\u308C\u305F\u4F7F\u7528\u671F\u9593\uFF08\u4F7F\u7528\u958B\u59CB\u65E5\u301C\u6700\u7D42\u4F7F\u7528\u65E5\uFF09\u306E\u9593\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u6700\u7D42\u4F7F\u7528\u65E5\u3092\u904E\u304E\u308B\u3068\u7FCC\u65E50\u6642\u306B\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u3001\u305D\u306E\u65E5\u304B\u3089\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\n\u65E5\u4ED8\u306F\u6CE8\u6587\u6642\u306B\u6C7A\u307E\u3063\u305F\u5951\u7D04\u30BF\u30A4\u30E0\u30BE\u30FC\u30F3\u57FA\u6E96\u306E\u305F\u3081\u3001\u8CFC\u5165\u8005\u3068\u8CA9\u58F2\u8005\u306F\u540C\u3058\u65E5\u4ED8\u3092\u898B\u307E\u3059\u3002\n\u51FA\u6F14\u6A29\u306F1\u56DE\u306E\u51FA\u6F14\u3067\u7D42\u308F\u308B\u5951\u7D04\u306E\u305F\u3081\u3001\u6709\u52B9\u671F\u9650\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "notice",
            text: "\u7D42\u4E86\u524D\u5F8C\u306E\u6848\u5185"
          },
          {
            type: "list",
            items: [
              "\u6700\u7D42\u4F7F\u7528\u65E5\u307E\u30677\u65E5\u30683\u65E5\u306B\u306A\u3063\u305F\u3068\u304D\u3001\u8CFC\u5165\u8005\u3068\u8CA9\u58F2\u8005\u306E\u4E21\u65B9\u306B\u901A\u77E5\u3068\u30D7\u30C3\u30B7\u30E5\u3092\u304A\u9001\u308A\u3057\u307E\u3059\u3002\u901A\u77E5\u3092\u30BF\u30C3\u30D7\u3059\u308B\u3068\u3001\u305D\u306E\u53D6\u5F15\u306E\u6CE8\u6587\u8A73\u7D30\u304C\u958B\u304D\u307E\u3059\u3002",
              "\u671F\u9593\u304C\u7D42\u308F\u308B\u3068\u53CC\u65B9\u306B\u7D42\u4E86\u901A\u77E5\u3092\u9001\u308A\u3001\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u306B\u300CIP\u5951\u7D04\u671F\u9593\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u518D\u5951\u7D04\u3092\u3054\u5E0C\u671B\u306E\u5834\u5408\u306F\u3001IP\u306E\u6CE8\u6587\u3092\u3082\u3046\u4E00\u5EA6\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u300D\u3068\u3044\u3046\u6848\u5185\u304C\u6B8B\u308A\u307E\u3059\u3002",
              "\u5951\u7D04\u306B\u95A2\u3059\u308B\u6848\u5185\u306E\u305F\u3081\u3001\u901A\u77E5\u8A2D\u5B9A\u3067\u30AA\u30D5\u306B\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
            ]
          },
          {
            type: "h2",
            id: "renew",
            text: "\u5F15\u304D\u7D9A\u304D\u4F7F\u3044\u305F\u3044\u5834\u5408"
          },
          {
            type: "p",
            text: "\u671F\u9593\u3092\u5EF6\u3070\u3059\u5EF6\u9577\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u540C\u3058IP\u3092\u3082\u3046\u4E00\u5EA6\u6CE8\u6587\u3059\u308B\u3068\u3001\u65B0\u3057\u3044\u5951\u7D04\u3067\u5F15\u304D\u7D9A\u304D\u4F7F\u7528\u3067\u304D\u307E\u3059\uFF08\u300C\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u78BA\u8A8D\u3059\u308B\u300D\u306E\u300C\u540C\u3058IP\u3092\u3082\u3046\u4E00\u5EA6\u8CFC\u5165\u3059\u308B\u300D\u53C2\u7167\uFF09\u3002\n\u9014\u5207\u308C\u305A\u306B\u4F7F\u3046\u306B\u306F\u3001\u671F\u9593\u304C\u7D42\u308F\u308B\u524D\u306B\u3082\u3046\u4E00\u5EA6\u6CE8\u6587\u3057\u3001\u30C1\u30E3\u30C3\u30C8\u3067\u8CA9\u58F2\u8005\u3068\u65B0\u3057\u3044\u5951\u7D04\u306E\u4F7F\u7528\u958B\u59CB\u65E5\u3092\u73FE\u5728\u306E\u5951\u7D04\u304C\u7D42\u308F\u308B\u7FCC\u65E5\u306B\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002\n\u4ED6\u306E\u8CFC\u5165\u8005\u304C\u305D\u306E\u6A29\u5229\u3092\u5B8C\u5168\u72EC\u5360\u3067\u5951\u7D04\u3057\u3066\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u518D\u5EA6\u8CFC\u5165\u3067\u304D\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "after",
            text: "\u7D42\u4E86\u3057\u305F\u5F8C\u306F"
          },
          {
            type: "list",
            items: [
              "\u671F\u9650\u5207\u308C\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u3067\u306F\u3001\u305D\u306EIP\u3092\u3053\u308C\u4EE5\u4E0A\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
              "\u8A3C\u66F8\u306F\u671F\u9650\u5207\u308C\u306E\u8868\u793A\u4ED8\u304D\u3067\u5F15\u304D\u7D9A\u304D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002",
              "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u306F\u3001\u6700\u7D42\u4F7F\u7528\u65E5\u304C\u3042\u308B\u6708\u307E\u3067\u58F2\u4E0A\u3092\u5831\u544A\u3057\u3066\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u652F\u6255\u3046\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u305D\u306E\u6708\u306F1\u65E5\u304B\u3089\u6700\u7D42\u4F7F\u7528\u65E5\u307E\u3067\u306E\u58F2\u4E0A\u3060\u3051\u3092\u542B\u3081\u307E\u3059\u3002",
              "\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u306F\u9589\u3058\u3089\u308C\u307E\u305B\u3093\u3002\u6B8B\u308A\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5831\u544A\u3084\u518D\u6CE8\u6587\u306B\u3064\u3044\u3066\u306E\u8A71\u3092\u7D9A\u3051\u3089\u308C\u307E\u3059\u3002",
              "\u671F\u9593\u7D42\u4E86\u524D\u306B\u5951\u7D04\u3092\u7D42\u3048\u308B\u89E3\u9664\u306B\u3064\u3044\u3066\u306F\u300C\u5951\u7D04\u89E3\u9664\u3068\u7D1B\u4E89\u300D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"
            ]
          }
        ]
      }
    ]
  },
  {
    title: "\u8CA9\u58F2\u8005\u30AC\u30A4\u30C9",
    pages: [
      {
        slug: "selling",
        title: "\u51FA\u54C1\u3059\u308B",
        description: "\u8CA9\u58F2\u3059\u308B\u6A29\u5229\u3092\u9078\u3073\u3001\u6761\u4EF6\u3092\u6C7A\u3081\u308B\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "listing",
            text: "\u5546\u54C1\u3092\u4F5C\u6210\u3059\u308B"
          },
          {
            type: "p",
            text: "\u300CIP\u3092\u8CA9\u58F2\u3059\u308B\u300D\u3067\u8CA9\u58F2\u3059\u308B\u6A29\u5229\u306E\u7A2E\u985E\u3092\u9078\u3073\u3001\u30BF\u30A4\u30C8\u30EB\u30FB\u7D39\u4ECB\u30FB\u6CE8\u610F\u4E8B\u9805\u3092\u66F8\u304D\u307E\u3059\u3002\n\u9078\u3093\u3060\u6A29\u5229\u3054\u3068\u306B\u6761\u4EF6\u30921\u3064\u305A\u3064\u6C7A\u3081\u3001\u540C\u3058\u6A29\u5229\u306E\u4E2D\u3067\u306F\u671F\u9593\u5225\u306E\u4FA1\u683C\u30FB\u51FA\u6F14\u65B9\u5F0F\u30FB\u8FFD\u52A0\u6599\u91D1\u30AA\u30D7\u30B7\u30E7\u30F3\u3067\u6761\u4EF6\u3092\u5206\u3051\u3089\u308C\u307E\u3059\u3002\n\u305D\u308C\u4EE5\u5916\u306E\u6761\u4EF6\u3092\u5909\u3048\u3066\u8CA9\u58F2\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u5546\u54C1\u3092\u5225\u306B\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "h2",
            id: "terms",
            text: "\u6761\u4EF6\u306E\u8A2D\u5B9A"
          },
          {
            type: "list",
            items: [
              "\u4F7F\u7528\u671F\u9593\u5225\u306E\u4FA1\u683C \u2014 1\u30FB3\u30FB6\u30FB12\u304B\u6708\u304B\u3089\u8CA9\u58F2\u3059\u308B\u671F\u9593\u3092\u9078\u3093\u3067\u4FA1\u683C\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002",
              "\u4F7F\u7528\u5730\u57DF \u2014 \u56FD\u5185\u9650\u5B9A\u307E\u305F\u306F\u30B0\u30ED\u30FC\u30D0\u30EB\u3002",
              "\u72EC\u5360\u306E\u6709\u7121 \u2014 \u975E\u72EC\u5360\uFF0F\u30AB\u30C6\u30B4\u30EA\u30FC\u72EC\u5360\uFF0F\u5B8C\u5168\u72EC\u5360\u3002\u72EC\u5360\u5EA6\u304C\u9AD8\u3044\u307B\u3069\u9AD8\u3044\u4FA1\u683C\u3092\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002",
              "\u4FEE\u6B63\u306E\u8A31\u5BB9\u7BC4\u56F2\u3068\u7981\u6B62\u696D\u7A2E \u2014 \u671B\u307E\u306A\u3044\u4F7F\u7528\u3092\u4E8B\u524D\u306B\u9632\u304E\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "pricing",
            text: "\u4FA1\u683C\u65B9\u5F0F"
          },
          {
            type: "p",
            text: "\u56FA\u5B9A\u4FA1\u683C\u3001\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3001\u56FA\u5B9A\u4FA1\u683C\uFF0B\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u304B\u3089\u9078\u3079\u307E\u3059\u3002\n\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u65B9\u5F0F\u3092\u9078\u3076\u3068\u3001\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u7387\u3068\u3042\u308F\u305B\u3066\u652F\u6255\u65E5\uFF08\u6BCE\u6708N\u65E5\uFF09\u3092\u6C7A\u3081\u307E\u3059 \u2014 \u8CFC\u5165\u8005\u306F\u6BCE\u6708\u305D\u306E\u65E5\u307E\u3067\u306B\u524D\u6708\u306E\u58F2\u4E0A\u3092\u5831\u544A\u3057\u3001\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u632F\u308A\u8FBC\u307F\u307E\u3059\u3002\n\u51FA\u6F14\u6A29\u306F1\u56DE\u30FB\u57FA\u672C\u6642\u9593\u3042\u305F\u308A\u306E\u56FA\u5B9A\u4FA1\u683C\u306E\u307F\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059\u3002\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u306B\u95A2\u3059\u308B\u8FFD\u52A0\u6599\u91D1\u306F\u9078\u629E\u6642\u306B\u52A0\u7B97\u3057\u307E\u3059\u3002\n\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\uFF08\u73FE\u5730\u8A2A\u554F\uFF09\u306F\u57FA\u672C\u4FA1\u683C\u306B\u542B\u3080\u304B\u3001\u5225\u9014\u8CBB\u7528\u5354\u8B70\u304B\u3092\u6C7A\u3081\u307E\u3059\u3002\n\u5EF6\u9577\u306F\u5EF6\u9577\u4E0D\u53EF\u30FB\u6642\u9593\u3068\u8CBB\u7528\u306F\u5225\u9014\u5354\u8B70\u30FB\u6C7A\u307E\u3063\u305F\u8FFD\u52A0\u6599\u91D1\uFF08N\u5206\u3042\u305F\u308A\u306E\u91D1\u984D\uFF09\u304B\u3089\u6C7A\u3081\u3001\u5EF6\u9577\u8CBB\u7528\u306F\u57FA\u672C\u306E\u6C7A\u6E08\u91D1\u984D\u306B\u542B\u307E\u308C\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "considerations",
            text: "\u5B9F\u969B\u306B\u8CA9\u58F2\u3059\u308B\u3068\u304D\u306B\u8003\u3048\u3066\u304A\u304F\u3053\u3068"
          },
          {
            type: "p",
            text: "\u5546\u54C1\u306B\u8A2D\u5B9A\u3057\u305F\u6761\u4EF6\u3060\u3051\u3067\u306F\u8868\u3057\u304D\u308C\u306A\u3044\u3001\u6A29\u5229\u3054\u3068\u306B\u3088\u308A\u7D30\u304B\u304F\u8A71\u3057\u5408\u3046\u5FC5\u8981\u304C\u3042\u308B\u90E8\u5206\u304C\u305F\u304F\u3055\u3093\u3042\u308A\u307E\u3059\u3002\n\u8CA9\u58F2\u524D\u306B\u3042\u3089\u304B\u3058\u3081\u57FA\u6E96\u3092\u6C7A\u3081\u3066\u304A\u304F\u3068\u3001\u4EA4\u6E09\u304C\u305A\u3063\u3068\u65E9\u304F\u9032\u307F\u307E\u3059\u3002"
          },
          {
            type: "list",
            items: [
              "\u540D\u524D\uFF0F\u30D6\u30E9\u30F3\u30C9 \u2014 \u3069\u306E\u8868\u8A18\uFF08\u30CF\u30F3\u30B0\u30EB\u30FB\u82F1\u8A9E\u30FB\u30ED\u30B4\uFF09\u307E\u3067\u8A31\u53EF\u3059\u308B\u304B\u3001\u5BFE\u8C61\u5546\u54C1\u30FB\u5E83\u544A\u7D20\u6750\u306A\u3069\u4F7F\u7528\u6570\u91CF\u306E\u4E0A\u9650\u3001\u5546\u6A19\u51FA\u9858\u30FB\u5546\u53F7\u767B\u9332\u3092\u7981\u6B62\u3059\u308B\u304B\u3002",
              "\u5199\u771F\u4F7F\u7528\u6A29 \u2014 \u3069\u306E\u64AE\u5F71\u30C7\u30FC\u30BF\u3092\u63D0\u4F9B\u3059\u308B\u304B\u3001\u88DC\u6B63\u30FB\u30C8\u30EA\u30DF\u30F3\u30B0\u3092\u3069\u3053\u307E\u3067\u8A31\u53EF\u3057\u3001\u5408\u6210\u30FBAI\u5B66\u7FD2\u3092\u7981\u6B62\u3059\u308B\u304B\u3002",
              "\u52D5\u753B\u4F7F\u7528\u6A29 \u2014 \u8A31\u53EF\u3059\u308B\u5143\u52D5\u753B\u306E\u7BC4\u56F2\u3001\u767A\u8A00\u306E\u8DA3\u65E8\u3092\u3086\u304C\u3081\u308B\u7DE8\u96C6\u30FB\u4ED6\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u518D\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306E\u53EF\u5426\u3002",
              "\u97F3\u58F0\u4F7F\u7528\u6A29 \u2014 \u30D5\u30A1\u30A4\u30EB\u4F7F\u7528\u30FB\u65B0\u898F\u5236\u4F5C\u30FB\u8CFC\u5165\u8005\u306EAI\u751F\u6210\u306E\u3046\u3061\u5408\u610F\u3057\u305F\u65B9\u5F0F\u306B\u5408\u308F\u305B\u3001\u5BFE\u8C61\u306E\u97F3\u58F0\u30FB\u30BB\u30EA\u30D5\u30FB\u5206\u91CF\u3001\u5236\u4F5C\u6761\u4EF6\u307E\u305F\u306F\u751F\u6210\u65B9\u6CD5\u30FB\u671F\u9593\u30FB\u30B5\u30FC\u30D3\u30B9\u8CBB\u7528\u3092\u78BA\u5B9A\u3002",
              "\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0 \u2014 \u4E00\u7DD2\u306B\u8868\u793A\u3059\u308B\u30D6\u30E9\u30F3\u30C9\u8981\u7D20\u30FB\u6587\u8A00\u3001\u30AD\u30E3\u30F3\u30DA\u30FC\u30F31\u4EF6\u3042\u305F\u308A\u306E\u4FA1\u683C\u3001\u8CFC\u5165\u8005\u304C\u9078\u3076\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u6570\u3001\u4F7F\u7528\u5834\u6240\u30FB1\u4EF6\u3042\u305F\u308A\u306E\u8FFD\u52A0\u6599\u91D1\u3001\u516C\u958B\u524D\u306E\u30C7\u30B6\u30A4\u30F3\u6848\u627F\u8A8D\u3068\u7D42\u4E86\u5F8C\u306E\u6295\u7A3F\u306E\u6271\u3044\u3002\u5B9F\u969B\u306E\u76F8\u624B\u30D6\u30E9\u30F3\u30C9\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u30FB\u30C7\u30B6\u30A4\u30F3\u6848\u306F\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u8A18\u9332\u3057\u307E\u3059\u3002\u540C\u3058\u7BC4\u56F2\u3067\u306E\u540D\u524D\u30FB\u30ED\u30B4\u306E\u4F7F\u7528\u306F\u542B\u307E\u308C\u3001\u5546\u54C1\u306E\u4F01\u753B\u30FB\u5236\u4F5C\u30FB\u8CA9\u58F2\u3084\u8CA9\u58F2\u8005\u81EA\u8EAB\u306E\u6295\u7A3F\u30FB\u51FA\u6F14\u306F\u5225\u3067\u3059\u3002",
              "\u30B0\u30C3\u30BA\u5236\u4F5C \u2014 \u8CA9\u58F2\u7528\u30FB\u975E\u58F2\u54C1\u914D\u5E03\u7528\u3092\u305D\u308C\u305E\u308C\u3001\u307E\u305F\u306F\u4E21\u65B9\u8A31\u53EF\u3057\u307E\u3059\u3002\u54C1\u76EE\u30FB\u4F7F\u7528\u3059\u308B\u8981\u7D20\u30FB\u7DCF\u5236\u4F5C\u6570\u30FB\u8CA9\u58F2\u304A\u3088\u3073\u914D\u5E03\u7D4C\u8DEF\u30FB\u30C7\u30B6\u30A4\u30F3\u6848\u3068\u30B5\u30F3\u30D7\u30EB\u306E\u627F\u8A8D\u30FB\u8FFD\u52A0\u5236\u4F5C\u30FB\u671F\u9593\u7D42\u4E86\u5F8C\u306E\u5728\u5EAB\u51E6\u7406\u6761\u4EF6\u3092\u6C7A\u3081\u307E\u3059\u3002\u8CA9\u58F2\u5206\u30FB\u30D7\u30EC\u30BC\u30F3\u30C8\u5206\u30FB\u30B5\u30F3\u30D7\u30EB\u306F\u7DCF\u6570\u306B\u5408\u7B97\u3057\u3001\u975E\u58F2\u54C1\u5C02\u7528\u306F\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306A\u3057\u3067\u4FA1\u683C\u3092\u6C7A\u3081\u307E\u3059\u3002",
              "\u51FA\u6F14 \u2014 1\u3064\u306E\u5546\u54C1\u306B\u3001\u73FE\u5730\u8A2A\u554F\u30FB\u30AA\u30F3\u30E9\u30A4\u30F3\u6620\u50CF\u30FB\u30AA\u30F3\u30E9\u30A4\u30F3\u97F3\u58F0\u306E\u3046\u3061\u63D0\u4F9B\u3059\u308B\u65B9\u5F0F\u3092\u307E\u3068\u3081\u3066\u767B\u9332\u3067\u304D\u307E\u3059\u3002\u65B9\u5F0F\u3054\u3068\u306B\u6D3B\u52D5\u30FB1\u56DE\u306E\u57FA\u672C\u6642\u9593\u30FB\u4FA1\u683C\u30FB\u5EF6\u9577\u6761\u4EF6\u30FB\u8A18\u9332\u7269\u306E\u4F7F\u7528\u7BC4\u56F2\u3068\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u6761\u4EF6\u3092\u8A2D\u5B9A\u3057\u3001\u8CFC\u5165\u8005\u306F\u65B9\u5F0F\u30921\u3064\u9078\u3073\u307E\u3059\u3002\u8A2A\u554F\u5730\u57DF\u30FB\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u306F\u73FE\u5730\u8A2A\u554F\u3067\u306E\u307F\u8A2D\u5B9A\u3057\u307E\u3059\u3002\u6620\u50CF\u306F\u672C\u4EBA\u306E\u59FF\u307E\u305F\u306F\u30A2\u30D0\u30BF\u30FC\u3067\u3001\u97F3\u58F0\u306F\u58F0\u306E\u307F\u3067\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u306B\u53C2\u52A0\u3057\u307E\u3059\u3002\u5B9F\u969B\u306E\u65E5\u7A0B\u3068\u53C2\u52A0\u65B9\u6CD5\u306F\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u8A18\u9332\u3057\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: "\u3053\u3046\u3057\u305F\u7D30\u304B\u3044\u4E8B\u9805\u306F\u6CE8\u6587\u5F8C\u306B\u30C1\u30E3\u30C3\u30C8\u3067\u4EA4\u6E09\u3057\u3001\u5408\u610F\u3057\u305F\u5185\u5BB9\u3092\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u3068\u3057\u3066\u767B\u9332\u3057\u3066\u8A3C\u66F8\u306B\u6B8B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8A73\u3057\u3044\u65B9\u6CD5\u306F\u300C\u30C1\u30E3\u30C3\u30C8\u3067\u306E\u4EA4\u6E09\u300D\u3068\u300C\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\uFF08\u7279\u7D04\uFF09\u300D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"
          }
        ]
      },
      {
        slug: "chat",
        title: "\u30C1\u30E3\u30C3\u30C8\u3067\u306E\u4EA4\u6E09",
        description: "\u6CE8\u6587\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u3067\u8CFC\u5165\u8005\u3068\u7D30\u304B\u306A\u6761\u4EF6\u3092\u4EA4\u6E09\u3059\u308B\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "room",
            text: "\u6CE8\u6587\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0"
          },
          {
            type: "p",
            text: "\u8CFC\u5165\u8005\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u308B\u3068\u3001\u8CFC\u5165\u8005\u3068\u306E\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u304C\u81EA\u52D5\u7684\u306B\u958B\u304D\u307E\u3059\u3002\u5165\u91D1\u524D\u306B\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u305F\u6CE8\u6587\u306F\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u304C\u958B\u304D\u307E\u305B\u3093\u3002\n\u4F7F\u7528\u7BC4\u56F2\u3001\u7D20\u6750\u306E\u53D7\u3051\u6E21\u3057\u3001\u65E5\u7A0B\u306A\u3069\u306E\u7D30\u304B\u306A\u4E8B\u9805\u306F\u3053\u3053\u3067\u4EA4\u6E09\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "h2",
            id: "draft",
            text: "\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u306E\u767B\u9332"
          },
          {
            type: "p",
            text: `\u30C1\u30E3\u30C3\u30C8\u3067\u4EA4\u6E09\u3057\u305F\u5185\u5BB9\u306F\u3001\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u4E0A\u90E8\u306E\u300C\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u300D\u30AB\u30FC\u30C9\u306B\u6B8B\u3057\u3066\u304A\u304D\u307E\u3057\u3087\u3046\u3002\u4F7F\u7528\u958B\u59CB\u65E5\uFF08\u4ECA\u65E5\u304B\u3089${BUSINESS2.LICENSE_START_MAX_DAYS_AHEAD}\u65E5\u5F8C\u307E\u3067\uFF09\u3068\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u3092\u767B\u9332\u3067\u304D\u3001\u4FDD\u5B58\u3059\u308B\u3068\u8CFC\u5165\u8005\u3082\u3059\u3050\u306B\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u767A\u884C\u3059\u308B\u307E\u3067\u4F55\u5EA6\u3067\u3082\u4FEE\u6B63\u3067\u304D\u307E\u3059\u3002
\u8907\u6570\u306E\u6A29\u5229\u3092\u307E\u3068\u3081\u3066\u6C7A\u6E08\u3057\u305F\u307E\u3068\u3081\u6CE8\u6587\u306E\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u306B\u306F\u3001\u3053\u306E\u30AB\u30FC\u30C9\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u305D\u306E\u5834\u5408\u306F\u6CE8\u6587\u8A73\u7D30\u3067\u6A29\u5229\u3054\u3068\u306B\u4F7F\u7528\u958B\u59CB\u65E5\u3068\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u3092\u5165\u529B\u3057\u3066\u767A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
          },
          {
            type: "callout",
            text: "\u53E3\u982D\u3060\u3051\u3067\u5408\u610F\u3057\u3066\u6E08\u307E\u305B\u308B\u3068\u3001\u5F8C\u3067\u304A\u4E92\u3044\u306E\u8A18\u61B6\u304C\u9055\u3046\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u5408\u610F\u3059\u308B\u305F\u3073\u306B\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u3092\u66F4\u65B0\u3057\u3066\u304A\u3051\u3070\u3001\u305D\u306E\u5185\u5BB9\u304C\u305D\u306E\u307E\u307E\u8A3C\u66F8\u306B\u8A18\u8F09\u3055\u308C\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "issuing",
        title: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u767A\u884C",
        description: "\u4EA4\u6E09\u304C\u7D42\u308F\u3063\u305F\u5185\u5BB9\u3069\u304A\u308A\u306B\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3059\u308B\u6D41\u308C\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "\u767A\u884C\u3067\u304D\u308B\u30BF\u30A4\u30DF\u30F3\u30B0"
          },
          {
            type: "p",
            text: "\u8CFC\u5165\u8005\u306E\u6C7A\u6E08\uFF08\u5165\u91D1\u78BA\u8A8D\uFF09\u304C\u5B8C\u4E86\u3059\u308B\u3068\u3001\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u3068\u6CE8\u6587\u8A73\u7D30\u3067\u767A\u884C\u30DC\u30BF\u30F3\u304C\u6709\u52B9\u306B\u306A\u308A\u307E\u3059\u3002\n\u4EA4\u6E09\u3067\u91D1\u984D\u304C\u5897\u3048\u305F\u5834\u5408\u306F\u3001\u767A\u884C\u524D\u306B\u6CE8\u6587\u8A73\u7D30\u304B\u3089\u8FFD\u52A0\u6599\u91D1\u3092\u8ACB\u6C42\u3067\u304D\u307E\u3059\u3002\u5165\u91D1\u5F85\u3061\u306E\u8FFD\u52A0\u6599\u91D1\u304C\u3042\u308B\u3068\u767A\u884C\u3067\u304D\u306A\u3044\u305F\u3081\u3001\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u3066\u304B\u3089\u767A\u884C\u3059\u308B\u304B\u3001\u8FFD\u52A0\u6599\u91D1\u306E\u8ACB\u6C42\u3092\u53D6\u308A\u6D88\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "h2",
            id: "how",
            text: "\u767A\u884C\u3059\u308B"
          },
          {
            type: "p",
            text: "\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u306B\u767B\u9332\u3057\u3066\u304A\u3044\u305F\u4F7F\u7528\u958B\u59CB\u65E5\u3068\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306E\u3068\u304A\u308A\u306B\u767A\u884C\u3055\u308C\u307E\u3059\u3002\u4F7F\u7528\u958B\u59CB\u65E5\u3092\u7A7A\u6B04\u306B\u3059\u308B\u3068\u4ECA\u65E5\u304B\u3089\u958B\u59CB\u3057\u307E\u3059\u3002\n\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u4F7F\u7528\u6A29\u4EE5\u5916\u306E\u6A29\u5229\u306F\u3001\u4F1A\u8A71\u3067\u78BA\u5B9A\u3057\u305F\u5BFE\u8C61\u30FB\u6570\u91CF\u30FB\u65E5\u7A0B\u306A\u3069\u306E\u5185\u5BB9\u3092\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u66F8\u304B\u306A\u3044\u3068\u767A\u884C\u3067\u304D\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "after",
            text: "\u767A\u884C\u5F8C\u306F"
          },
          {
            type: "p",
            text: "\u767A\u884C\u3068\u540C\u6642\u306B\u8CFC\u5165\u8005\u3078\u30E9\u30A4\u30BB\u30F3\u30B9\u8A3C\u66F8\u304C\u5C4A\u304D\u3001\u6CE8\u6587\u304C\u53D6\u5F15\u5B8C\u4E86\u306B\u5909\u308F\u308A\u307E\u3059\u3002\u8CFC\u5165\u8005\u304C\u8CFC\u5165\u78BA\u5B9A\u3059\u308B\u3068\u7CBE\u7B97\u624B\u7D9A\u304D\u304C\u59CB\u307E\u308A\u3001\u78BA\u5B9A\u3057\u306A\u304F\u3066\u3082\u4F7F\u7528\u958B\u59CB\u65E5\u304B\u3089{{purchaseConfirmDays}}\u65E5\u304C\u904E\u304E\u308B\u3068\u81EA\u52D5\u7684\u306B\u78BA\u5B9A\u3055\u308C\u307E\u3059\u3002\u4F7F\u7528\u958B\u59CB\u524D\u306B\u5148\u306B\u78BA\u5B9A\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "callout",
            text: "\u767A\u884C\u306F\u53D6\u308A\u6D88\u305B\u307E\u305B\u3093\u3002\u4EA4\u6E09\u304C\u7D42\u308F\u3063\u305F\u304B\u3001\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u304C\u6700\u65B0\u304B\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u767A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          }
        ]
      },
      {
        slug: "special-terms",
        title: "\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\uFF08\u7279\u7D04\uFF09",
        description: "\u3053\u306E\u8CFC\u5165\u8005\u306B\u3060\u3051\u9069\u7528\u3055\u308C\u308B\u6761\u4EF6\u3092\u8A3C\u66F8\u306B\u6B8B\u3059\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u3068\u306F"
          },
          {
            type: "p",
            text: "\u5546\u54C1\u306B\u8A2D\u5B9A\u3055\u308C\u305F\u6761\u4EF6\uFF08\u671F\u9593\u30FB\u5730\u57DF\u30FB\u72EC\u5360\u306A\u3069\uFF09\u4EE5\u5916\u306B\u3001\u3053\u306E\u8CFC\u5165\u8005\u3068\u3060\u3051\u5408\u610F\u3057\u305F\u5185\u5BB9\u3092\u66F8\u304F\u9805\u76EE\u3067\u3059\u3002\u8A3C\u66F8\u306B\u306F\u300C\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\uFF08\u7279\u7D04\uFF09\u300D\u3068\u3057\u3066\u305D\u306E\u307E\u307E\u8A18\u8F09\u3055\u308C\u3001\u5951\u7D04\u5185\u5BB9\u306B\u306A\u308A\u307E\u3059\u3002\u6700\u59272,000\u6587\u5B57\u307E\u3067\u66F8\u3051\u307E\u3059\u3002\n\u5165\u529B\u6B04\u306E\u540D\u524D\u306F\u6A29\u5229\u306B\u5408\u308F\u305B\u3066\u300C\u78BA\u5B9A\u3057\u305F\u51FA\u6F14\u6761\u4EF6\u300D\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u304C\u3001\u3059\u3079\u3066\u540C\u3058\u9805\u76EE\u3067\u3059\u3002"
          },
          {
            type: "h2",
            id: "tips",
            text: "\u66F8\u304D\u65B9\u306E\u30B3\u30C4"
          },
          {
            type: "list",
            items: [
              "\u8A31\u53EF\u7BC4\u56F2\u3092\u5177\u4F53\u7684\u306B \u2014 \u3069\u306E\u7D20\u6750\u3092\uFF08\u30EA\u30F3\u30AF\u30FB\u6570\u91CF\uFF09\u3001\u3069\u3053\u3067\uFF08\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u30FB\u63B2\u8F09\u9762\uFF09\u4F7F\u3046\u304B\u3092\u660E\u8A18\u3057\u307E\u3059\u3002",
              "\u4E8B\u524D\u78BA\u8A8D\u306E\u6761\u4EF6 \u2014 \u63B2\u8F09\u524D\u306E\u78BA\u8A8D\u304C\u5FC5\u8981\u306A\u3089\u3001\u305D\u306E\u624B\u9806\u3092\u66F8\u304D\u307E\u3059\u3002",
              "\u7981\u6B62\u4E8B\u9805 \u2014 \u671B\u307E\u306A\u3044\u7DE8\u96C6\u30FB\u518D\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u30FB\u8EE2\u58F2\u3092\u4E8B\u524D\u306B\u9632\u304E\u307E\u3059\u3002",
              "\u671F\u9650\u306E\u3042\u308B\u6761\u4EF6 \u2014 \u671F\u9650\u5207\u308C\u5F8C\u306E\u5728\u5EAB\u51E6\u7406\u3001\u6295\u7A3F\u306E\u63B2\u8F09\u671F\u9593\u306E\u3088\u3046\u306B\u6642\u671F\u304C\u3042\u308B\u7D04\u675F\u306F\u65E5\u4ED8\u3067\u66F8\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "examples",
            text: "\u7A2E\u985E\u5225\u306E\u4F8B"
          },
          {
            type: "p",
            text: "\u6A29\u5229\u3054\u3068\u306B\u3088\u304F\u4F7F\u308F\u308C\u308B\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306E\u4F8B\u3067\u3059\u3002\u5165\u529B\u6B04\u4E0A\u306E\u9805\u76EE\u540D\u306E\u53F3\u306B\u3042\u308B\u30AC\u30A4\u30C9\u30DC\u30BF\u30F3\u304B\u3089\u3082\u540C\u3058\u4F8B\u3092\u898B\u3089\u308C\u307E\u3059\u3002\u8907\u6570\u306E\u6A29\u5229\u3092\u307E\u3068\u3081\u3066\u53D6\u5F15\u3059\u308B\u3068\u304D\u306F\u3001\u305D\u308C\u305E\u308C\u306E\u6A29\u5229\u306E\u4F8B\u3092\u53C2\u8003\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          ...SPECIAL_TERMS_EXAMPLE_BLOCKS2
        ]
      },
      {
        slug: "settlement",
        title: "\u7CBE\u7B97\u3092\u53D7\u3051\u53D6\u308B",
        description: "\u767A\u884C\u5F8C\u3001\u7CBE\u7B97\u91D1\u304C\u652F\u6255\u308F\u308C\u308B\u307E\u3067\u306E\u6D41\u308C\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "flow",
            text: "\u7CBE\u7B97\u306E\u6D41\u308C"
          },
          {
            type: "steps",
            items: [
              "\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u5F8C\u3001\u8CFC\u5165\u8005\u304C\u53D7\u3051\u53D6\u3063\u305F\u8CC7\u6599\u3092\u78BA\u8A8D\u3057\u3066\u8CFC\u5165\u78BA\u5B9A\u3057\u307E\u3059\u3002\u7CBE\u7B97\u304C\u652F\u6255\u308F\u308C\u308B\u307E\u3067\u306F\u8CFC\u5165\u8005\u304C\u7D1B\u4E89\u3092\u7533\u3057\u7ACB\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u3001\u7D1B\u4E89\u4E2D\u306F\u7CBE\u7B97\u304C\u6B62\u307E\u308A\u307E\u3059\u3002",
              "\u8CFC\u5165\u78BA\u5B9A\uFF08\u307E\u305F\u306F\u671F\u9650\u304C\u904E\u304E\u3066\u81EA\u52D5\u78BA\u5B9A\uFF09\u3055\u308C\u308B\u3068\u3001\u7CBE\u7B97\u5F85\u3061\u306B\u306A\u308A\u307E\u3059\u3002",
              "\u7BA1\u7406\u8005\u304C\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3059\u308B\u3068\u3001\u767B\u9332\u3057\u305F\u7CBE\u7B97\u53E3\u5EA7\u306B\u632F\u308A\u8FBC\u307E\u308C\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "fee",
            text: "\u624B\u6570\u6599"
          },
          {
            type: "p",
            text: "\u8CA9\u58F2\u91D1\u984D\u304B\u3089\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u624B\u6570\u6599{{platformFee}}\u3092\u5DEE\u3057\u5F15\u3044\u305F\u91D1\u984D\u304C\u652F\u6255\u308F\u308C\u307E\u3059\u3002\u624B\u6570\u6599\u306F\u6CE8\u6587\u6642\u306E\u7387\u3067\u6C7A\u307E\u308A\u3001\u305D\u306E\u5F8C\u306B\u7387\u304C\u5909\u308F\u3063\u3066\u3082\u3059\u3067\u306B\u6210\u7ACB\u3057\u305F\u53D6\u5F15\u306B\u306F\u5F71\u97FF\u3057\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "account",
            text: "\u7CBE\u7B97\u53E3\u5EA7\u306E\u767B\u9332"
          },
          {
            type: "p",
            text: "\u30DE\u30A4\u30DA\u30FC\u30B8\u3067\u7CBE\u7B97\u3092\u53D7\u3051\u53D6\u308B\u53E3\u5EA7\u3092\u3042\u3089\u304B\u3058\u3081\u767B\u9332\u3057\u3066\u304A\u3044\u3066\u304F\u3060\u3055\u3044\u3002\u53E3\u5EA7\u304C\u306A\u3044\u3068\u652F\u6255\u3044\u304C\u9045\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "history",
            text: "\u7CBE\u7B97\u5C65\u6B74\u3092\u898B\u308B"
          },
          {
            type: "p",
            text: "\u30DE\u30A4\u30DA\u30FC\u30B8 > \u7CBE\u7B97\u5C65\u6B74\u3067\u3001\u8CA9\u58F2\u4EE3\u91D1\u3068\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u5408\u308F\u305B\u3066\u652F\u6255\u4E88\u5B9A\u30FB\u652F\u6255\u5B8C\u4E86\u30FB\u5DEE\u5F15\u30FB\u56DE\u53CE\u306B\u5206\u3051\u3066\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u306E\u91D1\u984D\u306F\u624B\u6570\u6599\u3092\u5DEE\u3057\u5F15\u3044\u305F\u5B9F\u969B\u306E\u652F\u6255\u984D\u3067\u3059\u3002\n\u7BA1\u7406\u8005\u304C\u78BA\u8A8D\u3059\u308B\u3053\u3068\u304C\u3042\u3063\u3066\u652F\u6255\u3044\u3092\u4E00\u6642\u7684\u306B\u6B62\u3081\u305F\u5834\u5408\u306F\u3001\u652F\u6255\u4FDD\u7559\u3068\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u8A02\u6B63\u3067\u6E1B\u3063\u305F\u91D1\u984D\u306F\u6B21\u56DE\u306E\u652F\u6255\u3044\u304B\u3089\u5DEE\u3057\u5F15\u304B\u308C\u3001\u652F\u6255\u3044\u5F8C\u306E\u8FD4\u91D1\u306B\u3088\u3063\u3066\u8FD4\u3057\u3066\u3044\u305F\u3060\u304F\u7CBE\u7B97\u91D1\u306F\u8FD4\u91D1\u984D\u3068\u3057\u3066\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "callout",
            text: "\u7D1B\u4E89\u304C\u9032\u884C\u4E2D\u307E\u305F\u306F\u8FD4\u91D1\u304C\u51E6\u7406\u4E2D\u306E\u53D6\u5F15\u306F\u3001\u7D50\u8AD6\u304C\u51FA\u308B\u307E\u3067\u652F\u6255\u308F\u308C\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "clawback",
            text: "\u7CBE\u7B97\u5F8C\u306B\u8FD4\u91D1\u3055\u308C\u305F\u5834\u5408 \u2014 \u7CBE\u7B97\u91D1\u306E\u8FD4\u9084"
          },
          {
            type: "p",
            text: `\u7CBE\u7B97\u3092\u53D7\u3051\u53D6\u3063\u305F\u5F8C\u3067\u3082\u3001\u6A29\u5229\u306E\u554F\u984C\u3084\u5951\u7D04\u9055\u53CD\u304C\u78BA\u8A8D\u3055\u308C\u305F\u5834\u5408\u3001\u7BA1\u7406\u8005\u304C\u8FD4\u91D1\u3092\u6C7A\u5B9A\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u3001\u53D7\u3051\u53D6\u3063\u305F\u7CBE\u7B97\u91D1\u306E\u3046\u3061\u8FD4\u91D1\u306E\u5272\u5408\u5206\uFF08\u5168\u984D\u8FD4\u91D1\u306A\u3089\u53D7\u3051\u53D6\u3063\u305F\u7CBE\u7B97\u91D1\u306E\u5168\u984D\uFF09\u3092Inflip\u306E\u53E3\u5EA7\u306B\u8FD4\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002
\u91D1\u984D\u30FB\u7406\u7531\u30FB\u632F\u8FBC\u5148\u53E3\u5EA7\u30FB\u671F\u9650\u306F\u901A\u77E5\u3068\u30DE\u30A4\u30DA\u30FC\u30B8 > \u7CBE\u7B97\u5C65\u6B74\u3067\u6848\u5185\u3055\u308C\u307E\u3059\u3002\u671F\u9650\u306F\u901A\u77E5\u3092\u53D7\u3051\u53D6\u3063\u305F\u6642\u70B9\u304B\u3089${BUSINESS2.PAYOUT_CLAWBACK_DUE_DAYS}\u65E5\u3067\u3001\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u308B\u3068\u8CFC\u5165\u8005\u306B\u8FD4\u91D1\u3055\u308C\u307E\u3059\u3002`
          },
          {
            type: "callout",
            text: "\u671F\u9650\u307E\u3067\u306B\u632F\u308A\u8FBC\u307E\u306A\u3044\u5834\u5408\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5229\u7528\uFF08\u30ED\u30B0\u30A4\u30F3\uFF09\u304C\u505C\u6B62\u3055\u308C\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u5951\u7D04\u3068\u5229\u7528\u898F\u7D04\u306B\u57FA\u3065\u304D\u6CD5\u7684\u63AA\u7F6E\u3092\u53D7\u3051\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u505C\u6B62\u5F8C\u3067\u3082\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u308C\u3070\u505C\u6B62\u306F\u89E3\u9664\u3055\u308C\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "royalty",
        title: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5831\u544A",
        description: "\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u65B9\u5F0F\u306E\u53D6\u5F15\u306E\u5831\u544A\u30FB\u652F\u6255\u3044\u624B\u9806\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u65B9\u5F0F\u3068\u306F"
          },
          {
            type: "p",
            text: "\u56FA\u5B9A\u4FA1\u683C\u306E\u4EE3\u308F\u308A\u306B\uFF08\u307E\u305F\u306F\u56FA\u5B9A\u4FA1\u683C\u306B\u52A0\u3048\u3066\uFF09\u8CFC\u5165\u8005\u306E\u58F2\u4E0A\u306E\u4E00\u90E8\u3092\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3068\u3057\u3066\u53D7\u3051\u53D6\u308B\u65B9\u5F0F\u3067\u3059\u3002\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u7387\u3068\u652F\u6255\u65E5\uFF08\u6BCE\u6708N\u65E5\uFF09\u306F\u5951\u7D04\u6642\u70B9\u3067\u78BA\u5B9A\u3057\u307E\u3059 \u2014 \u5546\u54C1\u306B\u8A2D\u5B9A\u3057\u305F\u5024\u3067\u5951\u7D04\u3059\u308B\u304B\u3001\u4EA4\u6E09\u306E\u63D0\u6848\u3067\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "payment-day",
            text: "\u652F\u6255\u65E5 \u2014 \u6BCE\u6708\u3044\u3064\u652F\u6255\u3046\u304B"
          },
          {
            type: "p",
            text: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u306B\u306F\u652F\u6255\u65E5\uFF08\u6BCE\u67081\u301C28\u65E5\u306E\u3044\u305A\u308C\u304B1\u65E5\uFF09\u304C\u5FC5\u305A\u542B\u307E\u308C\u307E\u3059\u3002\u8CFC\u5165\u8005\u306F\u6BCE\u6708\u652F\u6255\u65E5\u307E\u3067\u306B\u524D\u6708\uFF081\u65E5\u301C\u672B\u65E5\uFF09\u306E\u58F2\u4E0A\u3092\u5831\u544A\u3057\u3001\u7B97\u5B9A\u3055\u308C\u305F\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u632F\u308A\u8FBC\u307F\u307E\u3059\u3002\n\u5831\u544A\u5BFE\u8C61\u306F\u4F7F\u7528\u958B\u59CB\u65E5\u304C\u3042\u308B\u6708\u304B\u3089\u6700\u7D42\u4F7F\u7528\u65E5\u304C\u3042\u308B\u6708\u307E\u3067\u3067\u3059\u3002\u6700\u521D\u306E\u6708\u3068\u6700\u5F8C\u306E\u6708\u306F\u3001\u5951\u7D04\u671F\u9593\u5185\u306E\u65E5\u4ED8\u306E\u58F2\u4E0A\u3060\u3051\u3092\u5831\u544A\u3057\u307E\u3059\u3002\n\u305F\u3068\u3048\u30705\u670815\u65E5\u306B\u59CB\u307E\u3063\u305F3\u304B\u6708\u5951\u7D04\uFF088\u670814\u65E5\u307E\u3067\uFF09\u306A\u3089\u30015\u6708\u5206\u306F15\u301C31\u65E5\u30018\u6708\u5206\u306F1\u301C14\u65E5\u306E\u58F2\u4E0A\u3067\u3059\u3002"
          },
          {
            type: "h2",
            id: "report",
            text: "\u5831\u544A\u3068\u652F\u6255\u3044\u306E\u624B\u9806"
          },
          {
            type: "steps",
            items: [
              "\u8CFC\u5165\u8005\u304C\u6BCE\u6708\u652F\u6255\u65E5\u307E\u3067\u306B\u524D\u6708\u306E\u58F2\u4E0A\u3092\u5831\u544A\u3057\u3001\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u632F\u308A\u8FBC\u307F\u307E\u3059\u3002",
              "\u7BA1\u7406\u8005\u304C\u5165\u91D1\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002",
              "\u78BA\u8A8D\u3055\u308C\u305F\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u304B\u3089\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u624B\u6570\u6599\u3092\u5DEE\u3057\u5F15\u3044\u305F\u91D1\u984D\u304C\u8CA9\u58F2\u8005\u306B\u652F\u6255\u308F\u308C\u307E\u3059\u3002"
            ]
          },
          {
            type: "p",
            text: "\u5831\u544A\u6642\u306B\u58F2\u4E0A\u306E\u8A3C\u6191\uFF08PDF\u30FBJPG\u30FBPNG\u30011\u30D5\u30A1\u30A4\u30EB10MB\u307E\u3067\uFF09\u3092\u4E00\u7DD2\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002\u632F\u8FBC\u5F8C\u306B\u300C\u65E9\u3081\u306E\u5165\u91D1\u78BA\u8A8D\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u300D\u3092\u62BC\u3059\u3068\u3001\u7BA1\u7406\u8005\u304C\u512A\u5148\u3057\u3066\u78BA\u8A8D\u3057\u307E\u3059\u3002\u62BC\u3055\u306A\u304F\u3066\u3082\u5165\u91D1\u306F\u78BA\u8A8D\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "fix",
            text: "\u5831\u544A\u5185\u5BB9\u304C\u9593\u9055\u3063\u3066\u3044\u305F\u3068\u304D"
          },
          {
            type: "list",
            items: [
              "\u5165\u91D1\u78BA\u8A8D\u524D \u2014 \u8CFC\u5165\u8005\u306F\u5831\u544A\u3057\u305F\u58F2\u4E0A\u3092\u81EA\u5206\u3067\u4FEE\u6B63\u3067\u304D\u3001\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u304C\u518D\u8A08\u7B97\u3055\u308C\u3066\u8CA9\u58F2\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3059\u3002",
              "\u5165\u91D1\u78BA\u8A8D\u524D \u2014 \u8CA9\u58F2\u8005\u306F\u5B9F\u969B\u306E\u58F2\u4E0A\u3068\u7570\u306A\u308B\u5831\u544A\u3092\u5DEE\u3057\u623B\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u5DEE\u3057\u623B\u3055\u308C\u305F\u6708\u306F\u8CFC\u5165\u8005\u304C\u518D\u5EA6\u5831\u544A\u3057\u307E\u3059\u3002",
              "\u5165\u91D1\u78BA\u8A8D\u5F8C \u2014 \u8CA9\u58F2\u8005\u306F\u7406\u7531\u3068\u8CC7\u6599\u3092\u6DFB\u3048\u3066\u7570\u8B70\u3092\u7533\u3057\u7ACB\u3066\u3089\u308C\u307E\u3059\u3002\u7BA1\u7406\u8005\u304C\u8CFC\u5165\u8005\u304B\u3089\u8FFD\u52A0\u306E\u8A3C\u6191\u3092\u53D7\u3051\u53D6\u3063\u3066\u78BA\u8A8D\u3057\u3001\u8A02\u6B63\u307E\u305F\u306F\u68C4\u5374\u3057\u307E\u3059\u3002",
              "\u8A02\u6B63\u3055\u308C\u308B\u3068\u3001\u6B63\u3057\u3044\u58F2\u4E0A\u3068\u3059\u3067\u306B\u652F\u6255\u3063\u305F\u91D1\u984D\u306E\u5DEE\u984D\u5206\u3092\u8FFD\u52A0\u3067\u632F\u308A\u8FBC\u3080\u304B\u3001\u8CA9\u58F2\u8005\u3078\u306E\u652F\u6255\u3044\u304B\u3089\u5DEE\u3057\u5F15\u304B\u308C\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: `\u652F\u6255\u65E5\u306E${BUSINESS2.ROYALTY_REPORT_REMINDER_DAYS}\u65E5\u524D\u304B\u3089\u8CFC\u5165\u8005\u306B\u5831\u544A\u306E\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u901A\u77E5\u304C\u5C4A\u304D\u3001\u652F\u6255\u65E5\u3092\u904E\u304E\u3066\u3082\u5831\u544A\u304C\u306A\u3044\u5834\u5408\u306F\u3001\u8CFC\u5165\u8005\u306B\u306F\u5EF6\u6EDE\u901A\u77E5\u3001\u8CA9\u58F2\u8005\u306B\u306F\u9045\u5EF6\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002
\u5831\u544A\u5C65\u6B74\u3068\u652F\u6255\u72B6\u6CC1\u306F\u3001\u6CE8\u6587\u8A73\u7D30\u306E\u4E0B\u90E8\u306B\u3042\u308B\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u6B04\u3067\u53CC\u65B9\u304C\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u304C\u8907\u6570\u3042\u308B\u5834\u5408\u306F\u3001\u30DE\u30A4\u30DA\u30FC\u30B8 > \u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3067\u5831\u544A\u3059\u308B\u6708\u3068\u53D7\u3051\u53D6\u308B\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u307E\u3068\u3081\u3066\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002`
          }
        ]
      }
    ]
  },
  {
    title: "\u6848\u4EF6\u30AC\u30A4\u30C9",
    pages: [
      {
        slug: "sponsorship",
        title: "\u6848\u4EF6\u306E\u6982\u8981",
        description: "\u4F01\u696D\u304C\u6848\u4EF6\u3092\u63B2\u8F09\u3057\u3001\u8A8D\u8A3C\u6E08\u307F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u5FDC\u52DF\u3057\u3066\u4F53\u9A13\u3057\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u3067\u5831\u544A\u3057\u307E\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\u6848\u4EF6\u3068\u306F"
          },
          {
            type: "p",
            text: "\u4F01\u696D\uFF08\u6848\u4EF6\u306E\u63B2\u8F09\u8005\uFF09\u304C\u88FD\u54C1\u30FB\u30B5\u30FC\u30D3\u30B9\u30FB\u6765\u5E97\u4F53\u9A13\u3092\u63D0\u4F9B\u3057\u3001\u8A8D\u8A3C\u6E08\u307F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\uFF08\u5FDC\u52DF\u8005\uFF09\u304C\u305D\u308C\u3092\u4F53\u9A13\u3057\u305F\u5F8C\u3001SNS\u6295\u7A3F\u306A\u3069\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3067\u5831\u544A\u3059\u308B\u52DF\u96C6\u30B5\u30FC\u30D3\u30B9\u3067\u3059\u3002\n\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u4F01\u696D\u30FB\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306B\u5206\u304B\u308C\u3066\u3044\u307E\u305B\u3093\u30021\u3064\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u6848\u4EF6\u3092\u63B2\u8F09\u3059\u308B\u3053\u3068\u3082\u3001\u4ED6\u306E\u6848\u4EF6\u306B\u5FDC\u52DF\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "flow",
            text: "\u6848\u4EF6\u306E\u6D41\u308C"
          },
          {
            type: "steps",
            items: [
              "\u4F01\u696D\u304C\u6848\u4EF6\u30BF\u30D6\u306E\uFF3B\u6848\u4EF6\u3092\u63B2\u8F09\uFF3D\u304B\u3089\u3001\u63D0\u4F9B\u5185\u5BB9\u30FB\u4F9D\u983C\u4E8B\u9805\u30FB\u627F\u8A8D\u65B9\u5F0F\u30FB\u5FDC\u52DF\u6761\u4EF6\u3092\u66F8\u3044\u3066\u767B\u9332\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u307E\u3059\u3002",
              "\u904B\u55B6\u8005\u304C\u5BE9\u67FB\u3057\u3066\u627F\u8A8D\u3059\u308B\u3068\u3001\u6848\u4EF6\u304C\u52DF\u96C6\u4E2D\u3068\u3057\u3066\u516C\u958B\u3055\u308C\u307E\u3059\u3002",
              "\u5FDC\u52DF\u6761\u4EF6\u3092\u6E80\u305F\u3059\u8A8D\u8A3C\u6E08\u307F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u6848\u4EF6\u306E\u8A73\u7D30\u304B\u3089\u5FDC\u52DF\u3057\u307E\u3059\u3002\u6765\u5E97\u6848\u4EF6\u306E\u5834\u5408\u306F\u6765\u5E97\u4E88\u5B9A\u65E5\u3082\u5165\u529B\u3057\u307E\u3059\u3002",
              "\u627F\u8A8D\u65B9\u5F0F\u306B\u3088\u3063\u3066\u3001\u4F01\u696D\u304C\u627F\u8A8D\u3059\u308B\u304B\uFF08\u627F\u8A8D\u5F8C\u306B\u78BA\u5B9A\uFF09\u3001\u5FDC\u52DF\u3057\u305F\u6642\u70B9\u3067\u3059\u3050\u306B\u78BA\u5B9A\u3057\u307E\u3059\uFF08\u5FDC\u52DF\u3067\u3059\u3050\u78BA\u5B9A\uFF09\u3002",
              "\u78BA\u5B9A\u3057\u305F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u6765\u5E97\u30FB\u4F53\u9A13\u3057\u3001\u4F9D\u983C\u4E8B\u9805\u3069\u304A\u308A\u306B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u6295\u7A3F\u3057\u307E\u3059\u3002",
              "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u5FDC\u52DF\u8A73\u7D30\u306E\uFF3B\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3092\u767B\u9332\uFF3D\u3067\u30EC\u30D3\u30E5\u30FC\u3068\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u30EA\u30F3\u30AF\u3092\u6B8B\u3059\u3068\u3001\u4F01\u696D\u304C\uFF3B\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u78BA\u8A8D\uFF3D\u3092\u62BC\u3057\u3066\u6848\u4EF6\u304C\u5B8C\u4E86\u3057\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "where",
            text: "\u3069\u3053\u3067\u898B\u3089\u308C\u307E\u3059\u304B"
          },
          {
            type: "list",
            items: [
              "\u6848\u4EF6\u30BF\u30D6 \u2014 \u52DF\u96C6\u4E2D\u306E\u6848\u4EF6\u4E00\u89A7\u3002\u30B8\u30E3\u30F3\u30EB\u30FB\u5730\u57DF\u3067\u7D5E\u308A\u8FBC\u307F\u3001\u30BF\u30A4\u30C8\u30EB\u30FB\u4F01\u696D\u540D\u30FB\u5834\u6240\u3067\u691C\u7D22\u3057\u307E\u3059\u3002",
              "\u6848\u4EF6\u30BF\u30D6\u4E0A\u306E\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8 \u2014 \u6848\u4EF6\u3092\u63B2\u8F09\u3057\u305F\u3053\u3068\u304C\u3042\u308C\u3070\uFF3B\u53D7\u3051\u53D6\u3063\u305F\u5FDC\u52DF\uFF3D\u3001\u9032\u884C\u4E2D\u306E\u5FDC\u52DF\u304C\u3042\u308C\u3070\uFF3B\u81EA\u5206\u306E\u5FDC\u52DF\uFF3D\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
              "\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u63B2\u8F09\u3057\u305F\u6848\u4EF6 \u2014 \u63B2\u8F09\u3057\u305F\u6848\u4EF6\u3068\u53D7\u3051\u53D6\u3063\u305F\u5FDC\u52DF\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002",
              "\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u6848\u4EF6\u306E\u5FDC\u52DF\u5C65\u6B74 \u2014 \u5FDC\u52DF\u3057\u305F\u6848\u4EF6\u306E\u9032\u884C\u72B6\u6CC1\u3068\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: "\u6848\u4EF6\u306F\u4F01\u696D\u3068\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306E\u9593\u306E\u7D04\u675F\u3067\u3059\u3002Inflip\u306F\u52DF\u96C6\u3068\u9032\u884C\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u304C\u3001\u63D0\u4F9B\u3055\u308C\u308B\u88FD\u54C1\u30FB\u30B5\u30FC\u30D3\u30B9\u3068\u30DF\u30C3\u30B7\u30E7\u30F3\u306E\u5C65\u884C\u306B\u5BFE\u3059\u308B\u8CAC\u4EFB\u306F\u5404\u5F53\u4E8B\u8005\u306B\u3042\u308A\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "sponsorship-posting",
        title: "\u6848\u4EF6\u3092\u63B2\u8F09\u3059\u308B",
        description: "\u6848\u4EF6\u3092\u4F5C\u6210\u3057\u3066\u5BE9\u67FB\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u3001\u516C\u958B\u3055\u308C\u308B\u307E\u3067\u306E\u6D41\u308C\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "phone",
            text: "\u307E\u305A\u9023\u7D61\u5148\u3092\u767B\u9332\u3057\u307E\u3059"
          },
          {
            type: "p",
            text: "\u6848\u4EF6\u306F\u9023\u7D61\u5148\u3092\u767B\u9332\u3057\u305F\u4F1A\u54E1\u306E\u307F\u63B2\u8F09\u3067\u304D\u307E\u3059\u3002\u904B\u55B6\u8005\u304C\u5BE9\u67FB\u306E\u969B\u306B\u4F01\u696D\u3078\u9023\u7D61\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u305F\u3081\u3067\u3059\u3002\n\uFF3B\u6848\u4EF6\u3092\u63B2\u8F09\uFF3D\u3092\u62BC\u3057\u305F\u3068\u304D\u306B\u9023\u7D61\u5148\u304C\u306A\u3044\u5834\u5408\u306F\u3001\u307E\u305A\u767B\u9332\u306E\u6848\u5185\u30A6\u30A3\u30F3\u30C9\u30A6\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u9023\u7D61\u5148\u3092\u767B\u9332\u3059\u308B\u3068\u3059\u3050\u306B\u4F5C\u6210\u753B\u9762\u306B\u9032\u307F\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "fields",
            text: "\u5165\u529B\u3059\u308B\u9805\u76EE"
          },
          {
            type: "list",
            items: [
              "\u30E1\u30A4\u30F3\u753B\u50CF\uFF08\u4EFB\u610F\uFF09 \u2014 \u4E00\u89A7\u3068\u8A73\u7D30\u306B\u8868\u793A\u3055\u308C\u308B\u8868\u7D19\u3067\u3059\u3002JPG\u30FBPNG\u30FBWebP\u30012MB\u307E\u3067\u3067\u3059\u3002",
              "\u30BF\u30A4\u30C8\u30EB \u2014 \u4F8B\uFF09\u8056\u6C34\u306E\u30C7\u30B6\u30FC\u30C8\u30AB\u30D5\u30A7 \u65B0\u30E1\u30CB\u30E5\u30FC\u6765\u5E97\u6848\u4EF6",
              "\u4F01\u696D\u540D \u2014 \u4F01\u696D\u30FB\u30D6\u30E9\u30F3\u30C9\u306E\u540D\u524D",
              "\u30B8\u30E3\u30F3\u30EB\u30FB\u5730\u57DF \u2014 \u4E00\u89A7\u3067\u7D5E\u308A\u8FBC\u3080\u3068\u304D\u306B\u4F7F\u308F\u308C\u307E\u3059\u3002\u5730\u57DF\u306F\u5168\u56FD\u30FB\u30AA\u30F3\u30E9\u30A4\u30F3\u306817\u306E\u5E02\u30FB\u9053\u304B\u3089\u9078\u3073\u307E\u3059\u3002",
              "\u6765\u5E97\u306E\u6709\u7121 \u2014 \u5E97\u8217\u30FB\u5BBF\u6CCA\u65BD\u8A2D\u306E\u3088\u3046\u306B\u6765\u5E97\u304C\u5FC5\u8981\u306A\u3089\uFF3B\u6765\u5E97\u3057\u3066\u5B9F\u65BD\uFF3D\u3001\u914D\u9001\u30FB\u30AA\u30F3\u30E9\u30A4\u30F3\u306E\u3088\u3046\u306B\u6765\u5E97\u304C\u4E0D\u8981\u306A\u3089\uFF3B\u6765\u5E97\u306A\u3057\u3067\u5B9F\u65BD\uFF3D\u3002\u6765\u5E97\u6848\u4EF6\u306F\u4F4F\u6240\u3092\u691C\u7D22\u3057\u3066\u9078\u3073\u3001\u5FDC\u52DF\u8005\u304B\u3089\u6765\u5E97\u4E88\u5B9A\u65E5\u3092\u53D7\u3051\u53D6\u308A\u307E\u3059\u3002",
              "\u6848\u4EF6\u3067\u63D0\u4F9B\u3059\u308B\u3082\u306E \u2014 \u4F8B\uFF092\u540D\u5206\u306E\u30C7\u30B6\u30FC\u30C8\u30BB\u30C3\u30C8\uFF0B\u30C9\u30EA\u30F3\u30AF\u3001\u88FD\u54C11\u500B\u30D7\u30EC\u30BC\u30F3\u30C8\u3002\u540C\u4F34\u3067\u304D\u308B\u4EBA\u6570\u3082\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002",
              "\u7D39\u4ECB\u3068\u4F9D\u983C\u4E8B\u9805 \u2014 \u4F01\u696D\u306E\u7D39\u4ECB\u3068\u5E0C\u671B\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u30FB\u65E5\u7A0B\u3092\u66F8\u304D\u307E\u3059\u3002\u8A73\u3057\u3044\u66F8\u304D\u65B9\u306F\u300C\u4F9D\u983C\u4E8B\u9805\u306E\u66F8\u304D\u65B9\u300D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002",
              "\u627F\u8A8D\u65B9\u5F0F\u3068\u5FDC\u52DF\u6761\u4EF6 \u2014 \u8AB0\u304C\u5FDC\u52DF\u3067\u304D\u3001\u5FDC\u52DF\u3057\u305F\u3089\u3069\u306E\u3088\u3046\u306B\u78BA\u5B9A\u3059\u308B\u304B\u3092\u6C7A\u3081\u307E\u3059\u3002\u300C\u627F\u8A8D\u65B9\u5F0F\u3068\u5FDC\u52DF\u6761\u4EF6\u300D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"
            ]
          },
          {
            type: "h2",
            id: "review",
            text: "\u5BE9\u67FB\u3068\u516C\u958B"
          },
          {
            type: "steps",
            items: [
              "\uFF3B\u6848\u4EF6\u306E\u767B\u9332\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\uFF3D\u3092\u62BC\u3059\u3068\u5BE9\u67FB\u5F85\u3061\u306B\u306A\u308A\u307E\u3059\u3002",
              "\u904B\u55B6\u8005\u304C\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u627F\u8A8D\u3059\u308B\u3068\u3001\u52DF\u96C6\u4E2D\u3068\u3057\u3066\u516C\u958B\u3055\u308C\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002",
              "\u5374\u4E0B\u3055\u308C\u305F\u5834\u5408\u306F\u7406\u7531\u3068\u3068\u3082\u306B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002\u5185\u5BB9\u3092\u4FEE\u6B63\u3057\u3066\u518D\u5EA6\u5BE9\u67FB\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "list",
            items: [
              "\u6848\u4EF6\u4E00\u89A7\u306B\u306F\u8868\u7D19\u30FB\u30BF\u30A4\u30C8\u30EB\u30FB\u4F01\u696D\u540D\u3060\u3051\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u63D0\u4F9B\u5185\u5BB9\u30FB\u7D39\u4ECB\u30FB\u5FDC\u52DF\u6761\u4EF6\u306F\u3001\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E\u95B2\u89A7\u57FA\u6E96\u3092\u8D85\u3048\u308B\u8A8D\u8A3C\u6E08\u307F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306B\u306E\u307F\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
              "\u516C\u958B\u3055\u308C\u305F\u6848\u4EF6\u306E\u5185\u5BB9\u3092\u4FEE\u6B63\u3059\u308B\u3068\u3001\u518D\u5EA6\u5BE9\u67FB\u3092\u53D7\u3051\u307E\u3059\u3002\u3053\u306E\u3068\u304D\u627F\u8A8D\u5F85\u3061\u3060\u3063\u305F\u5FDC\u52DF\u306F\u5909\u66F4\u524D\u306E\u5185\u5BB9\u3092\u898B\u3066\u884C\u308F\u308C\u305F\u5FDC\u52DF\u306E\u305F\u3081\u3001\u3059\u3079\u3066\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u3001\u5FDC\u52DF\u8005\u306B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002\u78BA\u5B9A\u3057\u305F\u5FDC\u52DF\u306F\u305D\u306E\u307E\u307E\u3067\u3059\u3002",
              "\u30E1\u30A4\u30F3\u753B\u50CF\u3060\u3051\u3092\u5909\u66F4\u3057\u305F\u5834\u5408\u306F\u518D\u5BE9\u67FB\u3055\u308C\u307E\u305B\u3093\u3002",
              "\u516C\u958B\u3055\u308C\u305F\u3053\u3068\u304C\u306A\u304F\u5FDC\u52DF\u3082\u53D7\u3051\u305F\u3053\u3068\u306E\u306A\u3044\u6848\u4EF6\u306F\u3001\u8A73\u7D30\u304B\u3089\uFF3B\u524A\u9664\uFF3D\u3067\u304D\u307E\u3059\u3002\u516C\u958B\u3055\u308C\u305F\u6848\u4EF6\u306F\u524A\u9664\u3067\u306F\u306A\u304F\u52DF\u96C6\u3092\u7DE0\u3081\u5207\u308A\u307E\u3059\u3002"
            ]
          }
        ]
      },
      {
        slug: "sponsorship-approval",
        title: "\u627F\u8A8D\u65B9\u5F0F\u3068\u5FDC\u52DF\u6761\u4EF6",
        description: "\u5FDC\u52DF\u3067\u3059\u3050\u78BA\u5B9A\u3059\u308B\u304B\u3001\u81EA\u5206\u3067\u9078\u3093\u3067\u627F\u8A8D\u3059\u308B\u304B\u3068\u3001\u5FDC\u52DF\u8CC7\u683C\u3092\u6C7A\u3081\u307E\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "mode",
            text: "\u627F\u8A8D\u65B9\u5F0F \u2014 \u3069\u3061\u3089\u304B1\u3064\u3092\u9078\u3073\u307E\u3059"
          },
          {
            type: "example",
            label: "\u627F\u8A8D\u5F8C\u306B\u78BA\u5B9A",
            text: "\u5FDC\u52DF\u8005\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u898B\u3066\u3001\u81EA\u5206\u304C\u627F\u8A8D\u3057\u305F\u4EBA\u3060\u3051\u304C\u78BA\u5B9A\u3057\u307E\u3059\u3002\n\u5FDC\u52DF\u304C\u5C4A\u304F\u3068\u901A\u77E5\u304C\u6765\u3066\u3001\uFF3B\u53D7\u3051\u53D6\u3063\u305F\u5FDC\u52DF\uFF3D\u3067\u30C1\u30E3\u30F3\u30CD\u30EB\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u30FB\u30E1\u30C3\u30BB\u30FC\u30B8\u30FB\u6765\u5E97\u4E88\u5B9A\u65E5\u3092\u898B\u3066\u627F\u8A8D\u307E\u305F\u306F\u62D2\u5426\u3057\u307E\u3059\u3002\n\u52DF\u96C6\u4EBA\u6570\u304C\u6C7A\u307E\u3063\u3066\u3044\u308B\u5834\u5408\u3084\u3001\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u7279\u5FB4\u3092\u898B\u3066\u9078\u3073\u305F\u3044\u5834\u5408\u306B\u5411\u3044\u3066\u3044\u307E\u3059\u3002"
          },
          {
            type: "example",
            label: "\u5FDC\u52DF\u3067\u3059\u3050\u78BA\u5B9A",
            text: "\u5FDC\u52DF\u6761\u4EF6\u3092\u6E80\u305F\u3059\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u5FDC\u52DF\u3059\u308B\u3068\u3001\u627F\u8A8D\u306A\u3057\u3067\u3059\u3050\u306B\u78BA\u5B9A\u3057\u307E\u3059\u3002\n\u3044\u3061\u3044\u3061\u9078\u3076\u5FC5\u8981\u304C\u306A\u3044\u306E\u3067\u65E9\u3044\u3067\u3059\u304C\u3001\u6761\u4EF6\u3055\u3048\u6E80\u305F\u305B\u3070\u8AB0\u3067\u3082\u78BA\u5B9A\u3059\u308B\u305F\u3081\u3001\u5FDC\u52DF\u6761\u4EF6\u306F\u614E\u91CD\u306B\u6C7A\u3081\u3066\u304F\u3060\u3055\u3044\u3002\n\u4EBA\u6570\u5236\u9650\u306A\u3057\u3067\u591A\u304F\u96C6\u3081\u305F\u3044\u5834\u5408\u306B\u5411\u3044\u3066\u3044\u307E\u3059\u3002\u5341\u5206\u96C6\u307E\u3063\u305F\u3089\uFF3B\u52DF\u96C6\u3092\u7DE0\u3081\u5207\u308B\uFF3D\u3067\u5FDC\u52DF\u3092\u7DE0\u3081\u5207\u308A\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "requirements",
            text: "\u5FDC\u52DF\u6761\u4EF6 \u2014 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u5225\u306E\u6700\u4F4E\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570"
          },
          {
            type: "p",
            text: "\u3053\u306E\u6848\u4EF6\u306B\u5FDC\u52DF\u3067\u304D\u308B\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306E\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u306E\u57FA\u6E96\u3067\u3059\u3002YouTube\u30FBInstagram\u30FBTikTok\u30FBThreads\u30FBSOOP\u30FBPandaTV\u306E\u3046\u30611\u3064\u4EE5\u4E0A\u3092\u30AA\u30F3\u306B\u3057\u3001\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3054\u3068\u306B\u6700\u4F4E\u5024\uFF08\u4E07\u4EBA\u5358\u4F4D\uFF09\u3092\u5165\u529B\u3057\u307E\u3059\u3002\n\u8907\u6570\u306E\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u305D\u306E\u3046\u30611\u3064\u3092\u6E80\u305F\u305B\u3070\u5FDC\u52DF\u3067\u304D\u307E\u3059\u3002\u5224\u5B9A\u306F\u5FDC\u52DF\u8005\u304C\u8A8D\u8A3C\u3057\u305F\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u6570\u5024\u3067\u884C\u3044\u307E\u3059\u3002\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u3092\u516C\u958B\u3057\u3066\u3044\u306A\u3044\u30C1\u30E3\u30F3\u30CD\u30EB\u306F0\u3068\u307F\u306A\u3057\u307E\u3059\u3002"
          },
          {
            type: "example",
            label: "\u4F8B",
            text: "Instagram 1\u4E07\u4EBA\u30FBYouTube 2\u4E07\u4EBA\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\n\u2192 Instagram 1\u4E07\u4EBA\u4EE5\u4E0A\u3001\u307E\u305F\u306FYouTube 2\u4E07\u4EBA\u4EE5\u4E0A\u306E\u8A8D\u8A3C\u6E08\u307F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u5FDC\u52DF\u3067\u304D\u307E\u3059\u3002\n\u2192 Instagram 8\u5343\u4EBA\u3001YouTube\u672A\u8A8D\u8A3C\u306E\u5834\u5408\u306F\u5FDC\u52DF\u3067\u304D\u307E\u305B\u3093\u3002"
          },
          {
            type: "h2",
            id: "platform-standard",
            text: "\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E\u95B2\u89A7\u57FA\u6E96"
          },
          {
            type: "p",
            text: "\u6848\u4EF6\u306E\u8A73\u7D30\u3092\u898B\u3066\u5FDC\u52DF\u3059\u308B\u306B\u306F\u3001\u5FDC\u52DF\u6761\u4EF6\u3068\u306F\u5225\u306BInflip\u304C\u5B9A\u3081\u305F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E\u95B2\u89A7\u57FA\u6E96\u3082\u8D85\u3048\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u8A8D\u8A3C\u3057\u305F\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u3046\u30611\u3064\u304C\u57FA\u6E96\u4EE5\u4E0A\u3067\u3042\u308C\u3070\u5927\u4E08\u592B\u3067\u3059\u3002\n\u57FA\u6E96\u306B\u5C4A\u304B\u306A\u3044\u4F1A\u54E1\u304C\u6848\u4EF6\u3092\u30BF\u30C3\u30D7\u3059\u308B\u3068\u3001\u6848\u5185\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u30C1\u30E3\u30F3\u30CD\u30EB\u5225\u306E\u57FA\u6E96\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "callout",
            text: "\u307E\u3068\u3081\u308B\u3068\u3001\u5FDC\u52DF\u3059\u308B\u306B\u306F \u2460 SNS\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u8A8D\u8A3C \u2461 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E\u95B2\u89A7\u57FA\u6E96\u306E\u30AF\u30EA\u30A2 \u2462 \u3053\u306E\u6848\u4EF6\u306E\u5FDC\u52DF\u6761\u4EF6\u306E\u30AF\u30EA\u30A2\u3001\u306E3\u3064\u304C\u3059\u3079\u3066\u5FC5\u8981\u3067\u3059\u3002\u4E00\u89A7\u3067\u306F\u3001\u5FDC\u52DF\u3067\u304D\u308B\u6848\u4EF6\u306B\u7DD1\u306E\u70B9\u3001\u6761\u4EF6\u306B\u5C4A\u304B\u306A\u3044\u6848\u4EF6\u306B\u8D64\u306E\u70B9\u304C\u4ED8\u304D\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "sponsorship-request",
        title: "\u4F9D\u983C\u4E8B\u9805\u306E\u66F8\u304D\u65B9",
        description: "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306B\u5E0C\u671B\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u306F\u3063\u304D\u308A\u4F1D\u3048\u308B\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "why",
            text: "\u4F9D\u983C\u4E8B\u9805\u304C\u305D\u306E\u307E\u307E\u30DF\u30C3\u30B7\u30E7\u30F3\u306B\u306A\u308A\u307E\u3059"
          },
          {
            type: "p",
            text: "\u300C\u7D39\u4ECB\u3068\u4F9D\u983C\u4E8B\u9805\u300D\u306B\u66F8\u3044\u305F\u5185\u5BB9\u304C\u3001\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u884C\u3046\u30DF\u30C3\u30B7\u30E7\u30F3\u306B\u306A\u308A\u307E\u3059\u3002\u78BA\u5B9A\u3057\u305F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306F\u3053\u306E\u5185\u5BB9\u3092\u898B\u3066\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u308A\u3001\u7D42\u308F\u3063\u305F\u3089\u305D\u306E\u7D50\u679C\u3092\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3068\u3057\u3066\u5831\u544A\u3057\u307E\u3059\u3002\n\u5177\u4F53\u7684\u3067\u3042\u308B\u307B\u3069\u304A\u4E92\u3044\u306E\u671F\u5F85\u304C\u305D\u308D\u3044\u3001\u30DF\u30C3\u30B7\u30E7\u30F3\u306E\u78BA\u8A8D\u3082\u3057\u3084\u3059\u304F\u306A\u308A\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "checklist",
            text: "\u5FC5\u305A\u66F8\u304F\u3053\u3068"
          },
          {
            type: "list",
            items: [
              "\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u7A2E\u985E\u3068\u6570\u91CF \u2014 \u30D5\u30A3\u30FC\u30C9\u5199\u771F\u4F55\u679A\u3001\u30EA\u30FC\u30EB\u30FB\u30B7\u30E7\u30FC\u30C8\u4F55\u672C\u3001\u30D6\u30ED\u30B0\u30EC\u30D3\u30E5\u30FC\u4F55\u4EF6",
              "\u6295\u7A3F\u5148 \u2014 Instagram\u306E\u30D5\u30A3\u30FC\u30C9\u30FB\u30B9\u30C8\u30FC\u30EA\u30FC\u30BA\u3001YouTube\u3001\u30D6\u30ED\u30B0\u306A\u3069",
              "\u5FC5\u305A\u5165\u308C\u308B\u5185\u5BB9 \u2014 \u4F01\u696D\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30BF\u30B0\u3001\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3001\u4F4D\u7F6E\u60C5\u5831\u30BF\u30B0\u3001\u5FC5\u305A\u898B\u305B\u305F\u3044\u30E1\u30CB\u30E5\u30FC\u30FB\u88FD\u54C1",
              "\u65E5\u7A0B \u2014 \u6765\u5E97\u53EF\u80FD\u306A\u66DC\u65E5\u30FB\u6642\u9593\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u6295\u7A3F\u671F\u9650\uFF08\u4F8B\uFF1A\u6765\u5E97\u5F8C7\u65E5\u4EE5\u5185\uFF09",
              "\u6295\u7A3F\u306E\u63B2\u8F09\u671F\u9593 \u2014 \u4F8B\uFF1A\u6700\u4F4E3\u304B\u6708\u63B2\u8F09",
              "\u3057\u3066\u307B\u3057\u304F\u306A\u3044\u3053\u3068 \u2014 \u7AF6\u5408\u5E97\u3078\u306E\u8A00\u53CA\u3001\u64AE\u5F71\u3057\u3066\u307B\u3057\u304F\u306A\u3044\u30A8\u30EA\u30A2\u306A\u3069"
            ]
          },
          {
            type: "h2",
            id: "examples",
            text: "\u4F9D\u983C\u4E8B\u9805\u306E\u4F8B"
          },
          {
            type: "example",
            label: "SNS\u306B\u5199\u771F\u3092\u6295\u7A3F",
            text: "Instagram\u306E\u30D5\u30A3\u30FC\u30C9\u306B\u5E97\u8217\u30FB\u30E1\u30CB\u30E5\u30FC\u306E\u5199\u771F\u30923\u679A\u4EE5\u4E0A\u6295\u7A3F\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n@\u4F01\u696D\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30BF\u30B0\u3001#\u8056\u6C34\u30AB\u30D5\u30A7 #\u65B0\u30E1\u30CB\u30E5\u30FC \u306E\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3001\u4F4D\u7F6E\u60C5\u5831\u30BF\u30B0\u3092\u5165\u308C\u3066\u304F\u3060\u3055\u3044\u3002\n\u6765\u5E97\u5F8C7\u65E5\u4EE5\u5185\u306B\u6295\u7A3F\u3057\u3001\u6700\u4F4E3\u304B\u6708\u63B2\u8F09\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u6295\u7A3F\u306B\u300CPR\u300D\u307E\u305F\u306F\u300C\u5E83\u544A\u300D\u3068\u8868\u793A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "example",
            label: "\u30EA\u30FC\u30EB\u30FB\u30B7\u30E7\u30FC\u30C8\u52D5\u753B",
            text: "15\u301C30\u79D2\u306E\u30EA\u30FC\u30EB1\u672C \u2014 \u5E97\u8217\u306E\u5165\u53E3\u304B\u3089\u770B\u677F\u30E1\u30CB\u30E5\u30FC\u307E\u3067\u898B\u305B\u3066\u304F\u3060\u3055\u3044\u3002\nBGM\u306F\u81EA\u7531\u3001\u5B57\u5E55\u306B\u30E1\u30CB\u30E5\u30FC\u540D\u3092\u5165\u308C\u3066\u304F\u3060\u3055\u3044\u3002\n\u6295\u7A3F\u524D\u306B\u4F01\u696D\u306B\u898B\u305B\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\uFF08\u5FC5\u8981\u306A\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u307E\u3059\uFF09\u3002"
          },
          {
            type: "example",
            label: "\u88FD\u54C1\u30EC\u30D3\u30E5\u30FC",
            text: "\u88FD\u54C1\u3092\u53D7\u3051\u53D6\u3063\u3066\u304B\u308914\u65E5\u4EE5\u5185\u306B\u30D6\u30ED\u30B0\u30EC\u30D3\u30E5\u30FC\u30921\u4EF6\uFF08\u5199\u771F5\u679A\u4EE5\u4E0A\uFF09\u6295\u7A3F\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F7F\u7528\u524D\u30FB\u4F7F\u7528\u5F8C\u306E\u6BD4\u8F03\u5199\u771F\u3092\u5165\u308C\u3066\u304F\u3060\u3055\u3044\u3002\n\u7387\u76F4\u306A\u30EC\u30D3\u30E5\u30FC\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002\u8A87\u5F35\u3057\u305F\u52B9\u679C\u306E\u8868\u73FE\u306F\u63A7\u3048\u3066\u304F\u3060\u3055\u3044\u3002"
          },
          {
            type: "callout",
            text: "\u6848\u4EF6\u3067\u63D0\u4F9B\u3092\u53D7\u3051\u305F\u6295\u7A3F\u306B\u306F\u300CPR\u300D\u300C\u5E83\u544A\u300D\u306E\u3088\u3046\u306B\u5BFE\u4FA1\u3092\u53D7\u3051\u53D6\u3063\u305F\u4E8B\u5B9F\u3092\u660E\u793A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\uFF08\u97D3\u56FD\u306E\u8868\u793A\u30FB\u5E83\u544A\u6CD5\u3001\u516C\u6B63\u53D6\u5F15\u59D4\u54E1\u4F1A\u306E\u63A8\u85A6\u30FB\u4FDD\u8A3C\u306B\u95A2\u3059\u308B\u5BE9\u67FB\u6307\u91DD\uFF09\u3002\u865A\u507D\u30FB\u8A87\u5F35\u3057\u305F\u30EC\u30D3\u30E5\u30FC\u3092\u6C42\u3081\u305F\u308A\u3001\u6CD5\u4EE4\u4E0A\u5E83\u544A\u304C\u5236\u9650\u3055\u308C\u308B\u5185\u5BB9\uFF08\u533B\u7642\u30FB\u5065\u5EB7\u6A5F\u80FD\u98DF\u54C1\u306E\u52B9\u80FD\u306A\u3069\uFF09\u3092\u4F9D\u983C\u3057\u305F\u308A\u3059\u308B\u6848\u4EF6\u306F\u63B2\u8F09\u3067\u304D\u307E\u305B\u3093\u3002"
          }
        ]
      },
      {
        slug: "sponsorship-managing",
        title: "\u5FDC\u52DF\u8005\u3092\u7BA1\u7406\u3059\u308B",
        description: "\u53D7\u3051\u53D6\u3063\u305F\u5FDC\u52DF\u306E\u627F\u8A8D\u30FB\u62D2\u5426\u3001\u52DF\u96C6\u306E\u7DE0\u3081\u5207\u308A\u3001\u30DF\u30C3\u30B7\u30E7\u30F3\u306E\u78BA\u8A8D\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "received",
            text: "\u53D7\u3051\u53D6\u3063\u305F\u5FDC\u52DF"
          },
          {
            type: "p",
            text: "\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u63B2\u8F09\u3057\u305F\u6848\u4EF6 \u2192 \uFF3B\u53D7\u3051\u53D6\u3063\u305F\u5FDC\u52DF\uFF3D\u30BF\u30D6\u3067\u3001\u3059\u3079\u3066\u306E\u6848\u4EF6\u306B\u5C4A\u3044\u305F\u5FDC\u52DF\u30921\u304B\u6240\u3067\u51E6\u7406\u3057\u307E\u3059\u3002\u6848\u4EF6\u8A73\u7D30\u306E\u5FDC\u52DF\u8005\u4E00\u89A7\u3067\u3082\u540C\u3058\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
          },
          {
            type: "list",
            items: [
              "\u627F\u8A8D\u5F85\u3061 \u2014 \u81EA\u5206\u304C\u6C7A\u3081\u308B\u5FDC\u52DF\uFF08\u627F\u8A8D\u5F8C\u306B\u78BA\u5B9A\u306E\u6848\u4EF6\uFF09",
              "\u30DF\u30C3\u30B7\u30E7\u30F3\u78BA\u8A8D \u2014 \u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3092\u767B\u9332\u3057\u3001\u78BA\u8A8D\u3092\u5F85\u3063\u3066\u3044\u308B\u5FDC\u52DF",
              "\u9032\u884C\u4E2D \u2014 \u78BA\u5B9A\u6E08\u307F\u3067\u3001\u6765\u5E97\u30FB\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u5F85\u3063\u3066\u3044\u308B\u5FDC\u52DF",
              "\u5B8C\u4E86 \u2014 \u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u30FB\u62D2\u5426\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u30FB\u81EA\u52D5\u30AD\u30E3\u30F3\u30BB\u30EB\u306B\u306A\u3063\u305F\u5FDC\u52DF"
            ]
          },
          {
            type: "p",
            text: "\u5FDC\u52DF\u8005\u306E\u884C\u306B\u306F\u3001\u30C1\u30E3\u30F3\u30CD\u30EB\u3068\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u3001\u6B8B\u3057\u305F\u30E1\u30C3\u30BB\u30FC\u30B8\u3001\u6765\u5E97\u4E88\u5B9A\u65E5\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u4EE5\u524D\u306B\u81EA\u5206\u306E\u6848\u4EF6\u3067\u30DF\u30C3\u30B7\u30E7\u30F3\u307E\u3067\u5B8C\u4E86\u3057\u305F\u3053\u3068\u304C\u3042\u308C\u3070\u300C\u3053\u306E\u6848\u4EF6\u306E\u53C2\u52A0 N\u56DE\u30FB\u81EA\u5206\u306E\u6848\u4EF6\u306E\u53C2\u52A0 N\u56DE\u300D\u3082\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "decide",
            text: "\u627F\u8A8D\u3068\u62D2\u5426"
          },
          {
            type: "list",
            items: [
              "\u627F\u8A8D\u3059\u308B\u3068\u3059\u3050\u306B\u78BA\u5B9A\u3057\u3001\u5FDC\u52DF\u8005\u306B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002\u627F\u8A8D\u306F\u53D6\u308A\u6D88\u305B\u307E\u305B\u3093\u3002",
              "\u62D2\u5426\u3059\u308B\u3068\u304D\u306F\u7406\u7531\u3092\u5FC5\u305A\u66F8\u304D\u307E\u3059\u3002\u7406\u7531\u306F\u5FDC\u52DF\u8005\u306B\u305D\u306E\u307E\u307E\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
              "\u62D2\u5426\u3055\u308C\u305F\u5FDC\u52DF\u8005\u306F\u540C\u3058\u6848\u4EF6\u306B\u518D\u5EA6\u5FDC\u52DF\u3067\u304D\u307E\u305B\u3093\u3002"
            ]
          },
          {
            type: "h2",
            id: "auto-cancel",
            text: "\u81EA\u52D5\u7684\u306B\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u308B\u5FDC\u52DF"
          },
          {
            type: "list",
            items: [
              "\u6765\u5E97\u4E88\u5B9A\u65E5\u3092\u904E\u304E\u3066\u3082\u627F\u8A8D\u3055\u308C\u306A\u304B\u3063\u305F\u5FDC\u52DF\u306F\u3001\u7FCC\u65E5\u306B\u81EA\u52D5\u7684\u306B\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3059\u3002",
              "\u6848\u4EF6\u306E\u5185\u5BB9\u3092\u4FEE\u6B63\u3059\u308B\u3068\u3001\u627F\u8A8D\u5F85\u3061\u306E\u5FDC\u52DF\u306F\u3059\u3079\u3066\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3059\u3002",
              "\uFF3B\u52DF\u96C6\u3092\u7DE0\u3081\u5207\u308B\uFF3D\u3092\u62BC\u3059\u3068\u3001\u627F\u8A8D\u5F85\u3061\u306E\u5FDC\u52DF\u306F\u3059\u3079\u3066\u62D2\u5426\u3055\u308C\u307E\u3059\uFF08\u300C\u52DF\u96C6\u304C\u7DE0\u3081\u5207\u3089\u308C\u307E\u3057\u305F\u3002\u300D\uFF09\u3002\u78BA\u5B9A\u3057\u305F\u5FDC\u52DF\u306F\u305D\u306E\u307E\u307E\u3067\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "close",
            text: "\u52DF\u96C6\u306E\u7DE0\u3081\u5207\u308A\u3068\u518D\u958B"
          },
          {
            type: "p",
            text: "\u5341\u5206\u96C6\u307E\u3063\u305F\u3089\u3001\u6848\u4EF6\u8A73\u7D30\u3067\uFF3B\u52DF\u96C6\u3092\u7DE0\u3081\u5207\u308B\uFF3D\u3092\u62BC\u3057\u307E\u3059\u3002\u7DE0\u3081\u5207\u3063\u305F\u6848\u4EF6\u306F\u4E00\u89A7\u304B\u3089\u5916\u308C\u3001\u65B0\u3057\u3044\u5FDC\u52DF\u3092\u53D7\u3051\u4ED8\u3051\u307E\u305B\u3093\u3002\n\uFF3B\u52DF\u96C6\u3092\u518D\u958B\uFF3D\u3092\u62BC\u3059\u3068\u3001\u5BE9\u67FB\u306A\u3057\u3067\u518D\u3073\u52DF\u96C6\u4E2D\u306B\u306A\u308A\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "confirm-mission",
            text: "\u30DF\u30C3\u30B7\u30E7\u30F3\u306E\u78BA\u8A8D"
          },
          {
            type: "steps",
            items: [
              "\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3092\u767B\u9332\u3059\u308B\u3068\u901A\u77E5\u304C\u5C4A\u304D\u3001\uFF3B\u53D7\u3051\u53D6\u3063\u305F\u5FDC\u52DF\uFF3D\u306E\u30DF\u30C3\u30B7\u30E7\u30F3\u78BA\u8A8D\u30C1\u30C3\u30D7\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
              "\u6B8B\u3055\u308C\u305F\u30EC\u30D3\u30E5\u30FC\u3068\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u30EA\u30F3\u30AF\u3092\u958B\u304D\u3001\u4F9D\u983C\u4E8B\u9805\u3069\u304A\u308A\u306B\u6295\u7A3F\u3057\u305F\u304B\u78BA\u8A8D\u3057\u307E\u3059\u3002",
              "\uFF3B\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u78BA\u8A8D\uFF3D\u3092\u62BC\u3059\u3068\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u306B\u306A\u308A\u3001\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: "\u4F9D\u983C\u4E8B\u9805\u3068\u7570\u306A\u308B\u6295\u7A3F\u3060\u3063\u305F\u5834\u5408\u306F\u3001\u78BA\u8A8D\u3059\u308B\u524D\u306B1:1\u30C1\u30E3\u30C3\u30C8\u3067\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306B\u4FEE\u6B63\u3092\u4F9D\u983C\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306F\u4F01\u696D\u304C\u78BA\u8A8D\u3059\u308B\u307E\u3067\u30DF\u30C3\u30B7\u30E7\u30F3\u5185\u5BB9\u3092\u4FEE\u6B63\u3067\u304D\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "sponsorship-applying",
        title: "\u6848\u4EF6\u306B\u5FDC\u52DF\u3059\u308B",
        description: "\u8A8D\u8A3C\u6E08\u307F\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u304C\u6848\u4EF6\u3092\u63A2\u3057\u3066\u5FDC\u52DF\u3057\u3001\u78BA\u5B9A\u3059\u308B\u307E\u3067\u306E\u6D41\u308C\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "before",
            text: "\u5FDC\u52DF\u3059\u308B\u524D\u306B"
          },
          {
            type: "p",
            text: "\u6848\u4EF6\u306E\u8A73\u7D30\u3092\u898B\u3066\u5FDC\u52DF\u3059\u308B\u306B\u306F\u3001SNS\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u8A8D\u8A3C\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u8A8D\u8A3C\u3057\u305F\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u3046\u30611\u3064\u304C\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E\u95B2\u89A7\u57FA\u6E96\u3092\u8D85\u3048\u3001\u305D\u306E\u6848\u4EF6\u306E\u5FDC\u52DF\u6761\u4EF6\u3082\u6E80\u305F\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u8A8D\u8A3C\u65B9\u6CD5\u306F\u300C\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u8A8D\u8A3C\u300D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002\n\u6848\u4EF6\u30BF\u30D6\u306E\u300C\u81EA\u5206\u306E\u6761\u4EF6\u306B\u5408\u3046\u6848\u4EF6\u3060\u3051\u8868\u793A\u300D\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u5FDC\u52DF\u3067\u304D\u308B\u6848\u4EF6\u3060\u3051\u3092\u307E\u3068\u3081\u3066\u898B\u3089\u308C\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "apply",
            text: "\u5FDC\u52DF\u3059\u308B"
          },
          {
            type: "steps",
            items: [
              "\u6848\u4EF6\u306E\u8A73\u7D30\u3067\u63D0\u4F9B\u5185\u5BB9\u3068\u7D39\u4ECB\u30FB\u4F9D\u983C\u4E8B\u9805\u3092\u3088\u304F\u8AAD\u307F\u307E\u3059\u3002\u4F9D\u983C\u4E8B\u9805\u304C\u305D\u306E\u307E\u307E\u884C\u3046\u30DF\u30C3\u30B7\u30E7\u30F3\u3067\u3059\u3002",
              "\uFF3B\u5FDC\u52DF\u3059\u308B\uFF3D\u3092\u62BC\u3057\u3001\u4F01\u696D\u306B\u4F1D\u3048\u308B\u30E1\u30C3\u30BB\u30FC\u30B8\uFF08\u4EFB\u610F\uFF09\u3092\u66F8\u304D\u307E\u3059\u3002",
              `\u6765\u5E97\u6848\u4EF6\u306E\u5834\u5408\u306F\u6765\u5E97\u4E88\u5B9A\u65E5\u3092\u9078\u3073\u307E\u3059\u3002\u4ECA\u65E5\u304B\u3089180\u65E5\u4EE5\u5185\u3067\u9078\u3079\u307E\u3059\u3002`,
              "\u5FDC\u52DF\u3067\u3059\u3050\u78BA\u5B9A\u3059\u308B\u6848\u4EF6\u306F\u305D\u306E\u5834\u3067\u78BA\u5B9A\u3057\u3001\u627F\u8A8D\u5F8C\u306B\u78BA\u5B9A\u306E\u6848\u4EF6\u306F\u4F01\u696D\u306E\u6C7A\u5B9A\u3092\u5F85\u3061\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "status",
            text: "\u5FDC\u52DF\u72B6\u6CC1\u3092\u898B\u308B"
          },
          {
            type: "p",
            text: "\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u6848\u4EF6\u306E\u5FDC\u52DF\u5C65\u6B74\u3067\u3001\u9032\u884C\u4E2D\u30FB\u627F\u8A8D\u5F85\u3061\u30FB\u5B8C\u4E86\u306B\u5206\u3051\u3066\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u5FDC\u52DF\u3092\u30BF\u30C3\u30D7\u3059\u308B\u3068\u5FDC\u52DF\u8A73\u7D30\u304C\u958B\u304D\u3001\u81EA\u5206\u306E\u5FDC\u52DF\u5185\u5BB9\u3068\u5FDC\u52DF\u6642\u306E\u6848\u4EF6\u5185\u5BB9\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u5FDC\u52DF\u5F8C\u306B\u4F01\u696D\u304C\u6848\u4EF6\u5185\u5BB9\u3092\u4FEE\u6B63\u3057\u305F\u5834\u5408\u306F\u3001\u305D\u306E\u65E8\u3092\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002"
          },
          {
            type: "list",
            items: [
              "\u62D2\u5426\u3055\u308C\u308B\u3068\u7406\u7531\u3068\u3068\u3082\u306B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002\u62D2\u5426\u3055\u308C\u305F\u6848\u4EF6\u306B\u306F\u518D\u5EA6\u5FDC\u52DF\u3067\u304D\u307E\u305B\u3093\u3002",
              "\u6765\u5E97\u4E88\u5B9A\u65E5\u3092\u904E\u304E\u3066\u3082\u4F01\u696D\u304C\u627F\u8A8D\u3057\u306A\u3044\u5834\u5408\u3001\u5FDC\u52DF\u306F\u81EA\u52D5\u7684\u306B\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3059\u3002\u518D\u5EA6\u5FDC\u52DF\u3067\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "h2",
            id: "cancel",
            text: "\u5FDC\u52DF\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u3068\u518D\u5FDC\u52DF"
          },
          {
            type: "list",
            items: [
              "\u627F\u8A8D\u5F85\u3061\u3068\u78BA\u5B9A\u306E\u72B6\u614B\u3067\u306F\u3001\u5FDC\u52DF\u8A73\u7D30\u306E\uFF3B\u5FDC\u52DF\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\uFF3D\u3067\u30AD\u30E3\u30F3\u30BB\u30EB\u3067\u304D\u307E\u3059\u3002\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3092\u767B\u9332\u3057\u305F\u5F8C\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3067\u304D\u307E\u305B\u3093\u3002",
              "\u30AD\u30E3\u30F3\u30BB\u30EB\u30FB\u81EA\u52D5\u30AD\u30E3\u30F3\u30BB\u30EB\u30FB\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u306E\u5F8C\u306F\u3001\u540C\u3058\u6848\u4EF6\u306B\u518D\u5EA6\u5FDC\u52DF\u3067\u304D\u307E\u3059\u3002\u5FDC\u52DF\u3059\u308B\u305F\u3073\u306B\u65B0\u3057\u3044\u5FDC\u52DF\u3068\u3057\u3066\u8A18\u9332\u3055\u308C\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: "\u78BA\u5B9A\u3057\u305F\u5F8C\u306B\u6765\u5E97\u3084\u30B3\u30F3\u30C6\u30F3\u30C4\u5236\u4F5C\u304C\u96E3\u3057\u304F\u306A\u3063\u305F\u5834\u5408\u306F\u3001\u3059\u3050\u306B\u5FDC\u52DF\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B\u304B\u4F01\u696D\u306B\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002\u78BA\u5B9A\u3057\u305F\u7D04\u675F\u3092\u5B88\u3089\u306A\u3044\u5834\u5408\u3001\u904B\u55B6\u30DD\u30EA\u30B7\u30FC\u306B\u3088\u308A\u5229\u7528\u304C\u5236\u9650\u3055\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002"
          }
        ]
      },
      {
        slug: "sponsorship-mission",
        title: "\u6848\u4EF6\u306E\u5831\u544A\uFF08\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\uFF09",
        description: "\u4F53\u9A13\u5F8C\u3001\u4F9D\u983C\u4E8B\u9805\u3069\u304A\u308A\u306B\u6295\u7A3F\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5831\u544A\u3059\u308B\u65B9\u6CD5\u3067\u3059\u3002",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "\u3044\u3064\u5831\u544A\u3057\u307E\u3059\u304B"
          },
          {
            type: "p",
            text: "\u6765\u5E97\u6848\u4EF6\u306F\u6765\u5E97\u4E88\u5B9A\u65E5\u306E\u5F53\u65E5\u304B\u3089\u3001\u6765\u5E97\u306A\u3057\u306E\u6848\u4EF6\u306F\u78BA\u5B9A\u3059\u308B\u3068\u3059\u3050\u306B\u5831\u544A\u3067\u304D\u307E\u3059\u3002\n\u78BA\u5B9A\u3059\u308B\u3068\u5FDC\u52DF\u8A73\u7D30\u306B\u300C\u6848\u4EF6\u304C\u78BA\u5B9A\u3057\u307E\u3057\u305F\u3002\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u7D42\u3048\u305F\u3089\u3001\u4E0B\u304B\u3089\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u300D\u3068\u8868\u793A\u3055\u308C\u3001\u4E0B\u306B\u30DF\u30C3\u30B7\u30E7\u30F3\u6B04\u304C\u958B\u304D\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "how",
            text: "\u5831\u544A\u306E\u65B9\u6CD5"
          },
          {
            type: "steps",
            items: [
              "\u4F9D\u983C\u4E8B\u9805\u3069\u304A\u308A\u306B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u3063\u3066SNS\u306B\u6295\u7A3F\u3057\u307E\u3059\u3002\u6295\u7A3F\u306B\u306F\u300CPR\u300D\u307E\u305F\u306F\u300C\u5E83\u544A\u300D\u3092\u5FC5\u305A\u8868\u793A\u3057\u307E\u3059\u3002",
              "\u30DE\u30A4\u30DA\u30FC\u30B8 \u2192 \u6848\u4EF6\u306E\u5FDC\u52DF\u5C65\u6B74 \u2192 \u305D\u306E\u5FDC\u52DF\u3092\u30BF\u30C3\u30D7\u3057\u3066\u5FDC\u52DF\u8A73\u7D30\u3092\u958B\u304D\u307E\u3059\u3002",
              "\u30DF\u30C3\u30B7\u30E7\u30F3\u6B04\u306B\u6765\u5E97\u30EC\u30D3\u30E5\u30FC\u3084\u6295\u7A3F\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u8AAC\u660E\u3092\u66F8\u304D\u3001\u6295\u7A3F\u306EURL\u3092\u30EA\u30F3\u30AF\u3068\u3057\u3066\u5165\u308C\u307E\u3059\uFF085\u4EF6\u307E\u3067\u3001https:// \u3067\u59CB\u307E\u308B\u5B8C\u5168\u306AURL\uFF09\u3002",
              "\uFF3B\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3092\u767B\u9332\uFF3D\u3092\u62BC\u3059\u3068\u4F01\u696D\u306B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002",
              "\u4F01\u696D\u304C\u78BA\u8A8D\u3059\u308B\u3068\u300C\u4F01\u696D\u304C\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002\u6848\u4EF6\u304C\u7121\u4E8B\u306B\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u300D\u306B\u5909\u308F\u308A\u3001\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "p",
            text: "\u6587\u7AE0\u3068\u30EA\u30F3\u30AF\u306E\u3069\u3061\u3089\u304B\u4E00\u65B9\u3060\u3051\u3067\u3082\u767B\u9332\u3067\u304D\u307E\u3059\u304C\u3001\u4F01\u696D\u304C\u78BA\u8A8D\u3057\u3084\u3059\u3044\u3088\u3046\u4E21\u65B9\u6B8B\u3059\u3053\u3068\u3092\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002"
          },
          {
            type: "h2",
            id: "example",
            text: "\u5831\u544A\u306E\u4F8B \u2014 SNS\u306B\u5199\u771F\u3092\u6295\u7A3F"
          },
          {
            type: "example",
            label: "\u4F9D\u983C\u4E8B\u9805",
            text: "Instagram\u306E\u30D5\u30A3\u30FC\u30C9\u306B\u5E97\u8217\u30FB\u30E1\u30CB\u30E5\u30FC\u306E\u5199\u771F3\u679A\u4EE5\u4E0A\u3001@\u4F01\u696D\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30BF\u30B0\u3001#\u8056\u6C34\u30AB\u30D5\u30A7 \u306E\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3001\u6765\u5E97\u5F8C7\u65E5\u4EE5\u5185"
          },
          {
            type: "example",
            label: "\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u306E\u767B\u9332",
            text: "\u6587\u7AE0\uFF1A10\u670826\u65E5\u306B\u6765\u5E97\u3057\u307E\u3057\u305F\u3002\u65B0\u30E1\u30CB\u30E5\u30FC2\u7A2E\u3068\u5E97\u5185\u306E\u5199\u771F4\u679A\u3092\u30D5\u30A3\u30FC\u30C9\u306B\u6295\u7A3F\u3057\u3001@\u4F01\u696D\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30BF\u30B0\u3068 #\u8056\u6C34\u30AB\u30D5\u30A7 #\u65B0\u30E1\u30CB\u30E5\u30FC \u306E\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3001\u4F4D\u7F6E\u60C5\u5831\u30BF\u30B0\u3092\u5165\u308C\u307E\u3057\u305F\u3002\u6295\u7A3F\u306E1\u884C\u76EE\u306B\u300CPR\u300D\u3068\u8868\u793A\u3057\u307E\u3057\u305F\u3002\n\u30EA\u30F3\u30AF\uFF1Ahttps://www.instagram.com/p/\u2026"
          },
          {
            type: "h2",
            id: "edit",
            text: "\u4FEE\u6B63\u3068\u5B8C\u4E86\u5F8C"
          },
          {
            type: "list",
            items: [
              "\u4F01\u696D\u304C\u78BA\u8A8D\u3059\u308B\u307E\u3067\u306F\uFF3B\u4FEE\u6B63\u3092\u4FDD\u5B58\uFF3D\u3067\u6587\u7AE0\u3068\u30EA\u30F3\u30AF\u3092\u4FEE\u6B63\u3067\u304D\u307E\u3059\u3002\u4F01\u696D\u304B\u3089\u4FEE\u6B63\u3092\u4F9D\u983C\u3055\u308C\u305F\u3089\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4FEE\u6B63\u3057\u305F\u5F8C\u306B\u3053\u3053\u306E\u5185\u5BB9\u3082\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002",
              "\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u3092\u767B\u9332\u3057\u305F\u5F8C\u306F\u5FDC\u52DF\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3067\u304D\u307E\u305B\u3093\u3002",
              "\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86\u5F8C\u3082\u540C\u3058\u6848\u4EF6\u306B\u518D\u5EA6\u5FDC\u52DF\u3067\u304D\u307E\u3059\u3002"
            ]
          },
          {
            type: "callout",
            text: "\u6295\u7A3F\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u3001\u4F9D\u983C\u4E8B\u9805\u306B\u66F8\u304B\u308C\u305F\u671F\u9593\u4E2D\u306F\u63B2\u8F09\u3092\u7D9A\u3051\u3066\u304F\u3060\u3055\u3044\u3002\u5831\u544A\u3057\u305F\u76F4\u5F8C\u306B\u524A\u9664\u3057\u305F\u308A\u975E\u516C\u958B\u306B\u3057\u305F\u308A\u3059\u308B\u3068\u3001\u904B\u55B6\u30DD\u30EA\u30B7\u30FC\u306B\u3088\u308A\u5229\u7528\u304C\u5236\u9650\u3055\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002"
          }
        ]
      }
    ]
  }
];

// src/common/guide-content.ts
function fillGuideTokens(text, config) {
  return text.replaceAll("{{depositDueHours}}", String(config.depositDueHours)).replaceAll("{{addonDepositDueHours}}", String(config.addonDepositDueHours)).replaceAll("{{purchaseConfirmDays}}", String(config.purchaseConfirmDays)).replaceAll("{{proposalExpiryDays}}", String(config.proposalExpiryDays)).replaceAll("{{platformFee}}", feeRateLabel(config.platformFeeRateBp));
}
__name(fillGuideTokens, "fillGuideTokens");
var SPECIAL_TERMS_EXAMPLE_BLOCKS3 = ACTIVE_IP_RIGHT_TYPES3.map((t) => ({
  type: "example",
  label: IP_RIGHT_LABELS[t],
  text: SPECIAL_TERMS_PLACEHOLDERS[t].split("\n").slice(1).join("\n")
}));
var GUIDE_SECTIONS = [
  {
    title: "\uC2DC\uC791\uD558\uAE30",
    pages: [
      {
        slug: "intro",
        title: "Inflip \uC18C\uAC1C",
        description: "\uC778\uD50C\uB8E8\uC5B8\uC11C\xB7\uD06C\uB9AC\uC5D0\uC774\uD130\uC758 IP \uC0AC\uC6A9 \uAD8C\uB9AC\uB97C \uC548\uC804\uD558\uAC8C \uC0AC\uACE0\uD30C\uB294 \uB9C8\uCF13\uD50C\uB808\uC774\uC2A4\uC608\uC694.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "Inflip\uC740 \uC5B4\uB5A4 \uC11C\uBE44\uC2A4\uC778\uAC00\uC694?"
          },
          {
            type: "p",
            text: "\uC778\uD50C\uB8E8\uC5B8\uC11C\uC640 \uD06C\uB9AC\uC5D0\uC774\uD130\uAC00 \uAC00\uC9C4 IP(\uC774\uB984, \uC5BC\uAD74, \uCF58\uD150\uCE20 \uB4F1)\uC758 \uC0AC\uC6A9 \uAD8C\uB9AC\uB97C \uC870\uAC74\uACFC \uD568\uAED8 \uB4F1\uB85D\uD558\uACE0, \uAD6C\uB9E4\uC790\uB294 \uD544\uC694\uD55C \uAD8C\uB9AC\uB97C \uACE8\uB77C \uB77C\uC774\uC120\uC2A4\uB85C \uBC1B\uB294 \uAC70\uB798 \uD50C\uB7AB\uD3FC\uC774\uC5D0\uC694. \uACB0\uC81C\uB294 \uBB34\uD1B5\uC7A5\uC785\uAE08\uC73C\uB85C \uC9C4\uD589\uB418\uACE0, \uBAA8\uB4E0 \uC870\uAC74\uC740 \uB77C\uC774\uC120\uC2A4 \uC99D\uC11C\uC5D0 \uB0A8\uC544\uC694."
          },
          {
            type: "h2",
            id: "rights",
            text: "\uAC70\uB798\uD560 \uC218 \uC788\uB294 \uAD8C\uB9AC"
          },
          {
            type: "list",
            items: [
              "\uC774\uB984/\uBE0C\uB79C\uB4DC \uC0AC\uC6A9\uAD8C \u2014 \uC0C1\uD488\xB7\uB9C8\uCF00\uD305\uC5D0 \uC774\uB984\uC774\uB098 \uBE0C\uB79C\uB4DC\uB97C \uC0AC\uC6A9",
              "\uC0AC\uC9C4 \uC0AC\uC6A9\uAD8C \u2014 \uAE30\uC874 \uD504\uB85C\uD544\xB7\uCD2C\uC601 \uC0AC\uC9C4\uC744 \uD569\uC758\uD55C \uBC94\uC704\uC5D0\uC11C \uC0AC\uC6A9. \uC0C8 \uCD2C\uC601\xB7\uC81C\uC791\uC740 \uBCC4\uB3C4 \uD569\uC758",
              "\uC601\uC0C1 \uC0AC\uC6A9\uAD8C \u2014 \uAE30\uC874 \uB9B4\uC2A4\xB7\uC1FC\uCE20\xB7\uC720\uD29C\uBE0C \uC601\uC0C1\uC744 \uD569\uC758\uD55C \uBC94\uC704\uC5D0\uC11C \uC0AC\uC6A9. \uC0C8 \uCD2C\uC601\xB7\uC81C\uC791\uC740 \uBCC4\uB3C4 \uD569\uC758",
              "\uC74C\uC131 \uC0AC\uC6A9\uAD8C \u2014 \uAE30\uC874 \uC74C\uC131 \uC0AC\uC6A9, \uC0C8 \uC74C\uC131 \uC81C\uC791\xB7\uC804\uB2EC \uB610\uB294 \uAD6C\uB9E4\uC790\uC758 AI \uC74C\uC131 \uC0DD\uC131 \uD5C8\uB77D",
              "\uACF5\uB3D9 \uBE0C\uB79C\uB529 \u2014 \uC591\uCE21 \uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uB0B4\uC138\uC6B0\uB294 \uACF5\uB3D9 \uCEA0\uD398\uC778. \uD574\uB2F9 \uBC94\uC704\uC758 \uC774\uB984\xB7\uB85C\uACE0 \uC0AC\uC6A9 \uD3EC\uD568",
              "\uAD7F\uC988 \uC81C\uC791\uAD8C \u2014 \uD569\uC758\uD55C \uC694\uC18C\uB85C \uAD7F\uC988\uB97C \uC81C\uC791\uD574 \uD310\uB9E4\uD558\uAC70\uB098 \uBE44\uB9E4\uD488\uC73C\uB85C \uBC30\uD3EC",
              "\uCD9C\uC5F0\uAD8C \u2014 \uD604\uC7A5 \uBC29\uBB38 \uB610\uB294 \uC628\uB77C\uC778 \uCC38\uC5EC(\uC601\uC0C1\xB7\uC74C\uC131 \uCD9C\uC5F0)\uB85C \uD589\uC0AC\xB7\uCD2C\uC601 \uB4F1\uC5D0 1\uD68C \uCC38\uC5EC"
            ]
          },
          {
            type: "h2",
            id: "flow",
            text: "\uAC70\uB798\uB294 \uC774\uB807\uAC8C \uC9C4\uD589\uB3FC\uC694"
          },
          {
            type: "steps",
            items: [
              "\uAD6C\uB9E4\uC790\uAC00 \uC0C1\uD488\uC5D0\uC11C \uC6D0\uD558\uB294 \uAD8C\uB9AC\uC640 \uC870\uAC74\uC744 \uACE8\uB77C \uC8FC\uBB38\uD574\uC694.",
              "\uC548\uB0B4\uB41C \uACC4\uC88C\uB85C \uBB34\uD1B5\uC7A5\uC785\uAE08\uD558\uBA74 \uAD00\uB9AC\uC790\uAC00 \uC785\uAE08\uC744 \uD655\uC778\uD574\uC694.",
              "\uD310\uB9E4\uC790\uC640 \uCC44\uD305\uC73C\uB85C \uC138\uBD80 \uC870\uAC74\uC744 \uD611\uC758\uD558\uACE0, \uD310\uB9E4\uC790\uAC00 \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD574\uC694.",
              "\uBC1C\uAE09 \uC989\uC2DC \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uB77C\uC774\uC120\uC2A4 \uC99D\uC11C\uAC00 \uC804\uB2EC\uB418\uACE0 \uAC70\uB798\uAC00 \uC644\uB8CC\uB3FC\uC694."
            ]
          },
          {
            type: "callout",
            text: "\uC8FC\uBB38 \uC2DC\uC810\uC758 \uC870\uAC74(\uAE30\uAC04\xB7\uC9C0\uC5ED\xB7\uB3C5\uC810 \uC5EC\uBD80 \uB4F1)\uC740 \uC2A4\uB0C5\uC0F7\uC73C\uB85C \uACE0\uC815\uB3FC\uC694. \uC774\uD6C4 \uD310\uB9E4\uC790\uAC00 \uC0C1\uD488\uC744 \uC218\uC815\uD574\uB3C4 \uC774\uBBF8 \uCCB4\uACB0\uB41C \uACC4\uC57D \uB0B4\uC6A9\uC740 \uBC14\uB00C\uC9C0 \uC54A\uC544\uC694."
          }
        ]
      },
      {
        slug: "account",
        title: "\uD68C\uC6D0\uAC00\uC785\uACFC \uB85C\uADF8\uC778",
        description: "\uAD6C\uAE00\xB7\uC560\uD50C\xB7\uCE74\uCE74\uC624 \uACC4\uC815\uC73C\uB85C \uC2DC\uC791\uD560 \uC218 \uC788\uC5B4\uC694.",
        blocks: [
          {
            type: "h2",
            id: "signup",
            text: "\uAC00\uC785 \uBC29\uBC95"
          },
          {
            type: "p",
            text: "\uAD6C\uAE00\xB7\uC560\uD50C\xB7\uCE74\uCE74\uC624 \uACC4\uC815 \uC911 \uD558\uB098\uB85C \uAC04\uD3B8\uD558\uAC8C \uC2DC\uC791\uD560 \uC218 \uC788\uC5B4\uC694. \uAD6C\uB9E4\uC640 \uD310\uB9E4 \uBAA8\uB450 \uD558\uB098\uC758 \uACC4\uC815\uC73C\uB85C \uC774\uC6A9\uD574\uC694."
          },
          {
            type: "h2",
            id: "withdraw",
            text: "\uD68C\uC6D0 \uD0C8\uD1F4"
          },
          {
            type: "p",
            text: `\uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uB0B4 \uC815\uBCF4\uC5D0\uC11C \uD0C8\uD1F4\uD560 \uC218 \uC788\uC5B4\uC694.
\uD310\uB9E4 \uC911\uC778 \uC0C1\uD488\uC774 \uC788\uAC70\uB098, \uC815\uC0B0\uAE4C\uC9C0 \uB05D\uB098\uC9C0 \uC54A\uC740 \uAC70\uB798(\uAD6C\uB9E4\xB7\uD310\uB9E4 \uBAA8\uB450)\uAC00 \uC788\uC73C\uBA74 \uD0C8\uD1F4\uD560 \uC218 \uC5C6\uC5B4\uC694.
\uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC740 \uACC4\uC57D \uAE30\uAC04\uC774 \uB05D\uB098\uACE0 \uB9C8\uC9C0\uB9C9 \uB2EC \uB85C\uC5F4\uD2F0\uAE4C\uC9C0 \uC9C0\uAE09\uB3FC\uC57C \uAD6C\uB9E4\uC790\xB7\uD310\uB9E4\uC790 \uBAA8\uB450 \uD0C8\uD1F4\uD560 \uC218 \uC788\uC5B4\uC694.
\uBCF4\uC720\uD55C \uB77C\uC774\uC120\uC2A4\uB294 \uD0C8\uD1F4 \uD6C4 \uB2E4\uC2DC \uBCFC \uC218 \uC5C6\uC73C\uB2C8 \uD544\uC694\uD55C \uC99D\uC11C\uB294 \uBBF8\uB9AC \uB0B4\uB824\uBC1B\uC544 \uB450\uC138\uC694.
\uAC70\uB798\xB7\uC815\uC0B0 \uAE30\uB85D\uACFC \uB77C\uC774\uC120\uC2A4 \uC99D\uC11C\uB294 \uCD5C\uB300 ${BUSINESS3.TRADE_RECORD_RETENTION_YEARS}\uB144 \uBCF4\uAD00 \uB4A4 \uD30C\uAE30\uB3FC\uC694.`
          }
        ]
      },
      {
        slug: "influencer-verification",
        title: "\uC778\uD50C\uB8E8\uC5B8\uC11C \uC778\uC99D",
        description: "\uB0B4 SNS \uCC44\uB110\uC744 \uC778\uC99D\uD558\uACE0 \uD611\uCC2C\xB7\uCEE4\uBBA4\uB2C8\uD2F0\uB97C \uC774\uC6A9\uD574\uC694.",
        blocks: [
          {
            type: "h2",
            id: "why",
            text: "\uC778\uC99D\uD558\uBA74 \uD560 \uC218 \uC788\uB294 \uAC83"
          },
          {
            type: "p",
            text: "\uB0B4 SNS \uCC44\uB110\uACFC \uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uC218\uB97C \uC778\uC99D\uD558\uBA74 \uC778\uC99D\uB41C \uC778\uD50C\uB8E8\uC5B8\uC11C\uB85C \uD65C\uB3D9\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "list",
            items: [
              "\uD611\uCC2C \u2014 \uC5F4\uB78C \uAE30\uC900\uC744 \uB118\uB294 \uCC44\uB110\uC774 \uC788\uC73C\uBA74 \uD611\uCC2C \uC0C1\uC138\uB97C \uBCF4\uACE0 \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694.",
              "\uCEE4\uBBA4\uB2C8\uD2F0 \u2014 \uC778\uC99D \uCC44\uB110\uC774 \uC788\uC5B4\uC57C \uAE00\uACFC \uB313\uAE00\uC744 \uC4F8 \uC218 \uC788\uC5B4\uC694.",
              "\uBC30\uC9C0 \u2014 \uCEE4\uBBA4\uB2C8\uD2F0 \uAE00\xB7\uB313\uAE00\uC5D0 \uC778\uC99D\uD55C \uD50C\uB7AB\uD3FC\uACFC \uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uAD6C\uAC04(\uC608: 2\uB9CC+)\uC774 \uD45C\uC2DC\uB3FC\uC694.",
              "\uD504\uB85C\uD544 \u2014 \uACF5\uAC1C \uD504\uB85C\uD544\uC758 SNS \uB9C1\uD06C\uAC00 \uC778\uC99D\uD55C \uCC44\uB110 \uC8FC\uC18C\uB85C \uBC14\uB00C\uC5B4\uC694."
            ]
          },
          {
            type: "callout",
            text: "\uD611\uCC2C \uC5F4\uB78C, \uCEE4\uBBA4\uB2C8\uD2F0 \uAE00\uC4F0\uAE30, \uBC30\uC9C0 \uAD6C\uAC04\uC758 \uAE30\uC900 \uC218\uCE58\uB294 \uC6B4\uC601 \uC815\uCC45\uC5D0 \uB530\uB77C \uBC14\uB014 \uC218 \uC788\uC5B4\uC694. \uD611\uCC2C \uC5F4\uB78C \uAE30\uC900\uC740 \uAE30\uC900\uC744 \uB118\uC9C0 \uBABB\uD588\uC744 \uB54C \uD611\uCC2C \uD654\uBA74\uC758 \uC548\uB0B4 \uCC3D\uC5D0\uC11C \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "where",
            text: "\uC778\uC99D\uD558\uB294 \uACF3"
          },
          {
            type: "p",
            text: "\uD68C\uC6D0\uAC00\uC785 \uC911\uC5D0 \uBC14\uB85C \uC778\uC99D\uD558\uAC70\uB098, \uAC00\uC785 \uD6C4 \uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uC778\uD50C\uB8E8\uC5B8\uC11C \uC778\uC99D\uC5D0\uC11C \uC5B8\uC81C\uB4E0 \uD560 \uC218 \uC788\uC5B4\uC694. \uD50C\uB7AB\uD3FC\uB9C8\uB2E4 \uCC44\uB110 \uD558\uB098\uC529 \uC778\uC99D\uD574\uC694."
          },
          {
            type: "h2",
            id: "oauth",
            text: "\uACC4\uC815 \uC5F0\uACB0 \uC778\uC99D \u2014 \uC720\uD29C\uBE0C\xB7\uC778\uC2A4\uD0C0\uADF8\uB7A8\xB7\uD2F1\uD1A1"
          },
          {
            type: "steps",
            items: [
              "\uC778\uD50C\uB8E8\uC5B8\uC11C \uC778\uC99D \uD654\uBA74\uC5D0\uC11C \uC778\uC99D\uD560 \uD50C\uB7AB\uD3FC\uC744 \uB20C\uB7EC\uC694.",
              "\uC5F4\uB9B0 \uCC3D\uC5D0\uC11C \uADF8 \uD50C\uB7AB\uD3FC \uACC4\uC815\uC73C\uB85C \uB85C\uADF8\uC778\uD558\uACE0 \uC815\uBCF4 \uC81C\uACF5\uC5D0 \uB3D9\uC758\uD574\uC694.",
              "\uC778\uC99D\uC774 \uB05D\uB098\uBA74 \uCC44\uB110\uACFC \uADF8 \uC2DC\uC810\uC758 \uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uC218\uAC00 \uBC14\uB85C \uAE30\uB85D\uB3FC\uC694."
            ]
          },
          {
            type: "p",
            text: "\uB85C\uADF8\uC778 \uCC3D\uC740 10\uBD84 \uC548\uC5D0 \uB9C8\uCCD0\uC57C \uD574\uC694. \uC778\uD50C\uB9BD\uC740 \uD50C\uB7AB\uD3FC \uB85C\uADF8\uC778 \uC815\uBCF4\uB97C \uC800\uC7A5\uD558\uC9C0 \uC54A\uACE0, \uC778\uC99D\uD55C \uC2DC\uC810\uC758 \uC22B\uC790\uB9CC \uAE30\uB85D\uD574\uC694. \uC22B\uC790\uAC00 \uB298\uC5C8\uB2E4\uBA74 \uB2E4\uC2DC \uC778\uC99D\uD574\uC11C \uC0C8 \uC22B\uC790\uB85C \uBC14\uAFC0 \uC218 \uC788\uC5B4\uC694.\n\uACC4\uC815 \uC5F0\uACB0 \uC778\uC99D\uC740 \uC9C1\uC811 \uD574\uC81C\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "manual",
            text: "\uC8FC\uC18C\uB85C \uC778\uC99D \uC694\uCCAD \u2014 \uC2A4\uB808\uB4DC\xB7SOOP\xB7\uD32C\uB354TV"
          },
          {
            type: "p",
            text: "\uACC4\uC815 \uC5F0\uACB0\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uD50C\uB7AB\uD3FC\uC740 \uCC44\uB110 \uC8FC\uC18C\uB97C \uB0A8\uAE30\uBA74 \uC6B4\uC601\uC790\uAC00 \uCC44\uB110\uC744 \uC9C1\uC811 \uD655\uC778\uD574 \uC778\uC99D\uD574 \uB4DC\uB824\uC694."
          },
          {
            type: "steps",
            items: [
              "\uC778\uD50C\uB8E8\uC5B8\uC11C \uC778\uC99D \uD654\uBA74\uC5D0\uC11C \uCC44\uB110 \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uACE0 \uC778\uC99D \uC694\uCCAD\uC744 \uB20C\uB7EC\uC694.",
              "\uC6B4\uC601\uC790\uAC00 \uCC44\uB110\uC744 \uD655\uC778\uD558\uACE0 \uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uC218\uC640 \uD568\uAED8 \uC778\uC99D\uD574\uC694. \uD544\uC694\uD558\uBA74 \uB4F1\uB85D\uD55C \uC5F0\uB77D\uCC98\uB85C \uC5F0\uB77D\uB4DC\uB824\uC694.",
              "\uACB0\uACFC\uB294 \uC54C\uB9BC\uC73C\uB85C \uC54C\uB824\uB4DC\uB824\uC694. \uAC70\uC808\uB418\uBA74 \uC0AC\uC720\uB97C \uD655\uC778\uD558\uACE0 \uB2E4\uC2DC \uC694\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694."
            ]
          },
          {
            type: "list",
            items: [
              "\uC5F0\uB77D\uCC98\uB97C \uB4F1\uB85D\uD55C \uD68C\uC6D0\uB9CC \uC694\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694. \uC5F0\uB77D\uCC98\uAC00 \uC5C6\uC73C\uBA74 \uC694\uCCAD\uD560 \uB54C \uADF8 \uC790\uB9AC\uC5D0\uC11C \uB4F1\uB85D\uD560 \uC218 \uC788\uC5B4\uC694.",
              "\uCC44\uB110 \uD504\uB85C\uD544 \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
              "\uB2E8\uCD95 \uC8FC\uC18C, \uB9C1\uD06C \uBAA8\uC74C, \uB2E4\uB978 SNS \uC8FC\uC18C\uB85C\uB294 \uC694\uCCAD\uD560 \uC218 \uC5C6\uC5B4\uC694.",
              "\uC8FC\uC18C\uB85C \uC778\uC99D\uD55C \uCC44\uB110\uC740 \uC9C1\uC811 \uD574\uC81C\uD560 \uC218 \uC5C6\uC5B4\uC694. \uD574\uC81C\uAC00 \uD544\uC694\uD558\uBA74 \uACE0\uAC1D\uC13C\uD130\uB85C \uBB38\uC758\uD574 \uC8FC\uC138\uC694."
            ]
          },
          {
            type: "h2",
            id: "one-account",
            text: "\uD55C \uCC44\uB110\uC740 \uD55C \uACC4\uC815\uC5D0\uB9CC"
          },
          {
            type: "p",
            text: "\uAC19\uC740 \uCC44\uB110\uC744 \uC5EC\uB7EC \uACC4\uC815\uC5D0 \uC778\uC99D\uD560 \uC218 \uC5C6\uC5B4\uC694.\n\uC774\uBBF8 \uB2E4\uB978 \uACC4\uC815\uC5D0 \uC5F0\uACB0\uB41C \uCC44\uB110\uC774\uB77C\uBA74, \uADF8 \uACC4\uC815\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD574\uC81C\uD55C \uB4A4 \uB2E4\uC2DC \uC778\uC99D\uD574 \uC8FC\uC138\uC694. \uD0C8\uD1F4\uD55C \uACC4\uC815\uC758 \uC778\uC99D \uCC44\uB110\uC740 \uD0C8\uD1F4\uD560 \uB54C \uD568\uAED8 \uC9C0\uC6CC\uC838\uC694."
          },
          {
            type: "callout",
            text: "\uB0A8\uC758 \uCC44\uB110\uB85C \uC778\uC99D\uD55C \uAC83\uC774 \uD655\uC778\uB418\uBA74 \uC6B4\uC601\uC790\uAC00 \uC778\uC99D\uC744 \uD574\uC81C\uD560 \uC218 \uC788\uC5B4\uC694."
          }
        ]
      }
    ]
  },
  {
    title: "\uAD6C\uB9E4\uC790 \uAC00\uC774\uB4DC",
    pages: [
      {
        slug: "buying",
        title: "IP \uCC3E\uACE0 \uC8FC\uBB38\uD558\uAE30",
        description: "\uAD8C\uB9AC\uBCC4 \uC870\uAC74\uC744 \uD655\uC778\uD558\uACE0 \uC8FC\uBB38\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "explore",
            text: "IP \uB458\uB7EC\uBCF4\uAE30"
          },
          {
            type: "p",
            text: "\uC0C1\uB2E8\uC758 IP \uB458\uB7EC\uBCF4\uAE30\uC5D0\uC11C \uCE74\uD14C\uACE0\uB9AC\xB7\uAC80\uC0C9\uC73C\uB85C \uC6D0\uD558\uB294 IP\uB97C \uCC3E\uC544\uBCF4\uC138\uC694. \uD310\uB9E4\uC790 \uD504\uB85C\uD544\uC5D0\uC11C \uD574\uB2F9 \uD310\uB9E4\uC790\uC758 \uB2E4\uB978 \uC0C1\uD488\uB3C4 \uBCFC \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "offer",
            text: "\uC870\uAC74 \uC77D\uB294 \uBC95"
          },
          {
            type: "p",
            text: "\uC0C1\uD488\uC5D0\uB294 \uD310\uB9E4\uD558\uB294 \uAD8C\uB9AC\uB9C8\uB2E4 \uC870\uAC74\uC774 \uD558\uB098\uC529 \uC788\uACE0, \uAC19\uC740 \uAD8C\uB9AC \uC548\uC5D0\uC11C\uB3C4 \uAE30\uAC04\xB7\uC635\uC158\uC5D0 \uB530\uB77C \uAC00\uACA9\uC774 \uB2EC\uB77C\uC838\uC694.\n\uC8FC\uBB38 \uC804\uC5D0 \uC544\uB798 \uC870\uAC74\uC744 \uAF2D \uD655\uC778\uD574 \uBCF4\uC138\uC694."
          },
          {
            type: "list",
            items: [
              "\uC0AC\uC6A9 \uAE30\uAC04 \u2014 1\xB73\xB76\xB712\uAC1C\uC6D4 (\uCD9C\uC5F0\uAD8C \uB4F1 1\uD68C\uC131 \uAD8C\uB9AC\uB294 \uAE30\uAC04 \uC5C6\uC74C)",
              "\uC0AC\uC6A9 \uC9C0\uC5ED \u2014 \uAD6D\uB0B4(\uD55C\uAD6D) \uD55C\uC815 \uB610\uB294 \uAE00\uB85C\uBC8C",
              "\uB3C5\uC810 \uC5EC\uBD80 \u2014 \uBE44\uB3C5\uC810 / \uCE74\uD14C\uACE0\uB9AC \uB3C5\uC810 / \uC644\uC804 \uB3C5\uC810",
              "\uC218\uC815 \uD5C8\uC6A9 \uBC94\uC704 \u2014 \uD06C\uB86D\xB7\uC0C9\uC0C1 \uBCC0\uACBD \uAC00\uB2A5 \uC5EC\uBD80, AI \uC218\uC815 \uAE08\uC9C0 \uB4F1",
              "\uAE08\uC9C0 \uC5C5\uC885 \u2014 \uB3C4\uBC15\xB7\uC131\uC778\xB7\uC815\uCE58\xB7\uC758\uB8CC\xB7\uD22C\uC790\xB7\uC8FC\uB958 \uB4F1 \uC0AC\uC6A9 \uBD88\uAC00 \uBD84\uC57C",
              "\uAC00\uACA9 \uBC29\uC2DD \u2014 \uACE0\uC815\uAC00 / \uB9E4\uCD9C \uB85C\uC5F4\uD2F0 / \uACE0\uC815\uAC00 + \uB9E4\uCD9C \uB85C\uC5F4\uD2F0"
            ]
          },
          {
            type: "h2",
            id: "order",
            text: "\uC8FC\uBB38\uD558\uAE30"
          },
          {
            type: "p",
            text: "\uAD8C\uB9AC\uC640 \uC635\uC158\uC744 \uACE8\uB77C \uC8FC\uBB38\uD558\uBA74 \uADF8 \uC2DC\uC810\uC758 \uC870\uAC74\uC774 \uACC4\uC57D \uB0B4\uC6A9\uC73C\uB85C \uACE0\uC815\uB3FC\uC694.\n\uC0C1\uD488 \uD654\uBA74\uC758 \u2018\uD611\uC758\uB85C \uC9C4\uD589\uD558\uB294 \uAD8C\uB9AC\u2019(\uB9E4\uCD9C \uB85C\uC5F4\uD2F0 \uBC29\uC2DD\uC774\uAC70\uB098 \uAC00\uACA9 \uD611\uC758\uB85C \uD45C\uC2DC\uB41C \uAD8C\uB9AC)\uB294 \uBC14\uB85C \uC8FC\uBB38\uD558\uB294 \uB300\uC2E0 \uD611\uC758 \uC81C\uC548 \uBCF4\uB0B4\uAE30\uB85C \uAE30\uAC04\xB7\uAE08\uC561\xB7\uB85C\uC5F4\uD2F0 \uBE44\uC728\xB7\uC9C0\uAE09\uC77C\uC744 \uC81C\uC548\uD558\uACE0, \uD310\uB9E4\uC790\uC640 \uC8FC\uACE0\uBC1B\uC73C\uBA70 \uC815\uD574\uC694. \uADF8 \uBC16\uC758 \uC870\uAC74\uC740 \uD611\uC758 \uC81C\uC548\uC73C\uB85C \uBC14\uAFC0 \uC218 \uC5C6\uC5B4\uC694. \uC5B4\uB290 \uCABD\uC774\uB4E0 \uC0C1\uB300 \uC81C\uC548\uC744 \uC218\uB77D\uD558\uBA74 \uADF8 \uC870\uAC74\uC73C\uB85C \uC8FC\uBB38\uC774 \uB9CC\uB4E4\uC5B4\uC838\uC694.\n\uC81C\uC548\uC744 \uBCF4\uB0B8 \uB4A4 \uC0C1\uB300\uAC00 \uC751\uB2F5\uD558\uAE30 \uC804\uC5D0\uB294 \uB0B4 \uC81C\uC548\uC744 \uACE0\uCE58\uAC70\uB098 \uCDE8\uC18C\uD560 \uC218 \uC788\uC5B4\uC694. \uBC1B\uC740 \uC81C\uC548\uC740 \uAC70\uC808\uD560 \uC218 \uC788\uACE0, \uC5B4\uB290 \uCABD\uC774\uB4E0 \uADF8\uB54C \uD611\uC758\uAC00 \uB05D\uB098\uC694. \uC81C\uC548 \uD6C4 {{proposalExpiryDays}}\uC77C \uC548\uC5D0 \uC0C1\uB300\uAC00 \uC751\uB2F5\uD558\uC9C0 \uC54A\uC73C\uBA74 \uD611\uC758\uAC00 \uB9CC\uB8CC\uB3FC\uC694."
          }
        ]
      },
      {
        slug: "payment",
        title: "\uBB34\uD1B5\uC7A5\uC785\uAE08 \uACB0\uC81C",
        description: "\uC8FC\uBB38 \uD6C4 \uC548\uB0B4 \uACC4\uC88C\uB85C \uC785\uAE08\uD558\uBA74 \uAD00\uB9AC\uC790\uAC00 \uD655\uC778\uD574\uC694.",
        blocks: [
          {
            type: "h2",
            id: "how",
            text: "\uC785\uAE08 \uBC29\uBC95"
          },
          {
            type: "p",
            text: "\uC8FC\uBB38\uC744 \uC644\uB8CC\uD558\uBA74 \uC785\uAE08 \uACC4\uC88C\xB7\uAE08\uC561\xB7\uC785\uAE08\uC790\uBA85\uC774 \uC548\uB0B4\uB3FC\uC694. \uC548\uB0B4\uB41C \uAE08\uC561\uC744 \uC815\uD655\uD788, \uC548\uB0B4\uB41C \uC785\uAE08\uC790\uBA85\uC73C\uB85C \uC785\uAE08\uD574 \uC8FC\uC138\uC694."
          },
          {
            type: "h2",
            id: "deadline",
            text: "\uC785\uAE08 \uAE30\uD55C"
          },
          {
            type: "p",
            text: "\uC8FC\uBB38 \uD6C4 {{depositDueHours}}\uC2DC\uAC04 \uC548\uC5D0 \uC785\uAE08\uC774 \uD655\uC778\uB418\uC9C0 \uC54A\uC73C\uBA74 \uC8FC\uBB38\uC774 \uC790\uB3D9\uC73C\uB85C \uCDE8\uC18C\uB3FC\uC694. \uAE30\uD55C\uC774 \uC9C0\uB098 \uCDE8\uC18C\uB410\uB2E4\uBA74 \uB2E4\uC2DC \uC8FC\uBB38\uD574 \uC8FC\uC138\uC694."
          },
          {
            type: "h2",
            id: "bundle",
            text: "\uC5EC\uB7EC \uAD8C\uB9AC\uB97C \uD55C \uBC88\uC5D0 \uACB0\uC81C\uD560 \uB54C"
          },
          {
            type: "p",
            text: "\uD55C \uC0C1\uD488\uC5D0\uC11C \uC5EC\uB7EC \uAD8C\uB9AC\uB97C \uD568\uAED8 \uC8FC\uBB38\uD558\uBA74 \uC785\uAE08 \uC548\uB0B4\uAC00 \uD55C \uAC74\uC73C\uB85C \uB098\uC640\uC694. \uD569\uACC4 \uAE08\uC561\uC744 \uD55C \uBC88\uB9CC \uC785\uAE08\uD558\uBA74 \uD568\uAED8 \uC8FC\uBB38\uD55C \uAD8C\uB9AC \uC804\uCCB4\uC758 \uC785\uAE08\uC774 \uAC19\uC774 \uD655\uC778\uB3FC\uC694.\n\uACC4\uC57D\uC740 \uAD8C\uB9AC\uB9C8\uB2E4 \uB530\uB85C \uC0DD\uACA8\uC11C, \uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09\xB7\uAD6C\uB9E4\uD655\uC815\xB7\uD658\uBD88\uC740 \uAD8C\uB9AC\uBCC4\uB85C \uC9C4\uD589\uB3FC\uC694."
          },
          {
            type: "h2",
            id: "addon",
            text: "\uCD94\uAC00\uAE08 \uC785\uAE08"
          },
          {
            type: "p",
            text: "\uC785\uAE08 \uD655\uC778 \uB4A4 \uBC1C\uAE09 \uC804\uC5D0 \uD611\uC758\uB85C \uAE08\uC561\uC774 \uB298\uBA74, \uD310\uB9E4\uC790\uAC00 \uAC19\uC740 \uC8FC\uBB38\uC5D0 \uCD94\uAC00\uAE08\uC744 \uC694\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694. \uC694\uCCAD\uC774 \uC624\uBA74 \uC54C\uB9BC\uACFC \uC8FC\uBB38 \uC0C1\uC138\uC5D0 \uC785\uAE08 \uC548\uB0B4\uAC00 \uB5A0\uC694.\n\uCD94\uAC00\uAE08\uC740 \uC694\uCCAD \uD6C4 {{addonDepositDueHours}}\uC2DC\uAC04 \uC548\uC5D0 \uC785\uAE08\uD574 \uC8FC\uC138\uC694. \uAE30\uD55C\uC774 \uC9C0\uB098\uBA74 \uCD94\uAC00\uAE08 \uC694\uCCAD\uB9CC \uB9CC\uB8CC\uB418\uACE0 \uC8FC\uBB38\uC740 \uADF8\uB300\uB85C \uC720\uC9C0\uB3FC\uC694."
          },
          {
            type: "h2",
            id: "confirm",
            text: "\uC785\uAE08 \uD655\uC778"
          },
          {
            type: "p",
            text: "\uAD00\uB9AC\uC790\uAC00 \uC785\uAE08\uC744 \uD655\uC778\uD558\uBA74 \uC8FC\uBB38\uC774 \uACB0\uC81C \uC644\uB8CC \uC0C1\uD0DC\uB85C \uBC14\uB00C\uACE0 \uC54C\uB9BC\uC744 \uBCF4\uB0B4\uB4DC\uB824\uC694. \uC774\uD6C4 \uD310\uB9E4\uC790\uAC00 \uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09\uC744 \uC9C4\uD589\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "callout",
            text: "\uBCF4\uB0B4\uB294 \uBD84 \uC774\uB984\uC774 \uC785\uAE08\uC790\uBA85\uACFC \uB2E4\uB974\uBA74 \uD655\uC778\uC774 \uB2A6\uC5B4\uC9C8 \uC218 \uC788\uC5B4\uC694.\n\uB2E4\uB978 \uC774\uB984\uC73C\uB85C \uC785\uAE08\uD560 \uC608\uC815\uC774\uB77C\uBA74 \uC785\uAE08 \uC804\uC5D0 \uC785\uAE08 \uC548\uB0B4\uC758 \uC785\uAE08\uC790\uBA85 \uC606 \uBCC0\uACBD \uBC84\uD2BC\uC73C\uB85C \uBC14\uAFD4 \uC8FC\uC138\uC694.\n\uC774\uBBF8 \uB2E4\uB978 \uC774\uB984\uC73C\uB85C \uC785\uAE08\uD588\uB2E4\uBA74 \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694."
          },
          {
            type: "h2",
            id: "wrong-amount",
            text: "\uAE08\uC561\uC744 \uC798\uBABB \uBCF4\uB0C8\uC744 \uB54C"
          },
          {
            type: "list",
            items: [
              "\uB354 \uB9CE\uC774 \uBCF4\uB0C8\uB2E4\uBA74: \uC8FC\uBB38 \uAE08\uC561\uB9CC\uD07C \uC785\uAE08\uC774 \uD655\uC778\uB418\uACE0, \uB118\uCE5C \uAE08\uC561\uC740 \uAD00\uB9AC\uC790\uAC00 \uB3CC\uB824\uB4DC\uB824\uC694.",
              "\uBAA8\uC790\uB77C\uAC8C \uBCF4\uB0C8\uB2E4\uBA74: \uC785\uAE08\uC774 \uD655\uC778\uB418\uC9C0 \uC54A\uC544\uC694. \uBC1B\uC740 \uAE08\uC561\uC744 \uB3CC\uB824\uB4DC\uB9AC\uACE0 \uC8FC\uBB38\uC740 \uCDE8\uC18C\uB418\uB2C8, \uB3CC\uB824\uBC1B\uC740 \uB4A4 \uC815\uD655\uD55C \uAE08\uC561\uC73C\uB85C \uB2E4\uC2DC \uC8FC\uBB38\uD574 \uC8FC\uC138\uC694. \uCD94\uAC00\uAE08\uC774 \uBAA8\uC790\uB790\uB2E4\uBA74 \uBC1B\uC740 \uAE08\uC561\uB9CC \uB3CC\uB824\uB4DC\uB9AC\uACE0 \uCD94\uAC00\uAE08 \uC694\uCCAD\uC740 \uADF8\uB300\uB85C \uB0A8\uC544\uC694.",
              "\uB3CC\uB824\uB4DC\uB9B4 \uB54C\uB294 \uBC1B\uC73C\uC2E4 \uACC4\uC88C\uB97C \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694. \uB3CC\uB824\uB4DC\uB9B4 \uC608\uC815\uC778 \uAE08\uC561\uACFC \uC0AC\uC720, \uC785\uAE08 \uC644\uB8CC \uC5EC\uBD80\uB294 \uC8FC\uBB38 \uC0C1\uC138\uC640 \uC54C\uB9BC\uC5D0\uC11C \uBCFC \uC218 \uC788\uC5B4\uC694."
            ]
          },
          {
            type: "h2",
            id: "late",
            text: "\uAE30\uD55C\uC774 \uC9C0\uB09C \uB4A4 \uC785\uAE08\uD588\uC744 \uB54C"
          },
          {
            type: "p",
            text: "\uC785\uAE08 \uAE30\uD55C\uC774 \uC9C0\uB098 \uC8FC\uBB38\uC774 \uCDE8\uC18C\uB41C \uB4A4 \uC785\uAE08\uD588\uB2E4\uBA74 \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694. \uADF8 \uAD8C\uB9AC\uB97C \uC544\uC9C1 \uAC19\uC740 \uC870\uAC74\uC73C\uB85C \uC0B4 \uC218 \uC788\uC73C\uBA74 \uAD00\uB9AC\uC790\uAC00 \uC8FC\uBB38\uC744 \uB418\uC0B4\uB824 \uC785\uAE08\uC744 \uD655\uC778\uD574\uC694.\n\uADF8\uC0AC\uC774 \uD310\uB9E4\uAC00 \uC911\uC9C0\uB410\uAC70\uB098 \uB2E4\uB978 \uAD6C\uB9E4\uC790\uAC00 \uC644\uC804 \uB3C5\uC810\uC73C\uB85C \uACC4\uC57D\uD558\uB294 \uB4F1 \uC0B4 \uC218 \uC5C6\uAC8C \uB410\uB2E4\uBA74, \uBC1B\uC740 \uAE08\uC561\uC744 \uB3CC\uB824\uB4DC\uB824\uC694."
          }
        ]
      },
      {
        slug: "license",
        title: "\uB77C\uC774\uC120\uC2A4 \uD655\uC778\uD558\uAE30",
        description: "\uBC1C\uAE09\uB41C \uB77C\uC774\uC120\uC2A4\uC640 \uC99D\uC11C\uB97C \uD655\uC778\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "issue",
            text: "\uBC1C\uAE09 \uACFC\uC815"
          },
          {
            type: "p",
            text: "\uACB0\uC81C\uAC00 \uC644\uB8CC\uB418\uBA74 \uD310\uB9E4\uC790\uAC00 \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD574\uC694. \uBC1C\uAE09 \uC804\uC5D0\uB294 \uCC44\uD305\uBC29 \uC0C1\uB2E8\uC758 \u2018\uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\u2019 \uCE74\uB4DC\uC5D0\uC11C \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uACFC \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC744 \uBBF8\uB9AC \uBCFC \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "cert",
            text: "\uB77C\uC774\uC120\uC2A4 \uC99D\uC11C"
          },
          {
            type: "p",
            text: "\uBC1C\uAE09\uB418\uBA74 \uAD8C\uB9AC \uB0B4\uC6A9, \uC0AC\uC6A9 \uC870\uAC74, \uD6A8\uB825 \uAE30\uAC04, \uD310\uB9E4\uC790\uC640 \uD569\uC758\uD55C \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC774 \uB2F4\uAE34 \uC99D\uC11C\uAC00 \uC0DD\uC131\uB3FC\uC694.\n\uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uB77C\uC774\uC120\uC2A4\uC5D0\uC11C \uBC1B\uC740 \uB77C\uC774\uC120\uC2A4\uB97C \uBAA8\uC544 \uBCF4\uACE0 PDF \uC99D\uC11C\uB97C \uB0B4\uB824\uBC1B\uC744 \uC218 \uC788\uC5B4\uC694. \uB77C\uC774\uC120\uC2A4\uB97C \uB204\uB974\uBA74 \uADF8 \uB77C\uC774\uC120\uC2A4\uB97C \uBC1B\uC740 \uAC70\uB798\uC758 \uC0C1\uC138 \uD654\uBA74\uC774 \uC5F4\uB824\uC694.\n\uD310\uB9E4\uC790\uB3C4 \uAC19\uC740 \uD654\uBA74\uC758 \uBC1C\uAE09\uD55C \uB77C\uC774\uC120\uC2A4 \uD0ED\uACFC \uD310\uB9E4 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uAC19\uC740 \uC99D\uC11C\uB97C \uB0B4\uB824\uBC1B\uC744 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "download",
            text: "\uC99D\uC11C \uB2E4\uC6B4\uB85C\uB4DC"
          },
          {
            type: "p",
            text: "\uC8FC\uBB38 \uC0C1\uC138\uB098 \uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uB77C\uC774\uC120\uC2A4\uC758 PDF \uC99D\uC11C \uBC84\uD2BC\uC744 \uB204\uB974\uBA74 \uC5B8\uC81C\uB4E0 \uB0B4\uB824\uBC1B\uC744 \uC218 \uC788\uC5B4\uC694. \uB204\uB97C \uB54C\uB9C8\uB2E4 \uADF8 \uC2DC\uC810\uC758 \uC0C1\uD0DC\uB85C \uC0C8\uB85C \uB9CC\uB4E4\uC5B4\uC838\uC694.\n\uAE30\uAC04\uC774 \uB05D\uB09C \uB77C\uC774\uC120\uC2A4\uB294 \uC99D\uC11C\uC5D0 \uB9CC\uB8CC \uD45C\uC2DC\uAC00, \uACC4\uC57D\uC774 \uD574\uC9C0\uB41C \uB77C\uC774\uC120\uC2A4\uB294 \uD574\uC9C0 \uD45C\uC2DC\uAC00 \uCC0D\uD600\uC694. \uD68C\uC218\uB41C \uB77C\uC774\uC120\uC2A4\uB294 \uC99D\uC11C\uB97C \uBC1B\uC744 \uC218 \uC5C6\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "repurchase",
            text: "\uAC19\uC740 IP \uB2E4\uC2DC \uAD6C\uB9E4\uD558\uAE30"
          },
          {
            type: "p",
            text: "\uC774\uBBF8 \uBCF4\uC720 \uC911\uC778 \uB77C\uC774\uC120\uC2A4\uAC00 \uC788\uC5B4\uB3C4 \uAE30\uAC04 \uC5F0\uC7A5\uC774\uB098 \uCD94\uAC00 \uD504\uB85C\uC81D\uD2B8\uB97C \uC704\uD574 \uAC19\uC740 \uAD8C\uB9AC\uB97C \uB2E4\uC2DC \uAD6C\uB9E4\uD560 \uC218 \uC788\uC5B4\uC694.\n\uB2E4\uB9CC \uAC19\uC740 \uAD8C\uB9AC\uC5D0 \uC785\uAE08 \uB300\uAE30\xB7\uACB0\uC81C \uC644\uB8CC \uC0C1\uD0DC\uC758 \uC8FC\uBB38\uC774 \uB0A8\uC544 \uC788\uC73C\uBA74 \uADF8 \uC8FC\uBB38\uC774 \uB05D\uB09C \uB4A4 \uB2E4\uC2DC \uAD6C\uB9E4\uD560 \uC218 \uC788\uC5B4\uC694.\n\uB2E4\uB978 \uAD6C\uB9E4\uC790\uAC00 \uADF8 \uAD8C\uB9AC\uB97C \uC644\uC804 \uB3C5\uC810\uC73C\uB85C \uACC4\uC57D\uD574 \uC4F0\uACE0 \uC788\uC73C\uBA74 \uC5B4\uB5A4 \uC870\uAC74\uC73C\uB85C\uB3C4 \uC0B4 \uC218 \uC5C6\uACE0, \uB2E4\uB978 \uAD6C\uB9E4\uC790\uAC00 \uC4F0\uACE0 \uC788\uB294 \uAD8C\uB9AC\uB294 \uC644\uC804 \uB3C5\uC810\uC73C\uB85C \uC0B4 \uC218 \uC5C6\uC5B4\uC694."
          }
        ]
      },
      {
        slug: "refund",
        title: "\uD658\uBD88\uACFC \uBD84\uC7C1",
        description: "\uD658\uBD88 \uC2E0\uCCAD \uC808\uCC28\uC640 \uBD84\uC7C1 \uCC98\uB9AC \uAE30\uC900\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "request",
            text: "\uD658\uBD88 \uC2E0\uCCAD"
          },
          {
            type: "p",
            text: "\uC785\uAE08\uC774 \uD655\uC778\uB41C \uB4A4 \uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uAE30 \uC804(\uACB0\uC81C \uC644\uB8CC)\uC5D0\uB294 \uC8FC\uBB38 \uC0C1\uC138\uC758 \uD658\uBD88 \uC2E0\uCCAD \uBC84\uD2BC\uC73C\uB85C \uACB0\uC81C \uAE08\uC561 \uC804\uC561 \uD658\uBD88\uC744 \uC2E0\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694.\n\uC785\uAE08 \uD655\uC778 \uC804\uC774\uB77C\uBA74 \uD658\uBD88 \uB300\uC2E0 \uC8FC\uBB38 \uCDE8\uC18C\uB97C \uC774\uC6A9\uD574 \uC8FC\uC138\uC694.\n\uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB41C \uB4A4\uC5D0\uB294 \uD658\uBD88 \uC2E0\uCCAD \uB300\uC2E0 \uBD84\uC7C1\uC744 \uC811\uC218\uD574 \uC8FC\uC138\uC694.\n\uBB34\uD1B5\uC7A5\uC785\uAE08 \uAC74\uC740 \uD658\uBD88\uBC1B\uC744 \uACC4\uC88C \uC815\uBCF4\uAC00 \uAF2D \uD544\uC694\uD558\uACE0, \uC9C4\uD589 \uC911\uC778 \uD658\uBD88 \uC2E0\uCCAD\uC774 \uC788\uC73C\uBA74 \uC0C8\uB85C \uC2E0\uCCAD\uD560 \uC218 \uC5C6\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "partial",
            text: "\uBD80\uBD84 \uD658\uBD88"
          },
          {
            type: "p",
            text: "\uAD6C\uB9E4\uC790\uAC00 \uC9C1\uC811 \uC2E0\uCCAD\uD558\uB294 \uD658\uBD88\uC740 \uD56D\uC0C1 \uC804\uC561\uC774\uC5D0\uC694. \uC77C\uBD80 \uAE08\uC561\uB9CC \uB3CC\uB824\uBC1B\uB294 \uBD80\uBD84 \uD658\uBD88\uC740 \uAD00\uB9AC\uC790\uAC00 \uBD84\uC7C1 \uB4F1 \uC0C1\uD669\uC744 \uD655\uC778\uD574 \uC9C4\uD589\uD574\uC694.\n\uD658\uBD88 \uD569\uACC4\uB294 \uACB0\uC81C\uD55C \uAE08\uC561(\uD655\uC778\uB41C \uCD94\uAC00\uAE08 \uD3EC\uD568)\uC744 \uB118\uC744 \uC218 \uC5C6\uC5B4\uC694.\n\uD310\uB9E4\uC790\uC5D0\uAC8C \uC815\uC0B0\uC774 \uC774\uBBF8 \uC9C0\uAE09\uB41C \uAC70\uB798\uB294 \uD310\uB9E4\uC790\uC5D0\uAC8C\uC11C \uC815\uC0B0\uAE08\uC744 \uB3CC\uB824\uBC1B\uC740 \uB4A4\uC5D0 \uD658\uBD88\uAE08\uC774 \uC785\uAE08\uB3FC\uC694."
          },
          {
            type: "h2",
            id: "full",
            text: "\uC804\uC561 \uD658\uBD88 \uC2DC \uB77C\uC774\uC120\uC2A4 \uCC98\uB9AC"
          },
          {
            type: "p",
            text: "\uC804\uC561 \uD658\uBD88\uC774 \uC644\uB8CC\uB418\uBA74 \uC8FC\uBB38\uC740 \uD658\uBD88 \uC0C1\uD0DC\uAC00 \uB418\uACE0, \uBC1C\uAE09\uB410\uB358 \uB77C\uC774\uC120\uC2A4\uB294 \uD68C\uC218(\uD6A8\uB825 \uC0C1\uC2E4)\uB3FC\uC694."
          },
          {
            type: "h2",
            id: "dispute",
            text: "\uBD84\uC7C1 \uC811\uC218"
          },
          {
            type: "p",
            text: "\uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09 \uD6C4 \uACC4\uC57D \uB0B4\uC6A9\uACFC \uB2E4\uB978 \uBB38\uC81C\uAC00 \uC0DD\uAE30\uBA74 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uBD84\uC7C1\uC744 \uC811\uC218\uD560 \uC218 \uC788\uC5B4\uC694. \uAD6C\uB9E4\uD655\uC815\uD55C \uB4A4\uC5D0\uB3C4 \uD310\uB9E4\uC790 \uC815\uC0B0\uC774 \uC9C0\uAE09\uB418\uAE30 \uC804\uAE4C\uC9C0\uB294 \uC811\uC218\uD560 \uC218 \uC788\uC5B4\uC694.\n\uBD84\uC7C1\uC774 \uC811\uC218\uB418\uBA74 \uAD00\uB9AC\uC790\uAC00 \uAC70\uB798 \uCC44\uD305\uC5D0 \uD569\uB958\uD558\uACE0, \uADF8\uB3D9\uC548 \uAD6C\uB9E4\uD655\uC815\uACFC \uD310\uB9E4\uC790 \uC815\uC0B0\uC740 \uBA48\uCDB0\uC694.\n\uAD00\uB9AC\uC790\uAC00 \uC591\uCE21 \uC774\uC57C\uAE30\uB97C \uD655\uC778\uD55C \uB4A4 \uD658\uBD88(\uC804\uC561 \uB610\uB294 \uC77C\uBD80)\uD558\uAC70\uB098, \uADFC\uAC70\uAC00 \uC5C6\uAC70\uB098 \uD569\uC758\uAC00 \uB05D\uB0AC\uC73C\uBA74 \uBD84\uC7C1\uC744 \uAE30\uAC01\uD574 \uC815\uC0B0\uC744 \uB2E4\uC2DC \uC9C4\uD589\uD574\uC694. \uACC4\uC57D\uC744 \uC774\uC5B4 \uAC00\uAE30 \uC5B4\uB824\uC6B0\uBA74 \uACC4\uC57D\uC744 \uD574\uC9C0\uD574 \uBD84\uC7C1\uC744 \uB05D\uB0BC \uC218\uB3C4 \uC788\uC5B4\uC694(\uD574\uC9C0\uC640 \uBD84\uC7C1 \uCC38\uACE0). \uCC98\uB9AC \uACB0\uACFC\uC640 \uC0AC\uC720\uB294 \uC8FC\uBB38 \uC0C1\uC138\uC640 \uC54C\uB9BC\uC73C\uB85C \uC591\uCABD\uC5D0 \uC548\uB0B4\uB3FC\uC694.\n\uAD00\uB9AC\uC790\uAC00 \uAE30\uAC01\uD55C \uBD84\uC7C1\uC740 \uB2E4\uC2DC \uC811\uC218\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC0C8\uB85C\uC6B4 \uBB38\uC81C\uAC00 \uC0DD\uAE30\uBA74 \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694."
          }
        ]
      },
      {
        slug: "termination",
        title: "\uD574\uC9C0\uC640 \uBD84\uC7C1",
        description: "\uACC4\uC57D\uC744 \uC911\uAC04\uC5D0 \uB05D\uB0B4\uB294 \uD574\uC9C0\uC640, \uD574\uC9C0\uD560 \uB54C \uC120\uBD88\uC744 \uCC98\uB9AC\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\uACC4\uC57D \uD574\uC9C0\uB780"
          },
          {
            type: "p",
            text: "\uD574\uC9C0\uB294 \uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB41C \uACC4\uC57D\uC744 \uAE30\uAC04\uC774 \uB05D\uB098\uAE30 \uC804\uC5D0 \uB05D\uB0B4\uB294 \uAC70\uC608\uC694. \uC591\uCABD\uC774 \uD569\uC758\uD588\uAC70\uB098, \uD55C\uCABD\uC774 \uACC4\uC57D\uC744 \uC9C0\uD0A4\uC9C0 \uC54A\uC558\uAC70\uB098, \uD310\uB9E4\uC790\uAC00 \uB354 \uC774\uC0C1 \uAD8C\uB9AC\uB97C \uC81C\uACF5\uD560 \uC218 \uC5C6\uC744 \uB54C \uAD00\uB9AC\uC790\uAC00 \uD574\uC9C0\uD574\uC694.\n\uD574\uC9C0\uD558\uBA74 \uD574\uC9C0\uD55C \uB0A0\uAE4C\uC9C0\uC758 \uC0AC\uC6A9\uC740 \uC815\uB2F9\uD55C \uC0AC\uC6A9\uC73C\uB85C \uC778\uC815\uB418\uACE0, \uADF8\uB2E4\uC74C\uBD80\uD130\uB294 \uB77C\uC774\uC120\uC2A4\uB97C \uC4F8 \uC218 \uC5C6\uC5B4\uC694.\n\uC120\uBD88 \uAE08\uC561\uC774 \uC5C6\uB294 \uB85C\uC5F4\uD2F0 \uACC4\uC57D(\uC120\uBD88 0\uC6D0)\uC740 \uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uAE30 \uC804\uC774\uC5B4\uB3C4 \uD574\uC9C0\uB85C \uB05D\uB0BC \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "vs-refund",
            text: "\uD574\uC9C0\uC640 \uC804\uC561 \uD658\uBD88\uC758 \uCC28\uC774"
          },
          {
            type: "list",
            items: [
              "\uD574\uC9C0: \uD574\uC9C0\uD55C \uB0A0\uAE4C\uC9C0 \uC4F4 \uAC83\uC740 \uC778\uC815\uB3FC\uC694. \uC8FC\uBB38\uC740 \uACC4\uC57D \uD574\uC9C0 \uC0C1\uD0DC\uAC00 \uB418\uACE0, \uB77C\uC774\uC120\uC2A4 \uC99D\uC11C\uB294 \uD574\uC9C0 \uD45C\uC2DC\uC640 \uD568\uAED8 \uACC4\uC18D \uBC1B\uC744 \uC218 \uC788\uC5B4\uC694.",
              "\uC804\uC561 \uD658\uBD88: \uCC98\uC74C\uBD80\uD130 \uC5C6\uB358 \uACC4\uC57D\uC73C\uB85C \uCC98\uB9AC\uB3FC\uC694. \uC8FC\uBB38\uC740 \uD658\uBD88 \uC0C1\uD0DC\uAC00 \uB418\uACE0, \uB77C\uC774\uC120\uC2A4\uB294 \uD68C\uC218\uB3FC \uC99D\uC11C\uB97C \uBC1B\uC744 \uC218 \uC5C6\uC5B4\uC694.",
              "\uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uAE30 \uC804\uC5D0 \uACC4\uC57D\uC744 \uB05D\uB0B4\uB824\uBA74 \uD574\uC9C0\uAC00 \uC544\uB2C8\uB77C \uC8FC\uBB38 \uCDE8\uC18C(\uC785\uAE08 \uC804)\uB098 \uD658\uBD88(\uC785\uAE08 \uD6C4)\uC744 \uC774\uC6A9\uD574 \uC8FC\uC138\uC694. \uC120\uBD88 0\uC6D0 \uACC4\uC57D\uB9CC \uC608\uC678\uB85C \uBC1C\uAE09 \uC804\uC5D0\uB3C4 \uD574\uC9C0\uD574\uC694."
            ]
          },
          {
            type: "h2",
            id: "upfront",
            text: "\uD574\uC9C0\uD560 \uB54C \uC120\uBD88 \uCC98\uB9AC"
          },
          {
            type: "p",
            text: "\uD574\uC9C0\uD560 \uB54C\uB294 \uC774\uBBF8 \uB0B8 \uC120\uBD88 \uAE08\uC561\uC744 \uC5B4\uB5BB\uAC8C \uB098\uB20C\uC9C0 \uD568\uAED8 \uC815\uD574\uC694. \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uB294 \uACC4\uC57D \uD574\uC9C0 \uD45C\uC2DC \uC606\uC5D0 \uC5B4\uB5A4 \uBC29\uC2DD\uC73C\uB85C \uCC98\uB9AC\uB410\uB294\uC9C0 \uD568\uAED8 \uBCF4\uC5EC\uC694."
          },
          {
            type: "list",
            items: [
              "\uD574\uC9C0 \xB7 \uD658\uBD88 \uC5C6\uC74C: \uC120\uBD88\uC740 \uB3CC\uB824\uBC1B\uC9C0 \uC54A\uACE0, \uD310\uB9E4\uC790\uAC00 \uD310\uB9E4 \uB300\uAE08\uC73C\uB85C \uC815\uC0B0\uBC1B\uC544\uC694.",
              "\uD574\uC9C0 \xB7 \uBD80\uBD84 \uD658\uBD88(\uC120\uBD88): \uC120\uBD88 \uC911 \uC77C\uBD80\uB97C \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uB3CC\uB824\uC8FC\uACE0, \uB098\uBA38\uC9C0\uB294 \uD310\uB9E4\uC790\uAC00 \uC815\uC0B0\uBC1B\uC544\uC694.",
              "\uD574\uC9C0 \xB7 \uC804\uC561 \uD658\uBD88(\uC120\uBD88): \uC120\uBD88 \uC804\uBD80\uB97C \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uB3CC\uB824\uC918\uC694. \uADF8\uB798\uB3C4 \uACC4\uC57D\uC740 \uD574\uC9C0 \uC0C1\uD0DC\uB77C \uD574\uC9C0\uD55C \uB0A0\uAE4C\uC9C0 \uC4F4 \uAC83\uC740 \uC778\uC815\uB418\uACE0, \uADF8\uB54C\uAE4C\uC9C0\uC758 \uB85C\uC5F4\uD2F0\uB294 \uB0B4\uC57C \uD574\uC694."
            ]
          },
          {
            type: "p",
            text: "\uD658\uBD88\uC740 \uAD00\uB9AC\uC790\uAC00 \uC1A1\uAE08\uC744 \uB9C8\uCE58\uBA74 \uC644\uB8CC\uB3FC\uC694. \uBB34\uD1B5\uC7A5\uC785\uAE08 \uAC74\uC740 \uD658\uBD88\uBC1B\uC744 \uACC4\uC88C\uAC00 \uD544\uC694\uD574\uC694. \uD658\uBD88\uC774 \uB05D\uB098\uAE30 \uC804\uC5D0\uB294 \uD310\uB9E4\uC790 \uC815\uC0B0\uB3C4 \uC9C0\uAE09\uB418\uC9C0 \uC54A\uC544\uC694."
          },
          {
            type: "h2",
            id: "royalty",
            text: "\uD574\uC9C0 \uD6C4 \uB85C\uC5F4\uD2F0"
          },
          {
            type: "p",
            text: "\uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC740 \uD574\uC9C0\uD55C \uB0A0\uC774 \uC788\uB294 \uB2EC\uAE4C\uC9C0 \uB9E4\uCD9C\uC744 \uBCF4\uACE0\uD558\uACE0 \uB85C\uC5F4\uD2F0\uB97C \uB0B4\uC57C \uD574\uC694. \uD574\uC9C0\uD55C \uB2EC\uC740 1\uC77C\uBD80\uD130 \uD574\uC9C0\uD55C \uB0A0\uAE4C\uC9C0\uC758 \uB9E4\uCD9C\uB9CC \uB123\uC5B4\uC694.\n\uC608\uB97C \uB4E4\uC5B4 10\uC6D4 15\uC77C\uC5D0 \uD574\uC9C0\uD588\uB2E4\uBA74 10\uC6D4\uBD84(1~15\uC77C) \uB9E4\uCD9C\uC744 11\uC6D4 \uC9C0\uAE09\uC77C\uAE4C\uC9C0 \uBCF4\uACE0\uD558\uBA74 \uB418\uACE0, 11\uC6D4\uBD80\uD130\uB294 \uBCF4\uACE0\uD558\uC9C0 \uC54A\uC544\uC694.\n\uC774\uBBF8 \uB0B8 \uB85C\uC5F4\uD2F0\uB294 \uD574\uC9C0\uB85C \uB3CC\uB824\uBC1B\uC9C0 \uC54A\uC544\uC694. \uBCF4\uACE0\uD55C \uB9E4\uCD9C\uC774 \uD2C0\uB838\uB2E4\uBA74 \uB85C\uC5F4\uD2F0 \uBCF4\uACE0\uC758 \uC815\uC815 \uC808\uCC28\uB97C \uC774\uC6A9\uD574 \uC8FC\uC138\uC694."
          },
          {
            type: "h2",
            id: "request",
            text: "\uD574\uC9C0 \uC694\uCCAD\uD558\uAE30"
          },
          {
            type: "p",
            text: "\uD574\uC9C0\uAC00 \uD544\uC694\uD558\uBA74 \uAC70\uB798 \uCC44\uD305\uC5D0\uC11C \uC0C1\uB300\uBC29\uACFC \uD574\uC9C0 \uC5EC\uBD80\uC640 \uC120\uBD88 \uCC98\uB9AC \uBC29\uC2DD\uC744 \uBA3C\uC800 \uC774\uC57C\uAE30\uD55C \uB4A4 \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694.\n\uAD00\uB9AC\uC790\uAC00 \uC591\uCABD \uC758\uACAC\uACFC \uAC70\uB798 \uAE30\uB85D\uC744 \uD655\uC778\uD558\uACE0 \uD574\uC9C0 \uC0AC\uC720\uC640 \uC120\uBD88 \uCC98\uB9AC \uBC29\uC2DD\uC744 \uC815\uD574 \uCC98\uB9AC\uD574\uC694. \uCC98\uB9AC \uACB0\uACFC\uC640 \uC0AC\uC720\uB294 \uC8FC\uBB38 \uC0C1\uC138, \uC54C\uB9BC, \uAC70\uB798 \uCC44\uD305\uC73C\uB85C \uC591\uCABD\uC5D0 \uC548\uB0B4\uB3FC\uC694."
          },
          {
            type: "h2",
            id: "dispute",
            text: "\uBD84\uC7C1 \uC911 \uD574\uC9C0"
          },
          {
            type: "p",
            text: "\uBD84\uC7C1\uC744 \uD655\uC778\uD55C \uAD00\uB9AC\uC790\uAC00 \uACC4\uC57D\uC744 \uC774\uC5B4 \uAC00\uAE30 \uC5B4\uB835\uB2E4\uACE0 \uD310\uB2E8\uD558\uBA74 \uACC4\uC57D\uC744 \uD574\uC9C0\uD574 \uBD84\uC7C1\uC744 \uB05D\uB0BC \uC218 \uC788\uC5B4\uC694. \uC774\uB54C\uB3C4 \uC120\uBD88 \uCC98\uB9AC \uBC29\uC2DD(\uD658\uBD88 \uC5C6\uC74C, \uBD80\uBD84 \uD658\uBD88, \uC804\uC561 \uD658\uBD88)\uC744 \uD568\uAED8 \uC815\uD558\uACE0, \uBD84\uC7C1 \uCC98\uB9AC \uACB0\uACFC\uC5D0 \uACC4\uC57D \uD574\uC9C0\uB85C \uC885\uACB0\uB410\uB2E4\uACE0 \uD45C\uC2DC\uB3FC\uC694."
          },
          {
            type: "h2",
            id: "after",
            text: "\uD574\uC9C0\uB41C \uB4A4\uC5D0\uB294"
          },
          {
            type: "list",
            items: [
              "\uD574\uC9C0\uB41C \uB77C\uC774\uC120\uC2A4\uB294 \uD574\uC9C0\uD55C \uB0A0 \uC774\uD6C4\uB85C \uC4F8 \uC218 \uC5C6\uC5B4\uC694. \uACC4\uC18D \uC4F0\uB824\uBA74 \uC0C8\uB85C \uAD6C\uB9E4\uD574\uC57C \uD574\uC694.",
              "\uC644\uC804 \uB3C5\uC810 \uACC4\uC57D\uC774 \uD574\uC9C0\uB418\uBA74 \uADF8 \uAD8C\uB9AC\uB97C \uB2E4\uB978 \uAD6C\uB9E4\uC790\uAC00 \uC0B4 \uC218 \uC788\uAC8C \uB3FC\uC694.",
              "\uAC70\uB798 \uCC44\uD305\uBC29\uC740 \uB2EB\uD788\uC9C0 \uC54A\uC544\uC694. \uB0A8\uC740 \uB85C\uC5F4\uD2F0 \uBCF4\uACE0\uB098 \uD658\uBD88 \uC774\uC57C\uAE30\uB97C \uC774\uC5B4 \uAC08 \uC218 \uC788\uC5B4\uC694.",
              "\uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC740 \uD574\uC9C0\uD55C \uB2EC\uAE4C\uC9C0 \uB85C\uC5F4\uD2F0 \uC9C0\uAE09\uC774 \uB05D\uB098\uBA74 \uACC4\uC57D\uC774 \uB05D\uB09C \uAC83\uC73C\uB85C \uBCF4\uACE0, \uADF8 \uB4A4\uC5D0\uB294 \uD0C8\uD1F4\uD560 \uC218 \uC788\uC5B4\uC694."
            ]
          }
        ]
      },
      {
        slug: "contract-end",
        title: "\uACC4\uC57D\uC758 \uC885\uB8CC",
        description: "\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uAE30\uAC04\uC774 \uB05D\uB0A0 \uB54C\uC758 \uC548\uB0B4\uC640, \uB05D\uB09C \uB4A4 \uACC4\uC18D \uC4F0\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "\uACC4\uC57D \uAE30\uAC04\uC774 \uB05D\uB098\uB294 \uB54C"
          },
          {
            type: "p",
            text: "\uB77C\uC774\uC120\uC2A4\uB294 \uC99D\uC11C\uC5D0 \uC801\uD78C \uC0AC\uC6A9 \uAE30\uAC04(\uC0AC\uC6A9 \uC2DC\uC791\uC77C ~ \uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9\uC77C) \uB3D9\uC548 \uC4F8 \uC218 \uC788\uC5B4\uC694. \uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9\uC77C\uC774 \uC9C0\uB098\uBA74 \uB2E4\uC74C \uB0A0 00\uC2DC\uC5D0 \uB9CC\uB8CC\uB3FC \uADF8\uB0A0\uBD80\uD130\uB294 \uC4F8 \uC218 \uC5C6\uC5B4\uC694.\n\uB0A0\uC9DC\uB294 \uC8FC\uBB38\uD560 \uB54C \uC815\uD574\uC9C4 \uACC4\uC57D \uC2DC\uAC04\uB300 \uAE30\uC900\uC774\uB77C \uAD6C\uB9E4\uC790\uC640 \uD310\uB9E4\uC790\uAC00 \uAC19\uC740 \uB0A0\uC9DC\uB97C \uBD10\uC694.\n\uCD9C\uC5F0\uAD8C\uC740 1\uD68C \uCD9C\uC5F0\uC73C\uB85C \uB05D\uB098\uB294 \uACC4\uC57D\uC774\uB77C \uB9CC\uB8CC\uC77C\uC774 \uC5C6\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "notice",
            text: "\uC885\uB8CC \uC804\uD6C4 \uC548\uB0B4"
          },
          {
            type: "list",
            items: [
              "\uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9\uC77C\uAE4C\uC9C0 7\uC77C \uB0A8\uC558\uC744 \uB54C\uC640 3\uC77C \uB0A8\uC558\uC744 \uB54C, \uAD6C\uB9E4\uC790\uC640 \uD310\uB9E4\uC790 \uBAA8\uB450\uC5D0\uAC8C \uC54C\uB9BC\uACFC \uD478\uC2DC\uB97C \uBCF4\uB0B4\uC694. \uC54C\uB9BC\uC744 \uB204\uB974\uBA74 \uADF8 \uAC70\uB798\uC758 \uC8FC\uBB38 \uC0C1\uC138\uAC00 \uC5F4\uB824\uC694.",
              "\uAE30\uAC04\uC774 \uB05D\uB098\uBA74 \uC591\uCABD\uC5D0 \uC885\uB8CC \uC54C\uB9BC\uC744 \uBCF4\uB0B4\uACE0, \uAC70\uB798 \uCC44\uD305\uBC29\uC5D0 \u201CIP \uACC4\uC57D \uAE30\uAC04\uC774 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC7AC\uACC4\uC57D\uC744 \uC6D0\uD558\uC2DC\uBA74 IP \uC8FC\uBB38\uC744 \uB2E4\uC2DC \uC9C4\uD589\uD574 \uC8FC\uC138\uC694.\u201D \uC548\uB0B4\uAC00 \uB0A8\uC544\uC694.",
              "\uACC4\uC57D\uACFC \uAD00\uB828\uB41C \uC548\uB0B4\uB77C \uC54C\uB9BC \uC124\uC815\uC5D0\uC11C \uB04C \uC218 \uC5C6\uC5B4\uC694."
            ]
          },
          {
            type: "h2",
            id: "renew",
            text: "\uACC4\uC18D \uC4F0\uACE0 \uC2F6\uB2E4\uBA74"
          },
          {
            type: "p",
            text: "\uAE30\uAC04\uC744 \uB298\uB9AC\uB294 \uC5F0\uC7A5\uC740 \uB530\uB85C \uC5C6\uC5B4\uC694. \uAC19\uC740 IP\uB97C \uB2E4\uC2DC \uC8FC\uBB38\uD558\uBA74 \uC0C8 \uACC4\uC57D\uC73C\uB85C \uC774\uC5B4\uC11C \uC4F8 \uC218 \uC788\uC5B4\uC694(\uB77C\uC774\uC120\uC2A4 \uD655\uC778\uD558\uAE30\uC758 \uAC19\uC740 IP \uB2E4\uC2DC \uAD6C\uB9E4\uD558\uAE30 \uCC38\uACE0).\n\uB04A\uAE30\uC9C0 \uC54A\uAC8C \uC4F0\uB824\uBA74 \uAE30\uAC04\uC774 \uB05D\uB098\uAE30 \uC804\uC5D0 \uB2E4\uC2DC \uC8FC\uBB38\uD558\uACE0, \uCC44\uD305\uC73C\uB85C \uD310\uB9E4\uC790\uC640 \uC0C8 \uACC4\uC57D\uC758 \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uC744 \uC9C0\uAE08 \uACC4\uC57D\uC774 \uB05D\uB098\uB294 \uB2E4\uC74C \uB0A0\uB85C \uB9DE\uCDB0 \uC8FC\uC138\uC694.\n\uB2E4\uB978 \uAD6C\uB9E4\uC790\uAC00 \uADF8 \uAD8C\uB9AC\uB97C \uC644\uC804 \uB3C5\uC810\uC73C\uB85C \uACC4\uC57D\uD574 \uC4F0\uACE0 \uC788\uC73C\uBA74 \uB2E4\uC2DC \uC0B4 \uC218 \uC5C6\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "after",
            text: "\uC885\uB8CC\uB41C \uB4A4\uC5D0\uB294"
          },
          {
            type: "list",
            items: [
              "\uB9CC\uB8CC\uB41C \uB77C\uC774\uC120\uC2A4\uB85C\uB294 \uADF8 IP\uB97C \uB354 \uC4F8 \uC218 \uC5C6\uC5B4\uC694.",
              "\uC99D\uC11C\uB294 \uB9CC\uB8CC \uD45C\uC2DC\uC640 \uD568\uAED8 \uACC4\uC18D \uB0B4\uB824\uBC1B\uC744 \uC218 \uC788\uC5B4\uC694.",
              "\uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC740 \uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9\uC77C\uC774 \uC788\uB294 \uB2EC\uAE4C\uC9C0 \uB9E4\uCD9C\uC744 \uBCF4\uACE0\uD558\uACE0 \uB85C\uC5F4\uD2F0\uB97C \uB0B4\uC57C \uD574\uC694. \uADF8 \uB2EC\uC740 1\uC77C\uBD80\uD130 \uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9\uC77C\uAE4C\uC9C0\uC758 \uB9E4\uCD9C\uB9CC \uB123\uC5B4\uC694.",
              "\uAC70\uB798 \uCC44\uD305\uBC29\uC740 \uB2EB\uD788\uC9C0 \uC54A\uC544\uC694. \uB0A8\uC740 \uB85C\uC5F4\uD2F0 \uBCF4\uACE0\uB098 \uB2E4\uC2DC \uC8FC\uBB38\uD560 \uC774\uC57C\uAE30\uB97C \uC774\uC5B4 \uAC08 \uC218 \uC788\uC5B4\uC694.",
              "\uAE30\uAC04\uC774 \uB05D\uB098\uAE30 \uC804\uC5D0 \uACC4\uC57D\uC744 \uB05D\uB0B4\uB294 \uD574\uC9C0\uB294 \uD574\uC9C0\uC640 \uBD84\uC7C1\uC744 \uBD10 \uC8FC\uC138\uC694."
            ]
          }
        ]
      }
    ]
  },
  {
    title: "\uD310\uB9E4\uC790 \uAC00\uC774\uB4DC",
    pages: [
      {
        slug: "selling",
        title: "\uD310\uB9E4 \uB4F1\uB85D\uD558\uAE30",
        description: "\uD310\uB9E4\uD560 \uAD8C\uB9AC\uB97C \uACE0\uB974\uACE0 \uC870\uAC74\uC744 \uC815\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "listing",
            text: "\uC0C1\uD488 \uB9CC\uB4E4\uAE30"
          },
          {
            type: "p",
            text: "IP \uD310\uB9E4\uD558\uAE30\uC5D0\uC11C \uD310\uB9E4\uD560 \uAD8C\uB9AC \uC720\uD615\uC744 \uACE0\uB974\uACE0 \uC81C\uBAA9\xB7\uC18C\uAC1C\xB7\uC8FC\uC758\uC0AC\uD56D\uC744 \uC801\uC5B4\uC694.\n\uACE0\uB978 \uAD8C\uB9AC\uB9C8\uB2E4 \uC870\uAC74\uC744 \uD558\uB098\uC529 \uC815\uD558\uACE0, \uAC19\uC740 \uAD8C\uB9AC \uC548\uC5D0\uC11C\uB294 \uAE30\uAC04\uBCC4 \uAC00\uACA9\xB7\uCD9C\uC5F0 \uBC29\uC2DD\xB7\uCD94\uAC00\uAE08 \uC635\uC158\uC73C\uB85C \uC870\uAC74\uC744 \uB098\uB20C \uC218 \uC788\uC5B4\uC694.\n\uADF8 \uBC16\uC758 \uC870\uAC74\uC744 \uB2EC\uB9AC \uD314\uACE0 \uC2F6\uB2E4\uBA74 \uC0C1\uD488\uC744 \uB530\uB85C \uB4F1\uB85D\uD574 \uC8FC\uC138\uC694."
          },
          {
            type: "h2",
            id: "terms",
            text: "\uC870\uAC74 \uC124\uC815"
          },
          {
            type: "list",
            items: [
              "\uC0AC\uC6A9 \uAE30\uAC04\uBCC4 \uAC00\uACA9 \u2014 1\xB73\xB76\xB712\uAC1C\uC6D4 \uC911 \uD310\uB9E4\uD560 \uAE30\uAC04\uC744 \uACE8\uB77C \uAC00\uACA9\uC744 \uB9E4\uACA8\uC694.",
              "\uC0AC\uC6A9 \uC9C0\uC5ED \u2014 \uAD6D\uB0B4 \uD55C\uC815 \uB610\uB294 \uAE00\uB85C\uBC8C.",
              "\uB3C5\uC810 \uC5EC\uBD80 \u2014 \uBE44\uB3C5\uC810 / \uCE74\uD14C\uACE0\uB9AC \uB3C5\uC810 / \uC644\uC804 \uB3C5\uC810. \uB3C5\uC810\uC77C\uC218\uB85D \uB192\uC740 \uAC00\uACA9\uC744 \uBC1B\uC744 \uC218 \uC788\uC5B4\uC694.",
              "\uC218\uC815 \uD5C8\uC6A9 \uBC94\uC704\uC640 \uAE08\uC9C0 \uC5C5\uC885 \u2014 \uC6D0\uCE58 \uC54A\uB294 \uC0AC\uC6A9\uC744 \uBBF8\uB9AC \uCC28\uB2E8\uD574\uC694."
            ]
          },
          {
            type: "h2",
            id: "pricing",
            text: "\uAC00\uACA9 \uBC29\uC2DD"
          },
          {
            type: "p",
            text: "\uACE0\uC815\uAC00, \uB9E4\uCD9C \uB85C\uC5F4\uD2F0, \uACE0\uC815\uAC00 + \uB9E4\uCD9C \uB85C\uC5F4\uD2F0 \uC911\uC5D0\uC11C \uACE0\uB97C \uC218 \uC788\uC5B4\uC694.\n\uB85C\uC5F4\uD2F0 \uBC29\uC2DD\uC744 \uACE0\uB974\uBA74 \uB85C\uC5F4\uD2F0 \uBE44\uC728\uACFC \uD568\uAED8 \uC9C0\uAE09\uC77C(\uB9E4\uB2EC N\uC77C)\uC744 \uC815\uD574\uC694 \u2014 \uAD6C\uB9E4\uC790\uAC00 \uB9E4\uB2EC \uADF8 \uB0A0\uC9DC\uAE4C\uC9C0 \uC804\uC6D4 \uB9E4\uCD9C\uC744 \uBCF4\uACE0\uD558\uACE0 \uB85C\uC5F4\uD2F0\uB97C \uC785\uAE08\uD574\uC694.\n\uCD9C\uC5F0\uAD8C\uC740 1\uD68C\xB7\uAE30\uBCF8 \uC2DC\uAC04 \uAE30\uC900 \uACE0\uC815\uAC00\uB9CC \uC9C0\uC6D0\uD574\uC694. \uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uCD94\uAC00\uAE08\uC740 \uC120\uD0DD \uC2DC \uB354\uD574\uC694.\n\uAD50\uD1B5\xB7\uC219\uBC15\uBE44(\uD604\uC7A5 \uBC29\uBB38)\uB294 \uAE30\uBCF8\uAC00 \uD3EC\uD568 \uB610\uB294 \uBCC4\uB3C4 \uBE44\uC6A9 \uD611\uC758 \uC911\uC5D0\uC11C \uC815\uD574\uC694.\n\uC5F0\uC7A5\uC740 \uC5F0\uC7A5 \uBD88\uAC00\xB7\uC2DC\uAC04\xB7\uBE44\uC6A9 \uBCC4\uB3C4 \uD611\uC758\xB7\uC815\uD574\uC9C4 \uCD94\uAC00\uAE08(N\uBD84\uB2F9 \uAE08\uC561) \uC911\uC5D0\uC11C \uC815\uD558\uACE0, \uC5F0\uC7A5 \uBE44\uC6A9\uC740 \uAE30\uBCF8 \uACB0\uC81C\uAE08\uC5D0 \uD3EC\uD568\uB418\uC9C0 \uC54A\uC544\uC694."
          },
          {
            type: "h2",
            id: "considerations",
            text: "\uC2E4\uC81C \uD310\uB9E4 \uC2DC \uACE0\uB824\uD574\uC57C \uD560 \uC0AC\uD56D"
          },
          {
            type: "p",
            text: "\uC0C1\uD488\uC5D0 \uC815\uD55C \uC870\uAC74\uB9CC\uC73C\uB85C\uB294 \uB2E4 \uB2F4\uAE30 \uC5B4\uB824\uC6B4, \uAD8C\uB9AC\uB9C8\uB2E4 \uB354 \uC138\uBD80\uC801\uC73C\uB85C \uB17C\uC758\uAC00 \uD544\uC694\uD55C \uBD80\uBD84\uB4E4\uC774 \uB9CE\uC544\uC694.\n\uD310\uB9E4 \uC804\uC5D0 \uBBF8\uB9AC \uAE30\uC900\uC744 \uC815\uD574 \uB450\uBA74 \uD611\uC758\uAC00 \uD6E8\uC52C \uBE68\uB77C\uC838\uC694."
          },
          {
            type: "list",
            items: [
              "\uC774\uB984/\uBE0C\uB79C\uB4DC \u2014 \uC5B4\uB5A4 \uD45C\uAE30(\uD55C\uAE00\xB7\uC601\uBB38\xB7\uB85C\uACE0)\uAE4C\uC9C0 \uD5C8\uC6A9\uD560\uC9C0, \uC801\uC6A9 \uC0C1\uD488\xB7\uAD11\uACE0 \uC18C\uC7AC \uB4F1 \uC0AC\uC6A9 \uC218\uB7C9 \uD55C\uB3C4, \uC0C1\uD45C \uCD9C\uC6D0\xB7\uC0C1\uD638 \uB4F1\uB85D\uC740 \uB9C9\uC744\uC9C0.",
              "\uC0AC\uC9C4 \uC0AC\uC6A9\uAD8C \u2014 \uC5B4\uB5A4 \uCD2C\uC601\uBCF8\uC744 \uC81C\uACF5\uD560\uC9C0, \uBCF4\uC815\xB7\uD06C\uB86D\uC740 \uC5B4\uB514\uAE4C\uC9C0 \uD5C8\uC6A9\uD558\uACE0 \uD569\uC131\xB7AI \uD559\uC2B5\uC740 \uB9C9\uC744\uC9C0.",
              "\uC601\uC0C1 \uC0AC\uC6A9\uAD8C \u2014 \uD5C8\uC6A9\uD560 \uC6D0\uBCF8\uC758 \uBC94\uC704, \uBC1C\uC5B8 \uCDE8\uC9C0\uB97C \uC65C\uACE1\uD558\uB294 \uD3B8\uC9D1\xB7\uD0C0 \uD50C\uB7AB\uD3FC \uC7AC\uC5C5\uB85C\uB4DC \uD5C8\uC6A9 \uC5EC\uBD80.",
              "\uC74C\uC131 \uC0AC\uC6A9\uAD8C \u2014 \uD30C\uC77C \uC0AC\uC6A9\xB7\uC0C8 \uC81C\uC791\xB7\uAD6C\uB9E4\uC790 AI \uC0DD\uC131 \uC911 \uD569\uC758\uD55C \uBC29\uC2DD\uC5D0 \uB9DE\uCDB0 \uB300\uC0C1 \uC74C\uC131\xB7\uB300\uC0AC\xB7\uBD84\uB7C9, \uC81C\uC791 \uC870\uAC74 \uB610\uB294 \uC0DD\uC131 \uBC29\uBC95\xB7\uAE30\uAC04\xB7\uC11C\uBE44\uC2A4 \uBE44\uC6A9\uC744 \uD655\uC815.",
              "\uACF5\uB3D9 \uBE0C\uB79C\uB529 \u2014 \uD568\uAED8 \uD45C\uC2DC\uD560 \uBE0C\uB79C\uB4DC \uC694\uC18C\xB7\uBB38\uAD6C, \uCEA0\uD398\uC778 1\uAC74 \uAE30\uC900 \uAC00\uACA9, \uAD6C\uB9E4\uC790\uAC00 \uC120\uD0DD\uD558\uB294 \uCEA0\uD398\uC778 \uC218, \uC0AC\uC6A9 \uC704\uCE58\xB7\uAC74\uB2F9 \uCD94\uAC00\uAE08, \uACF5\uAC1C \uC804 \uC2DC\uC548 \uC2B9\uC778\uACFC \uC885\uB8CC \uD6C4 \uAC8C\uC2DC\uBB3C \uCC98\uB9AC. \uC2E4\uC81C \uC0C1\uB300 \uBE0C\uB79C\uB4DC\xB7\uCEA0\uD398\uC778\xB7\uC2DC\uC548\uC740 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uAE30\uB85D\uD574\uC694. \uAC19\uC740 \uBC94\uC704\uC758 \uC774\uB984\xB7\uB85C\uACE0 \uC0AC\uC6A9\uC740 \uD3EC\uD568\uD558\uBA70 \uC0C1\uD488 \uAE30\uD68D\xB7\uC81C\uC791\xB7\uD310\uB9E4\uB098 \uD310\uB9E4\uC790\uC758 \uC9C1\uC811 \uAC8C\uC2DC\xB7\uCD9C\uC5F0\uC740 \uBCC4\uB3C4\uC608\uC694.",
              "\uAD7F\uC988 \uC81C\uC791 \u2014 \uD310\uB9E4\uC6A9\xB7\uBE44\uB9E4\uD488 \uBC30\uD3EC\uC6A9\uC744 \uAC01\uAC01 \uB610\uB294 \uD568\uAED8 \uD5C8\uC6A9\uD574\uC694. \uD488\uBAA9\xB7\uC0AC\uC6A9\uD560 \uC694\uC18C\xB7\uCD1D \uC81C\uC791 \uC218\uB7C9\xB7\uD310\uB9E4 \uBC0F \uBC30\uD3EC \uACBD\uB85C\xB7\uC2DC\uC548\uACFC \uC0D8\uD50C \uC2B9\uC778\xB7\uCD94\uAC00 \uC81C\uC791\xB7\uAE30\uAC04 \uC885\uB8CC \uD6C4 \uC7AC\uACE0 \uCC98\uB9AC \uC870\uAC74\uC744 \uC815\uD574\uC694. \uD310\uB9E4\uBD84\xB7\uC99D\uC815\uBD84\xB7\uC0D8\uD50C\uC740 \uCD1D\uC218\uB7C9\uC5D0 \uD569\uC0B0\uD558\uBA70, \uBE44\uB9E4\uD488 \uC804\uC6A9\uC740 \uB9E4\uCD9C \uB85C\uC5F4\uD2F0 \uC5C6\uC774 \uAC00\uACA9\uC744 \uC815\uD574\uC694.",
              "\uCD9C\uC5F0 \u2014 \uD55C \uC0C1\uD488\uC5D0 \uD604\uC7A5 \uBC29\uBB38\xB7\uC628\uB77C\uC778 \uC601\uC0C1\xB7\uC628\uB77C\uC778 \uC74C\uC131 \uC911 \uC81C\uACF5\uD560 \uBC29\uC2DD\uC744 \uD568\uAED8 \uB4F1\uB85D\uD560 \uC218 \uC788\uC5B4\uC694. \uBC29\uC2DD\uBCC4\uB85C \uD65C\uB3D9\xB71\uD68C \uAE30\uBCF8 \uC2DC\uAC04\xB7\uAC00\uACA9\xB7\uC5F0\uC7A5 \uC870\uAC74\xB7\uAE30\uB85D\uBB3C \uC0AC\uC6A9 \uBC94\uC704\uC640 \uC77C\uC815 \uBCC0\uACBD\xB7\uCDE8\uC18C \uC870\uAC74\uC744 \uC124\uC815\uD558\uACE0, \uAD6C\uB9E4\uC790\uB294 \uBC29\uC2DD \uD558\uB098\uB97C \uC120\uD0DD\uD574\uC694. \uBC29\uBB38 \uC9C0\uC5ED\xB7\uAD50\uD1B5\xB7\uC219\uBC15\uBE44\uB294 \uD604\uC7A5 \uBC29\uBB38\uC5D0\uC11C\uB9CC \uC124\uC815\uD574\uC694. \uC601\uC0C1\uC740 \uBCF8\uC778 \uBAA8\uC2B5 \uB610\uB294 \uC544\uBC14\uD0C0\uB85C, \uC74C\uC131\uC740 \uBAA9\uC18C\uB9AC\uB85C\uB9CC \uC2E4\uC2DC\uAC04 \uCC38\uC5EC\uD574\uC694. \uC2E4\uC81C \uC77C\uC815\uACFC \uC811\uC18D \uBC29\uBC95\uC740 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uAE30\uB85D\uD574\uC694."
            ]
          },
          {
            type: "callout",
            text: "\uC774\uB7F0 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC8FC\uBB38 \uD6C4 \uCC44\uD305\uC73C\uB85C \uD611\uC758\uD558\uACE0, \uD569\uC758\uB41C \uB0B4\uC6A9\uC744 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC73C\uB85C \uB4F1\uB85D\uD574 \uC99D\uC11C\uC5D0 \uB0A8\uAE30\uC138\uC694. \uC790\uC138\uD55C \uBC29\uBC95\uC740 \uCC44\uD305 \uD611\uC758\uC640 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D(\uD2B9\uC57D) \uBB38\uC11C\uB97C \uCC38\uACE0\uD558\uC138\uC694."
          }
        ]
      },
      {
        slug: "chat",
        title: "\uCC44\uD305 \uD611\uC758",
        description: "\uC8FC\uBB38 \uCC44\uD305\uBC29\uC5D0\uC11C \uAD6C\uB9E4\uC790\uC640 \uC138\uBD80 \uC870\uAC74\uC744 \uD611\uC758\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "room",
            text: "\uC8FC\uBB38 \uCC44\uD305\uBC29"
          },
          {
            type: "p",
            text: "\uAD6C\uB9E4\uC790\uC758 \uC785\uAE08\uC774 \uD655\uC778\uB418\uBA74 \uAD6C\uB9E4\uC790\uC640\uC758 \uAC70\uB798 \uCC44\uD305\uBC29\uC774 \uC790\uB3D9\uC73C\uB85C \uC5F4\uB824\uC694. \uC785\uAE08 \uC804\uC5D0 \uCDE8\uC18C\uB41C \uC8FC\uBB38\uC740 \uCC44\uD305\uBC29\uC774 \uC5F4\uB9AC\uC9C0 \uC54A\uC544\uC694.\n\uC0AC\uC6A9 \uBC94\uC704, \uC18C\uC7AC \uC804\uB2EC, \uC77C\uC815 \uAC19\uC740 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5EC\uAE30\uC11C \uD611\uC758\uD558\uC138\uC694."
          },
          {
            type: "h2",
            id: "draft",
            text: "\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9 \uB4F1\uB85D"
          },
          {
            type: "p",
            text: `\uCC44\uD305\uC73C\uB85C \uD611\uC758\uD55C \uB0B4\uC6A9\uC740 \uCC44\uD305\uBC29 \uC0C1\uB2E8\uC758 \u2018\uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\u2019 \uCE74\uB4DC\uC5D0 \uB0A8\uACA8 \uB450\uC138\uC694. \uC0AC\uC6A9 \uC2DC\uC791\uC77C(\uC624\uB298\uBD80\uD130 ${BUSINESS3.LICENSE_START_MAX_DAYS_AHEAD}\uC77C \uB4A4\uAE4C\uC9C0)\uACFC \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC744 \uB4F1\uB85D\uD560 \uC218 \uC788\uACE0, \uC800\uC7A5\uD558\uBA74 \uAD6C\uB9E4\uC790\uB3C4 \uBC14\uB85C \uBCFC \uC218 \uC788\uC5B4\uC694. \uBC1C\uAE09 \uC804\uAE4C\uC9C0 \uACC4\uC18D \uC218\uC815\uD560 \uC218 \uC788\uC5B4\uC694.
\uC5EC\uB7EC \uAD8C\uB9AC\uB97C \uD55C \uBC88\uC5D0 \uACB0\uC81C\uD55C \uBB36\uC74C \uC8FC\uBB38\uC758 \uCC44\uD305\uBC29\uC5D0\uB294 \uC774 \uCE74\uB4DC\uAC00 \uC5C6\uC5B4\uC694. \uC774\uB54C\uB294 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uAD8C\uB9AC\uBCC4\uB85C \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uACFC \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC744 \uC801\uC5B4 \uBC1C\uAE09\uD574 \uC8FC\uC138\uC694.`
          },
          {
            type: "callout",
            text: "\uB9D0\uB85C\uB9CC \uD569\uC758\uD558\uACE0 \uB118\uC5B4\uAC00\uBA74 \uB098\uC911\uC5D0 \uC11C\uB85C \uAE30\uC5B5\uC774 \uB2E4\uB97C \uC218 \uC788\uC5B4\uC694. \uD569\uC758\uAC00 \uB420 \uB54C\uB9C8\uB2E4 \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uAC31\uC2E0\uD574 \uB450\uBA74 \uADF8 \uB0B4\uC6A9 \uADF8\uB300\uB85C \uC99D\uC11C\uC5D0 \uB2F4\uACA8\uC694."
          }
        ]
      },
      {
        slug: "issuing",
        title: "\uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09",
        description: "\uD611\uC758\uAC00 \uB05D\uB09C \uB0B4\uC6A9 \uADF8\uB300\uB85C \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD558\uB294 \uD750\uB984\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "\uBC1C\uAE09 \uAC00\uB2A5 \uC2DC\uC810"
          },
          {
            type: "p",
            text: "\uAD6C\uB9E4\uC790\uC758 \uACB0\uC81C(\uC785\uAE08 \uD655\uC778)\uAC00 \uC644\uB8CC\uB418\uBA74 \uCC44\uD305\uBC29\uACFC \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uBC1C\uAE09\uD558\uAE30 \uBC84\uD2BC\uC774 \uD65C\uC131\uD654\uB3FC\uC694.\n\uD611\uC758\uB85C \uAE08\uC561\uC774 \uB298\uC5C8\uB2E4\uBA74 \uBC1C\uAE09 \uC804\uC5D0 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uCD94\uAC00\uAE08\uC744 \uC694\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694. \uC785\uAE08 \uB300\uAE30 \uC911\uC778 \uCD94\uAC00\uAE08\uC774 \uC788\uC73C\uBA74 \uBC1C\uAE09\uD560 \uC218 \uC5C6\uC73C\uB2C8, \uC785\uAE08\uC774 \uD655\uC778\uB41C \uB4A4 \uBC1C\uAE09\uD558\uAC70\uB098 \uCD94\uAC00\uAE08 \uC694\uCCAD\uC744 \uCDE8\uC18C\uD574 \uC8FC\uC138\uC694."
          },
          {
            type: "h2",
            id: "how",
            text: "\uBC1C\uAE09\uD558\uAE30"
          },
          {
            type: "p",
            text: "\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC5D0 \uB4F1\uB85D\uD574 \uB454 \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uACFC \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D \uADF8\uB300\uB85C \uBC1C\uAE09\uB3FC\uC694. \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uC744 \uBE44\uC6CC \uB450\uBA74 \uC624\uB298\uBD80\uD130 \uC2DC\uC791\uD574\uC694.\n\uC774\uB984\xB7\uBE0C\uB79C\uB4DC \uC0AC\uC6A9\uAD8C \uC678\uC758 \uAD8C\uB9AC\uB294 \uB300\uD654\uB85C \uD655\uC815\uD55C \uB300\uC0C1\xB7\uC218\uB7C9\xB7\uC77C\uC815 \uAC19\uC740 \uB0B4\uC6A9\uC744 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uC801\uC5B4\uC57C \uBC1C\uAE09\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "after",
            text: "\uBC1C\uAE09 \uD6C4\uC5D0\uB294"
          },
          {
            type: "p",
            text: "\uBC1C\uAE09 \uC989\uC2DC \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uB77C\uC774\uC120\uC2A4 \uC99D\uC11C\uAC00 \uC804\uB2EC\uB418\uACE0 \uC8FC\uBB38\uC774 \uAC70\uB798 \uC644\uB8CC\uB85C \uBC14\uB00C\uC5B4\uC694. \uAD6C\uB9E4\uC790\uAC00 \uAD6C\uB9E4\uD655\uC815\uD558\uBA74 \uC815\uC0B0 \uC808\uCC28\uAC00 \uC2DC\uC791\uB418\uACE0, \uD655\uC815\uD558\uC9C0 \uC54A\uC544\uB3C4 \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uBD80\uD130 {{purchaseConfirmDays}}\uC77C\uC774 \uC9C0\uB098\uBA74 \uC790\uB3D9\uC73C\uB85C \uD655\uC815\uB3FC\uC694. \uC0AC\uC6A9 \uC2DC\uC791 \uC804\uC5D0\uB3C4 \uBA3C\uC800 \uD655\uC815\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "callout",
            text: "\uBC1C\uAE09\uC740 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC5B4\uC694. \uD611\uC758\uAC00 \uB05D\uB0AC\uB294\uC9C0, \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC774 \uCD5C\uC2E0\uC778\uC9C0 \uD655\uC778\uD55C \uB4A4\uC5D0 \uBC1C\uAE09\uD574 \uC8FC\uC138\uC694."
          }
        ]
      },
      {
        slug: "special-terms",
        title: "\uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D(\uD2B9\uC57D)",
        description: "\uC774 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB9CC \uC801\uC6A9\uB418\uB294 \uC870\uAC74\uC744 \uC99D\uC11C\uC5D0 \uB0A8\uAE30\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC774\uB780"
          },
          {
            type: "p",
            text: '\uC0C1\uD488\uC5D0 \uC815\uD574\uC9C4 \uC870\uAC74(\uAE30\uAC04\xB7\uC9C0\uC5ED\xB7\uB3C5\uC810 \uB4F1) \uC678\uC5D0, \uC774 \uAD6C\uB9E4\uC790\uC640\uB9CC \uD569\uC758\uD55C \uB0B4\uC6A9\uC744 \uC801\uB294 \uD56D\uBAA9\uC774\uC5D0\uC694. \uC99D\uC11C\uC5D0\uB294 "\uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D (\uD2B9\uC57D)"\uC73C\uB85C \uADF8\uB300\uB85C \uB2F4\uACA8 \uACC4\uC57D \uB0B4\uC6A9\uC774 \uB3FC\uC694. \uCD5C\uB300 2,000\uC790\uAE4C\uC9C0 \uC801\uC744 \uC218 \uC788\uC5B4\uC694.\n\uC785\uB825\uB780 \uC774\uB984\uC740 \uAD8C\uB9AC\uC5D0 \uB9DE\uAC8C "\uD655\uC815\uD55C \uCD9C\uC5F0 \uC870\uAC74"\uCC98\uB7FC \uBCF4\uC774\uC9C0\uB9CC \uBAA8\uB450 \uAC19\uC740 \uD56D\uBAA9\uC774\uC5D0\uC694.'
          },
          {
            type: "h2",
            id: "tips",
            text: "\uC791\uC131 \uD301"
          },
          {
            type: "list",
            items: [
              "\uD5C8\uC6A9 \uBC94\uC704\uB97C \uAD6C\uCCB4\uC801\uC73C\uB85C \u2014 \uC5B4\uB5A4 \uC18C\uC7AC\uB97C(\uB9C1\uD06C\xB7\uC218\uB7C9), \uC5B4\uB514\uC5D0(\uD50C\uB7AB\uD3FC\xB7\uC9C0\uBA74) \uC4F0\uB294\uC9C0 \uBA85\uC2DC\uD574\uC694.",
              "\uC0AC\uC804 \uD655\uC778 \uC870\uAC74 \u2014 \uAC8C\uC2DC \uC804 \uD655\uC778\uC774 \uD544\uC694\uD558\uBA74 \uADF8 \uC808\uCC28\uB97C \uC801\uC5B4\uC694.",
              "\uAE08\uC9C0 \uC0AC\uD56D \u2014 \uC6D0\uCE58 \uC54A\uB294 \uD3B8\uC9D1\xB7\uC7AC\uC5C5\uB85C\uB4DC\xB7\uC7AC\uD310\uB9E4\uB97C \uBBF8\uB9AC \uB9C9\uC544\uC694.",
              "\uAE30\uD55C\uC774 \uC788\uB294 \uC870\uAC74 \u2014 \uB9CC\uB8CC \uD6C4 \uC7AC\uACE0 \uCC98\uB9AC, \uAC8C\uC2DC \uC720\uC9C0 \uAE30\uAC04\uCC98\uB7FC \uC2DC\uC810\uC774 \uC788\uB294 \uC57D\uC18D\uC740 \uB0A0\uC9DC\uB85C \uC801\uC5B4\uC694."
            ]
          },
          {
            type: "h2",
            id: "examples",
            text: "\uC720\uD615\uBCC4 \uC608\uC2DC"
          },
          {
            type: "p",
            text: "\uAD8C\uB9AC\uBCC4\uB85C \uC790\uC8FC \uC4F0\uB294 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D \uC608\uC2DC\uC608\uC694. \uC785\uB825\uB780 \uC704 \uC774\uB984 \uC904 \uC624\uB978\uCABD\uC758 \uAC00\uC774\uB4DC \uBC84\uD2BC\uC73C\uB85C\uB3C4 \uAC19\uC740 \uC608\uC2DC\uB97C \uBCFC \uC218 \uC788\uC5B4\uC694. \uC5EC\uB7EC \uAD8C\uB9AC\uB97C \uD568\uAED8 \uAC70\uB798\uD560 \uB54C\uB294 \uAC01 \uAD8C\uB9AC\uC758 \uC608\uC2DC\uB97C \uCC38\uACE0\uD558\uC138\uC694."
          },
          ...SPECIAL_TERMS_EXAMPLE_BLOCKS3
        ]
      },
      {
        slug: "settlement",
        title: "\uC815\uC0B0 \uBC1B\uAE30",
        description: "\uBC1C\uAE09 \uD6C4 \uC815\uC0B0\uC774 \uC9C0\uAE09\uB418\uAE30\uAE4C\uC9C0\uC758 \uD750\uB984\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "flow",
            text: "\uC815\uC0B0 \uD750\uB984"
          },
          {
            type: "steps",
            items: [
              "\uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09 \uD6C4 \uAD6C\uB9E4\uC790\uAC00 \uBC1B\uC740 \uC790\uB8CC\uB97C \uD655\uC778\uD558\uACE0 \uAD6C\uB9E4\uD655\uC815\uD574\uC694. \uC815\uC0B0\uC774 \uC9C0\uAE09\uB418\uAE30 \uC804\uAE4C\uC9C0\uB294 \uAD6C\uB9E4\uC790\uAC00 \uBD84\uC7C1\uC744 \uC2E0\uCCAD\uD560 \uC218 \uC788\uACE0, \uBD84\uC7C1 \uC911\uC5D0\uB294 \uC815\uC0B0\uC774 \uBA48\uCDB0\uC694.",
              "\uAD6C\uB9E4\uD655\uC815(\uB610\uB294 \uAE30\uD55C\uC774 \uC9C0\uB098 \uC790\uB3D9 \uD655\uC815)\uB418\uBA74 \uC815\uC0B0 \uB300\uAE30 \uC0C1\uD0DC\uAC00 \uB3FC\uC694.",
              "\uAD00\uB9AC\uC790\uAC00 \uC9C0\uAE09\uC744 \uC644\uB8CC\uD558\uBA74 \uB4F1\uB85D\uD55C \uC815\uC0B0 \uACC4\uC88C\uB85C \uC785\uAE08\uB3FC\uC694."
            ]
          },
          {
            type: "h2",
            id: "fee",
            text: "\uC218\uC218\uB8CC"
          },
          {
            type: "p",
            text: "\uD310\uB9E4 \uAE08\uC561\uC5D0\uC11C \uD50C\uB7AB\uD3FC \uC218\uC218\uB8CC {{platformFee}}\uB97C \uC81C\uC678\uD55C \uAE08\uC561\uC774 \uC9C0\uAE09\uB3FC\uC694. \uC218\uC218\uB8CC\uB294 \uC8FC\uBB38\uD560 \uB54C\uC758 \uBE44\uC728\uB85C \uC815\uD574\uC9C0\uACE0, \uADF8 \uB4A4 \uBE44\uC728\uC774 \uBC14\uB00C\uC5B4\uB3C4 \uC774\uBBF8 \uB9FA\uC740 \uAC70\uB798\uC5D0\uB294 \uC601\uD5A5\uC774 \uC5C6\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "account",
            text: "\uC815\uC0B0 \uACC4\uC88C \uB4F1\uB85D"
          },
          {
            type: "p",
            text: "\uB9C8\uC774\uD398\uC774\uC9C0\uC5D0\uC11C \uC815\uC0B0\uBC1B\uC744 \uACC4\uC88C\uB97C \uBBF8\uB9AC \uB4F1\uB85D\uD574 \uB450\uC138\uC694. \uACC4\uC88C\uAC00 \uC5C6\uC73C\uBA74 \uC9C0\uAE09\uC774 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "history",
            text: "\uC815\uC0B0 \uB0B4\uC5ED \uBCF4\uAE30"
          },
          {
            type: "p",
            text: "\uB9C8\uC774\uD398\uC774\uC9C0 > \uC815\uC0B0 \uB0B4\uC5ED\uC5D0\uC11C \uD310\uB9E4 \uB300\uAE08\uACFC \uB85C\uC5F4\uD2F0\uB97C \uD569\uCCD0 \uC9C0\uAE09 \uC608\uC815\xB7\uC9C0\uAE09 \uC644\uB8CC\xB7\uCC28\uAC10\xB7\uD68C\uC218\uB85C \uB098\uB220 \uBCFC \uC218 \uC788\uC5B4\uC694. \uBAA8\uB4E0 \uAE08\uC561\uC740 \uC218\uC218\uB8CC\uB97C \uBE80 \uC2E4\uC81C \uC9C0\uAE09\uC561\uC774\uC5D0\uC694.\n\uAD00\uB9AC\uC790\uAC00 \uD655\uC778\uD560 \uC77C\uC774 \uC788\uC5B4 \uC9C0\uAE09\uC744 \uC7A0\uC2DC \uBA48\uCD94\uBA74 \uC9C0\uAE09 \uBCF4\uB958\uB85C \uD45C\uC2DC\uB3FC\uC694. \uB85C\uC5F4\uD2F0 \uC815\uC815\uC73C\uB85C \uC904\uC5B4\uB4E0 \uAE08\uC561\uC740 \uB2E4\uC74C \uC9C0\uAE09\uC5D0\uC11C \uCC28\uAC10\uB418\uACE0, \uC9C0\uAE09 \uB4A4 \uD658\uBD88\uB3FC \uB3CC\uB824\uC8FC\uC2E4 \uC815\uC0B0\uAE08\uC740 \uB3CC\uB824\uC904 \uAE08\uC561\uC73C\uB85C \uD45C\uC2DC\uB3FC\uC694."
          },
          {
            type: "callout",
            text: "\uBD84\uC7C1\uC774 \uC9C4\uD589 \uC911\uC774\uAC70\uB098 \uD658\uBD88\uC774 \uCC98\uB9AC \uC911\uC778 \uAC70\uB798\uB294 \uACB0\uB860\uC774 \uB0A0 \uB54C\uAE4C\uC9C0 \uC9C0\uAE09\uB418\uC9C0 \uC54A\uC544\uC694."
          },
          {
            type: "h2",
            id: "clawback",
            text: "\uC815\uC0B0 \uB4A4 \uD658\uBD88\uB418\uBA74 \u2014 \uC815\uC0B0\uAE08 \uB3CC\uB824\uC8FC\uAE30"
          },
          {
            type: "p",
            text: `\uC815\uC0B0\uC744 \uBC1B\uC740 \uB4A4\uC5D0\uB3C4 \uAD8C\uB9AC \uBB38\uC81C\uB098 \uACC4\uC57D \uC704\uBC18\uC774 \uD655\uC778\uB418\uBA74 \uAD00\uB9AC\uC790\uAC00 \uD658\uBD88\uC744 \uACB0\uC815\uD560 \uC218 \uC788\uC5B4\uC694. \uC774\uB54C\uB294 \uBC1B\uC740 \uC815\uC0B0\uAE08 \uC911 \uD658\uBD88 \uBE44\uC728\uB9CC\uD07C(\uC804\uC561 \uD658\uBD88\uC774\uBA74 \uBC1B\uC740 \uC815\uC0B0\uAE08 \uC804\uBD80)\uC744 \uC778\uD50C\uB9BD \uACC4\uC88C\uB85C \uB3CC\uB824\uBCF4\uB0B4 \uC8FC\uC154\uC57C \uD574\uC694.
\uAE08\uC561\xB7\uC0AC\uC720\xB7\uC785\uAE08 \uACC4\uC88C\xB7\uAE30\uD55C\uC740 \uC54C\uB9BC\uACFC \uB9C8\uC774\uD398\uC774\uC9C0 > \uC815\uC0B0 \uB0B4\uC5ED\uC5D0 \uC548\uB0B4\uB3FC\uC694. \uAE30\uD55C\uC740 \uC54C\uB9BC\uC744 \uBC1B\uC740 \uB54C\uBD80\uD130 ${BUSINESS3.PAYOUT_CLAWBACK_DUE_DAYS}\uC77C\uC774\uACE0, \uC785\uAE08\uC774 \uD655\uC778\uB418\uBA74 \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uD658\uBD88\uB3FC\uC694.`
          },
          {
            type: "callout",
            text: "\uAE30\uD55C\uAE4C\uC9C0 \uC785\uAE08\uD558\uC9C0 \uC54A\uC73C\uBA74 \uACC4\uC815 \uC774\uC6A9(\uC811\uC18D)\uC774 \uC815\uC9C0\uB418\uACE0, \uB77C\uC774\uC120\uC2A4 \uACC4\uC57D\uACFC \uC774\uC6A9\uC57D\uAD00\uC5D0 \uB530\uB77C \uBC95\uC801 \uC870\uCE58\uB97C \uBC1B\uC744 \uC218 \uC788\uC5B4\uC694. \uC815\uC9C0 \uB4A4\uC5D0\uB77C\uB3C4 \uC785\uAE08\uC774 \uD655\uC778\uB418\uBA74 \uC815\uC9C0\uB294 \uD480\uB824\uC694."
          }
        ]
      },
      {
        slug: "royalty",
        title: "\uB85C\uC5F4\uD2F0 \uBCF4\uACE0",
        description: "\uB9E4\uCD9C \uB85C\uC5F4\uD2F0 \uBC29\uC2DD \uAC70\uB798\uC758 \uBCF4\uACE0\xB7\uC9C0\uAE09 \uC808\uCC28\uC608\uC694.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\uB9E4\uCD9C \uB85C\uC5F4\uD2F0 \uBC29\uC2DD\uC774\uB780"
          },
          {
            type: "p",
            text: "\uACE0\uC815\uAC00 \uB300\uC2E0(\uB610\uB294 \uACE0\uC815\uAC00\uC5D0 \uB354\uD574) \uAD6C\uB9E4\uC790\uC758 \uB9E4\uCD9C \uC77C\uBD80\uB97C \uB85C\uC5F4\uD2F0\uB85C \uBC1B\uB294 \uBC29\uC2DD\uC774\uC5D0\uC694. \uB85C\uC5F4\uD2F0 \uBE44\uC728\uACFC \uC9C0\uAE09\uC77C(\uB9E4\uB2EC N\uC77C)\uC740 \uACC4\uC57D \uC2DC\uC810\uC5D0 \uD655\uC815\uB3FC\uC694 \u2014 \uC0C1\uD488\uC5D0 \uC815\uD55C \uAC12\uC73C\uB85C \uACC4\uC57D\uD558\uAC70\uB098, \uD611\uC758 \uC81C\uC548\uC73C\uB85C \uC870\uC815\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "payment-day",
            text: "\uC9C0\uAE09\uC77C \u2014 \uB9E4\uB2EC \uC5B8\uC81C \uB0B4\uB098\uC694"
          },
          {
            type: "p",
            text: "\uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC5D0\uB294 \uC9C0\uAE09\uC77C(\uB9E4\uB2EC 1~28\uC77C \uC911 \uD558\uB8E8)\uC774 \uBC18\uB4DC\uC2DC \uD3EC\uD568\uB3FC\uC694. \uAD6C\uB9E4\uC790\uB294 \uB9E4\uB2EC \uC9C0\uAE09\uC77C\uAE4C\uC9C0 \uC804\uC6D4(1\uC77C~\uB9D0\uC77C) \uB9E4\uCD9C\uC744 \uBCF4\uACE0\uD558\uACE0 \uC0B0\uC815\uB41C \uB85C\uC5F4\uD2F0\uB97C \uC785\uAE08\uD574\uC694.\n\uBCF4\uACE0 \uB300\uC0C1\uC740 \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uC774 \uC788\uB294 \uB2EC\uBD80\uD130 \uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9\uC77C\uC774 \uC788\uB294 \uB2EC\uAE4C\uC9C0\uC608\uC694. \uCCAB \uB2EC\uACFC \uB9C8\uC9C0\uB9C9 \uB2EC\uC740 \uACC4\uC57D \uAE30\uAC04 \uC548\uC758 \uB0A0\uC9DC \uB9E4\uCD9C\uB9CC \uBCF4\uACE0\uD574\uC694.\n\uC608\uB97C \uB4E4\uC5B4 5\uC6D4 15\uC77C\uC5D0 \uC2DC\uC791\uD55C 3\uAC1C\uC6D4 \uACC4\uC57D(8\uC6D4 14\uC77C\uAE4C\uC9C0)\uC774\uB77C\uBA74 5\uC6D4\uBD84\uC740 15~31\uC77C, 8\uC6D4\uBD84\uC740 1~14\uC77C \uB9E4\uCD9C\uC774\uC5D0\uC694."
          },
          {
            type: "h2",
            id: "report",
            text: "\uBCF4\uACE0\uC640 \uC9C0\uAE09 \uC808\uCC28"
          },
          {
            type: "steps",
            items: [
              "\uAD6C\uB9E4\uC790\uAC00 \uB9E4\uB2EC \uC9C0\uAE09\uC77C\uAE4C\uC9C0 \uC804\uC6D4 \uB9E4\uCD9C\uC744 \uBCF4\uACE0\uD558\uACE0 \uB85C\uC5F4\uD2F0\uB97C \uC785\uAE08\uD574\uC694.",
              "\uAD00\uB9AC\uC790\uAC00 \uC785\uAE08\uC744 \uD655\uC778\uD574\uC694.",
              "\uD655\uC778\uB41C \uB85C\uC5F4\uD2F0\uC5D0\uC11C \uD50C\uB7AB\uD3FC \uC218\uC218\uB8CC\uB97C \uC81C\uC678\uD55C \uAE08\uC561\uC774 \uD310\uB9E4\uC790\uC5D0\uAC8C \uC9C0\uAE09\uB3FC\uC694."
            ]
          },
          {
            type: "p",
            text: "\uBCF4\uACE0\uD560 \uB54C \uB9E4\uCD9C \uC99D\uBE59(PDF\xB7JPG\xB7PNG, \uD30C\uC77C\uB2F9 10MB)\uC744 \uD568\uAED8 \uC62C\uB9B4 \uC218 \uC788\uC5B4\uC694. \uC785\uAE08\uD55C \uB4A4 \uBE60\uB978 \uC785\uAE08 \uD655\uC778 \uC694\uCCAD\uC744 \uB204\uB974\uBA74 \uAD00\uB9AC\uC790\uAC00 \uBA3C\uC800 \uD655\uC778\uD574\uC694. \uB204\uB974\uC9C0 \uC54A\uC544\uB3C4 \uC785\uAE08\uC740 \uD655\uC778\uB3FC\uC694."
          },
          {
            type: "h2",
            id: "fix",
            text: "\uBCF4\uACE0 \uB0B4\uC6A9\uC774 \uD2C0\uB838\uC744 \uB54C"
          },
          {
            type: "list",
            items: [
              "\uC785\uAE08 \uD655\uC778 \uC804 \u2014 \uAD6C\uB9E4\uC790\uB294 \uBCF4\uACE0\uD55C \uB9E4\uCD9C\uC744 \uC9C1\uC811 \uACE0\uCE60 \uC218 \uC788\uACE0, \uB85C\uC5F4\uD2F0\uAC00 \uB2E4\uC2DC \uACC4\uC0B0\uB3FC \uD310\uB9E4\uC790\uC5D0\uAC8C \uC54C\uB824\uC838\uC694.",
              "\uC785\uAE08 \uD655\uC778 \uC804 \u2014 \uD310\uB9E4\uC790\uB294 \uC2E4\uC81C \uB9E4\uCD9C\uACFC \uB2E4\uB978 \uBCF4\uACE0\uB97C \uBC18\uB824\uD560 \uC218 \uC788\uC5B4\uC694. \uBC18\uB824\uB41C \uB2EC\uC740 \uAD6C\uB9E4\uC790\uAC00 \uB2E4\uC2DC \uBCF4\uACE0\uD574\uC694.",
              "\uC785\uAE08 \uD655\uC778 \uB4A4 \u2014 \uD310\uB9E4\uC790\uB294 \uC0AC\uC720\uC640 \uC790\uB8CC\uB97C \uBD99\uC5EC \uC774\uC758\uB97C \uC81C\uAE30\uD560 \uC218 \uC788\uC5B4\uC694. \uAD00\uB9AC\uC790\uAC00 \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uCD94\uAC00 \uC99D\uBE59\uC744 \uBC1B\uC544 \uD655\uC778\uD558\uACE0, \uC815\uC815\uD558\uAC70\uB098 \uAE30\uAC01\uD574\uC694.",
              "\uC815\uC815\uB418\uBA74 \uBC14\uB85C\uC7A1\uC740 \uB9E4\uCD9C\uACFC \uC774\uBBF8 \uB0B8 \uAE08\uC561\uC758 \uCC28\uC561\uB9CC\uD07C \uCD94\uAC00 \uC785\uAE08\uD558\uAC70\uB098, \uD310\uB9E4\uC790 \uC9C0\uAE09\uC5D0\uC11C \uCC28\uAC10\uB3FC\uC694."
            ]
          },
          {
            type: "callout",
            text: `\uC9C0\uAE09\uC77C ${BUSINESS3.ROYALTY_REPORT_REMINDER_DAYS}\uC77C \uC804\uBD80\uD130 \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uBCF4\uACE0 \uB9AC\uB9C8\uC778\uB354 \uC54C\uB9BC\uC774 \uAC00\uACE0, \uC9C0\uAE09\uC77C\uC774 \uC9C0\uB098\uB3C4\uB85D \uBCF4\uACE0\uAC00 \uC5C6\uC73C\uBA74 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB294 \uC5F0\uCCB4 \uC54C\uB9BC, \uD310\uB9E4\uC790\uC5D0\uAC8C\uB294 \uC9C0\uC5F0 \uC54C\uB9BC\uC774 \uAC00\uC694.
\uBCF4\uACE0 \uB0B4\uC5ED\uACFC \uC9C0\uAE09 \uC0C1\uD0DC\uB294 \uC8FC\uBB38 \uC0C1\uC138 \uC544\uB798\uCABD\uC758 \uB85C\uC5F4\uD2F0 \uC601\uC5ED\uC5D0\uC11C \uC591\uCE21 \uBAA8\uB450 \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694. \uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC774 \uC5EC\uB7EC \uAC74\uC774\uBA74 \uB9C8\uC774\uD398\uC774\uC9C0 > \uB85C\uC5F4\uD2F0\uC5D0\uC11C \uBCF4\uACE0\uD560 \uB2EC\uACFC \uBC1B\uC744 \uB85C\uC5F4\uD2F0\uB97C \uD55C\uB208\uC5D0 \uBAA8\uC544 \uBCFC \uC218 \uC788\uC5B4\uC694.`
          }
        ]
      }
    ]
  },
  {
    title: "\uD611\uCC2C \uAC00\uC774\uB4DC",
    pages: [
      {
        slug: "sponsorship",
        title: "\uD611\uCC2C \uD55C\uB208\uC5D0 \uBCF4\uAE30",
        description: "\uC5C5\uCCB4\uB294 \uD611\uCC2C\uC744 \uC62C\uB9AC\uACE0, \uC778\uC99D\uB41C \uC778\uD50C\uB8E8\uC5B8\uC11C\uB294 \uC9C0\uC6D0\uD574 \uCCB4\uD5D8\uD558\uACE0 \uCF58\uD150\uCE20\uB85C \uC778\uC99D\uD574\uC694.",
        blocks: [
          {
            type: "h2",
            id: "what",
            text: "\uD611\uCC2C\uC774\uB780"
          },
          {
            type: "p",
            text: "\uC5C5\uCCB4(\uD611\uCC2C \uB4F1\uB85D\uC790)\uAC00 \uC81C\uD488\xB7\uC11C\uBE44\uC2A4\xB7\uBC29\uBB38 \uCCB4\uD5D8\uC744 \uC81C\uACF5\uD558\uACE0, \uC778\uC99D\uB41C \uC778\uD50C\uB8E8\uC5B8\uC11C(\uC9C0\uC6D0\uC790)\uAC00 \uADF8\uAC83\uC744 \uCCB4\uD5D8\uD55C \uB4A4 SNS \uAC8C\uC2DC\uBB3C \uAC19\uC740 \uCF58\uD150\uCE20\uB85C \uC778\uC99D\uD558\uB294 \uBAA8\uC9D1 \uC11C\uBE44\uC2A4\uC608\uC694.\n\uACC4\uC815\uC740 \uC5C5\uCCB4\xB7\uC778\uD50C\uB8E8\uC5B8\uC11C\uB85C \uB098\uB258\uC9C0 \uC54A\uC544\uC694. \uD55C \uACC4\uC815\uC73C\uB85C \uD611\uCC2C\uC744 \uC62C\uB9B4 \uC218\uB3C4, \uB2E4\uB978 \uD611\uCC2C\uC5D0 \uC9C0\uC6D0\uD560 \uC218\uB3C4 \uC788\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "flow",
            text: "\uD611\uCC2C\uC740 \uC774\uB807\uAC8C \uC9C4\uD589\uB3FC\uC694"
          },
          {
            type: "steps",
            items: [
              "\uC5C5\uCCB4\uAC00 \uD611\uCC2C \uD0ED\uC5D0\uC11C [\uD611\uCC2C \uC62C\uB9AC\uAE30]\uB85C \uC81C\uACF5 \uB0B4\uC6A9\xB7\uC694\uCCAD \uC0AC\uD56D\xB7\uC2B9\uC778 \uBC29\uC2DD\xB7\uC9C0\uC6D0 \uC870\uAC74\uC744 \uC801\uC5B4 \uB4F1\uB85D \uC694\uCCAD\uD574\uC694.",
              "\uC6B4\uC601\uC790\uAC00 \uC2EC\uC0AC\uD574 \uC2B9\uC778\uD558\uBA74 \uD611\uCC2C\uC774 \uBAA8\uC9D1 \uC911\uC73C\uB85C \uACF5\uAC1C\uB3FC\uC694.",
              "\uC9C0\uC6D0 \uC870\uAC74\uC5D0 \uB9DE\uB294 \uC778\uC99D \uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uD611\uCC2C \uC0C1\uC138\uC5D0\uC11C \uC9C0\uC6D0\uD574\uC694. \uBC29\uBB38 \uD611\uCC2C\uC774\uBA74 \uBC29\uBB38 \uC608\uC815\uC77C\uB3C4 \uD568\uAED8 \uC801\uC5B4\uC694.",
              "\uC2B9\uC778 \uBC29\uC2DD\uC5D0 \uB530\uB77C \uC5C5\uCCB4\uAC00 \uC2B9\uC778\uD558\uAC70\uB098(\uC2B9\uC778 \uD6C4 \uD655\uC815), \uC9C0\uC6D0\uD558\uB294 \uC21C\uAC04 \uBC14\uB85C \uD655\uC815\uB3FC\uC694(\uC9C0\uC6D0\uD558\uBA74 \uBC14\uB85C \uD655\uC815).",
              "\uD655\uC815\uB41C \uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uBC29\uBB38\xB7\uCCB4\uD5D8\uD558\uACE0, \uC694\uCCAD \uC0AC\uD56D\uB300\uB85C \uCF58\uD150\uCE20\uB97C \uC62C\uB824\uC694.",
              "\uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uC9C0\uC6D0 \uC0C1\uC138\uC5D0\uC11C [\uBBF8\uC158 \uC644\uB8CC \uB4F1\uB85D]\uC73C\uB85C \uD6C4\uAE30\uC640 \uCF58\uD150\uCE20 \uB9C1\uD06C\uB97C \uB0A8\uAE30\uBA74, \uC5C5\uCCB4\uAC00 [\uBBF8\uC158 \uD655\uC778]\uC744 \uB20C\uB7EC \uD611\uCC2C\uC774 \uB9C8\uBB34\uB9AC\uB3FC\uC694."
            ]
          },
          {
            type: "h2",
            id: "where",
            text: "\uC5B4\uB514\uC11C \uBCF4\uB098\uC694"
          },
          {
            type: "list",
            items: [
              "\uD611\uCC2C \uD0ED \u2014 \uBAA8\uC9D1 \uC911\uC778 \uD611\uCC2C \uBAA9\uB85D. \uC885\uBAA9\xB7\uC9C0\uC5ED\uC73C\uB85C \uAC70\uB974\uACE0 \uC81C\uBAA9\xB7\uC5C5\uCCB4\uBA85\xB7\uC704\uCE58\uB85C \uAC80\uC0C9\uD574\uC694.",
              "\uD611\uCC2C \uD0ED \uC704 \uBC14\uB85C\uAC00\uAE30 \u2014 \uD611\uCC2C\uC744 \uC62C\uB9B0 \uC801\uC774 \uC788\uC73C\uBA74 [\uBC1B\uC740 \uC9C0\uC6D0], \uC9C4\uD589 \uC911\uC778 \uC9C0\uC6D0\uC774 \uC788\uC73C\uBA74 [\uB0B4 \uC9C0\uC6D0]\uC774 \uBCF4\uC5EC\uC694.",
              "\uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uB0B4\uAC00 \uC62C\uB9B0 \uD611\uCC2C \u2014 \uC62C\uB9B0 \uD611\uCC2C\uACFC \uBC1B\uC740 \uC9C0\uC6D0\uC744 \uAD00\uB9AC\uD574\uC694.",
              "\uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uD611\uCC2C \uC9C0\uC6D0 \uB0B4\uC5ED \u2014 \uB0B4\uAC00 \uC9C0\uC6D0\uD55C \uD611\uCC2C\uC758 \uC9C4\uD589 \uC0C1\uD0DC\uC640 \uBBF8\uC158\uC744 \uBD10\uC694."
            ]
          },
          {
            type: "callout",
            text: "\uD611\uCC2C\uC740 \uC5C5\uCCB4\uC640 \uC778\uD50C\uB8E8\uC5B8\uC11C \uC0AC\uC774\uC758 \uC57D\uC18D\uC774\uC5D0\uC694. \uC778\uD50C\uB9BD\uC740 \uBAA8\uC9D1\uACFC \uC9C4\uD589\uC744 \uB3D5\uC9C0\uB9CC, \uC81C\uACF5\uB418\uB294 \uC81C\uD488\xB7\uC11C\uBE44\uC2A4\uC640 \uBBF8\uC158 \uC774\uD589\uC5D0 \uB300\uD55C \uCC45\uC784\uC740 \uAC01 \uB2F9\uC0AC\uC790\uC5D0\uAC8C \uC788\uC5B4\uC694."
          }
        ]
      },
      {
        slug: "sponsorship-posting",
        title: "\uD611\uCC2C \uC62C\uB9AC\uAE30",
        description: "\uD611\uCC2C\uC744 \uC791\uC131\uD574 \uC2EC\uC0AC\uB97C \uC694\uCCAD\uD558\uACE0 \uACF5\uAC1C\uB418\uAE30\uAE4C\uC9C0\uC758 \uACFC\uC815\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "phone",
            text: "\uBA3C\uC800 \uC5F0\uB77D\uCC98\uB97C \uB4F1\uB85D\uD574\uC694"
          },
          {
            type: "p",
            text: "\uD611\uCC2C\uC740 \uC5F0\uB77D\uCC98\uB97C \uB4F1\uB85D\uD55C \uD68C\uC6D0\uB9CC \uC62C\uB9B4 \uC218 \uC788\uC5B4\uC694. \uC6B4\uC601\uC790\uAC00 \uC2EC\uC0AC\uD560 \uB54C \uC5C5\uCCB4\uC5D0 \uC5F0\uB77D\uD560 \uC218 \uC788\uAC8C \uD558\uAE30 \uC704\uD574\uC11C\uC608\uC694.\n[\uD611\uCC2C \uC62C\uB9AC\uAE30]\uB97C \uB20C\uB800\uC744 \uB54C \uC5F0\uB77D\uCC98\uAC00 \uC5C6\uC73C\uBA74 \uB4F1\uB85D \uC548\uB0B4 \uCC3D\uC774 \uBA3C\uC800 \uB5A0\uC694. \uC5F0\uB77D\uCC98\uB97C \uB4F1\uB85D\uD558\uBA74 \uBC14\uB85C \uC791\uC131 \uD654\uBA74\uC73C\uB85C \uB118\uC5B4\uAC00\uC694."
          },
          {
            type: "h2",
            id: "fields",
            text: "\uC791\uC131\uD558\uB294 \uD56D\uBAA9"
          },
          {
            type: "list",
            items: [
              "\uB300\uD45C \uC774\uBBF8\uC9C0(\uC120\uD0DD) \u2014 \uBAA9\uB85D\uACFC \uC0C1\uC138\uC5D0 \uBCF4\uC774\uB294 \uD45C\uC9C0\uC608\uC694. JPG\xB7PNG\xB7WebP, 2MB\uAE4C\uC9C0\uC608\uC694.",
              "\uC81C\uBAA9 \u2014 \uC608) \uC131\uC218 \uB514\uC800\uD2B8 \uCE74\uD398 \uC2E0\uBA54\uB274 \uBC29\uBB38 \uD611\uCC2C",
              "\uC5C5\uCCB4\uBA85 \u2014 \uC5C5\uCCB4\xB7\uBE0C\uB79C\uB4DC \uC774\uB984",
              "\uD611\uCC2C \uC885\uBAA9\xB7\uC9C0\uC5ED \u2014 \uBAA9\uB85D\uC5D0\uC11C \uAC70\uB97C \uB54C \uC4F0\uC5EC\uC694. \uC9C0\uC5ED\uC740 \uC804\uAD6D\xB7\uC628\uB77C\uC778\uACFC 17\uAC1C \uC2DC\uB3C4 \uC911\uC5D0\uC11C \uACE8\uB77C\uC694.",
              "\uBC29\uBB38 \uC5EC\uBD80 \u2014 \uB9E4\uC7A5\xB7\uC219\uC18C\uCC98\uB7FC \uBC29\uBB38\uD574\uC57C \uD558\uBA74 [\uBC29\uBB38\uD574\uC11C \uC9C4\uD589], \uBC30\uC1A1\xB7\uC628\uB77C\uC778\uCC98\uB7FC \uBC29\uBB38\uC774 \uD544\uC694 \uC5C6\uC73C\uBA74 [\uBC29\uBB38 \uC5C6\uC774 \uC9C4\uD589]. \uBC29\uBB38 \uD611\uCC2C\uC740 \uC8FC\uC18C\uB97C \uAC80\uC0C9\uD574 \uACE0\uB974\uACE0, \uC9C0\uC6D0\uC790\uC5D0\uAC8C \uBC29\uBB38 \uC608\uC815\uC77C\uC744 \uBC1B\uC544\uC694.",
              "\uD611\uCC2C\uC73C\uB85C \uC81C\uACF5\uD558\uB294 \uAC83 \u2014 \uC608) 2\uC778 \uB514\uC800\uD2B8 \uC138\uD2B8 + \uC74C\uB8CC, \uC81C\uD488 1\uAC1C \uC99D\uC815. \uD568\uAED8 \uC62C \uC218 \uC788\uB294 \uC778\uC6D0\uB3C4 \uC801\uC5B4 \uC8FC\uC138\uC694.",
              "\uC18C\uAC1C\uC640 \uC694\uCCAD \uC0AC\uD56D \u2014 \uC5C5\uCCB4 \uC18C\uAC1C\uC640 \uC6D0\uD558\uB294 \uCF58\uD150\uCE20\xB7\uC77C\uC815\uC744 \uC801\uC5B4\uC694. \uC790\uC138\uD55C \uC791\uC131\uBC95\uC740 [\uC694\uCCAD \uC0AC\uD56D \uC801\uAE30] \uBB38\uC11C\uB97C \uCC38\uACE0\uD558\uC138\uC694.",
              "\uC2B9\uC778 \uBC29\uC2DD\uACFC \uC9C0\uC6D0 \uC870\uAC74 \u2014 \uB204\uAC00 \uC9C0\uC6D0\uD560 \uC218 \uC788\uACE0, \uC9C0\uC6D0\uD558\uBA74 \uC5B4\uB5BB\uAC8C \uD655\uC815\uB418\uB294\uC9C0 \uC815\uD574\uC694. [\uC2B9\uC778 \uBC29\uC2DD\uACFC \uC9C0\uC6D0 \uC870\uAC74] \uBB38\uC11C\uB97C \uCC38\uACE0\uD558\uC138\uC694."
            ]
          },
          {
            type: "h2",
            id: "review",
            text: "\uC2EC\uC0AC\uC640 \uACF5\uAC1C"
          },
          {
            type: "steps",
            items: [
              "[\uD611\uCC2C \uB4F1\uB85D \uC694\uCCAD\uD558\uAE30]\uB97C \uB204\uB974\uBA74 \uC2EC\uC0AC \uB300\uAE30\uAC00 \uB3FC\uC694.",
              "\uC6B4\uC601\uC790\uAC00 \uB0B4\uC6A9\uC744 \uD655\uC778\uD574 \uC2B9\uC778\uD558\uBA74 \uBAA8\uC9D1 \uC911\uC73C\uB85C \uACF5\uAC1C\uB418\uACE0 \uC54C\uB9BC\uC774 \uAC00\uC694.",
              "\uBC18\uB824\uB418\uBA74 \uC0AC\uC720\uC640 \uD568\uAED8 \uC54C\uB9BC\uC774 \uAC00\uC694. \uB0B4\uC6A9\uC744 \uACE0\uCCD0 \uB2E4\uC2DC \uC2EC\uC0AC\uB97C \uC694\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694."
            ]
          },
          {
            type: "list",
            items: [
              "\uD611\uCC2C \uBAA9\uB85D\uC5D0\uB294 \uD45C\uC9C0\xB7\uC81C\uBAA9\xB7\uC5C5\uCCB4\uBA85\uB9CC \uBCF4\uC5EC\uC694. \uC81C\uACF5 \uB0B4\uC6A9\xB7\uC18C\uAC1C\xB7\uC9C0\uC6D0 \uC870\uAC74\uC740 \uD50C\uB7AB\uD3FC \uC5F4\uB78C \uAE30\uC900\uC744 \uB118\uB294 \uC778\uC99D \uC778\uD50C\uB8E8\uC5B8\uC11C\uC5D0\uAC8C\uB9CC \uBCF4\uC5EC\uC694.",
              "\uACF5\uAC1C\uB41C \uD611\uCC2C\uC758 \uB0B4\uC6A9\uC744 \uACE0\uCE58\uBA74 \uB2E4\uC2DC \uC2EC\uC0AC\uB97C \uBC1B\uC544\uC694. \uC774\uB54C \uC2B9\uC778 \uB300\uAE30 \uC911\uC774\uB358 \uC9C0\uC6D0\uC740 \uBC14\uB00C\uAE30 \uC804 \uB0B4\uC6A9\uC744 \uBCF4\uACE0 \uD55C \uC9C0\uC6D0\uC774\uB77C \uBAA8\uB450 \uCDE8\uC18C\uB418\uACE0, \uC9C0\uC6D0\uC790\uC5D0\uAC8C \uC54C\uB9BC\uC774 \uAC00\uC694. \uD655\uC815\uB41C \uC9C0\uC6D0\uC740 \uADF8\uB300\uB85C\uC608\uC694.",
              "\uB300\uD45C \uC774\uBBF8\uC9C0\uB9CC \uBC14\uAFB8\uBA74 \uB2E4\uC2DC \uC2EC\uC0AC\uD558\uC9C0 \uC54A\uC544\uC694.",
              "\uACF5\uAC1C\uB41C \uC801\uC774 \uC5C6\uACE0 \uC9C0\uC6D0\uB3C4 \uBC1B\uC740 \uC801 \uC5C6\uB294 \uD611\uCC2C\uC740 \uC0C1\uC138\uC5D0\uC11C [\uC0AD\uC81C]\uD560 \uC218 \uC788\uC5B4\uC694. \uACF5\uAC1C\uB41C \uD611\uCC2C\uC740 \uC0AD\uC81C \uB300\uC2E0 \uBAA8\uC9D1\uC744 \uB9C8\uAC10\uD574\uC694."
            ]
          }
        ]
      },
      {
        slug: "sponsorship-approval",
        title: "\uC2B9\uC778 \uBC29\uC2DD\uACFC \uC9C0\uC6D0 \uC870\uAC74",
        description: "\uC9C0\uC6D0\uD558\uBA74 \uBC14\uB85C \uD655\uC815\uD560\uC9C0, \uB0B4\uAC00 \uACE8\uB77C \uC2B9\uC778\uD560\uC9C0\uC640 \uC9C0\uC6D0 \uC790\uACA9\uC744 \uC815\uD574\uC694.",
        blocks: [
          {
            type: "h2",
            id: "mode",
            text: "\uC2B9\uC778 \uBC29\uC2DD \u2014 \uB458 \uC911 \uD558\uB098\uB97C \uACE8\uB77C\uC694"
          },
          {
            type: "example",
            label: "\uC2B9\uC778 \uD6C4 \uD655\uC815",
            text: "\uC9C0\uC6D0\uC790\uC758 \uCC44\uB110\uC744 \uBCF4\uACE0 \uB0B4\uAC00 \uC2B9\uC778\uD55C \uC0AC\uB78C\uB9CC \uD655\uC815\uB3FC\uC694.\n\uC9C0\uC6D0\uC774 \uB4E4\uC5B4\uC624\uBA74 \uC54C\uB9BC\uC774 \uC624\uACE0, [\uBC1B\uC740 \uC9C0\uC6D0]\uC5D0\uC11C \uCC44\uB110\xB7\uD314\uB85C\uC6CC \uC218\xB7\uBA54\uC2DC\uC9C0\xB7\uBC29\uBB38 \uC608\uC815\uC77C\uC744 \uBCF4\uACE0 \uC2B9\uC778\uD558\uAC70\uB098 \uAC70\uC808\uD574\uC694.\n\uBAA8\uC9D1 \uC778\uC6D0\uC774 \uC815\uD574\uC838 \uC788\uAC70\uB098, \uCC44\uB110 \uC131\uACA9\uC744 \uBCF4\uACE0 \uACE0\uB974\uACE0 \uC2F6\uC744 \uB54C \uB9DE\uC544\uC694."
          },
          {
            type: "example",
            label: "\uC9C0\uC6D0\uD558\uBA74 \uBC14\uB85C \uD655\uC815",
            text: "\uC9C0\uC6D0 \uC870\uAC74\uC5D0 \uB9DE\uB294 \uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uC9C0\uC6D0\uD558\uBA74 \uC2B9\uC778 \uC5C6\uC774 \uBC14\uB85C \uD655\uC815\uB3FC\uC694.\n\uC77C\uC77C\uC774 \uACE0\uB97C \uD544\uC694\uAC00 \uC5C6\uC5B4 \uBE60\uB974\uC9C0\uB9CC, \uC870\uAC74\uB9CC \uB118\uC73C\uBA74 \uB204\uAD6C\uB098 \uD655\uC815\uB418\uB2C8 \uC9C0\uC6D0 \uC870\uAC74\uC744 \uC2E0\uC911\uD558\uAC8C \uC815\uD574 \uC8FC\uC138\uC694.\n\uC778\uC6D0 \uC81C\uD55C \uC5C6\uC774 \uB9CE\uC774 \uBAA8\uC73C\uACE0 \uC2F6\uC744 \uB54C \uB9DE\uC544\uC694. \uCDA9\uBD84\uD788 \uBAA8\uC600\uB2E4\uBA74 [\uBAA8\uC9D1 \uB9C8\uAC10]\uC73C\uB85C \uC9C0\uC6D0\uC744 \uB2EB\uC544\uC694."
          },
          {
            type: "h2",
            id: "requirements",
            text: "\uC9C0\uC6D0 \uC870\uAC74 \u2014 \uD50C\uB7AB\uD3FC\uBCC4 \uCD5C\uC18C \uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC"
          },
          {
            type: "p",
            text: "\uC774 \uD611\uCC2C\uC5D0 \uC9C0\uC6D0\uD560 \uC218 \uC788\uB294 \uC778\uD50C\uB8E8\uC5B8\uC11C\uC758 \uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uAE30\uC900\uC774\uC5D0\uC694. \uC720\uD29C\uBE0C\xB7\uC778\uC2A4\uD0C0\uADF8\uB7A8\xB7\uD2F1\uD1A1\xB7\uC2A4\uB808\uB4DC\xB7SOOP\xB7\uD32C\uB354TV \uC911 \uD558\uB098 \uC774\uC0C1\uC744 \uCF1C\uACE0, \uD50C\uB7AB\uD3FC\uB9C8\uB2E4 \uCD5C\uC18C \uC218\uCE58(\uB9CC \uBA85 \uB2E8\uC704)\uB97C \uC801\uC5B4\uC694.\n\uC5EC\uB7EC \uD50C\uB7AB\uD3FC\uC744 \uCF1C\uBA74 \uADF8\uC911 \uD558\uB098\uB9CC \uCDA9\uC871\uD574\uB3C4 \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694. \uD310\uC815\uC740 \uC9C0\uC6D0\uC790\uAC00 \uC778\uC99D\uD55C \uCC44\uB110\uC758 \uC218\uCE58\uB85C \uD574\uC694. \uD314\uB85C\uC6CC \uC218\uB97C \uACF5\uAC1C\uD558\uC9C0 \uC54A\uC740 \uCC44\uB110\uC740 0\uC73C\uB85C \uBD10\uC694."
          },
          {
            type: "example",
            label: "\uC608\uC2DC",
            text: "\uC778\uC2A4\uD0C0\uADF8\uB7A8 1\uB9CC \uBA85 \xB7 \uC720\uD29C\uBE0C 2\uB9CC \uBA85\uC744 \uCF1C\uBA74\n\u2192 \uC778\uC2A4\uD0C0\uADF8\uB7A8 1\uB9CC \uBA85 \uC774\uC0C1\uC774\uAC70\uB098 \uC720\uD29C\uBE0C 2\uB9CC \uBA85 \uC774\uC0C1\uC778 \uC778\uC99D \uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694.\n\u2192 \uC778\uC2A4\uD0C0\uADF8\uB7A8 8\uCC9C \uBA85, \uC720\uD29C\uBE0C \uBBF8\uC778\uC99D\uC774\uBA74 \uC9C0\uC6D0\uD560 \uC218 \uC5C6\uC5B4\uC694."
          },
          {
            type: "h2",
            id: "platform-standard",
            text: "\uD50C\uB7AB\uD3FC \uC5F4\uB78C \uAE30\uC900"
          },
          {
            type: "p",
            text: "\uD611\uCC2C \uC0C1\uC138\uB97C \uBCF4\uACE0 \uC9C0\uC6D0\uD558\uB824\uBA74, \uC9C0\uC6D0 \uC870\uAC74\uACFC \uBCC4\uAC1C\uB85C \uC778\uD50C\uB9BD\uC774 \uC815\uD55C \uD50C\uB7AB\uD3FC \uC5F4\uB78C \uAE30\uC900\uB3C4 \uB118\uC5B4\uC57C \uD574\uC694. \uC778\uC99D\uD55C \uCC44\uB110 \uC911 \uD558\uB098\uAC00 \uAE30\uC900 \uC774\uC0C1\uC774\uBA74 \uB3FC\uC694.\n\uAE30\uC900\uC5D0 \uBABB \uBBF8\uCE58\uB294 \uD68C\uC6D0\uC774 \uD611\uCC2C\uC744 \uB204\uB974\uBA74 \uC548\uB0B4 \uCC3D\uC5D0\uC11C \uCC44\uB110\uBCC4 \uAE30\uC900\uC744 \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "callout",
            text: "\uC815\uB9AC\uD558\uBA74 \uC9C0\uC6D0\uD558\uB824\uBA74 \u2460 SNS \uCC44\uB110 \uC778\uC99D \u2461 \uD50C\uB7AB\uD3FC \uC5F4\uB78C \uAE30\uC900 \uD1B5\uACFC \u2462 \uC774 \uD611\uCC2C\uC758 \uC9C0\uC6D0 \uC870\uAC74 \uD1B5\uACFC, \uC138 \uAC00\uC9C0\uAC00 \uBAA8\uB450 \uD544\uC694\uD574\uC694. \uBAA9\uB85D\uC5D0\uC11C\uB294 \uC9C0\uC6D0\uD560 \uC218 \uC788\uB294 \uD611\uCC2C\uC5D0 \uCD08\uB85D \uC810, \uC870\uAC74\uC5D0 \uBABB \uBBF8\uCE58\uB294 \uD611\uCC2C\uC5D0 \uBE68\uAC04 \uC810\uC774 \uCC0D\uD600\uC694."
          }
        ]
      },
      {
        slug: "sponsorship-request",
        title: "\uC694\uCCAD \uC0AC\uD56D \uC801\uAE30",
        description: "\uC778\uD50C\uB8E8\uC5B8\uC11C\uC5D0\uAC8C \uC6D0\uD558\uB294 \uCF58\uD150\uCE20\uB97C \uBD84\uBA85\uD558\uAC8C \uC804\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "why",
            text: "\uC694\uCCAD \uC0AC\uD56D\uC774 \uACE7 \uBBF8\uC158\uC774\uC5D0\uC694"
          },
          {
            type: "p",
            text: '"\uC18C\uAC1C\uC640 \uC694\uCCAD \uC0AC\uD56D"\uC5D0 \uC801\uC740 \uB0B4\uC6A9\uC774 \uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uD574\uC57C \uD560 \uBBF8\uC158\uC774 \uB3FC\uC694. \uD655\uC815\uB41C \uC778\uD50C\uB8E8\uC5B8\uC11C\uB294 \uC774 \uB0B4\uC6A9\uC744 \uBCF4\uACE0 \uCF58\uD150\uCE20\uB97C \uB9CC\uB4E4\uACE0, \uB9C8\uCE5C \uB4A4 \uADF8 \uACB0\uACFC\uB97C \uBBF8\uC158 \uC644\uB8CC\uB85C \uC778\uC99D\uD574\uC694.\n\uAD6C\uCCB4\uC801\uC77C\uC218\uB85D \uC11C\uB85C \uAE30\uB300\uAC00 \uAC19\uC544\uC9C0\uACE0, \uBBF8\uC158\uC744 \uD655\uC778\uD558\uAE30\uB3C4 \uC26C\uC6CC\uC694.'
          },
          {
            type: "h2",
            id: "checklist",
            text: "\uAF2D \uC801\uC744 \uAC83"
          },
          {
            type: "list",
            items: [
              "\uCF58\uD150\uCE20 \uC885\uB958\uC640 \uC218\uB7C9 \u2014 \uD53C\uB4DC \uC0AC\uC9C4 \uBA87 \uC7A5, \uB9B4\uC2A4\xB7\uC1FC\uCE20 \uBA87 \uAC74, \uBE14\uB85C\uADF8 \uD6C4\uAE30 \uBA87 \uAC74",
              "\uC62C\uB9B4 \uACF3 \u2014 \uC778\uC2A4\uD0C0\uADF8\uB7A8 \uD53C\uB4DC\xB7\uC2A4\uD1A0\uB9AC, \uC720\uD29C\uBE0C, \uBE14\uB85C\uADF8 \uB4F1",
              "\uAF2D \uB123\uC744 \uB0B4\uC6A9 \u2014 \uC5C5\uCCB4 \uACC4\uC815 \uD0DC\uADF8, \uD574\uC2DC\uD0DC\uADF8, \uC704\uCE58 \uD0DC\uADF8, \uAF2D \uBCF4\uC5EC \uC904 \uBA54\uB274\xB7\uC81C\uD488",
              "\uC77C\uC815 \u2014 \uBC29\uBB38 \uAC00\uB2A5\uD55C \uC694\uC77C\xB7\uC2DC\uAC04, \uCF58\uD150\uCE20\uB97C \uC62C\uB9B4 \uAE30\uD55C(\uC608: \uBC29\uBB38 \uD6C4 7\uC77C \uC548)",
              "\uAC8C\uC2DC \uC720\uC9C0 \uAE30\uAC04 \u2014 \uC608: \uCD5C\uC18C 3\uAC1C\uC6D4 \uC720\uC9C0",
              "\uD558\uC9C0 \uB9D0\uC544\uC57C \uD560 \uAC83 \u2014 \uACBD\uC7C1 \uC5C5\uCCB4 \uC5B8\uAE09, \uC6D0\uD558\uC9C0 \uC54A\uB294 \uCD2C\uC601 \uAD6C\uC5ED \uB4F1"
            ]
          },
          {
            type: "h2",
            id: "examples",
            text: "\uC694\uCCAD \uC0AC\uD56D \uC608\uC2DC"
          },
          {
            type: "example",
            label: "SNS \uC0AC\uC9C4 \uC62C\uB9AC\uAE30",
            text: '\uC778\uC2A4\uD0C0\uADF8\uB7A8 \uD53C\uB4DC\uC5D0 \uB9E4\uC7A5\xB7\uBA54\uB274 \uC0AC\uC9C4 3\uC7A5 \uC774\uC0C1 \uC62C\uB824 \uC8FC\uC138\uC694.\n@\uC5C5\uCCB4\uACC4\uC815 \uD0DC\uADF8, #\uC131\uC218\uCE74\uD398 #\uC2E0\uBA54\uB274 \uD574\uC2DC\uD0DC\uADF8, \uC704\uCE58 \uD0DC\uADF8\uB97C \uB123\uC5B4 \uC8FC\uC138\uC694.\n\uBC29\uBB38 \uD6C4 7\uC77C \uC548\uC5D0 \uC62C\uB9AC\uACE0, \uCD5C\uC18C 3\uAC1C\uC6D4 \uC720\uC9C0\uD574 \uC8FC\uC138\uC694.\n\uAC8C\uC2DC\uBB3C\uC5D0 "\uD611\uCC2C" \uB610\uB294 "\uAD11\uACE0"\uB97C \uD45C\uC2DC\uD574 \uC8FC\uC138\uC694.'
          },
          {
            type: "example",
            label: "\uB9B4\uC2A4\xB7\uC1FC\uCE20 \uC601\uC0C1",
            text: "15~30\uCD08 \uB9B4\uC2A4 1\uAC74 \u2014 \uB9E4\uC7A5 \uC785\uAD6C\uBD80\uD130 \uB300\uD45C \uBA54\uB274\uAE4C\uC9C0 \uBCF4\uC5EC \uC8FC\uC138\uC694.\n\uBC30\uACBD \uC74C\uC545\uC740 \uC790\uC720, \uC790\uB9C9\uC5D0 \uBA54\uB274 \uC774\uB984\uC744 \uB123\uC5B4 \uC8FC\uC138\uC694.\n\uC62C\uB9AC\uAE30 \uC804\uC5D0 \uC5C5\uCCB4\uC5D0 \uBBF8\uB9AC \uBCF4\uC5EC \uC8FC\uC2E4 \uD544\uC694\uB294 \uC5C6\uC5B4\uC694(\uD544\uC694\uD558\uBA74 \uC5EC\uAE30\uC5D0 \uC801\uC5B4\uC694)."
          },
          {
            type: "example",
            label: "\uC81C\uD488 \uB9AC\uBDF0",
            text: "\uC81C\uD488\uC744 \uBC1B\uC740 \uB4A4 14\uC77C \uC548\uC5D0 \uBE14\uB85C\uADF8 \uD6C4\uAE30 1\uAC74(\uC0AC\uC9C4 5\uC7A5 \uC774\uC0C1)\uC744 \uC62C\uB824 \uC8FC\uC138\uC694.\n\uC0AC\uC6A9 \uC804\xB7\uD6C4 \uBE44\uAD50 \uC0AC\uC9C4\uC744 \uB123\uC5B4 \uC8FC\uC138\uC694.\n\uC194\uC9C1\uD55C \uD6C4\uAE30\uB97C \uBD80\uD0C1\uB4DC\uB824\uC694. \uACFC\uC7A5\uB41C \uD6A8\uACFC \uD45C\uD604\uC740 \uBE7C \uC8FC\uC138\uC694."
          },
          {
            type: "callout",
            text: '\uD611\uCC2C\uBC1B\uC740 \uAC8C\uC2DC\uBB3C\uC5D0\uB294 "\uD611\uCC2C", "\uAD11\uACE0"\uCC98\uB7FC \uB300\uAC00\uB97C \uBC1B\uC558\uB2E4\uB294 \uC0AC\uC2E4\uC744 \uBC1D\uD600\uC57C \uD574\uC694(\uD45C\uC2DC\xB7\uAD11\uACE0\uBC95, \uACF5\uC815\uC704 \uCD94\uCC9C\xB7\uBCF4\uC99D \uC2EC\uC0AC\uC9C0\uCE68). \uD5C8\uC704\xB7\uACFC\uC7A5 \uD6C4\uAE30\uB97C \uC694\uAD6C\uD558\uAC70\uB098, \uBC95\uB839\uC0C1 \uAD11\uACE0\uAC00 \uC81C\uD55C\uB418\uB294 \uB0B4\uC6A9(\uC758\uB8CC\xB7\uAC74\uAC15\uAE30\uB2A5\uC2DD\uD488 \uD6A8\uB2A5 \uB4F1)\uC744 \uC694\uCCAD\uD558\uB294 \uD611\uCC2C\uC740 \uC62C\uB9B4 \uC218 \uC5C6\uC5B4\uC694.'
          }
        ]
      },
      {
        slug: "sponsorship-managing",
        title: "\uC9C0\uC6D0\uC790 \uAD00\uB9AC\uD558\uAE30",
        description: "\uBC1B\uC740 \uC9C0\uC6D0\uC744 \uC2B9\uC778\xB7\uAC70\uC808\uD558\uACE0, \uBAA8\uC9D1\uC744 \uB9C8\uAC10\uD558\uACE0, \uBBF8\uC158\uC744 \uD655\uC778\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "received",
            text: "\uBC1B\uC740 \uC9C0\uC6D0"
          },
          {
            type: "p",
            text: "\uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uB0B4\uAC00 \uC62C\uB9B0 \uD611\uCC2C \u2192 [\uBC1B\uC740 \uC9C0\uC6D0] \uD0ED\uC5D0\uC11C \uB0B4 \uBAA8\uB4E0 \uD611\uCC2C\uC5D0 \uB4E4\uC5B4\uC628 \uC9C0\uC6D0\uC744 \uD55C\uACF3\uC5D0\uC11C \uCC98\uB9AC\uD574\uC694. \uD611\uCC2C \uC0C1\uC138\uC758 \uC9C0\uC6D0\uC790 \uBAA9\uB85D\uC5D0\uC11C\uB3C4 \uAC19\uC740 \uC77C\uC744 \uD560 \uC218 \uC788\uC5B4\uC694."
          },
          {
            type: "list",
            items: [
              "\uC2B9\uC778 \uB300\uAE30 \u2014 \uB0B4\uAC00 \uACB0\uC815\uD560 \uC9C0\uC6D0 (\uC2B9\uC778 \uD6C4 \uD655\uC815 \uD611\uCC2C)",
              "\uBBF8\uC158 \uD655\uC778 \u2014 \uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uBBF8\uC158 \uC644\uB8CC\uB97C \uB4F1\uB85D\uD574 \uD655\uC778\uC744 \uAE30\uB2E4\uB9AC\uB294 \uC9C0\uC6D0",
              "\uC9C4\uD589\uC911 \u2014 \uD655\uC815\uB410\uACE0 \uBC29\uBB38\xB7\uBBF8\uC158\uC744 \uAE30\uB2E4\uB9AC\uB294 \uC9C0\uC6D0",
              "\uC644\uB8CC \u2014 \uBBF8\uC158 \uC644\uB8CC\xB7\uAC70\uC808\xB7\uCDE8\uC18C\xB7\uC790\uB3D9 \uCDE8\uC18C\uB41C \uC9C0\uC6D0"
            ]
          },
          {
            type: "p",
            text: '\uC9C0\uC6D0\uC790 \uC904\uC5D0\uB294 \uCC44\uB110\uACFC \uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uC218, \uB0A8\uAE34 \uBA54\uC2DC\uC9C0, \uBC29\uBB38 \uC608\uC815\uC77C\uC774 \uBCF4\uC5EC\uC694. \uC804\uC5D0 \uB0B4 \uD611\uCC2C\uC5D0\uC11C \uBBF8\uC158\uAE4C\uC9C0 \uB9C8\uCE5C \uC801\uC774 \uC788\uC73C\uBA74 "\uC774 \uD611\uCC2C \uCC38\uC5EC N\uBC88 \xB7 \uB0B4 \uD611\uCC2C \uCC38\uC5EC N\uBC88"\uB3C4 \uBCF4\uC5EC\uC694.'
          },
          {
            type: "h2",
            id: "decide",
            text: "\uC2B9\uC778\uACFC \uAC70\uC808"
          },
          {
            type: "list",
            items: [
              "\uC2B9\uC778\uD558\uBA74 \uBC14\uB85C \uD655\uC815\uB418\uACE0 \uC9C0\uC6D0\uC790\uC5D0\uAC8C \uC54C\uB9BC\uC774 \uAC00\uC694. \uC2B9\uC778\uC740 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC5B4\uC694.",
              "\uAC70\uC808\uD560 \uB54C\uB294 \uC0AC\uC720\uB97C \uAF2D \uC801\uC5B4\uC694. \uC0AC\uC720\uB294 \uC9C0\uC6D0\uC790\uC5D0\uAC8C \uADF8\uB300\uB85C \uBCF4\uC5EC\uC694.",
              "\uAC70\uC808\uB41C \uC9C0\uC6D0\uC790\uB294 \uAC19\uC740 \uD611\uCC2C\uC5D0 \uB2E4\uC2DC \uC9C0\uC6D0\uD560 \uC218 \uC5C6\uC5B4\uC694."
            ]
          },
          {
            type: "h2",
            id: "auto-cancel",
            text: "\uC790\uB3D9\uC73C\uB85C \uCDE8\uC18C\uB418\uB294 \uC9C0\uC6D0"
          },
          {
            type: "list",
            items: [
              "\uBC29\uBB38 \uC608\uC815\uC77C\uC774 \uC9C0\uB098\uB3C4\uB85D \uC2B9\uC778\uD558\uC9C0 \uC54A\uC740 \uC9C0\uC6D0\uC740 \uB2E4\uC74C \uB0A0 \uC790\uB3D9\uC73C\uB85C \uCDE8\uC18C\uB3FC\uC694.",
              "\uD611\uCC2C \uB0B4\uC6A9\uC744 \uACE0\uCE58\uBA74 \uC2B9\uC778 \uB300\uAE30 \uC911\uC778 \uC9C0\uC6D0\uC740 \uBAA8\uB450 \uCDE8\uC18C\uB3FC\uC694.",
              '[\uBAA8\uC9D1 \uB9C8\uAC10]\uC744 \uB204\uB974\uBA74 \uC2B9\uC778 \uB300\uAE30 \uC911\uC778 \uC9C0\uC6D0\uC774 \uBAA8\uB450 \uAC70\uC808\uB3FC\uC694("\uBAA8\uC9D1\uC774 \uB9C8\uAC10\uB410\uC5B4\uC694."). \uD655\uC815\uB41C \uC9C0\uC6D0\uC740 \uADF8\uB300\uB85C\uC608\uC694.'
            ]
          },
          {
            type: "h2",
            id: "close",
            text: "\uBAA8\uC9D1 \uB9C8\uAC10\uACFC \uB2E4\uC2DC \uC5F4\uAE30"
          },
          {
            type: "p",
            text: "\uCDA9\uBD84\uD788 \uBAA8\uC600\uB2E4\uBA74 \uD611\uCC2C \uC0C1\uC138\uC5D0\uC11C [\uBAA8\uC9D1 \uB9C8\uAC10]\uC744 \uB20C\uB7EC\uC694. \uB9C8\uAC10\uD55C \uD611\uCC2C\uC740 \uBAA9\uB85D\uC5D0\uC11C \uBE60\uC9C0\uACE0 \uC0C8 \uC9C0\uC6D0\uC744 \uBC1B\uC9C0 \uC54A\uC544\uC694.\n[\uBAA8\uC9D1 \uB2E4\uC2DC \uC5F4\uAE30]\uB97C \uB204\uB974\uBA74 \uC2EC\uC0AC \uC5C6\uC774 \uB2E4\uC2DC \uBAA8\uC9D1 \uC911\uC774 \uB3FC\uC694."
          },
          {
            type: "h2",
            id: "confirm-mission",
            text: "\uBBF8\uC158 \uD655\uC778"
          },
          {
            type: "steps",
            items: [
              "\uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uBBF8\uC158 \uC644\uB8CC\uB97C \uB4F1\uB85D\uD558\uBA74 \uC54C\uB9BC\uC774 \uC624\uACE0, [\uBC1B\uC740 \uC9C0\uC6D0]\uC758 \uBBF8\uC158 \uD655\uC778 \uCE69\uC5D0 \uBCF4\uC5EC\uC694.",
              "\uB0A8\uAE34 \uD6C4\uAE30\uC640 \uCF58\uD150\uCE20 \uB9C1\uD06C\uB97C \uC5F4\uC5B4 \uC694\uCCAD \uC0AC\uD56D\uB300\uB85C \uC62C\uB838\uB294\uC9C0 \uD655\uC778\uD574\uC694.",
              "[\uBBF8\uC158 \uD655\uC778]\uC744 \uB204\uB974\uBA74 \uBBF8\uC158 \uC644\uB8CC\uAC00 \uB418\uACE0 \uC778\uD50C\uB8E8\uC5B8\uC11C\uC5D0\uAC8C \uC54C\uB9BC\uC774 \uAC00\uC694."
            ]
          },
          {
            type: "callout",
            text: "\uC694\uCCAD \uC0AC\uD56D\uACFC \uB2E4\uB974\uAC8C \uC62C\uB838\uB2E4\uBA74 \uD655\uC778\uD558\uAE30 \uC804\uC5D0 \uC778\uD50C\uB8E8\uC5B8\uC11C\uC5D0\uAC8C 1:1 \uCC44\uD305\uC73C\uB85C \uC218\uC815\uC744 \uC694\uCCAD\uD558\uC138\uC694. \uC778\uD50C\uB8E8\uC5B8\uC11C\uB294 \uC5C5\uCCB4\uAC00 \uD655\uC778\uD558\uAE30 \uC804\uAE4C\uC9C0 \uBBF8\uC158 \uB0B4\uC6A9\uC744 \uACE0\uCE60 \uC218 \uC788\uC5B4\uC694."
          }
        ]
      },
      {
        slug: "sponsorship-applying",
        title: "\uD611\uCC2C \uC9C0\uC6D0\uD558\uAE30",
        description: "\uC778\uC99D \uC778\uD50C\uB8E8\uC5B8\uC11C\uAC00 \uD611\uCC2C\uC744 \uCC3E\uC544 \uC9C0\uC6D0\uD558\uACE0 \uD655\uC815\uB418\uAE30\uAE4C\uC9C0\uC758 \uACFC\uC815\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "before",
            text: "\uC9C0\uC6D0\uD558\uAE30 \uC804\uC5D0"
          },
          {
            type: "p",
            text: '\uD611\uCC2C \uC0C1\uC138\uB97C \uBCF4\uACE0 \uC9C0\uC6D0\uD558\uB824\uBA74 SNS \uCC44\uB110\uC744 \uC778\uC99D\uD574\uC57C \uD574\uC694. \uC778\uC99D\uD55C \uCC44\uB110 \uC911 \uD558\uB098\uAC00 \uD50C\uB7AB\uD3FC \uC5F4\uB78C \uAE30\uC900\uC744 \uB118\uACE0, \uADF8 \uD611\uCC2C\uC758 \uC9C0\uC6D0 \uC870\uAC74\uB3C4 \uB118\uC5B4\uC57C \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694. \uC778\uC99D \uBC29\uBC95\uC740 [\uC778\uD50C\uB8E8\uC5B8\uC11C \uC778\uC99D] \uBB38\uC11C\uB97C \uCC38\uACE0\uD558\uC138\uC694.\n\uD611\uCC2C \uD0ED\uC758 "\uB0B4 \uC870\uAC74\uC5D0 \uB9DE\uB294 \uD611\uCC2C\uB9CC \uBCF4\uAE30"\uB97C \uCF1C\uBA74 \uC9C0\uC6D0\uD560 \uC218 \uC788\uB294 \uD611\uCC2C\uB9CC \uBAA8\uC544 \uBCFC \uC218 \uC788\uC5B4\uC694.'
          },
          {
            type: "h2",
            id: "apply",
            text: "\uC9C0\uC6D0\uD558\uAE30"
          },
          {
            type: "steps",
            items: [
              "\uD611\uCC2C \uC0C1\uC138\uC5D0\uC11C \uC81C\uACF5 \uB0B4\uC6A9\uACFC \uC18C\uAC1C\xB7\uC694\uCCAD \uC0AC\uD56D\uC744 \uAF3C\uAF3C\uD788 \uC77D\uC5B4\uC694. \uC694\uCCAD \uC0AC\uD56D\uC774 \uACE7 \uD574\uC57C \uD560 \uBBF8\uC158\uC774\uC5D0\uC694.",
              "[\uC9C0\uC6D0\uD558\uAE30]\uB97C \uB204\uB974\uACE0 \uC5C5\uCCB4\uC5D0 \uC804\uD560 \uBA54\uC2DC\uC9C0(\uC120\uD0DD)\uB97C \uC801\uC5B4\uC694.",
              `\uBC29\uBB38 \uD611\uCC2C\uC774\uBA74 \uBC29\uBB38 \uC608\uC815\uC77C\uC744 \uACE8\uB77C\uC694. \uC624\uB298\uBD80\uD130 180\uC77C \uC548\uC5D0\uC11C \uACE0\uB97C \uC218 \uC788\uC5B4\uC694.`,
              "\uC9C0\uC6D0\uD558\uBA74 \uBC14\uB85C \uD655\uC815\uB418\uB294 \uD611\uCC2C\uC740 \uADF8 \uC790\uB9AC\uC5D0\uC11C \uD655\uC815\uB418\uACE0, \uC2B9\uC778 \uD6C4 \uD655\uC815 \uD611\uCC2C\uC740 \uC5C5\uCCB4\uC758 \uACB0\uC815\uC744 \uAE30\uB2E4\uB824\uC694."
            ]
          },
          {
            type: "h2",
            id: "status",
            text: "\uC9C0\uC6D0 \uC0C1\uD0DC \uBCF4\uAE30"
          },
          {
            type: "p",
            text: "\uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uD611\uCC2C \uC9C0\uC6D0 \uB0B4\uC5ED\uC5D0\uC11C \uC9C4\uD589\uC911\xB7\uC2B9\uC778 \uB300\uAE30\xB7\uC644\uB8CC\uB85C \uB098\uB220 \uBCFC \uC218 \uC788\uC5B4\uC694. \uC9C0\uC6D0\uC744 \uB204\uB974\uBA74 \uC9C0\uC6D0 \uC0C1\uC138\uAC00 \uC5F4\uB824 \uB0B4 \uC9C0\uC6D0 \uB0B4\uC6A9\uACFC \uC9C0\uC6D0\uD560 \uB54C\uC758 \uD611\uCC2C \uB0B4\uC6A9\uC744 \uD655\uC778\uD574\uC694. \uC9C0\uC6D0\uD55C \uB4A4 \uC5C5\uCCB4\uAC00 \uD611\uCC2C \uB0B4\uC6A9\uC744 \uACE0\uCCE4\uB2E4\uBA74 \uADF8\uB807\uB2E4\uACE0 \uC54C\uB824 \uB4DC\uB824\uC694."
          },
          {
            type: "list",
            items: [
              "\uAC70\uC808\uB418\uBA74 \uC0AC\uC720\uC640 \uD568\uAED8 \uC54C\uB9BC\uC774 \uAC00\uC694. \uAC70\uC808\uB41C \uD611\uCC2C\uC5D0\uB294 \uB2E4\uC2DC \uC9C0\uC6D0\uD560 \uC218 \uC5C6\uC5B4\uC694.",
              "\uBC29\uBB38 \uC608\uC815\uC77C\uC774 \uC9C0\uB098\uB3C4\uB85D \uC5C5\uCCB4\uAC00 \uC2B9\uC778\uD558\uC9C0 \uC54A\uC73C\uBA74 \uC9C0\uC6D0\uC774 \uC790\uB3D9\uC73C\uB85C \uCDE8\uC18C\uB3FC\uC694. \uB2E4\uC2DC \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694."
            ]
          },
          {
            type: "h2",
            id: "cancel",
            text: "\uC9C0\uC6D0 \uCDE8\uC18C\uC640 \uB2E4\uC2DC \uC9C0\uC6D0"
          },
          {
            type: "list",
            items: [
              "\uC2B9\uC778 \uB300\uAE30\uC640 \uD655\uC815 \uC0C1\uD0DC\uC5D0\uC11C \uC9C0\uC6D0 \uC0C1\uC138\uC758 [\uC9C0\uC6D0 \uCDE8\uC18C]\uB85C \uCDE8\uC18C\uD560 \uC218 \uC788\uC5B4\uC694. \uBBF8\uC158 \uC644\uB8CC\uB97C \uB4F1\uB85D\uD55C \uB4A4\uC5D0\uB294 \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC5B4\uC694.",
              "\uCDE8\uC18C\xB7\uC790\uB3D9 \uCDE8\uC18C\xB7\uBBF8\uC158 \uC644\uB8CC \uB4A4\uC5D0\uB294 \uAC19\uC740 \uD611\uCC2C\uC5D0 \uB2E4\uC2DC \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694. \uC9C0\uC6D0\uD560 \uB54C\uB9C8\uB2E4 \uC0C8 \uC9C0\uC6D0\uC73C\uB85C \uAE30\uB85D\uB3FC\uC694."
            ]
          },
          {
            type: "callout",
            text: "\uD655\uC815\uB41C \uB4A4 \uBC29\uBB38\uC774\uB098 \uCF58\uD150\uCE20 \uC81C\uC791\uC774 \uC5B4\uB824\uC6CC\uC84C\uB2E4\uBA74 \uBC14\uB85C \uC9C0\uC6D0\uC744 \uCDE8\uC18C\uD558\uAC70\uB098 \uC5C5\uCCB4\uC5D0 \uC54C\uB824 \uC8FC\uC138\uC694. \uD655\uC815\uB41C \uC57D\uC18D\uC744 \uC9C0\uD0A4\uC9C0 \uC54A\uC73C\uBA74 \uC6B4\uC601\uC815\uCC45\uC5D0 \uB530\uB77C \uC774\uC6A9\uC774 \uC81C\uD55C\uB420 \uC218 \uC788\uC5B4\uC694."
          }
        ]
      },
      {
        slug: "sponsorship-mission",
        title: "\uD611\uCC2C \uC778\uC99D(\uBBF8\uC158 \uC644\uB8CC)",
        description: "\uCCB4\uD5D8 \uB4A4 \uC694\uCCAD \uC0AC\uD56D\uB300\uB85C \uC62C\uB9B0 \uCF58\uD150\uCE20\uB97C \uC778\uC99D\uD558\uB294 \uBC29\uBC95\uC774\uC5D0\uC694.",
        blocks: [
          {
            type: "h2",
            id: "when",
            text: "\uC5B8\uC81C \uC778\uC99D\uD558\uB098\uC694"
          },
          {
            type: "p",
            text: '\uBC29\uBB38 \uD611\uCC2C\uC740 \uBC29\uBB38 \uC608\uC815\uC77C \uB2F9\uC77C\uBD80\uD130, \uBC29\uBB38 \uC5C6\uB294 \uD611\uCC2C\uC740 \uD655\uC815\uB418\uC790\uB9C8\uC790 \uC778\uC99D\uD560 \uC218 \uC788\uC5B4\uC694.\n\uD655\uC815\uB418\uBA74 \uC9C0\uC6D0 \uC0C1\uC138\uC5D0 "\uD611\uCC2C\uC774 \uD655\uC815\uB410\uC5B4\uC694. \uBBF8\uC158\uC744 \uB9C8\uCE58\uBA74 \uC544\uB798\uC5D0\uC11C \uBBF8\uC158 \uC644\uB8CC\uB97C \uB4F1\uB85D\uD574 \uC8FC\uC138\uC694."\uAC00 \uBCF4\uC774\uACE0, \uC544\uB798\uC5D0 \uBBF8\uC158 \uCE78\uC774 \uC5F4\uB824\uC694.'
          },
          {
            type: "h2",
            id: "how",
            text: "\uC778\uC99D\uD558\uB294 \uBC29\uBC95"
          },
          {
            type: "steps",
            items: [
              '\uC694\uCCAD \uC0AC\uD56D\uB300\uB85C \uCF58\uD150\uCE20\uB97C \uB9CC\uB4E4\uC5B4 SNS\uC5D0 \uC62C\uB824\uC694. \uAC8C\uC2DC\uBB3C\uC5D0 "\uD611\uCC2C" \uB610\uB294 "\uAD11\uACE0"\uB97C \uAF2D \uD45C\uC2DC\uD574\uC694.',
              "\uB9C8\uC774\uD398\uC774\uC9C0 \u2192 \uD611\uCC2C \uC9C0\uC6D0 \uB0B4\uC5ED \u2192 \uADF8 \uC9C0\uC6D0\uC744 \uB20C\uB7EC \uC9C0\uC6D0 \uC0C1\uC138\uB97C \uC5F4\uC5B4\uC694.",
              "\uBBF8\uC158 \uCE78\uC5D0 \uBC29\uBB38 \uD6C4\uAE30\uB098 \uC62C\uB9B0 \uCF58\uD150\uCE20 \uC124\uBA85\uC744 \uC801\uACE0, \uC62C\uB9B0 \uAC8C\uC2DC\uBB3C \uC8FC\uC18C\uB97C \uB9C1\uD06C\uB85C \uB123\uC5B4\uC694(5\uAC1C\uAE4C\uC9C0, https:// \uB85C \uC2DC\uC791\uD558\uB294 \uC804\uCCB4 \uC8FC\uC18C).",
              "[\uBBF8\uC158 \uC644\uB8CC \uB4F1\uB85D]\uC744 \uB204\uB974\uBA74 \uC5C5\uCCB4\uC5D0 \uC54C\uB9BC\uC774 \uAC00\uC694.",
              '\uC5C5\uCCB4\uAC00 \uD655\uC778\uD558\uBA74 "\uC5C5\uCCB4\uAC00 \uBBF8\uC158\uC744 \uD655\uC778\uD588\uC5B4\uC694. \uD611\uCC2C\uC774 \uC131\uACF5\uC801\uC73C\uB85C \uB9C8\uBB34\uB9AC\uB418\uC5C8\uC5B4\uC694."\uB85C \uBC14\uB00C\uACE0 \uC54C\uB9BC\uC774 \uC640\uC694.'
            ]
          },
          {
            type: "p",
            text: "\uAE00\uACFC \uB9C1\uD06C \uC911 \uD558\uB098\uB9CC \uC788\uC5B4\uB3C4 \uB4F1\uB85D\uD560 \uC218 \uC788\uC9C0\uB9CC, \uC5C5\uCCB4\uAC00 \uD655\uC778\uD558\uAE30 \uC27D\uAC8C \uB458 \uB2E4 \uB0A8\uAE30\uB294 \uAC78 \uAD8C\uD574\uC694."
          },
          {
            type: "h2",
            id: "example",
            text: "\uC778\uC99D \uC608\uC2DC \u2014 SNS \uC0AC\uC9C4 \uC62C\uB9AC\uAE30"
          },
          {
            type: "example",
            label: "\uC694\uCCAD \uC0AC\uD56D",
            text: "\uC778\uC2A4\uD0C0\uADF8\uB7A8 \uD53C\uB4DC\uC5D0 \uB9E4\uC7A5\xB7\uBA54\uB274 \uC0AC\uC9C4 3\uC7A5 \uC774\uC0C1, @\uC5C5\uCCB4\uACC4\uC815 \uD0DC\uADF8, #\uC131\uC218\uCE74\uD398 \uD574\uC2DC\uD0DC\uADF8, \uBC29\uBB38 \uD6C4 7\uC77C \uC548\uC5D0"
          },
          {
            type: "example",
            label: "\uBBF8\uC158 \uC644\uB8CC \uB4F1\uB85D",
            text: '\uAE00: 10\uC6D4 26\uC77C \uBC29\uBB38\uD588\uC5B4\uC694. \uC2E0\uBA54\uB274 2\uC885\uACFC \uB9E4\uC7A5 \uB0B4\uBD80 \uC0AC\uC9C4 4\uC7A5\uC744 \uD53C\uB4DC\uC5D0 \uC62C\uB838\uACE0, @\uC5C5\uCCB4\uACC4\uC815 \uD0DC\uADF8\uC640 #\uC131\uC218\uCE74\uD398 #\uC2E0\uBA54\uB274 \uD574\uC2DC\uD0DC\uADF8, \uC704\uCE58 \uD0DC\uADF8\uB97C \uB123\uC5C8\uC5B4\uC694. \uAC8C\uC2DC\uBB3C \uCCAB \uC904\uC5D0 "\uD611\uCC2C"\uC744 \uD45C\uC2DC\uD588\uC5B4\uC694.\n\uB9C1\uD06C: https://www.instagram.com/p/\u2026'
          },
          {
            type: "h2",
            id: "edit",
            text: "\uACE0\uCE58\uAE30\uC640 \uC644\uB8CC \uB4A4"
          },
          {
            type: "list",
            items: [
              "\uC5C5\uCCB4\uAC00 \uD655\uC778\uD558\uAE30 \uC804\uAE4C\uC9C0 [\uC218\uC815 \uC800\uC7A5]\uC73C\uB85C \uAE00\uACFC \uB9C1\uD06C\uB97C \uACE0\uCE60 \uC218 \uC788\uC5B4\uC694. \uC5C5\uCCB4\uAC00 \uC218\uC815\uC744 \uC694\uCCAD\uD558\uBA74 \uCF58\uD150\uCE20\uB97C \uACE0\uCE5C \uB4A4 \uC5EC\uAE30 \uB0B4\uC6A9\uB3C4 \uB9DE\uCDB0 \uC8FC\uC138\uC694.",
              "\uBBF8\uC158 \uC644\uB8CC\uB97C \uB4F1\uB85D\uD55C \uB4A4\uC5D0\uB294 \uC9C0\uC6D0\uC744 \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC5B4\uC694.",
              "\uBBF8\uC158 \uC644\uB8CC \uB4A4\uC5D0\uB3C4 \uAC19\uC740 \uD611\uCC2C\uC5D0 \uB2E4\uC2DC \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694."
            ]
          },
          {
            type: "callout",
            text: "\uC62C\uB9B0 \uAC8C\uC2DC\uBB3C\uC740 \uC694\uCCAD \uC0AC\uD56D\uC5D0 \uC801\uD78C \uAE30\uAC04 \uB3D9\uC548 \uC720\uC9C0\uD574 \uC8FC\uC138\uC694. \uC778\uC99D\uD55C \uB4A4 \uBC14\uB85C \uC9C0\uC6B0\uAC70\uB098 \uBE44\uACF5\uAC1C\uB85C \uBC14\uAFB8\uBA74 \uC6B4\uC601\uC815\uCC45\uC5D0 \uB530\uB77C \uC774\uC6A9\uC774 \uC81C\uD55C\uB420 \uC218 \uC788\uC5B4\uC694."
          }
        ]
      }
    ]
  }
];
function flattenSections(sections) {
  return sections.flatMap((section) => section.pages.map((page) => ({
    ...page,
    section: section.title
  })));
}
__name(flattenSections, "flattenSections");
var GUIDE_PAGES = flattenSections(GUIDE_SECTIONS);
var SECTIONS_BY_LOCALE = {
  ko: GUIDE_SECTIONS,
  en: GUIDE_SECTIONS_EN,
  ja: GUIDE_SECTIONS_JA
};
var PAGES_BY_LOCALE = {
  ko: GUIDE_PAGES,
  en: flattenSections(GUIDE_SECTIONS_EN),
  ja: flattenSections(GUIDE_SECTIONS_JA)
};
function guideSections(locale = "ko") {
  return SECTIONS_BY_LOCALE[locale] ?? GUIDE_SECTIONS;
}
__name(guideSections, "guideSections");
function guidePages(locale = "ko") {
  return PAGES_BY_LOCALE[locale] ?? GUIDE_PAGES;
}
__name(guidePages, "guidePages");
function findGuidePage(slug, locale = "ko") {
  return guidePages(locale).find((p) => p.slug === slug) ?? null;
}
__name(findGuidePage, "findGuidePage");
function adjacentGuidePages(slug, locale = "ko") {
  const pages = guidePages(locale);
  const idx = pages.findIndex((p) => p.slug === slug);
  return {
    prev: idx > 0 ? pages[idx - 1] : null,
    next: idx >= 0 && idx < pages.length - 1 ? pages[idx + 1] : null
  };
}
__name(adjacentGuidePages, "adjacentGuidePages");
var guideBlockSchema = z8.discriminatedUnion("type", [
  z8.object({
    type: z8.literal("h2"),
    id: z8.string(),
    text: z8.string()
  }),
  z8.object({
    type: z8.literal("p"),
    text: z8.string()
  }),
  z8.object({
    type: z8.literal("list"),
    items: z8.array(z8.string())
  }),
  z8.object({
    type: z8.literal("steps"),
    items: z8.array(z8.string())
  }),
  z8.object({
    type: z8.literal("callout"),
    text: z8.string()
  }),
  z8.object({
    type: z8.literal("example"),
    label: z8.string(),
    text: z8.string()
  })
]);
var guidePageSchema = z8.object({
  slug: z8.string(),
  title: z8.string(),
  description: z8.string(),
  blocks: z8.array(guideBlockSchema)
});
var guideSectionSchema = z8.object({
  title: z8.string(),
  pages: z8.array(guidePageSchema)
});
var guideResponseSchema = z8.object({
  sections: z8.array(guideSectionSchema)
});
function fillGuideSections(config, locale = "ko") {
  const fill = /* @__PURE__ */ __name((text) => fillGuideTokens(text, config), "fill");
  const block = /* @__PURE__ */ __name((b) => {
    switch (b.type) {
      case "h2":
        return {
          ...b,
          text: fill(b.text)
        };
      case "list":
      case "steps":
        return {
          ...b,
          items: b.items.map(fill)
        };
      case "example":
        return {
          ...b,
          label: fill(b.label),
          text: fill(b.text)
        };
      default:
        return {
          ...b,
          text: fill(b.text)
        };
    }
  }, "block");
  return guideSections(locale).map((section) => ({
    title: section.title,
    pages: section.pages.map((page) => ({
      ...page,
      title: fill(page.title),
      description: fill(page.description),
      blocks: page.blocks.map(block)
    }))
  }));
}
__name(fillGuideSections, "fillGuideSections");

// src/user/community.schema.ts
import { CommunityPostCategory } from "@inflip/shared";
import { z as z9 } from "zod";
var COMMUNITY_POST_TITLE_MAX = 100;
var COMMUNITY_POST_CONTENT_MIN = 5;
var COMMUNITY_POST_CONTENT_MAX = 5e3;
var COMMUNITY_COMMENT_MAX = 1e3;
var communityAuthorSchema = z9.object({
  platform: socialPlatformSchema.nullable(),
  tier: z9.number().int().nullable()
});
var communityPostCategorySchema = z9.nativeEnum(CommunityPostCategory);
var communityPostSummarySchema = z9.object({
  id: z9.string().uuid(),
  category: communityPostCategorySchema,
  title: z9.string(),
  /** 목록용 본문 미리보기 (앞부분 일부) */
  preview: z9.string(),
  author: communityAuthorSchema,
  commentCount: z9.number().int().nonnegative(),
  likeCount: z9.number().int().nonnegative(),
  createdAt: z9.string().datetime(),
  /** 로그인한 내가 상세를 열어 본 글(내가 쓴 글 포함) — 목록 제목을 흐리게. 로그인하지 않았으면 false */
  isRead: z9.boolean()
});
var communityCommentSchema = z9.object({
  id: z9.string().uuid(),
  authorLabel: z9.string().nullable(),
  parentCommentId: z9.string().uuid().nullable(),
  replyToCommentId: z9.string().uuid().nullable(),
  isDeleted: z9.boolean(),
  content: z9.string(),
  author: communityAuthorSchema,
  isPostAuthor: z9.boolean(),
  /** 작성 뒤 내용을 고친 적이 있으면 true — 댓글 끝에 "(수정됨)" */
  isEdited: z9.boolean(),
  createdAt: z9.string().datetime()
});
var communityPostDetailSchema = z9.object({
  id: z9.string().uuid(),
  category: communityPostCategorySchema,
  title: z9.string(),
  content: z9.string(),
  author: communityAuthorSchema,
  commentCount: z9.number().int().nonnegative(),
  likeCount: z9.number().int().nonnegative(),
  createdAt: z9.string().datetime(),
  comments: z9.array(communityCommentSchema)
});
var createCommunityCommentResponseSchema = communityPostDetailSchema.extend({
  createdCommentId: z9.string().uuid()
});
var COMMUNITY_SEARCH_MAX = 50;
var listCommunityPostsQuerySchema = pageQuerySchema.extend({
  /** 제목·본문 부분 일치 검색어 */
  q: z9.string().trim().max(COMMUNITY_SEARCH_MAX).optional(),
  /** 말머리로 거르기 — 없으면 전체 */
  category: communityPostCategorySchema.optional()
});
var communityPostPageSchema = pageResponseSchema(communityPostSummarySchema);
var createCommunityPostRequestSchema = z9.object({
  /** 말머리 — 보내지 않으면 일반 (옛 앱) */
  category: communityPostCategorySchema.default(CommunityPostCategory.GENERAL),
  title: z9.string().trim().min(2, "\uC81C\uBAA9\uC744 2\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694.").max(COMMUNITY_POST_TITLE_MAX),
  content: z9.string().trim().min(COMMUNITY_POST_CONTENT_MIN, "\uB0B4\uC6A9\uC744 5\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694.").max(COMMUNITY_POST_CONTENT_MAX)
});
var createCommunityCommentRequestSchema = z9.object({
  content: z9.string().trim().min(1, "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.").max(COMMUNITY_COMMENT_MAX),
  parentCommentId: z9.string().uuid().optional(),
  replyToCommentId: z9.string().uuid().optional()
});
var updateCommunityPostRequestSchema = createCommunityPostRequestSchema.extend({
  /** 말머리 — 보내지 않으면 그대로 (옛 앱) */
  category: communityPostCategorySchema.optional()
});
var updateCommunityCommentRequestSchema = createCommunityCommentRequestSchema.pick({
  content: true
});
var COMMUNITY_REPORT_REASONS = {
  SPAM: "\uAD11\uACE0\xB7\uB3C4\uBC30",
  ABUSE: "\uC695\uC124\xB7\uD610\uC624\xB7\uAD34\uB86D\uD798",
  SEXUAL: "\uC74C\uB780\xB7\uBD80\uC801\uC808\uD55C \uB0B4\uC6A9",
  PRIVACY: "\uAC1C\uC778\uC815\uBCF4 \uB178\uCD9C",
  ILLEGAL: "\uBD88\uBC95\xB7\uC0AC\uAE30",
  OTHER: "\uAE30\uD0C0"
};
var COMMUNITY_REPORT_REASONS_I18N = {
  ko: COMMUNITY_REPORT_REASONS,
  en: {
    SPAM: "Spam / flooding",
    ABUSE: "Abuse, hate or harassment",
    SEXUAL: "Sexual or inappropriate content",
    PRIVACY: "Exposes personal information",
    ILLEGAL: "Illegal or fraudulent",
    OTHER: "Other"
  },
  ja: {
    SPAM: "\u5E83\u544A\u30FB\u9023\u6295",
    ABUSE: "\u66B4\u8A00\u30FB\u30D8\u30A4\u30C8\u30FB\u5ACC\u304C\u3089\u305B",
    SEXUAL: "\u308F\u3044\u305B\u3064\u30FB\u4E0D\u9069\u5207\u306A\u5185\u5BB9",
    PRIVACY: "\u500B\u4EBA\u60C5\u5831\u306E\u9732\u51FA",
    ILLEGAL: "\u9055\u6CD5\u30FB\u8A50\u6B3A",
    OTHER: "\u305D\u306E\u4ED6"
  }
};
var reportCommunityRequestSchema = z9.object({
  reason: z9.enum([
    "SPAM",
    "ABUSE",
    "SEXUAL",
    "PRIVACY",
    "ILLEGAL",
    "OTHER"
  ]),
  detail: z9.string().trim().max(1e3, "\uC2E0\uACE0 \uB0B4\uC6A9\uC740 1,000\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.").optional()
}).refine((value) => value.reason !== "OTHER" || !!value.detail, {
  path: [
    "detail"
  ],
  message: "\uAE30\uD0C0 \uC0AC\uC720\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694."
});
var communityHiddenPostsSchema = z9.object({
  postIds: z9.array(z9.string().uuid())
});
var communityHiddenCommentsSchema = z9.object({
  commentIds: z9.array(z9.string().uuid())
});
var communityEligibilityResponseSchema = z9.object({
  /** SNS 채널을 하나라도 인증했는지 */
  verified: z9.boolean(),
  /** 팔로워 수가 가장 많은 인증 채널 (배지에 쓰일 채널). 미인증이면 null */
  bestChannel: z9.object({
    platform: socialPlatformSchema,
    followerCount: z9.number().int()
  }).nullable(),
  canPost: z9.boolean(),
  canComment: z9.boolean(),
  /** 옛 앱용 — 채널별 글쓰기 기준 중 가장 낮은 값 */
  minFollowersToPost: z9.number().int(),
  /** 옛 앱용 — 채널별 댓글 기준 중 가장 낮은 값 */
  minFollowersToComment: z9.number().int(),
  /** 채널별 글쓰기 기준 — 인증 채널 중 하나만 넘으면 된다 */
  minFollowersToPostByPlatform: channelMinFollowersSchema,
  /** 채널별 댓글 기준 */
  minFollowersToCommentByPlatform: channelMinFollowersSchema,
  /** 글쓰기 조건 안내 문구 — ["유튜브 구독자 2만 이상", …] (shared communityActivityConditions, 요청 언어) */
  postConditions: z9.array(z9.string()),
  /** 댓글 조건 안내 문구 */
  commentConditions: z9.array(z9.string())
});
var communityMineResponseSchema = z9.object({
  postIsMine: z9.boolean(),
  myCommentIds: z9.array(z9.string().uuid()),
  /** 내가 이 글에 좋아요를 눌렀는지 */
  liked: z9.boolean(),
  /** 내가 이 글을 스크랩했는지 */
  scrapped: z9.boolean()
});
var communityLikeStateSchema = z9.object({
  liked: z9.boolean(),
  likeCount: z9.number().int().nonnegative()
});
var communityScrapStateSchema = z9.object({
  scrapped: z9.boolean()
});
var myCommunityCommentSchema = z9.object({
  id: z9.string().uuid(),
  postId: z9.string().uuid(),
  postTitle: z9.string(),
  content: z9.string(),
  /** 다른 댓글에 단 답글인지 */
  isReply: z9.boolean(),
  createdAt: z9.string().datetime()
});
var myCommunityCommentPageSchema = pageResponseSchema(myCommunityCommentSchema);

// src/user/payouts.schema.ts
import { z as z10 } from "zod";
var payoutItemKindSchema = z10.enum([
  /** 판매 대금 정산 (수수료 제외) */
  "SALE",
  /** 정산 지급 뒤 환불로 판매자에게서 회수할 금액 */
  "SALE_CLAWBACK",
  /** 로열티 월 지급분 (수수료 제외) */
  "ROYALTY",
  /** 로열티 정정 차액 */
  "ROYALTY_ADJUSTMENT"
]);
var payoutItemStatusSchema = z10.enum([
  /** 로열티 — 구매자 입금 전 */
  "AWAITING_DEPOSIT",
  /** 지급 예정 (입금 확인·정산 생성됨) */
  "SCHEDULED",
  /** 어드민 보류 */
  "ON_HOLD",
  "PAID",
  "CANCELLED",
  /** 감액 정정 — 아직 지급 전인 원래 보고에서 차감 예정 / 차감됨 */
  "DEDUCT_PENDING",
  "DEDUCTED",
  /** 이미 지급한 돈에서 회수 예정 / 회수됨 */
  "CLAWBACK_PENDING",
  "CLAWED_BACK"
]);
var payoutItemSchema = z10.object({
  id: z10.string().uuid(),
  kind: payoutItemKindSchema,
  status: payoutItemStatusSchema,
  orderId: z10.string().uuid(),
  listingTitle: z10.string().nullable(),
  /** 로열티면 매출 달 (YYYY-MM) */
  period: z10.string().nullable(),
  amount: z10.number().int(),
  /** 지급·회수된 시각, 아니면 생긴 시각 */
  occurredAt: z10.string().datetime(),
  /** 정정 근거 등 */
  note: z10.string().nullable(),
  /** 이어 받을 때 before 로 보낼 값 (payoutCursorOf) — 앱이 커서 규칙을 따로 갖지 않게 */
  cursor: z10.string().optional()
});
var pendingRoyaltyReportSchema = z10.object({
  orderId: z10.string().uuid(),
  listingTitle: z10.string().nullable(),
  /** 매출 달 (YYYY-MM) */
  period: z10.string(),
  /** 보고·입금 기한 (YYYY-MM-DD, 다음 달 지급일) */
  dueDate: z10.string(),
  overdue: z10.boolean()
});
var payoutClawbackRequestSchema = z10.object({
  id: z10.string().uuid(),
  orderId: z10.string().uuid(),
  listingTitle: z10.string().nullable(),
  amount: z10.number().int(),
  /** 회수 사유 (환불 사유) */
  reason: z10.string(),
  requestedAt: z10.string().datetime(),
  dueAt: z10.string().datetime(),
  overdue: z10.boolean()
});
var myPayoutsResponseSchema = z10.object({
  summary: z10.object({
    /** 실제로 받은 금액 (지급 − 차감·회수 완료) */
    paidTotal: z10.number().int(),
    /** 지급 예정 (차감 예정 반영) */
    scheduledTotal: z10.number().int(),
    /** 로열티 — 구매자 입금을 기다리는 금액 */
    awaitingDepositTotal: z10.number().int(),
    /** 회수 예정 금액 (양수) */
    clawbackPendingTotal: z10.number().int(),
    /** 구매자 보고 대기 달 수 / 그중 기한이 지난 달 수 */
    pendingReportCount: z10.number().int(),
    overdueReportCount: z10.number().int()
  }),
  /** 고른 칩의 한 쪽(최근 순) — 합계·칩 수는 전체 기준 */
  items: z10.array(payoutItemSchema),
  /** 칩별 수 — all 은 전체 */
  counts: z10.partialRecord(z10.enum([
    "all",
    "scheduled",
    "paid",
    "awaiting",
    "deduct"
  ]), z10.number().int()),
  /** 이 쪽 뒤에 더 있는지 — 이어 받을 때는 마지막 줄의 cursor 를 before 로 */
  hasMore: z10.boolean(),
  /** 아직 입금하지 않은 정산금 회수 — 기한이 이른 순 */
  clawbackRequests: z10.array(payoutClawbackRequestSchema),
  /** 구매자 보고 대기 — 연체가 먼저, 그다음 오래된 달부터 */
  pendingReports: z10.array(pendingRoyaltyReportSchema)
});
var PAYOUT_LIST_PAGE = 20;
var PAYOUT_GROUPS = [
  {
    key: "scheduled",
    label: "\uC9C0\uAE09 \uC608\uC815",
    statuses: [
      "SCHEDULED",
      "ON_HOLD"
    ]
  },
  {
    key: "paid",
    label: "\uC9C0\uAE09 \uC644\uB8CC",
    statuses: [
      "PAID"
    ]
  },
  {
    key: "awaiting",
    label: "\uAD6C\uB9E4\uC790 \uC785\uAE08 \uB300\uAE30",
    statuses: [
      "AWAITING_DEPOSIT"
    ]
  },
  {
    key: "deduct",
    label: "\uCC28\uAC10\xB7\uD68C\uC218",
    statuses: [
      "DEDUCT_PENDING",
      "DEDUCTED",
      "CLAWBACK_PENDING",
      "CLAWED_BACK"
    ]
  }
];
function payoutCursorOf(item) {
  return `${item.kind}:${item.id}`;
}
__name(payoutCursorOf, "payoutCursorOf");
var myPayoutsQuerySchema = z10.object({
  group: z10.enum([
    "scheduled",
    "paid",
    "awaiting",
    "deduct"
  ]).optional(),
  before: z10.string().max(80).optional(),
  limit: z10.coerce.number().int().min(1).max(100).default(PAYOUT_LIST_PAGE)
});

// src/user/listing-form.ts
import { defaultAppearanceScope, defaultUsageScope, APPEARANCE_SERVICE_AREA_NATIONWIDE, APPEARANCE_VARIANT_LABELS_I18N as APPEARANCE_VARIANT_LABELS_I18N2, appearanceVariantMode, ACTIVE_IP_RIGHT_TYPES as ACTIVE_IP_RIGHT_TYPES4, getUsagePurpose, isGiveawayOnly, isAdultIndustryForbidden, supportsUsagePurpose, UsagePurpose, usageScopeRows, monthlyAddonLabel, BRAND_ASSET_LABELS_I18N, BRAND_LEGAL_USE_LABELS_I18N, BrandAsset, DEFAULT_LANG, EXCLUSIVITY_LABELS_I18N, Exclusivity, formatWon, forbiddenIndustryLabel, ForbiddenIndustry, IpRightType as IpRightType4, MODIFICATION_RIGHT_LABELS_I18N, PRICING_MODEL_LABELS_I18N, PricingModel, RIGHT_TYPE_FORM_CONFIG, RIGHT_TYPE_REGION_LABELS_I18N, tr, USAGE_PLACEMENT_LABELS_I18N, USAGE_REGION_LABELS_I18N, UsagePlacement, UsageRegion, VIOLATION_POLICY_LABELS_I18N, ViolationPolicy, josa as josa2, withAppearancePackages } from "@inflip/shared";

// src/common/validation-i18n.ts
import { APPEARANCE_VARIANT_LABELS_I18N, DEPOSITOR_NAME_MAX_LENGTH, INTL_LOCALE, josa, MAX_NOTE_ITEM_LENGTH, MAX_NOTE_ITEMS, NICKNAME_RULE_MESSAGE_I18N, SUPPORT_INQUIRY_BODY_MAX, SUPPORT_INQUIRY_BODY_MIN, SUPPORT_INQUIRY_TITLE_MAX } from "@inflip/shared";
var fmt = /* @__PURE__ */ __name((n, lang) => n.toLocaleString(INTL_LOCALE[lang]), "fmt");
var merchandiseSelect = /* @__PURE__ */ __name((label, en, ja) => [
  `${josa(label, "\uC744", "\uB97C")} 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.`,
  {
    en,
    ja
  }
], "merchandiseSelect");
var VALIDATION_MESSAGES_I18N = {
  // ── 공통 (common/) ──
  [`\uD56D\uBAA9\uC740 ${MAX_NOTE_ITEMS}\uAC1C\uAE4C\uC9C0 \uC801\uC744 \uC218 \uC788\uC5B4\uC694.`]: {
    en: `You can add up to ${fmt(MAX_NOTE_ITEMS, "en")} items.`,
    ja: `\u9805\u76EE\u306F${fmt(MAX_NOTE_ITEMS, "ja")}\u500B\u307E\u3067\u5165\u529B\u3067\u304D\u307E\u3059\u3002`
  },
  [`\uD55C \uD56D\uBAA9\uC740 ${MAX_NOTE_ITEM_LENGTH}\uC790\uAE4C\uC9C0 \uC801\uC744 \uC218 \uC788\uC5B4\uC694.`]: {
    en: `Each item can be up to ${fmt(MAX_NOTE_ITEM_LENGTH, "en")} characters.`,
    ja: `1\u3064\u306E\u9805\u76EE\u306F${fmt(MAX_NOTE_ITEM_LENGTH, "ja")}\u6587\u5B57\u307E\u3067\u5165\u529B\u3067\u304D\u307E\u3059\u3002`
  },
  "\uC5C6\uB294 \uB0A0\uC9DC\uC608\uC694": {
    en: "This date doesn't exist",
    ja: "\u5B58\u5728\u3057\u306A\u3044\u65E5\u4ED8\u3067\u3059"
  },
  "\uBC84\uC804\uC740 x.y.z \uD615\uC2DD\uC774\uC5B4\uC57C \uD574\uC694 (\uC608: 1.2.3)": {
    en: "The version must be in x.y.z format (e.g. 1.2.3)",
    ja: "\u30D0\u30FC\u30B8\u30E7\u30F3\u306F x.y.z \u5F62\u5F0F\u306B\u3057\u3066\u304F\u3060\u3055\u3044\uFF08\u4F8B: 1.2.3\uFF09"
  },
  "\uCD5C\uC18C \uBC84\uC804\uC774 \uCD5C\uC2E0 \uBC84\uC804\uBCF4\uB2E4 \uB192\uC744 \uC218 \uC5C6\uC5B4\uC694": {
    en: "The minimum version can't be higher than the latest version",
    ja: "\u6700\u4F4E\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u6700\u65B0\u30D0\u30FC\u30B8\u30E7\u30F3\u3088\u308A\u9AD8\u304F\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093"
  },
  "\uAD8C\uB9AC \uC218\uB294 1~20\uAC1C \uC0AC\uC774\uB85C \uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set the number of rights between 1 and 20.",
    ja: "\u6A29\u5229\u306E\u6570\u306F1\u301C20\u500B\u306E\u9593\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC218\uC218\uB8CC\uB294 0~50% \uC0AC\uC774\uB85C \uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set the fee between 0% and 50%.",
    ja: "\u624B\u6570\u6599\u306F0\u301C50%\u306E\u9593\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uD2F0\uC5B4 \uACBD\uACC4\uAC12\uC740 \uC624\uB984\uCC28\uC21C\uC774\uACE0 \uC911\uBCF5\uC774 \uC5C6\uC5B4\uC57C \uD574\uC694.": {
    en: "Tier boundaries must be in ascending order with no duplicates.",
    ja: "\u30C6\u30A3\u30A2\u306E\u5883\u754C\u5024\u306F\u6607\u9806\u3067\u3001\u91CD\u8907\u304C\u306A\u3044\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC885\uBAA9 \uC774\uB984\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter a category name",
    ja: "\u30AB\u30C6\u30B4\u30EA\u30FC\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC885\uBAA9\uC744 1\uAC1C \uC774\uC0C1 \uB0A8\uACA8 \uC8FC\uC138\uC694": {
    en: "Keep at least one category",
    ja: "\u30AB\u30C6\u30B4\u30EA\u30FC\u30921\u3064\u4EE5\u4E0A\u6B8B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC885\uBAA9 id \uAC00 \uACB9\uCCD0\uC694.": {
    en: "Category IDs overlap.",
    ja: "\u30AB\u30C6\u30B4\u30EA\u30FCID\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059\u3002"
  },
  "\uAC19\uC740 \uC774\uB984\uC758 \uC885\uBAA9\uC774 \uC788\uC5B4\uC694.": {
    en: "A category with the same name already exists.",
    ja: "\u540C\u3058\u540D\u524D\u306E\u30AB\u30C6\u30B4\u30EA\u30FC\u304C\u3042\u308A\u307E\u3059\u3002"
  },
  "http:// \uB610\uB294 https:// \uB85C \uC2DC\uC791\uD558\uB294 \uC8FC\uC18C\uB97C \uB123\uC5B4 \uC8FC\uC138\uC694.": {
    en: "Enter an address starting with http:// or https://.",
    ja: "http:// \u307E\u305F\u306F https:// \u3067\u59CB\u307E\u308B\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  // ── 회원·로그인 (auth·users) ──
  [NICKNAME_RULE_MESSAGE_I18N.ko]: {
    en: NICKNAME_RULE_MESSAGE_I18N.en,
    ja: NICKNAME_RULE_MESSAGE_I18N.ja
  },
  "\uC22B\uC790\uC640 - \uB9CC \uC785\uB825": {
    en: "Numbers and - only",
    ja: "\u6570\u5B57\u3068 - \u306E\u307F\u5165\u529B"
  },
  "\uAC04\uD3B8\uBE44\uBC00\uBC88\uD638\uB294 \uC22B\uC790 6\uC790\uB9AC\uC608\uC694": {
    en: "Your PIN must be 6 digits",
    ja: "\u7C21\u5358\u6697\u8A3C\u756A\u53F7\u306F\u6570\u5B576\u6841\u3067\u3059"
  },
  "\uC18C\uC15C \uB85C\uADF8\uC778 \uC815\uBCF4\uAC00 \uC5C6\uC5B4\uC694": {
    en: "Social login information is missing",
    ja: "\u30BD\u30FC\u30B7\u30E3\u30EB\u30ED\u30B0\u30A4\u30F3\u60C5\u5831\u304C\u3042\u308A\u307E\u305B\u3093"
  },
  "\uCC44\uB110 \uC8FC\uC18C\uB294 https:// \uB85C \uC2DC\uC791\uD558\uB294 \uC804\uCCB4 \uC8FC\uC18C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694": {
    en: "Enter the full channel address starting with https://",
    ja: "\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u30A2\u30C9\u30EC\u30B9\u306F https:// \u304B\u3089\u59CB\u307E\u308B\u5B8C\u5168\u306A\u30A2\u30C9\u30EC\u30B9\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uCC44\uB110 \uC8FC\uC18C\uB294 500\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694": {
    en: "Enter a channel address of 500 characters or fewer",
    ja: "\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u30A2\u30C9\u30EC\u30B9\u306F500\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "idToken \uB610\uB294 (code + redirectUri) \uAC00 \uD544\uC694\uD569\uB2C8\uB2E4": {
    en: "idToken or (code + redirectUri) is required",
    ja: "idToken \u307E\u305F\u306F (code + redirectUri) \u304C\u5FC5\u8981\u3067\u3059"
  },
  "\uB77C\uC774\uC120\uC2A4 \uC811\uADFC \uC0C1\uC2E4 \uC548\uB0B4\uC5D0 \uB3D9\uC758\uD574 \uC8FC\uC138\uC694": {
    en: "Please agree to the notice about losing access to your licenses",
    ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u5931\u3046\u3053\u3068\u3078\u306E\u6848\u5185\u306B\u540C\u610F\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uAC04\uD3B8\uBE44\uBC00\uBC88\uD638\uB098 \uC18C\uC15C \uACC4\uC815 \uB85C\uADF8\uC778\uC73C\uB85C \uBCF8\uC778 \uD655\uC778\uC774 \uD544\uC694\uD574\uC694": {
    en: "Please verify your identity with your PIN or social login",
    ja: "\u7C21\u5358\u6697\u8A3C\u756A\u53F7\u307E\u305F\u306F\u30BD\u30FC\u30B7\u30E3\u30EB\u30ED\u30B0\u30A4\u30F3\u3067\u672C\u4EBA\u78BA\u8A8D\u304C\u5FC5\u8981\u3067\u3059"
  },
  "\uCC44\uB110 \uC8FC\uC18C \uC804\uCCB4\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter the full channel address.",
    ja: "\u30C1\u30E3\u30F3\u30CD\u30EB\u306E\u30A2\u30C9\u30EC\u30B9\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC9C1\uC811 \uCD94\uAC00\uD55C \uD65C\uB3D9 \uC774\uB984\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter a name for the activity you added.",
    ja: "\u8FFD\u52A0\u3057\u305F\u6D3B\u52D5\u306E\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uD65C\uB3D9 \uC9C1\uC811 \uCD94\uAC00\uB294 \uB2E8\uC77C \uAC00\uACA9 \uD604\uC7A5 \uBC29\uBB38\uC5D0\uC11C\uB9CC \uD560 \uC218 \uC788\uC5B4\uC694.": {
    en: "You can add your own activities only to on-site appearances with a single price.",
    ja: "\u6D3B\u52D5\u306E\u8FFD\u52A0\u306F\u3001\u5358\u4E00\u4FA1\u683C\u306E\u73FE\u5730\u8A2A\u554F\u3067\u306E\u307F\u3067\u304D\u307E\u3059\u3002"
  },
  "\uD65C\uB3D9 \uC774\uB984\uC744 \uC11C\uB85C \uB2E4\uB974\uAC8C \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Give each activity a different name.",
    ja: "\u6D3B\u52D5\u3054\u3068\u306B\u7570\u306A\u308B\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC9C1\uC811 \uCD94\uAC00\uD55C \uD65C\uB3D9\uB9C8\uB2E4 \uCD2C\uC601\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Choose the filming and usage scope for each activity you added.",
    ja: "\u8FFD\u52A0\u3057\u305F\u6D3B\u52D5\u3054\u3068\u306B\u64AE\u5F71\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC778\uC2A4\uD0C0\uADF8\uB7A8 \uC544\uC774\uB514\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694.": {
    en: "Check your Instagram username.",
    ja: "Instagram\u306E\u30E6\u30FC\u30B6\u30FC\u30CD\u30FC\u30E0\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
  },
  // ── 채팅 ──
  "SYSTEM \uD0C0\uC785\uC740 \uD074\uB77C\uC774\uC5B8\uD2B8\uAC00 \uBCF4\uB0BC \uC218 \uC5C6\uC74C": {
    en: "Clients can't send SYSTEM messages",
    ja: "SYSTEM \u30BF\u30A4\u30D7\u306F\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u304B\u3089\u9001\u4FE1\u3067\u304D\u307E\u305B\u3093"
  },
  "TEXT \uBA54\uC2DC\uC9C0\uB294 content \uD544\uC218": {
    en: "TEXT messages require content",
    ja: "TEXT \u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u306F content \u304C\u5FC5\u8981\u3067\u3059"
  },
  "\uCCA8\uBD80 \uBA54\uC2DC\uC9C0\uB294 attachmentKey \uD544\uC218": {
    en: "Attachment messages require attachmentKey",
    ja: "\u6DFB\u4ED8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u306F attachmentKey \u304C\u5FC5\u8981\u3067\u3059"
  },
  "message \uAC00 \uC788\uC73C\uBA74 messageClientKey \uD544\uC218": {
    en: "messageClientKey is required when message is present",
    ja: "message \u304C\u3042\u308B\u5834\u5408\u306F messageClientKey \u304C\u5FC5\u8981\u3067\u3059"
  },
  // ── 커뮤니티 ──
  "\uC81C\uBAA9\uC744 2\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter a title of at least 2 characters.",
    ja: "\u30BF\u30A4\u30C8\u30EB\u306F2\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uB0B4\uC6A9\uC744 5\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter at least 5 characters.",
    ja: "\u5185\u5BB9\u306F5\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC2E0\uACE0 \uB0B4\uC6A9\uC740 1,000\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter report details of 1,000 characters or fewer.",
    ja: "\u5831\u544A\u5185\u5BB9\u306F1,000\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAE30\uD0C0 \uC0AC\uC720\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Please enter the other reason.",
    ja: "\u305D\u306E\u4ED6\u306E\u7406\u7531\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  // ── 고객센터 ──
  "\uC81C\uBAA9\uC744 2\uC790 \uC774\uC0C1 \uC801\uC5B4 \uC8FC\uC138\uC694": {
    en: "Enter a title of at least 2 characters",
    ja: "\u30BF\u30A4\u30C8\u30EB\u306F2\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  [`\uC81C\uBAA9\uC740 ${SUPPORT_INQUIRY_TITLE_MAX}\uC790\uAE4C\uC9C0\uC608\uC694`]: {
    en: `The title can be up to ${fmt(SUPPORT_INQUIRY_TITLE_MAX, "en")} characters`,
    ja: `\u30BF\u30A4\u30C8\u30EB\u306F${fmt(SUPPORT_INQUIRY_TITLE_MAX, "ja")}\u6587\u5B57\u307E\u3067\u3067\u3059`
  },
  [`\uB0B4\uC6A9\uC744 ${SUPPORT_INQUIRY_BODY_MIN}\uC790 \uC774\uC0C1 \uC801\uC5B4 \uC8FC\uC138\uC694`]: {
    en: `Enter at least ${fmt(SUPPORT_INQUIRY_BODY_MIN, "en")} characters`,
    ja: `\u5185\u5BB9\u306F${fmt(SUPPORT_INQUIRY_BODY_MIN, "ja")}\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044`
  },
  [`\uB0B4\uC6A9\uC740 ${SUPPORT_INQUIRY_BODY_MAX}\uC790\uAE4C\uC9C0\uC608\uC694`]: {
    en: `The content can be up to ${fmt(SUPPORT_INQUIRY_BODY_MAX, "en")} characters`,
    ja: `\u5185\u5BB9\u306F${fmt(SUPPORT_INQUIRY_BODY_MAX, "ja")}\u6587\u5B57\u307E\u3067\u3067\u3059`
  },
  "\uB0B4\uC6A9\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694": {
    en: "Please enter a message",
    ja: "\u5185\u5BB9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  // ── 주문·분쟁·로열티 ──
  "\uAC19\uC740 \uC624\uD37C\uB97C \uC911\uBCF5 \uC120\uD0DD\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4": {
    en: "You can't select the same offer twice",
    ja: "\u540C\u3058\u30AA\u30D5\u30A1\u30FC\u3092\u91CD\u8907\u3057\u3066\u9078\u629E\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093"
  },
  "\uC785\uAE08\uC790\uBA85\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter the depositor's name",
    ja: "\u632F\u8FBC\u540D\u7FA9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  [`\uC785\uAE08\uC790\uBA85\uC740 ${DEPOSITOR_NAME_MAX_LENGTH}\uC790\uAE4C\uC9C0 \uC785\uB825\uD560 \uC218 \uC788\uC5B4\uC694`]: {
    en: `The depositor's name can be up to ${fmt(DEPOSITOR_NAME_MAX_LENGTH, "en")} characters`,
    ja: `\u632F\u8FBC\u540D\u7FA9\u306F${fmt(DEPOSITOR_NAME_MAX_LENGTH, "ja")}\u6587\u5B57\u307E\u3067\u5165\u529B\u3067\u304D\u307E\u3059`
  },
  "YYYY-MM-DD \uD615\uC2DD": {
    en: "YYYY-MM-DD format",
    ja: "YYYY-MM-DD \u5F62\u5F0F"
  },
  "YYYY-MM \uD615\uC2DD": {
    en: "YYYY-MM format",
    ja: "YYYY-MM \u5F62\u5F0F"
  },
  "\uC774\uBBF8\uC9C0(JPG\xB7PNG\xB7WEBP\xB7GIF\xB7HEIC)\uB9CC \uCCA8\uBD80\uD560 \uC218 \uC788\uC5B4\uC694": {
    en: "Only images (JPG, PNG, WEBP, GIF, HEIC) can be attached",
    ja: "\u753B\u50CF\uFF08JPG\u30FBPNG\u30FBWEBP\u30FBGIF\u30FBHEIC\uFF09\u306E\u307F\u6DFB\u4ED8\u3067\u304D\u307E\u3059"
  },
  "\uC774\uBBF8\uC9C0 \uD55C \uC7A5\uC740 10MB\uAE4C\uC9C0 \uCCA8\uBD80\uD560 \uC218 \uC788\uC5B4\uC694": {
    en: "Each image can be up to 10MB",
    ja: "\u753B\u50CF\u306F1\u679A\u3042\u305F\u308A10MB\u307E\u3067\u6DFB\u4ED8\u3067\u304D\u307E\u3059"
  },
  "\uBD84\uC7C1 \uC0AC\uC720\uB97C 10\uC790 \uC774\uC0C1 \uC801\uC5B4\uC8FC\uC138\uC694": {
    en: "Enter a dispute reason of at least 10 characters",
    ja: "\u7D1B\u4E89\u306E\u7406\u7531\u306F10\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  [`\uC99D\uAC70 \uC774\uBBF8\uC9C0\uB294 ${DISPUTE_EVIDENCE_MAX_FILES}\uC7A5\uAE4C\uC9C0 \uCCA8\uBD80\uD560 \uC218 \uC788\uC5B4\uC694`]: {
    en: `You can attach up to ${fmt(DISPUTE_EVIDENCE_MAX_FILES, "en")} evidence images`,
    ja: `\u8A3C\u62E0\u753B\u50CF\u306F${fmt(DISPUTE_EVIDENCE_MAX_FILES, "ja")}\u679A\u307E\u3067\u6DFB\u4ED8\u3067\u304D\u307E\u3059`
  },
  "\uC2E0\uACE0 \uC0AC\uC720\uB97C 10\uC790 \uC774\uC0C1 \uC801\uC5B4\uC8FC\uC138\uC694": {
    en: "Enter a report reason of at least 10 characters",
    ja: "\u5831\u544A\u306E\u7406\u7531\u306F10\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uBC18\uB824 \uC0AC\uC720\uB97C 5\uC790 \uC774\uC0C1 \uC801\uC5B4 \uC8FC\uC138\uC694": {
    en: "Enter a rejection reason of at least 5 characters",
    ja: "\u5DEE\u3057\u623B\u3057\u306E\u7406\u7531\u306F5\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC740 \uC9C0\uAE09\uC77C(\uB9E4\uB2EC N\uC77C) \uD569\uC758\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4": {
    en: "Royalty contracts need an agreed payment day (day N of each month)",
    ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u306F\u652F\u6255\u65E5\uFF08\u6BCE\u6708N\u65E5\uFF09\u306E\u5408\u610F\u304C\u5FC5\u8981\u3067\u3059"
  },
  // ── 협찬 ──
  "\uC774\uBBF8\uC9C0\uB294 2MB \uC774\uD558\uB85C \uC62C\uB824 \uC8FC\uC138\uC694": {
    en: "Upload an image of 2MB or less",
    ja: "\u753B\u50CF\u306F2MB\u4EE5\u4E0B\u3067\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC774\uBBF8\uC9C0 \uD615\uC2DD\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694": {
    en: "The image format is invalid",
    ja: "\u753B\u50CF\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093"
  },
  "\uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uC218\uB294 \uC815\uC218\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter the subscriber/follower count as a whole number",
    ja: "\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u306F\u6574\u6570\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uAD6C\uB3C5\uC790\xB7\uD314\uB85C\uC6CC \uC218\uB294 1\uBA85 \uC774\uC0C1\uC774\uC5B4\uC57C \uD574\uC694": {
    en: "The subscriber/follower count must be at least 1",
    ja: "\u767B\u9332\u8005\u30FB\u30D5\u30A9\u30ED\u30EF\u30FC\u6570\u306F1\u4EBA\u4EE5\u4E0A\u306B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC81C\uBAA9\uC740 2\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter a title of at least 2 characters",
    ja: "\u30BF\u30A4\u30C8\u30EB\u306F2\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC5C5\uCCB4\uBA85\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter the business name",
    ja: "\u696D\u8005\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC18C\uAC1C\uB294 10\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter an introduction of at least 10 characters",
    ja: "\u7D39\u4ECB\u306F10\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uD611\uCC2C\uC73C\uB85C \uC81C\uACF5\uD558\uB294 \uB0B4\uC6A9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter what the sponsorship provides",
    ja: "\u6848\u4EF6\u3067\u63D0\u4F9B\u3059\u308B\u5185\u5BB9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uD611\uCC2C \uC885\uBAA9\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694": {
    en: "Select a sponsorship category",
    ja: "\u6848\u4EF6\u306E\u30AB\u30C6\u30B4\u30EA\u30FC\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694": {
    en: "Select a region",
    ja: "\u5730\u57DF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uC9C0\uC6D0 \uC870\uAC74\uC744 \uD558\uB098 \uC774\uC0C1 \uC124\uC815\uD574 \uC8FC\uC138\uC694": {
    en: "Set at least one application requirement",
    ja: "\u5FDC\u52DF\u6761\u4EF6\u30921\u3064\u4EE5\u4E0A\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uBC29\uBB38 \uC608\uC815\uC77C\uC744 \uB0A0\uC9DC\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter the planned visit date as a date",
    ja: "\u8A2A\u554F\u4E88\u5B9A\u65E5\u3092\u65E5\u4ED8\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uAC70\uC808 \uC0AC\uC720\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter a reason for declining",
    ja: "\u304A\u65AD\u308A\u306E\u7406\u7531\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  [`\uAC70\uC808 \uC0AC\uC720\uB294 ${SPONSORSHIP_REJECT_REASON_MAX}\uC790\uAE4C\uC9C0 \uC4F8 \uC218 \uC788\uC5B4\uC694`]: {
    en: `The reason can be up to ${fmt(SPONSORSHIP_REJECT_REASON_MAX, "en")} characters`,
    ja: `\u304A\u65AD\u308A\u306E\u7406\u7531\u306F${fmt(SPONSORSHIP_REJECT_REASON_MAX, "ja")}\u6587\u5B57\u307E\u3067\u5165\u529B\u3067\u304D\u307E\u3059`
  },
  "\uC62C\uBC14\uB978 \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter a valid URL",
    ja: "\u6B63\u3057\u3044URL\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uBBF8\uC158 \uB0B4\uC6A9\uC774\uB098 \uB9C1\uD06C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter the mission details or a link",
    ja: "\u30DF\u30C3\u30B7\u30E7\u30F3\u5185\u5BB9\u307E\u305F\u306F\u30EA\u30F3\u30AF\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  "\uB450 \uAE00\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694": {
    en: "Enter at least 2 characters",
    ja: "2\u6587\u5B57\u4EE5\u4E0A\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  // ── 상품 (listings) ──
  "\uC0AC\uC6A9 \uAE30\uAC04\uC740 1/3/6/12\uAC1C\uC6D4 (\uB610\uB294 \uAE30\uAC04 \uC5C6\uC74C 0) \uC911 \uD558\uB098": {
    en: "The usage period must be 1/3/6/12 months (or 0 for no period)",
    ja: "\u4F7F\u7528\u671F\u9593\u306F1/3/6/12\u304B\u6708\uFF08\u307E\u305F\u306F\u671F\u9593\u306A\u30570\uFF09\u306E\u3044\u305A\u308C\u304B\u3067\u3059"
  },
  "\uD56D\uBAA9\uC774 \uC911\uBCF5\uB429\uB2C8\uB2E4": {
    en: "Duplicate items",
    ja: "\u9805\u76EE\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059"
  },
  "\uC0AC\uC6A9\uD560 \uC774\uB984\xB7\uBE0C\uB79C\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter the name or brand to use.",
    ja: "\u4F7F\u7528\u3059\u308B\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAC19\uC740 \uD56D\uBAA9\uC744 \uC911\uBCF5 \uC120\uD0DD\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "You can't select the same item twice.",
    ja: "\u540C\u3058\u9805\u76EE\u3092\u91CD\u8907\u3057\u3066\u9078\u629E\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uAC19\uC740 \uC0AC\uC6A9 \uC704\uCE58\uB97C \uAE30\uBCF8\uAC00\uC640 \uCD94\uAC00\uAE08\uC5D0 \uC911\uBCF5 \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "The same placement can't be in both the base price and add-ons.",
    ja: "\u540C\u3058\u4F7F\u7528\u5834\u6240\u3092\u57FA\u672C\u4FA1\u683C\u3068\u8FFD\u52A0\u6599\u91D1\u306E\u4E21\u65B9\u306B\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uAC19\uC740 \uACBD\uB85C\uB97C \uAE30\uBCF8\uAC00\uC640 \uCD94\uAC00\uAE08\uC5D0 \uC911\uBCF5 \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "The same channel can't be in both the base price and add-ons.",
    ja: "\u540C\u3058\u7D4C\u8DEF\u3092\u57FA\u672C\u4FA1\u683C\u3068\u8FFD\u52A0\u6599\u91D1\u306E\u4E21\u65B9\u306B\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uAE30\uD0C0 \uC81C\uC791 \uD488\uBAA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter the other product to make.",
    ja: "\u305D\u306E\u4ED6\u306E\u88FD\u4F5C\u54C1\u76EE\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAE30\uD0C0 \uD488\uBAA9\uC744 \uC120\uD0DD\uD558\uAC70\uB098 \uC785\uB825\uD55C \uAE30\uD0C0 \uD488\uBAA9\uC744 \uBE44\uC6CC \uC8FC\uC138\uC694.": {
    en: 'Select "Other" or clear the other product you entered.',
    ja: "\u305D\u306E\u4ED6\u306E\u54C1\u76EE\u3092\u9078\u629E\u3059\u308B\u304B\u3001\u5165\u529B\u3057\u305F\u305D\u306E\u4ED6\u306E\u54C1\u76EE\u3092\u7A7A\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAE30\uC874 \uC7AC\uACE0\uC758 \uD310\uB9E4\xB7\uBC30\uD3EC \uD5C8\uC6A9 \uAE30\uAC04\uC744 1~365\uC77C\uB85C \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set a sell-off period of 1\u2013365 days for existing stock.",
    ja: "\u65E2\u5B58\u5728\u5EAB\u306E\u8CA9\u58F2\u30FB\u914D\u5E03\u3092\u8A31\u53EF\u3059\u308B\u671F\u9593\u30921\u301C365\u65E5\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAE30\uC874 \uC7AC\uACE0\uC758 \uD310\uB9E4\xB7\uBC30\uD3EC\uB97C \uD5C8\uC6A9\uD560 \uB54C\uB9CC \uC815\uB9AC \uAE30\uAC04\uC744 \uC124\uC815\uD560 \uC218 \uC788\uC5B4\uC694.": {
    en: "You can set a sell-off period only when selling existing stock is allowed.",
    ja: "\u65E2\u5B58\u5728\u5EAB\u306E\u8CA9\u58F2\u30FB\u914D\u5E03\u3092\u8A31\u53EF\u3059\u308B\u5834\u5408\u306E\u307F\u3001\u6574\u7406\u671F\u9593\u3092\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002"
  },
  "\uB300\uC0AC \uBD84\uB7C9\xB7\uCD08\uC548 \uC804\uB2EC \uAE30\uD55C\xB7\uC218\uC815 \uD69F\uC218\uB97C \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set the script length, draft delivery deadline, and number of revisions.",
    ja: "\u30BB\u30EA\u30D5\u306E\u5206\u91CF\u30FB\u521D\u7A3F\u306E\u7D0D\u671F\u30FB\u4FEE\u6B63\u56DE\u6570\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC0C8 \uC74C\uC131 \uC81C\uC791\xB7\uC804\uB2EC \uBC29\uC2DD\uC5D0\uB9CC \uC81C\uC791 \uC870\uAC74\uC744 \uD3EC\uD568\uD560 \uC218 \uC788\uC5B4\uC694.": {
    en: "Production terms can only be included for new voice recordings.",
    ja: "\u5236\u4F5C\u6761\u4EF6\u306F\u65B0\u3057\u3044\u97F3\u58F0\u306E\u5236\u4F5C\u30FB\u7D0D\u54C1\u65B9\u5F0F\u306B\u306E\u307F\u542B\u3081\u3089\u308C\u307E\u3059\u3002"
  },
  "AI \uC74C\uC131 \uC0DD\uC131 \uBC29\uBC95\xB7\uC11C\uBE44\uC2A4\xB7\uD5C8\uC6A9 \uC5B8\uC5B4\xB7\uAE30\uAC04\uC744 \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set the AI voice generation method, service, allowed languages, and period.",
    ja: "AI\u97F3\u58F0\u306E\u751F\u6210\u65B9\u6CD5\u30FB\u30B5\u30FC\u30D3\u30B9\u30FB\u8A31\u53EF\u8A00\u8A9E\u30FB\u671F\u9593\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAD6C\uB9E4\uC790\uAC00 \uC0DD\uC131\uD558\uB294 \uC74C\uC131\uC740 AI \uC0DD\uC131 \uBC29\uC2DD\uC774\uC5B4\uC57C \uD574\uC694.": {
    en: "Voice generated by the buyer must use AI generation.",
    ja: "\u8CFC\u5165\u8005\u304C\u751F\u6210\u3059\u308B\u97F3\u58F0\u306FAI\u751F\u6210\u65B9\u5F0F\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAD6C\uB9E4\uC790\uAC00 AI \uC74C\uC131 \uC0DD\uC131 \uBC29\uC2DD\uC5D0\uB9CC \uC0DD\uC131 \uC870\uAC74\uC744 \uD3EC\uD568\uD560 \uC218 \uC788\uC5B4\uC694.": {
    en: "Generation terms can only be included when the buyer generates AI voice.",
    ja: "\u751F\u6210\u6761\u4EF6\u306F\u8CFC\u5165\u8005\u304CAI\u97F3\u58F0\u3092\u751F\u6210\u3059\u308B\u65B9\u5F0F\u306B\u306E\u307F\u542B\u3081\u3089\u308C\u307E\u3059\u3002"
  },
  "\uC74C\uC131 \uC0AC\uC6A9\uAD8C\uC5D0\uC11C \uC81C\uACF5\uD560 \uC218 \uC5C6\uB294 \uC0AC\uC6A9 \uC704\uCE58\uAC00 \uD3EC\uD568\uB418\uC5B4 \uC788\uC5B4\uC694.": {
    en: "Includes placements that voice usage rights can't offer.",
    ja: "\u97F3\u58F0\u306E\u4F7F\u7528\u6A29\u3067\u306F\u63D0\u4F9B\u3067\u304D\u306A\u3044\u4F7F\u7528\u5834\u6240\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002"
  },
  "\uAC1C\uC778 \uAC10\uC0C1\uC6A9\uC5D0\uB294 \uC0AC\uC5C5\xB7\uD64D\uBCF4\uC6A9 \uC0AC\uC6A9 \uC704\uCE58\uB098 \uCD94\uAC00\uAE08\uC744 \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "Personal use can't have business or promotional placements or add-ons.",
    ja: "\u500B\u4EBA\u9451\u8CDE\u7528\u306B\u306F\u4E8B\u696D\u30FB\u5E83\u5831\u7528\u306E\u4F7F\u7528\u5834\u6240\u3084\u8FFD\u52A0\u6599\u91D1\u3092\u8A2D\u5B9A\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uC0AC\uC6A9\uCC98\uB97C 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select at least one use.",
    ja: "\u4F7F\u7528\u5148\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAC19\uC740 \uC0AC\uC6A9\uCC98\uB97C \uAE30\uBCF8\uAC00\uC640 \uCD94\uAC00\uAE08\uC5D0 \uC911\uBCF5 \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "The same use can't be in both the base price and add-ons.",
    ja: "\u540C\u3058\u4F7F\u7528\u5148\u3092\u57FA\u672C\u4FA1\u683C\u3068\u8FFD\u52A0\u6599\u91D1\u306E\u4E21\u65B9\u306B\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uC0C1\uD488\uBA85 \uC0AC\uC6A9\uC740 \uC774\uB984/\uBE0C\uB79C\uB4DC \uC0AC\uC6A9\uAD8C\uC5D0\uC11C \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set product name use in the name/brand usage rights.",
    ja: "\u5546\u54C1\u540D\u3067\u306E\u4F7F\u7528\u306F\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u306E\u4F7F\u7528\u6A29\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC0AC\uC6A9\uCC98\uAC00 \uC911\uBCF5\uB429\uB2C8\uB2E4.": {
    en: "Duplicate uses.",
    ja: "\u4F7F\u7528\u5148\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059\u3002"
  },
  "\uAE08\uC9C0 \uC5C5\uC885\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter a prohibited industry.",
    ja: "\u7981\u6B62\u696D\u7A2E\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAE08\uC9C0 \uC5C5\uC885\uC740 40\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter a prohibited industry of 40 characters or fewer.",
    ja: "\u7981\u6B62\u696D\u7A2E\u306F40\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC774\uBBF8 \uCD94\uAC00\uD55C \uAE08\uC9C0 \uC5C5\uC885\uC774\uC5D0\uC694.": {
    en: "This prohibited industry is already added.",
    ja: "\u3059\u3067\u306B\u8FFD\u52A0\u3057\u305F\u7981\u6B62\u696D\u7A2E\u3067\u3059\u3002"
  },
  "\uC9C1\uC811 \uCD94\uAC00\uD558\uB294 \uAE08\uC9C0 \uC5C5\uC885\uC740 \uCD5C\uB300 10\uAC1C\uC608\uC694.": {
    en: "You can add up to 10 custom prohibited industries.",
    ja: "\u76F4\u63A5\u8FFD\u52A0\u3067\u304D\u308B\u7981\u6B62\u696D\u7A2E\u306F\u6700\u592710\u500B\u3067\u3059\u3002"
  },
  "\uAD8C\uB9AC\uC758 \uC138\uBD80 \uC870\uAC74\uC744 \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set the detailed terms for this right.",
    ja: "\u6A29\u5229\u306E\u8A73\u7D30\u6761\u4EF6\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC774 \uAD8C\uB9AC\uC5D0\uC11C \uD5C8\uC6A9\uD558\uB294 \uC218\uC815 \uD56D\uBAA9\uB9CC \uC911\uBCF5 \uC5C6\uC774 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select only the modifications this right allows, without duplicates.",
    ja: "\u3053\u306E\u6A29\u5229\u3067\u8A31\u53EF\u3055\u308C\u3066\u3044\u308B\u6539\u5909\u9805\u76EE\u306E\u307F\u3092\u91CD\u8907\u306A\u304F\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uCD9C\uC5F0\uAD8C\uC5D0\uB294 \uB3C5\uC810 \uC870\uAC74\uC744 \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "Appearance rights can't have exclusivity terms.",
    ja: "\u51FA\u6F14\u6A29\u306B\u306F\u72EC\u5360\u6761\u4EF6\u3092\u8A2D\u5B9A\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uBC29\uBB38 \uAC00\uB2A5\uD55C \uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select the areas you can visit.",
    ja: "\u8A2A\u554F\u53EF\u80FD\u306A\u5730\u57DF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uCD9C\uC5F0 \uBC29\uC2DD\uBCC4 \uAC00\uACA9\uACFC \uB300\uD45C \uAC00\uACA9\uC774 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.": {
    en: "The prices for each appearance type don't match the main price.",
    ja: "\u51FA\u6F14\u65B9\u5F0F\u3054\u3068\u306E\u4FA1\u683C\u3068\u4EE3\u8868\u4FA1\u683C\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002"
  },
  "\uD604\uC7A5 \uBC29\uBB38 \uAD6C\uC131 \uAC00\uACA9\uACFC \uB300\uD45C \uAC00\uACA9\uC774 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.": {
    en: "The on-site package prices don't match the main price.",
    ja: "\u73FE\u5730\u8A2A\u554F\u306E\u69CB\u6210\u4FA1\u683C\u3068\u4EE3\u8868\u4FA1\u683C\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002"
  },
  "\uCD9C\uC5F0\uAD8C\uC740 \uC0AC\uC6A9 \uAE30\uAC04 \uC5C6\uC774 1\uD68C \uAE30\uC900 \uACE0\uC815\uAC00\uB85C \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set appearance rights as a one-time fixed price with no usage period.",
    ja: "\u51FA\u6F14\u6A29\u306F\u4F7F\u7528\u671F\u9593\u306A\u3057\u306E1\u56DE\u3042\u305F\u308A\u306E\u56FA\u5B9A\u4FA1\u683C\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uCF5C\uB77C\uBCF4 \uC0C1\uD488\uAD8C\uC740 \uC2E0\uADDC \uB4F1\uB85D\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "Collaboration product rights can't be newly listed.",
    ja: "\u30B3\u30E9\u30DC\u5546\u54C1\u6A29\u306F\u65B0\u898F\u767B\u9332\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uACF5\uB3D9\uBE0C\uB79C\uB529 \uAC00\uACA9\uC740 \uBE0C\uB79C\uB4DC \uC218 \uC81C\uD55C \uC5C6\uC774 \uCEA0\uD398\uC778 1\uAC74 \uAE30\uC900\uC73C\uB85C \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set co-branding prices per campaign, with no limit on the number of brands.",
    ja: "\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0\u306E\u4FA1\u683C\u306F\u30D6\u30E9\u30F3\u30C9\u6570\u306E\u5236\u9650\u306A\u3057\u3067\u3001\u30AD\u30E3\u30F3\u30DA\u30FC\u30F31\u4EF6\u3042\u305F\u308A\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC131\uC778 \uC5C5\uC885 \uCD94\uAC00\uAE08\uC744 1,000\uC6D0 \uC774\uC0C1 \uC785\uB825\uD558\uAC70\uB098 \uAE30\uBCF8\uAC00 \uD3EC\uD568\uC73C\uB85C \uBC14\uAFD4 \uC8FC\uC138\uC694.": {
    en: "Enter an adult-industry add-on of \u20A91,000 or more, or include it in the base price.",
    ja: "\u6210\u4EBA\u5411\u3051\u696D\u7A2E\u306E\u8FFD\u52A0\u6599\u91D1\u30921,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3059\u308B\u304B\u3001\u57FA\u672C\u4FA1\u683C\u306B\u542B\u3081\u308B\u306B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC131\uC778 \uC5C5\uC885\uC744 \uAE08\uC9C0\uD558\uBA74 \uC131\uC778 \uC0AC\uC6A9 \uC635\uC158\uC744 \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "If adult industries are prohibited, you can't set adult-use options.",
    ja: "\u6210\u4EBA\u5411\u3051\u696D\u7A2E\u3092\u7981\u6B62\u3059\u308B\u3068\u3001\u6210\u4EBA\u5411\u3051\u306E\u4F7F\u7528\u30AA\u30D7\u30B7\u30E7\u30F3\u306F\u8A2D\u5B9A\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uAC1C\uC778 \uAC10\uC0C1\uC6A9\uC740 \uB9E4\uCD9C \uB85C\uC5F4\uD2F0 \uC5C6\uC774 \uACE0\uC815\uAC00 \uB610\uB294 \uAC00\uACA9 \uD611\uC758\uB85C \uD310\uB9E4\uD574 \uC8FC\uC138\uC694.": {
    en: "Sell personal use at a fixed or negotiable price, without revenue royalties.",
    ja: "\u500B\u4EBA\u9451\u8CDE\u7528\u306F\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306A\u3057\u3067\u3001\u56FA\u5B9A\u4FA1\u683C\u307E\u305F\u306F\u4FA1\u683C\u5FDC\u76F8\u8AC7\u3067\u8CA9\u58F2\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uBE44\uB9E4\uD488 \uC804\uC6A9 \uAD7F\uC988\uB294 \uB9E4\uCD9C \uB85C\uC5F4\uD2F0 \uC5C6\uC774 \uACE0\uC815\uAC00 \uB610\uB294 \uAC00\uACA9 \uD611\uC758\uB85C \uD310\uB9E4\uD574 \uC8FC\uC138\uC694.": {
    en: "Sell not-for-sale merchandise at a fixed or negotiable price, without revenue royalties.",
    ja: "\u975E\u58F2\u54C1\u5C02\u7528\u30B0\u30C3\u30BA\u306F\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306A\u3057\u3067\u3001\u56FA\u5B9A\u4FA1\u683C\u307E\u305F\u306F\u4FA1\u683C\u5FDC\u76F8\u8AC7\u3067\u8CA9\u58F2\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC601\uC0C1 \uC0AC\uC6A9\uAD8C\uC5D0\uC11C\uB294 \uC0C1\uD488 \uD328\uD0A4\uC9C0 \uD45C\uAE30\uB97C \uC81C\uACF5\uD560 \uC218 \uC5C6\uC5B4\uC694. \uAE30\uC874 \uD328\uD0A4\uC9C0 \uC124\uC815\uC744 \uC81C\uAC70\uD574 \uC8FC\uC138\uC694.": {
    en: "Video usage rights can't offer product packaging credits. Remove the existing packaging setting.",
    ja: "\u6620\u50CF\u306E\u4F7F\u7528\u6A29\u3067\u306F\u5546\u54C1\u30D1\u30C3\u30B1\u30FC\u30B8\u8868\u8A18\u3092\u63D0\u4F9B\u3067\u304D\u307E\u305B\u3093\u3002\u65E2\u5B58\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u8A2D\u5B9A\u3092\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAD8C\uB9AC \uC885\uB958\uC640 \uC81C\uACF5 \uBC94\uC704\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.": {
    en: "The right type and the scope provided don't match.",
    ja: "\u6A29\u5229\u306E\u7A2E\u985E\u3068\u63D0\u4F9B\u7BC4\u56F2\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002"
  },
  "\uC774\uB984/\uBE0C\uB79C\uB4DC \uC0AC\uC6A9\uAD8C\uC740 \uC81C\uACF5 \uBC94\uC704 \uC124\uC815\uC774 \uD544\uC694\uD569\uB2C8\uB2E4": {
    en: "Name/brand usage rights need a scope",
    ja: "\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u306E\u4F7F\u7528\u6A29\u306B\u306F\u63D0\u4F9B\u7BC4\u56F2\u306E\u8A2D\u5B9A\u304C\u5FC5\u8981\u3067\u3059"
  },
  "\uC81C\uACF5 \uBC94\uC704\uB294 \uC774\uB984/\uBE0C\uB79C\uB4DC \uC0AC\uC6A9\uAD8C\uC5D0\uC11C\uB9CC \uC124\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4": {
    en: "A scope can only be set for name/brand usage rights",
    ja: "\u63D0\u4F9B\u7BC4\u56F2\u306F\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u306E\u4F7F\u7528\u6A29\u3067\u306E\u307F\u8A2D\u5B9A\u3067\u304D\u307E\u3059"
  },
  "\uAE30\uAC04\uC774 \uC911\uBCF5\uB429\uB2C8\uB2E4": {
    en: "Duplicate periods",
    ja: "\u671F\u9593\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059"
  },
  "\uAE30\uAC04 \uC5C6\uC74C(0) \uC635\uC158\uC740 \uB2E8\uB3C5\uC73C\uB85C\uB9CC \uC4F8 \uC218 \uC788\uC2B5\uB2C8\uB2E4": {
    en: "The no-period (0) option can only be used on its own",
    ja: "\u671F\u9593\u306A\u3057\uFF080\uFF09\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u306F\u5358\u72EC\u3067\u306E\u307F\u4F7F\u7528\u3067\u304D\u307E\u3059"
  },
  "\uB85C\uC5F4\uD2F0 %\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4": {
    en: "A royalty % is required",
    ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3%\u304C\u5FC5\u8981\u3067\u3059"
  },
  "\uB85C\uC5F4\uD2F0 \uC9C0\uAE09\uC77C(\uB9E4\uB2EC N\uC77C)\uC774 \uD544\uC694\uD569\uB2C8\uB2E4": {
    en: "A royalty payment day (day N of each month) is required",
    ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u652F\u6255\u65E5\uFF08\u6BCE\u6708N\u65E5\uFF09\u304C\u5FC5\u8981\u3067\u3059"
  },
  // '이미지는 2MB 이하로 올려 주세요' — 협찬과 같은 문구 (위)
  "\uC378\uB124\uC77C \uC774\uBBF8\uC9C0 \uD615\uC2DD\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694": {
    en: "The thumbnail image format is invalid",
    ja: "\u30B5\u30E0\u30CD\u30A4\u30EB\u753B\u50CF\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093"
  },
  "\uD55C \uC0C1\uD488\uC5D0\uB294 \uAD8C\uB9AC\uB9C8\uB2E4 \uC624\uD37C\uB97C \uD558\uB098\uB9CC \uB458 \uC218 \uC788\uC5B4\uC694.": {
    en: "A listing can have only one offer per right.",
    ja: "1\u3064\u306E\u5546\u54C1\u306B\u306F\u6A29\u5229\u3054\u3068\u306B\u30AA\u30D5\u30A1\u30FC\u30921\u3064\u3060\u3051\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002"
  },
  "\uC0AC\uC9C4\xB7\uC601\uC0C1\xB7\uC74C\uC131\uC758 \uC774\uC6A9 \uBAA9\uC801\uC740 \uD55C \uC0C1\uD488\uC5D0\uC11C \uB3D9\uC77C\uD574\uC57C \uD574\uC694. \uAC1C\uC778 \uAC10\uC0C1\uC6A9\uACFC \uC0AC\uC5C5\xB7\uD64D\uBCF4\uC6A9\uC740 \uBCC4\uB3C4 \uC0C1\uD488\uC73C\uB85C \uB4F1\uB85D\uD574 \uC8FC\uC138\uC694.": {
    en: "Photos, video and voice must have the same purpose within a listing. List personal use and business/promotional use as separate listings.",
    ja: "\u5199\u771F\u30FB\u6620\u50CF\u30FB\u97F3\u58F0\u306E\u5229\u7528\u76EE\u7684\u306F1\u3064\u306E\u5546\u54C1\u5185\u3067\u540C\u3058\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u500B\u4EBA\u9451\u8CDE\u7528\u3068\u4E8B\u696D\u30FB\u5E83\u5831\u7528\u306F\u5225\u306E\u5546\u54C1\u3068\u3057\u3066\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  // ── 굿즈 (merchandise-scope) — 선택 칸 이름이 들어간 문구 ──
  ...Object.fromEntries([
    merchandiseSelect("\uD310\uB9E4\xB7\uBC30\uD3EC \uBC29\uC2DD", "Select at least one sales or distribution method.", "\u8CA9\u58F2\u30FB\u914D\u5E03\u65B9\u5F0F\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
    merchandiseSelect("\uC81C\uC791 \uD488\uBAA9", "Select at least one product to make.", "\u88FD\u4F5C\u54C1\u76EE\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
    merchandiseSelect("\uC0AC\uC6A9\uD560 \uC694\uC18C", "Select at least one element to use.", "\u4F7F\u7528\u3059\u308B\u8981\u7D20\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
    merchandiseSelect("\uD310\uB9E4\xB7\uBC30\uD3EC \uACBD\uB85C", "Select at least one sales or distribution channel.", "\u8CA9\u58F2\u30FB\u914D\u5E03\u7D4C\u8DEF\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002")
  ]),
  // ── 출연 (appearance-scope) ──
  "\uAD6C\uC131 \uC774\uB984\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter a package name.",
    ja: "\u69CB\u6210\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uAE30\uAC04\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select how long the footage can be used.",
    ja: "\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u671F\u9593\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC77C\uC815 \uBCC0\uACBD\xB7\uCDE8\uC18C \uC870\uAC74\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter the rescheduling and cancellation terms.",
    ja: "\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u306E\u6761\u4EF6\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAC19\uC740 \uCD9C\uC5F0 \uBC29\uC2DD\uC744 \uC911\uBCF5 \uB4F1\uB85D\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "You can't add the same appearance type twice.",
    ja: "\u540C\u3058\u51FA\u6F14\u65B9\u5F0F\u3092\u91CD\u8907\u3057\u3066\u767B\u9332\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uC120\uD0DD\uD55C \uCD9C\uC5F0 \uBC29\uC2DD\uC5D0 \uB9DE\uB294 \uD65C\uB3D9\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select activities that fit the chosen appearance type.",
    ja: "\u9078\u629E\u3057\u305F\u51FA\u6F14\u65B9\u5F0F\u306B\u5408\u3046\u6D3B\u52D5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uD3EC\uD568\uD560 \uCD9C\uC5F0 \uD65C\uB3D9\uC744 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select at least one appearance activity to include.",
    ja: "\u542B\u3081\u308B\u51FA\u6F14\u6D3B\u52D5\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uD604\uC7A5 \uBC29\uBB38\uC5D0\uC11C\uB9CC \uAD6C\uC131\uC744 \uC124\uC815\uD560 \uC218 \uC788\uC5B4\uC694.": {
    en: "Packages can only be set for on-site visits.",
    ja: "\u69CB\u6210\u306F\u73FE\u5730\u8A2A\u554F\u3067\u306E\u307F\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002"
  },
  "\uAC19\uC740 \uAD6C\uC131\uC744 \uC911\uBCF5 \uB4F1\uB85D\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "You can't add the same package twice.",
    ja: "\u540C\u3058\u69CB\u6210\u3092\u91CD\u8907\u3057\u3066\u767B\u9332\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uAD6C\uC131 \uC774\uB984\uC744 \uC11C\uB85C \uB2E4\uB974\uAC8C \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Give each package a different name.",
    ja: "\u69CB\u6210\u540D\u306F\u305D\u308C\u305E\u308C\u7570\u306A\u308B\u540D\u524D\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAC01 \uAD6C\uC131\uC758 \uCD2C\uC601\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select the allowed filming and use for each package.",
    ja: "\u5404\u69CB\u6210\u306E\u64AE\u5F71\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAD6C\uC131\uBCC4 \uCD2C\uC601 \uC870\uAC74\uACFC \uAE30\uC874 \uD65C\uB3D9\uBCC4 \uC870\uAC74\uC744 \uD568\uAED8 \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "Package filming terms and per-activity terms can't be set together.",
    ja: "\u69CB\u6210\u3054\u3068\u306E\u64AE\u5F71\u6761\u4EF6\u3068\u65E2\u5B58\u306E\u6D3B\u52D5\u3054\u3068\u306E\u6761\u4EF6\u306F\u540C\u6642\u306B\u8A2D\u5B9A\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uAD6C\uC131\uBCC4 \uCD2C\uC601 \uD5C8\uC6A9 \uBC94\uC704\uC640 \uACF5\uAC1C \uC0AC\uC6A9 \uC870\uAC74\uC774 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.": {
    en: "The filming allowed for each package doesn't match the public use terms.",
    ja: "\u69CB\u6210\u3054\u3068\u306E\u64AE\u5F71\u8A31\u53EF\u7BC4\u56F2\u3068\u516C\u958B\u4F7F\u7528\u306E\u6761\u4EF6\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002"
  },
  "\uCD2C\uC601 \uAD6C\uC131\uC740 \uB0B4\uBD80 \uAE30\uB85D \uB610\uB294 \uACF5\uAC1C \uC0AC\uC6A9 \uC911 \uD5C8\uC6A9\uD560 \uBC94\uC704\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "For filmed packages, choose whether to allow internal records or public use.",
    ja: "\u64AE\u5F71\u3092\u542B\u3080\u69CB\u6210\u306F\u3001\u5185\u90E8\u8A18\u9332\u307E\u305F\u306F\u516C\u958B\u4F7F\u7528\u306E\u3046\u3061\u8A31\u53EF\u3059\u308B\u7BC4\u56F2\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC5F0\uC7A5 \uB2E8\uC704\uC640 \uCD94\uAC00\uAE08\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.": {
    en: "Check the extension unit and fee.",
    ja: "\u5EF6\u9577\u5358\u4F4D\u3068\u8FFD\u52A0\u6599\u91D1\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
  },
  "\uAC19\uC740 \uCD9C\uC5F0 \uD65C\uB3D9\uC744 \uC911\uBCF5 \uC120\uD0DD\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "You can't select the same appearance activity twice.",
    ja: "\u540C\u3058\u51FA\u6F14\u6D3B\u52D5\u3092\u91CD\u8907\u3057\u3066\u9078\u629E\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uAD50\uD1B5\xB7\uC219\uBC15\uBE44 \uC870\uAC74\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select the travel and accommodation terms.",
    ja: "\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u306E\u6761\u4EF6\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uBCC4\uB3C4 \uAD50\uD1B5\xB7\uC219\uBC15\uBE44\uC758 \uC0B0\uC815\xB7\uD569\uC758 \uAE30\uC900\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter how separate travel and accommodation costs are calculated and agreed.",
    ja: "\u5225\u9014\u306E\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u306E\u7B97\u5B9A\u30FB\u5408\u610F\u57FA\u6E96\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC628\uB77C\uC778 \uCC38\uC5EC\uC5D0\uB294 \uBC29\uBB38 \uC9C0\uC5ED\uACFC \uAD50\uD1B5\xB7\uC219\uBC15\uBE44\uB97C \uC124\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "Online participation can't have visit areas or travel and accommodation costs.",
    ja: "\u30AA\u30F3\u30E9\u30A4\u30F3\u53C2\u52A0\u306B\u306F\u8A2A\u554F\u5730\u57DF\u3084\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u3092\u8A2D\u5B9A\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uC2DC\uAC04 \uCD08\uACFC \uC2DC \uC801\uC6A9\uD560 \uB2E8\uC704\uC640 \uCD94\uAC00\uAE08\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.": {
    en: "Enter the unit and fee that apply when time runs over.",
    ja: "\u6642\u9593\u8D85\u904E\u6642\u306B\u9069\u7528\u3059\u308B\u5358\u4F4D\u3068\u8FFD\u52A0\u6599\u91D1\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uC815\uD574\uC9C4 \uCD94\uAC00\uAE08\uC73C\uB85C \uC5F0\uC7A5\uD560 \uB54C\uB9CC \uC5F0\uC7A5 \uAE08\uC561\uC744 \uC124\uC815\uD560 \uC218 \uC788\uC5B4\uC694.": {
    en: "You can set an extension fee only when extending for a set fee.",
    ja: "\u6C7A\u3081\u3089\u308C\u305F\u8FFD\u52A0\u6599\u91D1\u3067\u5EF6\u9577\u3059\u308B\u5834\u5408\u306E\u307F\u3001\u5EF6\u9577\u91D1\u984D\u3092\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002"
  },
  "\uAC19\uC740 \uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC704\uCE58\uB97C \uC911\uBCF5 \uC120\uD0DD\uD560 \uC218 \uC5C6\uC5B4\uC694.": {
    en: "You can't select the same footage placement twice.",
    ja: "\u540C\u3058\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u5834\u6240\u3092\u91CD\u8907\u3057\u3066\u9078\u629E\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
  },
  "\uC120\uD0DD\uD55C \uD65C\uB3D9\uB9C8\uB2E4 \uCD2C\uC601\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704\uB97C \uD558\uB098\uC529 \uC124\uC815\uD574 \uC8FC\uC138\uC694.": {
    en: "Set one allowed filming and use option for each selected activity.",
    ja: "\u9078\u629E\u3057\u305F\u6D3B\u52D5\u3054\u3068\u306B\u64AE\u5F71\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2\u30921\u3064\u305A\u3064\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uD65C\uB3D9\uBCC4 \uCD2C\uC601\xB7\uC0AC\uC6A9 \uBC94\uC704\uC640 \uACF5\uAC1C \uC0AC\uC6A9 \uC870\uAC74\uC774 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.": {
    en: "The filming and use for each activity doesn't match the public use terms.",
    ja: "\u6D3B\u52D5\u3054\u3068\u306E\u64AE\u5F71\u30FB\u4F7F\u7528\u7BC4\u56F2\u3068\u516C\u958B\u4F7F\u7528\u306E\u6761\u4EF6\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002"
  },
  "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC704\uCE58\uB97C 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "Select at least one footage placement.",
    ja: "\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u5834\u6240\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  "\uACF5\uAC1C \uC0AC\uC6A9\uC744 \uD5C8\uC6A9\uD560 \uB54C\uB9CC \uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC704\uCE58\xB7\uAE30\uAC04\uC744 \uC124\uC815\uD560 \uC218 \uC788\uC5B4\uC694.": {
    en: "You can set footage placements and periods only when public use is allowed.",
    ja: "\u516C\u958B\u4F7F\u7528\u3092\u8A31\u53EF\u3059\u308B\u5834\u5408\u306E\u307F\u3001\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u5834\u6240\u30FB\u671F\u9593\u3092\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002"
  },
  "\uCD2C\uC601 \uCD9C\uC5F0\uC744 \uD3EC\uD568\uD558\uBA74 \uB0B4\uBD80 \uAE30\uB85D \uB610\uB294 \uACF5\uAC1C \uC0AC\uC6A9 \uC911 \uD5C8\uC6A9\uD560 \uBC94\uC704\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.": {
    en: "If filmed appearances are included, choose whether to allow internal records or public use.",
    ja: "\u64AE\u5F71\u3092\u4F34\u3046\u51FA\u6F14\u3092\u542B\u3080\u5834\u5408\u306F\u3001\u5185\u90E8\u8A18\u9332\u307E\u305F\u306F\u516C\u958B\u4F7F\u7528\u306E\u3046\u3061\u8A31\u53EF\u3059\u308B\u7BC4\u56F2\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  }
};
var ZOD_FIXED_KEYS = [
  "required",
  "invalidType",
  "stringRequired",
  "tooSmall",
  "tooBig",
  "email",
  "url",
  "date",
  "invalidChoice",
  "invalidDate",
  "unknownKeys",
  "invalid"
];
var ZOD_NUMBER_PATTERNS = [
  [
    /^([\d,.]+)자 이상 입력해 주세요\.$/,
    "stringMin"
  ],
  [
    /^([\d,.]+)개 이상 선택해 주세요\.$/,
    "arrayMin"
  ],
  [
    /^(-?[\d,.]+) 이상이어야 해요\.$/,
    "numberMin"
  ],
  [
    /^(-?[\d,.]+)보다 커야 해요\.$/,
    "numberGt"
  ],
  [
    /^([\d,.]+)자 이하로 입력해 주세요\.$/,
    "stringMax"
  ],
  [
    /^([\d,.]+)개까지 선택할 수 있어요\.$/,
    "arrayMax"
  ],
  [
    /^(-?[\d,.]+) 이하여야 해요\.$/,
    "numberMax"
  ],
  [
    /^(-?[\d,.]+)보다 작아야 해요\.$/,
    "numberLt"
  ],
  [
    /^(-?[\d,.]+) 단위로 입력해 주세요\.$/,
    "multipleOf"
  ]
];
function localizeZodDefault(message, lang) {
  const ko = ZOD_MESSAGES.ko;
  const target = ZOD_MESSAGES[lang];
  for (const key of ZOD_FIXED_KEYS) if (ko[key] === message) return target[key];
  for (const [re, key] of ZOD_NUMBER_PATTERNS) {
    const m = re.exec(message);
    if (!m) continue;
    const n = Number(m[1].replace(/,/g, ""));
    if (!Number.isFinite(n)) continue;
    return target[key](n);
  }
  return void 0;
}
__name(localizeZodDefault, "localizeZodDefault");
var variantLabel = /* @__PURE__ */ __name((ko, lang) => {
  const key = Object.keys(APPEARANCE_VARIANT_LABELS_I18N.ko).find((k) => APPEARANCE_VARIANT_LABELS_I18N.ko[k] === ko);
  return key ? APPEARANCE_VARIANT_LABELS_I18N[lang][key] : void 0;
}, "variantLabel");
function localizeLine(line, lang) {
  if (Object.hasOwn(VALIDATION_MESSAGES_I18N, line)) return VALIDATION_MESSAGES_I18N[line][lang];
  const zodDefault = localizeZodDefault(line, lang);
  if (zodDefault) return zodDefault;
  const sep = line.indexOf(": ");
  if (sep > 0) {
    const head = line.slice(0, sep);
    const rest = localizeLine(line.slice(sep + 2), lang);
    return `${variantLabel(head, lang) ?? head}: ${rest}`;
  }
  return line;
}
__name(localizeLine, "localizeLine");
function localizeValidationMessage(message, lang) {
  if (lang === "ko" || !message) return message;
  return message.split("\n").map((line) => localizeLine(line, lang)).join("\n");
}
__name(localizeValidationMessage, "localizeValidationMessage");

// src/user/listing-form.ts
function defaultBrandScope() {
  return {
    assets: [
      {
        key: BrandAsset.KOREAN_NAME,
        addonAmount: 0
      }
    ],
    placements: [
      {
        key: UsagePlacement.BRAND_SOCIAL,
        addonAmount: 0
      }
    ],
    legalUses: []
  };
}
__name(defaultBrandScope, "defaultBrandScope");
function brandScopeIssue(offer, lang = DEFAULT_LANG) {
  if (!RIGHT_TYPE_FORM_CONFIG[offer.rightType].brandScope) return null;
  const scope = offer.brandScope;
  if (!scope) return tr(lang, {
    ko: "\uC81C\uACF5 \uBC94\uC704 \uC124\uC815\uC774 \uD544\uC694\uD574\uC694",
    en: "Set the scope provided",
    ja: "\u63D0\u4F9B\u7BC4\u56F2\u306E\u8A2D\u5B9A\u304C\u5FC5\u8981\u3067\u3059"
  });
  if (!scope.assets.length) return tr(lang, {
    ko: "\uD45C\uAE30\xB7\uC790\uC0B0\uC744 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694",
    en: "Select at least one credit or asset",
    ja: "\u8868\u8A18\u30FB\u7D20\u6750\u30921\u3064\u4EE5\u4E0A\u9078\u3093\u3067\u304F\u3060\u3055\u3044"
  });
  if (!scope.placements.length) return tr(lang, {
    ko: "\uC0AC\uC6A9 \uC704\uCE58\uB97C 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694",
    en: "Select at least one placement",
    ja: "\u4F7F\u7528\u5834\u6240\u30921\u3064\u4EE5\u4E0A\u9078\u3093\u3067\u304F\u3060\u3055\u3044"
  });
  return null;
}
__name(brandScopeIssue, "brandScopeIssue");
function defaultOffer(rightType) {
  const config = RIGHT_TYPE_FORM_CONFIG[rightType];
  if (rightType === IpRightType4.APPEARANCE) {
    const scope = defaultAppearanceScope();
    return {
      ...defaultOfferBase(rightType, config),
      durationOptions: [
        {
          months: 0,
          fixedAmount: 1e5
        }
      ],
      usageScope: withAppearancePackages(scope, [
        {
          id: "onsite-default",
          title: "",
          durationMinutes: scope.durationMinutes,
          fixedAmount: 1e5,
          overtimePolicy: scope.overtimePolicy
        }
      ])
    };
  }
  return defaultOfferBase(rightType, config);
}
__name(defaultOffer, "defaultOffer");
function defaultOfferBase(rightType, config) {
  return {
    rightType,
    // 기간 개념이 없는 권리(출연권)는 months=0 단일 옵션
    durationOptions: config.duration ? [
      {
        months: 3,
        fixedAmount: 0
      }
    ] : [
      {
        months: 0,
        fixedAmount: 0
      }
    ],
    region: UsageRegion.DOMESTIC,
    exclusivity: Exclusivity.NON_EXCLUSIVE,
    modificationRights: [],
    requiresPreApproval: rightType === "MERCHANDISE" || rightType === "CO_BRANDING" || rightType === "APPEARANCE",
    forbiddenIndustries: [
      ForbiddenIndustry.GAMBLING,
      ForbiddenIndustry.ADULT,
      ForbiddenIndustry.POLITICS
    ],
    pricingModel: config.pricingModels[0] ?? PricingModel.FIXED,
    royaltyRateBp: null,
    royaltyPaymentDay: null,
    violationPolicies: [
      ViolationPolicy.SUSPEND_USE
    ],
    brandScope: config.brandScope ? defaultBrandScope() : null,
    usageScope: defaultUsageScope(rightType)
  };
}
__name(defaultOfferBase, "defaultOfferBase");
function toFormOffers(initial) {
  return initial?.offers.map((o) => ({
    id: o.id,
    status: o.status,
    rightType: o.rightType,
    durationOptions: o.durationOptions.map((d) => ({
      months: d.months,
      fixedAmount: d.fixedAmount
    })),
    usageScope: o.usageScope ?? null,
    region: o.region,
    exclusivity: o.exclusivity,
    modificationRights: o.modificationRights,
    requiresPreApproval: o.requiresPreApproval,
    forbiddenIndustries: o.forbiddenIndustries,
    pricingModel: o.pricingModel,
    royaltyRateBp: o.royaltyRateBp,
    royaltyPaymentDay: o.royaltyPaymentDay,
    violationPolicies: o.violationPolicies,
    // 범위 도입 전 기존 오퍼는 기본 범위로 채워 편집 (저장 시부터 범위가 계약에 명시됨)
    brandScope: o.brandScope ?? (RIGHT_TYPE_FORM_CONFIG[o.rightType].brandScope ? defaultBrandScope() : null)
  })) ?? [];
}
__name(toFormOffers, "toFormOffers");
function normalizeOfferDraft(draft) {
  const normalize = /* @__PURE__ */ __name((offer) => {
    if (offer.usageScope?.kind === "APPEARANCE") {
      const strip = /* @__PURE__ */ __name((value) => {
        const { leadDays: _days, preparation: _preparation, ...current } = value;
        return current;
      }, "strip");
      const scope2 = strip(offer.usageScope);
      return {
        ...offer,
        usageScope: {
          ...scope2,
          variants: scope2.variants?.map(strip)
        }
      };
    }
    if (offer.usageScope?.kind !== "CO_BRANDING") return offer;
    const { expressions: _legacy, brandCount: _brands, guidelines: _guidelines, ...scope } = offer.usageScope;
    return {
      ...offer,
      usageScope: {
        ...scope,
        campaignPricing: "PER_CAMPAIGN",
        campaignCount: 1
      }
    };
  }, "normalize");
  return {
    offers: draft.offers.filter((offer) => offer.id || ACTIVE_IP_RIGHT_TYPES4.includes(offer.rightType)).map(normalize),
    removed: Object.fromEntries(Object.entries(draft.removed).filter(([, offer]) => offer.id || ACTIVE_IP_RIGHT_TYPES4.includes(offer.rightType)).map(([key, offer]) => [
      key,
      normalize(offer)
    ]))
  };
}
__name(normalizeOfferDraft, "normalizeOfferDraft");
var listJoin = /* @__PURE__ */ __name((lang) => lang === "ja" ? "\u3001" : ", ", "listJoin");
var NONE = {
  ko: "\uC5C6\uC74C",
  en: "None",
  ja: "\u306A\u3057"
};
var NEGOTIABLE = {
  ko: "\uAC00\uACA9 \uD611\uC758",
  en: "Price negotiable",
  ja: "\u4FA1\u683C\u5FDC\u76F8\u8AC7"
};
var REVENUE_ROYALTY = {
  ko: "\uB9E4\uCD9C \uB85C\uC5F4\uD2F0",
  en: "Revenue royalty",
  ja: "\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3"
};
var money = /* @__PURE__ */ __name((value, lang) => value == null ? NEGOTIABLE[lang] : formatWon(value, lang), "money");
var labels = /* @__PURE__ */ __name((values, dictionary, lang) => [
  ...values
].sort().map((value) => dictionary[value] ?? value).join(listJoin(lang)) || NONE[lang], "labels");
function describeOffer(offer, lang) {
  const join = listJoin(lang);
  const scope = /* @__PURE__ */ __name((group, dictionary) => [
    ...offer.brandScope?.[group] ?? []
  ].sort((a, b) => a.key.localeCompare(b.key)).map((item) => `${dictionary[item.key]}: ${item.addonAmount === 0 ? tr(lang, {
    ko: "\uAE30\uBCF8\uAC00 \uD3EC\uD568",
    en: "Included in base price",
    ja: "\u57FA\u672C\u4FA1\u683C\u306B\u542B\u3080"
  }) : monthlyAddonLabel(item.addonAmount, lang)}`).join(join) || tr(lang, {
    ko: "\uBBF8\uC81C\uACF5",
    en: "Not provided",
    ja: "\u63D0\u4F9B\u3057\u306A\u3044"
  }), "scope");
  const months = /* @__PURE__ */ __name((m) => m ? tr(lang, {
    ko: `${m}\uAC1C\uC6D4`,
    en: m === 1 ? "1 month" : `${m} months`,
    ja: `${m}\u304B\u6708`
  }) : tr(lang, {
    ko: "1\uD68C",
    en: "One-time",
    ja: "1\u56DE"
  }), "months");
  const L = /* @__PURE__ */ __name((text) => text[lang], "L");
  const terms = {
    [L({
      ko: "\uAE30\uAC04\xB7\uAC00\uACA9",
      en: "Period & price",
      ja: "\u671F\u9593\u30FB\u4FA1\u683C"
    })]: [
      ...offer.durationOptions
    ].sort((a, b) => a.months - b.months).map((item) => `${months(item.months)} / ${offer.pricingModel === PricingModel.REVENUE_SHARE ? REVENUE_ROYALTY[lang] : money(item.fixedAmount, lang)}`).join(join) || L({
      ko: "\uAE30\uAC04 \uC120\uD0DD \uD544\uC694",
      en: "Choose a period",
      ja: "\u671F\u9593\u306E\u9078\u629E\u304C\u5FC5\u8981"
    }),
    [RIGHT_TYPE_REGION_LABELS_I18N[lang][offer.rightType]]: USAGE_REGION_LABELS_I18N[lang][offer.region],
    [L({
      ko: "\uB3C5\uC810 \uC5EC\uBD80",
      en: "Exclusivity",
      ja: "\u72EC\u5360\u306E\u6709\u7121"
    })]: EXCLUSIVITY_LABELS_I18N[lang][offer.exclusivity],
    [L({
      ko: "\uC218\uC815 \uAC00\uB2A5 \uC5EC\uBD80",
      en: "Modifications allowed",
      ja: "\u6539\u5909\u306E\u53EF\u5426"
    })]: labels(offer.modificationRights, MODIFICATION_RIGHT_LABELS_I18N[lang], lang),
    [L({
      ko: "\uC0AC\uC804 \uC2B9\uC778",
      en: "Pre-approval",
      ja: "\u4E8B\u524D\u627F\u8A8D"
    })]: offer.requiresPreApproval ? L({
      ko: "\uD544\uC694",
      en: "Required",
      ja: "\u5FC5\u8981"
    }) : L({
      ko: "\uBD88\uD544\uC694",
      en: "Not required",
      ja: "\u4E0D\u8981"
    }),
    [L({
      ko: "\uAE08\uC9C0 \uC5C5\uC885",
      en: "Prohibited industries",
      ja: "\u7981\u6B62\u696D\u7A2E"
    })]: [
      ...offer.forbiddenIndustries
    ].map((value) => forbiddenIndustryLabel(value, lang)).sort().join(join) || NONE[lang],
    [L({
      ko: "\uAC00\uACA9 \uBC29\uC2DD",
      en: "Pricing model",
      ja: "\u4FA1\u683C\u65B9\u5F0F"
    })]: PRICING_MODEL_LABELS_I18N[lang][offer.pricingModel],
    [REVENUE_ROYALTY[lang]]: offer.royaltyRateBp == null ? NONE[lang] : `${offer.royaltyRateBp / 100}%`,
    [L({
      ko: "\uB85C\uC5F4\uD2F0 \uC9C0\uAE09\uC77C",
      en: "Royalty payment day",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u652F\u6255\u65E5"
    })]: offer.royaltyPaymentDay == null ? L({
      ko: "\uBBF8\uC124\uC815",
      en: "Not set",
      ja: "\u672A\u8A2D\u5B9A"
    }) : L({
      ko: `\uB9E4\uB2EC ${offer.royaltyPaymentDay}\uC77C`,
      en: `Day ${offer.royaltyPaymentDay} of each month`,
      ja: `\u6BCE\u6708${offer.royaltyPaymentDay}\u65E5`
    }),
    [L({
      ko: "\uC704\uBC18 \uC2DC \uC870\uCE58",
      en: "Actions on violation",
      ja: "\u9055\u53CD\u6642\u306E\u63AA\u7F6E"
    })]: labels(offer.violationPolicies, VIOLATION_POLICY_LABELS_I18N[lang], lang),
    // 제공 범위는 이름/브랜드 권리만 — 다른 권리의 세부 조건 줄(사용 위치 등)과 이름이 겹치지 않게
    ...offer.brandScope && {
      [L({
        ko: "\uC81C\uACF5 \uD45C\uAE30\xB7\uC790\uC0B0",
        en: "Credits & assets provided",
        ja: "\u63D0\u4F9B\u3059\u308B\u8868\u8A18\u30FB\u7D20\u6750"
      })]: scope("assets", BRAND_ASSET_LABELS_I18N[lang]),
      [L({
        ko: "\uC0AC\uC6A9 \uC704\uCE58",
        en: "Placements",
        ja: "\u4F7F\u7528\u5834\u6240"
      })]: scope("placements", USAGE_PLACEMENT_LABELS_I18N[lang]),
      [L({
        ko: "\uC0C1\uD638\xB7\uC0C1\uD45C \uD5C8\uC6A9",
        en: "Business name & trademark use",
        ja: "\u5546\u53F7\u30FB\u5546\u6A19\u306E\u8A31\u53EF"
      })]: scope("legalUses", BRAND_LEGAL_USE_LABELS_I18N[lang])
    }
  };
  const detail = L({
    ko: "\uC138\uBD80 \uC0AC\uC6A9 \uC870\uAC74",
    en: "Detailed usage terms",
    ja: "\u8A73\u7D30\u306A\u4F7F\u7528\u6761\u4EF6"
  });
  if (!offer.usageScope) terms[detail] = L({
    ko: "\uAE30\uC874 \uC870\uAC74 \uC720\uC9C0",
    en: "Keep existing terms",
    ja: "\u65E2\u5B58\u306E\u6761\u4EF6\u3092\u7DAD\u6301"
  });
  else for (const row of usageScopeRows(offer.usageScope, lang)) terms[row.label in terms ? `${detail} \xB7 ${row.label}` : row.label] = row.value;
  return terms;
}
__name(describeOffer, "describeOffer");
function getOfferChanges(before, after, lang = DEFAULT_LANG) {
  const previous = describeOffer(before, lang);
  const next = describeOffer(after, lang);
  return [
    .../* @__PURE__ */ new Set([
      ...Object.keys(next),
      ...Object.keys(previous)
    ])
  ].flatMap((label) => previous[label] === next[label] ? [] : [
    {
      label,
      before: previous[label] ?? NONE[lang],
      after: next[label] ?? NONE[lang]
    }
  ]);
}
__name(getOfferChanges, "getOfferChanges");
function priceIssue(amount, rightType, lang) {
  return {
    message: amount === 0 ? tr(lang, {
      ko: "\uAC00\uACA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Please enter a price.",
      ja: "\u4FA1\u683C\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }) : amount > 1e9 ? tr(lang, {
      ko: "\uAC00\uACA9\uC740 10\uC5B5 \uC6D0 \uC774\uD558\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter a price of \u20A91,000,000,000 or less.",
      ja: "\u4FA1\u683C\u306F10\u5104\u30A6\u30A9\u30F3\u4EE5\u4E0B\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }) : tr(lang, {
      ko: "\uAC00\uACA9\uC740 1,000\uC6D0 \uC774\uC0C1\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter a price of \u20A91,000 or more.",
      ja: "\u4FA1\u683C\u306F1,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }),
    field: rightType === "APPEARANCE" ? "usageScope.fixedAmount" : "durationOptions.fixedAmount"
  };
}
__name(priceIssue, "priceIssue");
var FIELD_LABELS = {
  ko: {
    durationOptions: "\uC0AC\uC6A9 \uAE30\uAC04\xB7\uAC00\uACA9",
    region: "\uC0AC\uC6A9 \uC9C0\uC5ED",
    exclusivity: "\uB3C5\uC810 \uC5EC\uBD80",
    modificationRights: "\uC218\uC815 \uAC00\uB2A5 \uC5EC\uBD80",
    forbiddenIndustries: "\uAE08\uC9C0 \uC5C5\uC885",
    pricingModel: "\uAC00\uACA9 \uBC29\uC2DD",
    royaltyRateBp: "\uB9E4\uCD9C \uB85C\uC5F4\uD2F0",
    royaltyPaymentDay: "\uB85C\uC5F4\uD2F0 \uC9C0\uAE09\uC77C",
    violationPolicies: "\uC704\uBC18 \uC2DC \uC870\uCE58",
    brandScope: "\uC81C\uACF5 \uBC94\uC704",
    usageScope: "\uC0AC\uC6A9 \uBC94\uC704\xB7\uAC00\uACA9 \uAE30\uC900"
  },
  en: {
    durationOptions: "Usage period & price",
    region: "Usage region",
    exclusivity: "Exclusivity",
    modificationRights: "Modifications allowed",
    forbiddenIndustries: "Prohibited industries",
    pricingModel: "Pricing model",
    royaltyRateBp: "Revenue royalty",
    royaltyPaymentDay: "Royalty payment day",
    violationPolicies: "Actions on violation",
    brandScope: "Scope provided",
    usageScope: "Usage scope & price basis"
  },
  ja: {
    durationOptions: "\u4F7F\u7528\u671F\u9593\u30FB\u4FA1\u683C",
    region: "\u4F7F\u7528\u5730\u57DF",
    exclusivity: "\u72EC\u5360\u306E\u6709\u7121",
    modificationRights: "\u6539\u5909\u306E\u53EF\u5426",
    forbiddenIndustries: "\u7981\u6B62\u696D\u7A2E",
    pricingModel: "\u4FA1\u683C\u65B9\u5F0F",
    royaltyRateBp: "\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3",
    royaltyPaymentDay: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u652F\u6255\u65E5",
    violationPolicies: "\u9055\u53CD\u6642\u306E\u63AA\u7F6E",
    brandScope: "\u63D0\u4F9B\u7BC4\u56F2",
    usageScope: "\u4F7F\u7528\u7BC4\u56F2\u30FB\u4FA1\u683C\u57FA\u6E96"
  }
};
var USAGE_FIELD_LABELS = {
  ko: {
    activities: "\uD3EC\uD568\uD560 \uCD9C\uC5F0 \uD65C\uB3D9",
    onsitePackages: "\uD604\uC7A5 \uBC29\uBB38 \uAD6C\uC131\uC758 \uC774\uB984\xB7\uC2DC\uAC04\xB7\uAC00\uACA9",
    durationMinutes: "\uAE30\uBCF8 \uCD9C\uC5F0 \uC2DC\uAC04",
    serviceArea: "\uBC29\uBB38 \uAC00\uB2A5 \uC9C0\uC5ED",
    travelPolicy: "\uAD50\uD1B5\xB7\uC219\uBC15\uBE44 \uC870\uAC74",
    travelNotes: "\uAD50\uD1B5\xB7\uC219\uBC15\uBE44 \uC0B0\uC815 \uAE30\uC900",
    overtimePolicy: "\uC2DC\uAC04 \uCD08\uACFC \uC870\uAC74",
    overtimeUnitMinutes: "\uC5F0\uC7A5 \uB2E8\uC704",
    overtimeAmount: "\uC5F0\uC7A5 \uCD94\uAC00\uAE08",
    recordingPolicy: "\uCD9C\uC5F0 \uBAA8\uC2B5\uC758 \uCD2C\uC601\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704",
    activityRecordings: "\uD65C\uB3D9\uBCC4 \uCD2C\uC601\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704",
    recordingMonths: "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uAE30\uAC04",
    cancellationNotes: "\uC77C\uC815 \uBCC0\uACBD\xB7\uCDE8\uC18C \uC870\uAC74",
    brandName: "\uC0AC\uC6A9\uD560 \uC774\uB984\xB7\uBE0C\uB79C\uB4DC",
    expressions: "\uD5C8\uC6A9\uD558\uB294 \uD45C\uD604",
    distributionModes: "\uD310\uB9E4\xB7\uBC30\uD3EC \uBC29\uC2DD",
    products: "\uC81C\uC791 \uD488\uBAA9",
    otherProduct: "\uAE30\uD0C0 \uC81C\uC791 \uD488\uBAA9",
    campaignCount: "\uACF5\uB3D9 \uCEA0\uD398\uC778 \uCD1D\uAC74\uC218",
    expiryPolicy: "\uAE30\uAC04 \uC885\uB8CC \uD6C4 \uCC98\uB9AC",
    distributionChannels: "\uD310\uB9E4\xB7\uBC30\uD3EC \uACBD\uB85C",
    additionalProduction: "\uCD94\uAC00 \uC81C\uC791 \uC870\uAC74",
    sampleApprovalRequired: "\uC0D8\uD50C \uC2B9\uC778",
    inventoryPolicy: "\uAE30\uAC04 \uC885\uB8CC \uD6C4 \uC7AC\uACE0",
    sellOffDays: "\uAE30\uC874 \uC7AC\uACE0 \uC815\uB9AC \uAE30\uAC04",
    purpose: "\uC774\uC6A9 \uBAA9\uC801",
    mode: "\uC74C\uC131 \uC0AC\uC6A9 \uBC29\uC2DD",
    source: "\uC74C\uC131 \uC81C\uC791 \uBC29\uC2DD",
    totalSeconds: "\uC804\uCCB4 \uC74C\uC131\uC758 \uCD1D\uAE38\uC774",
    production: "\uC74C\uC131 \uC81C\uC791 \uC870\uAC74",
    generation: "AI \uC74C\uC131 \uC0DD\uC131 \uC870\uAC74",
    channels: "\uC0AC\uC6A9\uCC98",
    distributionChannelAddons: "\uD310\uB9E4\xB7\uBC30\uD3EC \uACBD\uB85C \uCD94\uAC00\uAE08",
    adultUsage: "\uC131\uC778 \uC5C5\uC885 \uCD94\uAC00\uAE08",
    channelAddons: "\uC0AC\uC6A9\uCC98 \uCD94\uAC00\uAE08",
    guidelines: "\uC0AC\uC6A9\xB7\uD45C\uAE30 \uAC00\uC774\uB4DC",
    delivery: "\uD30C\uC77C \uC81C\uACF5 \uBC29\uC2DD",
    rights: "\uAD8C\uB9AC \uD655\uC778\xB7\uC81C\uC678 \uBC94\uC704"
  },
  en: {
    activities: "Appearance activities to include",
    onsitePackages: "On-site package name, time and price",
    durationMinutes: "Base appearance time",
    serviceArea: "Areas you can visit",
    travelPolicy: "Travel and lodging terms",
    travelNotes: "Travel and lodging cost basis",
    overtimePolicy: "Overtime terms",
    overtimeUnitMinutes: "Extension unit",
    overtimeAmount: "Extension fee",
    recordingPolicy: "Filming and use allowed for the appearance",
    activityRecordings: "Filming and use allowed per activity",
    recordingMonths: "Footage usage period",
    cancellationNotes: "Schedule change and cancellation terms",
    brandName: "Name or brand to use",
    expressions: "Allowed expressions",
    distributionModes: "Sales and distribution method",
    products: "Products to make",
    otherProduct: "Other product",
    campaignCount: "Total number of joint campaigns",
    expiryPolicy: "After the period ends",
    distributionChannels: "Sales and distribution channels",
    additionalProduction: "Additional production terms",
    sampleApprovalRequired: "Sample approval",
    inventoryPolicy: "Stock after the period ends",
    sellOffDays: "Sell-off period for existing stock",
    purpose: "Purpose of use",
    mode: "Voice usage type",
    source: "Voice production method",
    totalSeconds: "Total voice length",
    production: "Voice production terms",
    generation: "AI voice generation terms",
    channels: "Placements included in the base price",
    distributionChannelAddons: "Add-on fees for sales and distribution channels",
    adultUsage: "Adult industry add-on fee",
    channelAddons: "Placement add-on fees",
    guidelines: "Usage and credit guide",
    delivery: "File delivery method",
    rights: "Rights check and exclusions"
  },
  ja: {
    activities: "\u542B\u3081\u308B\u51FA\u6F14\u6D3B\u52D5",
    onsitePackages: "\u73FE\u5730\u8A2A\u554F\u306E\u69CB\u6210\u306E\u540D\u524D\u30FB\u6642\u9593\u30FB\u4FA1\u683C",
    durationMinutes: "\u57FA\u672C\u51FA\u6F14\u6642\u9593",
    serviceArea: "\u8A2A\u554F\u53EF\u80FD\u306A\u5730\u57DF",
    travelPolicy: "\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u306E\u6761\u4EF6",
    travelNotes: "\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u306E\u7B97\u5B9A\u57FA\u6E96",
    overtimePolicy: "\u6642\u9593\u8D85\u904E\u306E\u6761\u4EF6",
    overtimeUnitMinutes: "\u5EF6\u9577\u5358\u4F4D",
    overtimeAmount: "\u5EF6\u9577\u8FFD\u52A0\u6599\u91D1",
    recordingPolicy: "\u51FA\u6F14\u306E\u69D8\u5B50\u306E\u64AE\u5F71\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2",
    activityRecordings: "\u6D3B\u52D5\u3054\u3068\u306E\u64AE\u5F71\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2",
    recordingMonths: "\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u671F\u9593",
    cancellationNotes: "\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u306E\u6761\u4EF6",
    brandName: "\u4F7F\u7528\u3059\u308B\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9",
    expressions: "\u8A31\u53EF\u3059\u308B\u8868\u73FE",
    distributionModes: "\u8CA9\u58F2\u30FB\u914D\u5E03\u65B9\u5F0F",
    products: "\u5236\u4F5C\u54C1\u76EE",
    otherProduct: "\u305D\u306E\u4ED6\u306E\u5236\u4F5C\u54C1\u76EE",
    campaignCount: "\u5171\u540C\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u306E\u7DCF\u4EF6\u6570",
    expiryPolicy: "\u671F\u9593\u7D42\u4E86\u5F8C\u306E\u6271\u3044",
    distributionChannels: "\u8CA9\u58F2\u30FB\u914D\u5E03\u7D4C\u8DEF",
    additionalProduction: "\u8FFD\u52A0\u5236\u4F5C\u306E\u6761\u4EF6",
    sampleApprovalRequired: "\u30B5\u30F3\u30D7\u30EB\u627F\u8A8D",
    inventoryPolicy: "\u671F\u9593\u7D42\u4E86\u5F8C\u306E\u5728\u5EAB",
    sellOffDays: "\u65E2\u5B58\u5728\u5EAB\u306E\u6574\u7406\u671F\u9593",
    purpose: "\u5229\u7528\u76EE\u7684",
    mode: "\u97F3\u58F0\u306E\u4F7F\u7528\u65B9\u5F0F",
    source: "\u97F3\u58F0\u306E\u5236\u4F5C\u65B9\u5F0F",
    totalSeconds: "\u97F3\u58F0\u5168\u4F53\u306E\u5408\u8A08\u306E\u9577\u3055",
    production: "\u97F3\u58F0\u5236\u4F5C\u306E\u6761\u4EF6",
    generation: "AI\u97F3\u58F0\u751F\u6210\u306E\u6761\u4EF6",
    channels: "\u57FA\u672C\u4FA1\u683C\u306B\u542B\u307E\u308C\u308B\u4F7F\u7528\u5148",
    distributionChannelAddons: "\u8CA9\u58F2\u30FB\u914D\u5E03\u7D4C\u8DEF\u306E\u8FFD\u52A0\u6599\u91D1",
    adultUsage: "\u6210\u4EBA\u5411\u3051\u696D\u7A2E\u306E\u8FFD\u52A0\u6599\u91D1",
    channelAddons: "\u4F7F\u7528\u5148\u306E\u8FFD\u52A0\u6599\u91D1",
    guidelines: "\u4F7F\u7528\u30FB\u8868\u8A18\u30AC\u30A4\u30C9",
    delivery: "\u30D5\u30A1\u30A4\u30EB\u306E\u63D0\u4F9B\u65B9\u6CD5",
    rights: "\u6A29\u5229\u78BA\u8A8D\u30FB\u9664\u5916\u7BC4\u56F2"
  }
};
function includedQuantityLabel(rightType, lang) {
  if (rightType === "MERCHANDISE") return tr(lang, {
    ko: "\uD5C8\uC6A9\uD558\uB294 \uCD1D \uC81C\uC791 \uC218\uB7C9",
    en: "Total production quantity allowed",
    ja: "\u8A31\u53EF\u3059\u308B\u7DCF\u5236\u4F5C\u6570\u91CF"
  });
  if (rightType === "FACE_PHOTO") return tr(lang, {
    ko: "\uAE30\uBCF8 \uAC00\uACA9\uC5D0 \uD3EC\uD568\uB418\uB294 \uC0AC\uC9C4 \uC218",
    en: "Photos included in the base price",
    ja: "\u57FA\u672C\u4FA1\u683C\u306B\u542B\u307E\u308C\u308B\u5199\u771F\u6570"
  });
  if (rightType === "AI_VOICE") return tr(lang, {
    ko: "\uAE30\uBCF8 \uAC00\uACA9\uC5D0 \uD3EC\uD568\uB418\uB294 \uC74C\uC131 \uC218",
    en: "Voice clips included in the base price",
    ja: "\u57FA\u672C\u4FA1\u683C\u306B\u542B\u307E\u308C\u308B\u97F3\u58F0\u6570"
  });
  return tr(lang, {
    ko: "\uAE30\uBCF8 \uAC00\uACA9\uC5D0 \uD3EC\uD568\uB418\uB294 \uCF58\uD150\uCE20 \uC218",
    en: "Content items included in the base price",
    ja: "\u57FA\u672C\u4FA1\u683C\u306B\u542B\u307E\u308C\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u6570"
  });
}
__name(includedQuantityLabel, "includedQuantityLabel");
var checkLabel = /* @__PURE__ */ __name((label, lang) => tr(lang, {
  ko: `${josa2(label, "\uC744", "\uB97C")} \uD655\uC778\uD574 \uC8FC\uC138\uC694.`,
  en: `Please check \u201C${label}\u201D.`,
  ja: `\u300C${label}\u300D\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002`
}), "checkLabel");
var selectOneOrMore = /* @__PURE__ */ __name((label, lang) => tr(lang, {
  ko: `${josa2(label, "\uC744", "\uB97C")} 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.`,
  en: `Select at least one option for \u201C${label}\u201D.`,
  ja: `\u300C${label}\u300D\u30921\u3064\u4EE5\u4E0A\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002`
}), "selectOneOrMore");
var wholeNumber = /* @__PURE__ */ __name((label, max, lang) => tr(lang, {
  ko: `${josa2(label, "\uC744", "\uB97C")} 1~${max} \uC0AC\uC774\uC758 \uC815\uC218\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`,
  en: `Enter \u201C${label}\u201D as a whole number from 1 to ${max}.`,
  ja: `\u300C${label}\u300D\u30921\u301C${max}\u306E\u6574\u6570\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
}), "wholeNumber");
function getOfferIssueDetails(offer, lang = DEFAULT_LANG) {
  const result = listingOfferInputSchema.safeParse(offer);
  const fieldLabels = FIELD_LABELS[lang];
  const usageFieldLabels = {
    ...USAGE_FIELD_LABELS[lang],
    includedQuantity: includedQuantityLabel(offer.rightType, lang),
    assets: offer.rightType === "CO_BRANDING" ? tr(lang, {
      ko: "\uD568\uAED8 \uD45C\uC2DC\uD560 \uBE0C\uB79C\uB4DC \uC694\uC18C",
      en: "Brand elements to show together",
      ja: "\u4F75\u8A18\u3059\u308B\u30D6\u30E9\u30F3\u30C9\u8981\u7D20"
    }) : tr(lang, {
      ko: "\uC0AC\uC6A9\uD560 \uC694\uC18C",
      en: "Elements to use",
      ja: "\u4F7F\u7528\u3059\u308B\u8981\u7D20"
    })
  };
  const usageIssue = /* @__PURE__ */ __name((key, issue) => {
    const label = usageFieldLabels[key] ?? tr(lang, {
      ko: "\uC138\uBD80 \uC0AC\uC6A9 \uC870\uAC74",
      en: "Detailed usage terms",
      ja: "\u8A73\u7D30\u306A\u4F7F\u7528\u6761\u4EF6"
    });
    let message = checkLabel(label, lang);
    if (issue.code === "custom") message = localizeValidationMessage(issue.message, lang);
    else if (key === "brandName") message = issue.code === "too_big" ? tr(lang, {
      ko: "\uC0AC\uC6A9\uD560 \uC774\uB984\xB7\uBE0C\uB79C\uB4DC\uB97C 200\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter the name or brand to use in 200 characters or fewer.",
      ja: "\u4F7F\u7528\u3059\u308B\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u3092200\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }) : tr(lang, {
      ko: "\uC0AC\uC6A9\uD560 \uC774\uB984\xB7\uBE0C\uB79C\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter the name or brand to use.",
      ja: "\u4F7F\u7528\u3059\u308B\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "activities") message = tr(lang, {
      ko: "\uD3EC\uD568\uD560 \uCD9C\uC5F0 \uD65C\uB3D9\uC744 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.",
      en: "Select at least one appearance activity to include.",
      ja: "\u542B\u3081\u308B\u51FA\u6F14\u6D3B\u52D5\u30921\u3064\u4EE5\u4E0A\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "cancellationNotes") message = tr(lang, {
      ko: "\uC77C\uC815 \uBCC0\uACBD\xB7\uCDE8\uC18C \uC870\uAC74\uC744 1~1,000\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter the schedule change and cancellation terms in 1\u20131,000 characters.",
      ja: "\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u306E\u6761\u4EF6\u30921\u301C1,000\u6587\u5B57\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "durationMinutes") message = tr(lang, {
      ko: "\uAE30\uBCF8 \uCD9C\uC5F0 \uC2DC\uAC04\uC744 15~1,440\uBD84 \uC0AC\uC774\uC758 15\uBD84 \uB2E8\uC704\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter a base appearance time of 15\u20131,440 minutes, in 15-minute steps.",
      ja: "\u57FA\u672C\u51FA\u6F14\u6642\u9593\u309215\u301C1,440\u5206\u306E\u9593\u3067\u300115\u5206\u5358\u4F4D\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "overtimeAmount") message = tr(lang, {
      ko: "\uC5F0\uC7A5 \uCD94\uAC00\uAE08\uC744 1,000\uC6D0 \uC774\uC0C1\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter an extension fee of \u20A91,000 or more.",
      ja: "\u5EF6\u9577\u8FFD\u52A0\u6599\u91D1\u30921,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "expressions") message = tr(lang, {
      ko: "\uD5C8\uC6A9\uD558\uB294 \uD45C\uD604\uC744 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.",
      en: "Select at least one allowed expression.",
      ja: "\u8A31\u53EF\u3059\u308B\u8868\u73FE\u30921\u3064\u4EE5\u4E0A\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "campaignCount") message = wholeNumber(label, "100", lang);
    else if (key === "channels") message = tr(lang, {
      ko: "\uC0AC\uC6A9\uCC98\uB97C 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.",
      en: "Select at least one use.",
      ja: "\u4F7F\u7528\u5148\u30921\u3064\u4EE5\u4E0A\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "includedQuantity") message = wholeNumber(label, offer.rightType === "MERCHANDISE" ? "1,000,000" : "1,000", lang);
    else if (key === "assets") message = selectOneOrMore(label, lang);
    else if ([
      "distributionModes",
      "products",
      "distributionChannels"
    ].includes(key)) message = selectOneOrMore(label, lang);
    else if (key === "otherProduct") message = tr(lang, {
      ko: "\uAE30\uD0C0 \uC81C\uC791 \uD488\uBAA9\uC744 100\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter the other product in 100 characters or fewer.",
      ja: "\u305D\u306E\u4ED6\u306E\u5236\u4F5C\u54C1\u76EE\u3092100\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "sellOffDays") message = tr(lang, {
      ko: "\uAE30\uC874 \uC7AC\uACE0 \uC815\uB9AC \uAE30\uAC04\uC744 1~365\uC77C \uC0AC\uC774\uC758 \uC815\uC218\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter the sell-off period for existing stock as a whole number from 1 to 365 days.",
      ja: "\u65E2\u5B58\u5728\u5EAB\u306E\u6574\u7406\u671F\u9593\u30921\u301C365\u65E5\u306E\u6574\u6570\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "totalSeconds") message = tr(lang, {
      ko: "\uC804\uCCB4 \uC74C\uC131\uC758 \uCD1D\uAE38\uC774\uB294 1~36,000\uCD08 \uC0AC\uC774\uC758 \uC815\uC218\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter the total voice length as a whole number from 1 to 36,000 seconds.",
      ja: "\u97F3\u58F0\u5168\u4F53\u306E\u5408\u8A08\u306E\u9577\u3055\u306F1\u301C36,000\u79D2\u306E\u6574\u6570\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "production") message = tr(lang, {
      ko: "\uB300\uC0AC \uBD84\uB7C9\uC740 1~100,000\uC790, \uCD08\uC548 \uC804\uB2EC\uC740 1~365\uC77C, \uC218\uC815\uC740 0~100\uD68C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
      en: "Enter a script length of 1\u2013100,000 characters, draft delivery in 1\u2013365 days, and 0\u2013100 revisions.",
      ja: "\u30BB\u30EA\u30D5\u306E\u5206\u91CF\u306F1\u301C100,000\u6587\u5B57\u3001\u521D\u7A3F\u306E\u7D0D\u54C1\u306F1\u301C365\u65E5\u3001\u4FEE\u6B63\u306F0\u301C100\u56DE\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    });
    else if (key === "generation") {
      const part = String(issue.path[2] ?? "");
      const messages = {
        languages: tr(lang, {
          ko: "\uD5C8\uC6A9 \uC5B8\uC5B4\uB97C 1~200\uC790\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
          en: "Enter the allowed languages in 1\u2013200 characters.",
          ja: "\u8A31\u53EF\u3059\u308B\u8A00\u8A9E\u30921\u301C200\u6587\u5B57\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }),
        generationDays: tr(lang, {
          ko: "\uC0DD\uC131 \uAC00\uB2A5 \uAE30\uAC04\uC740 1~365\uC77C \uC0AC\uC774\uC758 \uC815\uC218\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
          en: "Enter a generation period as a whole number from 1 to 365 days.",
          ja: "\u751F\u6210\u53EF\u80FD\u671F\u9593\u306F1\u301C365\u65E5\u306E\u6574\u6570\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        })
      };
      return {
        message: messages[part] ?? tr(lang, {
          ko: "AI \uC74C\uC131 \uC0DD\uC131 \uBC29\uBC95\xB7\uC11C\uBE44\uC2A4 \uBE44\uC6A9\xB7\uB300\uC0AC \uD655\uC778 \uC870\uAC74\uC744 \uC124\uC815\uD574 \uC8FC\uC138\uC694.",
          en: "Set the AI voice generation method, service cost, and script review terms.",
          ja: "AI\u97F3\u58F0\u306E\u751F\u6210\u65B9\u6CD5\u30FB\u30B5\u30FC\u30D3\u30B9\u8CBB\u7528\u30FB\u30BB\u30EA\u30D5\u78BA\u8A8D\u306E\u6761\u4EF6\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }),
        field: messages[part] ? `usageScope.generation.${part}` : "usageScope.generation"
      };
    } else if ([
      "channelAddons",
      "distributionChannelAddons",
      "adultUsage"
    ].includes(key)) message = tr(lang, {
      ko: `${josa2(label, "\uC740", "\uB294")} 1,000\uC6D0 \uC774\uC0C1\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`,
      en: `Enter \u201C${label}\u201D of \u20A91,000 or more.`,
      ja: `\u300C${label}\u300D\u306F1,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    });
    else if ([
      "guidelines",
      "delivery",
      "rights"
    ].includes(key)) {
      const max = key === "delivery" ? "500" : "1,000";
      message = tr(lang, {
        ko: `${josa2(label, "\uC740", "\uB294")} ${max}\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`,
        en: `Keep \u201C${label}\u201D to ${max} characters or fewer.`,
        ja: `\u300C${label}\u300D\u306F${max}\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
      });
    }
    return {
      message,
      field: usageFieldLabels[key] ? `usageScope.${key}` : "usageScope"
    };
  }, "usageIssue");
  const variants = offer.usageScope?.kind === "APPEARANCE" ? offer.usageScope.variants : void 0;
  const zodIssues = result.success ? [] : result.error.issues;
  const packageIssueVariants = new Set(zodIssues.filter((issue) => issue.path[1] === "variants" && issue.path[3] === "onsitePackages").map((issue) => issue.path[2]));
  const issues = zodIssues.filter((issue) => {
    if (!variants) return true;
    if (issue.path[0] === "usageScope" && issue.path[1] !== "variants") return false;
    if (issue.path[0] === "durationOptions" && issue.code !== "custom") return false;
    if (issue.path[3] === "fixedAmount" && packageIssueVariants.has(issue.path[2])) return false;
    return true;
  }).map((issue) => {
    if (issue.path[0] === "usageScope") {
      if (issue.path[1] === "variants" && variants) {
        const variant = variants[Number(issue.path[2])];
        const prefix = variants.length > 1 && variant ? `${APPEARANCE_VARIANT_LABELS_I18N2[lang][appearanceVariantMode(variant.mode)]}: ` : "";
        const field = String(issue.path[3] ?? "");
        const at = /* @__PURE__ */ __name((rest) => rest ? `usageScope.variants.${String(issue.path[2])}.${rest}` : "usageScope.variants", "at");
        if (issue.code === "custom") return {
          message: localizeValidationMessage(issue.message, lang),
          field: at(field)
        };
        if (field === "onsitePackages") {
          const item = variant?.onsitePackages?.[Number(issue.path[4])];
          const title = item?.title.trim();
          const name = tr(lang, {
            ko: title ? `\u2018${title}\u2019 \uAD6C\uC131 ` : "\uAD6C\uC131 ",
            en: title ? `the \u2018${title}\u2019 package` : "the package",
            ja: title ? `\u300C${title}\u300D\u69CB\u6210\u306E` : "\u69CB\u6210\u306E"
          });
          const messages = {
            title: tr(lang, {
              ko: "\uAD6C\uC131 \uC774\uB984\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
              en: "Enter a package name.",
              ja: "\u69CB\u6210\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
            }),
            durationMinutes: tr(lang, {
              ko: `${name}\uC2DC\uAC04\uC744 15~1,440\uBD84 \uC0AC\uC774\uC758 15\uBD84 \uB2E8\uC704\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`,
              en: `Enter a time of 15\u20131,440 minutes, in 15-minute steps, for ${name}.`,
              ja: `${name}\u6642\u9593\u309215\u301C1,440\u5206\u306E\u9593\u3067\u300115\u5206\u5358\u4F4D\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
            }),
            fixedAmount: tr(lang, {
              ko: `${name}\uAC00\uACA9\uC744 1,000\uC6D0 \uC774\uC0C1\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`,
              en: `Enter a price of \u20A91,000 or more for ${name}.`,
              ja: `${name}\u4FA1\u683C\u30921,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
            }),
            overtimeAmount: tr(lang, {
              ko: `${name}\uC5F0\uC7A5 \uCD94\uAC00\uAE08\uC744 1,000\uC6D0 \uC774\uC0C1\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`,
              en: `Enter an extension fee of \u20A91,000 or more for ${name}.`,
              ja: `${name}\u5EF6\u9577\u8FFD\u52A0\u6599\u91D1\u30921,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
            })
          };
          return {
            message: prefix + (messages[String(issue.path[5] ?? "")] ?? tr(lang, {
              ko: "\uD604\uC7A5 \uBC29\uBB38 \uAD6C\uC131\uC758 \uC774\uB984\xB7\uC2DC\uAC04\xB7\uAC00\uACA9\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
              en: "Check the name, time, and price of the on-site packages.",
              ja: "\u73FE\u5730\u8A2A\u554F\u306E\u69CB\u6210\u306E\u540D\u524D\u30FB\u6642\u9593\u30FB\u4FA1\u683C\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
            })),
            field: at(issue.path[4] === void 0 ? "" : `onsitePackages.${String(issue.path[4])}.${String(issue.path[5] ?? "")}`)
          };
        }
        if (field === "fixedAmount") return {
          message: prefix + tr(lang, {
            ko: "\uAE30\uBCF8 \uCD9C\uC5F0\uB8CC\uB97C 1,000\uC6D0 \uC774\uC0C1\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
            en: "Enter a base appearance fee of \u20A91,000 or more.",
            ja: "\u57FA\u672C\u51FA\u6F14\u6599\u30921,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          }),
          field: at("fixedAmount")
        };
        return {
          message: prefix + usageIssue(field, issue).message,
          field: at(field)
        };
      }
      return usageIssue(String(issue.path[1] ?? ""), issue);
    }
    if (issue.path[0] === "durationOptions" && issue.code !== "custom") {
      if (issue.path[2] === "fixedAmount") return priceIssue(offer.durationOptions[Number(issue.path[1])]?.fixedAmount ?? 0, offer.rightType, lang);
      return {
        message: issue.path.length === 1 && issue.code === "too_small" ? tr(lang, {
          ko: "\uC0AC\uC6A9 \uAE30\uAC04\uC744 1\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.",
          en: "Select at least one usage period.",
          ja: "\u4F7F\u7528\u671F\u9593\u30921\u3064\u4EE5\u4E0A\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002"
        }) : tr(lang, {
          ko: "\uC0AC\uC6A9 \uAE30\uAC04\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
          en: "Please check the usage period.",
          ja: "\u4F7F\u7528\u671F\u9593\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
        }),
        field: "durationOptions"
      };
    }
    const fieldLabel = fieldLabels[String(issue.path[0])];
    return {
      message: issue.code === "custom" ? localizeValidationMessage(issue.message, lang) : tr(lang, {
        ko: `${fieldLabel ?? "\uC785\uB825\uAC12"}\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.`,
        en: fieldLabel ? `Please check \u201C${fieldLabel}\u201D.` : "Please check your input.",
        ja: fieldLabel ? `\u300C${fieldLabel}\u300D\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002` : "\u5165\u529B\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
      })
    };
  });
  const scopeIssue = brandScopeIssue(offer, lang);
  if (scopeIssue) issues.push({
    message: scopeIssue
  });
  if (!variants && offer.durationOptions.some((item) => item.fixedAmount === 0)) {
    issues.push(priceIssue(0, offer.rightType, lang));
  } else if (!variants) {
    const low = offer.durationOptions.find((item) => item.fixedAmount != null && item.fixedAmount < 1e3);
    if (low) issues.push(priceIssue(low.fixedAmount ?? 0, offer.rightType, lang));
  }
  if (offer.royaltyRateBp != null && (offer.royaltyRateBp < 10 || offer.royaltyRateBp % 10 !== 0)) {
    issues.push({
      message: tr(lang, {
        ko: "\uB9E4\uCD9C \uB85C\uC5F4\uD2F0\uB294 0.1% \uC774\uC0C1, 0.1% \uB2E8\uC704\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
        en: "Enter a revenue royalty of 0.1% or more, in 0.1% steps.",
        ja: "\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306F0.1%\u4EE5\u4E0A\u30010.1%\u5358\u4F4D\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
      })
    });
  }
  for (const items of Object.values(offer.brandScope ?? {})) {
    if (items.some((item) => item.addonAmount > 0 && item.addonAmount < 1e3)) {
      issues.push({
        message: tr(lang, {
          ko: "\uC635\uC158 \uCD94\uAC00\uAE08\uC740 1,000\uC6D0 \uC774\uC0C1\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
          en: "Enter add-on fees of \u20A91,000 or more.",
          ja: "\u30AA\u30D7\u30B7\u30E7\u30F3\u306E\u8FFD\u52A0\u6599\u91D1\u306F1,000\u30A6\u30A9\u30F3\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        })
      });
    }
  }
  return [
    ...new Map(issues.map((issue) => [
      issue.message,
      issue
    ])).values()
  ];
}
__name(getOfferIssueDetails, "getOfferIssueDetails");
function getOfferIssues(offer, lang = DEFAULT_LANG) {
  return getOfferIssueDetails(offer, lang).map((issue) => issue.message);
}
__name(getOfferIssues, "getOfferIssues");
function withUsagePurpose(offer, purpose) {
  if (!supportsUsagePurpose(offer.rightType)) return offer;
  if (!offer.usageScope && purpose === UsagePurpose.BUSINESS) return offer;
  const scope = offer.usageScope ?? defaultUsageScope(offer.rightType);
  if (!scope || scope.kind !== "CONTENT_SECONDARY" && scope.kind !== "AI_VOICE") return offer;
  return {
    ...offer,
    ...purpose === UsagePurpose.PERSONAL ? {
      pricingModel: PricingModel.FIXED,
      royaltyRateBp: null,
      royaltyPaymentDay: null
    } : {},
    usageScope: {
      ...scope,
      purpose,
      ...purpose === UsagePurpose.PERSONAL ? {
        channels: [],
        channelAddons: []
      } : {}
    }
  };
}
__name(withUsagePurpose, "withUsagePurpose");
function offerDraftReducer(state, action) {
  if (action.type === "purpose") return {
    offers: state.offers.map((offer) => withUsagePurpose(offer, action.purpose)),
    removed: Object.fromEntries(Object.entries(state.removed).map(([key, offer]) => [
      key,
      offer ? withUsagePurpose(offer, action.purpose) : offer
    ]))
  };
  const purpose = state.offers.filter((offer) => supportsUsagePurpose(offer.rightType)).map((offer) => getUsagePurpose(offer.usageScope) ?? UsagePurpose.BUSINESS).find(Boolean);
  if (action.type === "update") return {
    ...state,
    offers: state.offers.map((offer) => offer.rightType === action.rightType ? (() => {
      const updated = {
        ...offer,
        ...action.patch
      };
      if (updated.region === UsageRegion.GLOBAL && updated.usageScope?.kind === "APPEARANCE") {
        updated.usageScope = {
          ...updated.usageScope,
          serviceArea: "",
          variants: updated.usageScope.variants?.map((variant) => ({
            ...variant,
            serviceArea: ""
          }))
        };
      } else if (offer.region === UsageRegion.GLOBAL && updated.region !== UsageRegion.GLOBAL && updated.usageScope?.kind === "APPEARANCE") {
        const area = /* @__PURE__ */ __name((session) => session.mode === "ONSITE" && !session.serviceArea ? {
          ...session,
          serviceArea: APPEARANCE_SERVICE_AREA_NATIONWIDE
        } : session, "area");
        updated.usageScope = {
          ...area(updated.usageScope),
          variants: updated.usageScope.variants?.map(area)
        };
      }
      if ((updated.usageScope?.kind === "MERCHANDISE" || updated.usageScope?.kind === "CO_BRANDING") && isAdultIndustryForbidden(updated.forbiddenIndustries)) {
        const { adultUsage: _adult, ...scope } = updated.usageScope;
        updated.usageScope = scope;
      }
      return isGiveawayOnly(updated.usageScope) ? {
        ...updated,
        pricingModel: PricingModel.FIXED,
        royaltyRateBp: null,
        royaltyPaymentDay: null
      } : updated;
    })() : offer)
  };
  const existing = state.offers.find((offer) => offer.rightType === action.rightType);
  if (existing) return {
    offers: state.offers.filter((offer) => offer.rightType !== action.rightType),
    removed: {
      ...state.removed,
      [action.rightType]: existing
    }
  };
  if (!ACTIVE_IP_RIGHT_TYPES4.includes(action.rightType) && !state.removed[action.rightType]?.id) return state;
  const original = state.removed[action.rightType] ?? defaultOffer(action.rightType);
  const restored = purpose ? withUsagePurpose(original, purpose) : original;
  const removed = {
    ...state.removed
  };
  delete removed[action.rightType];
  return {
    offers: [
      ...state.offers,
      restored
    ],
    removed
  };
}
__name(offerDraftReducer, "offerDraftReducer");

// src/user/listing-form-api.ts
import { ACTIVE_IP_RIGHT_TYPES as ACTIVE_IP_RIGHT_TYPES5, APPEARANCE_ACTIVITY_LABELS_I18N, APPEARANCE_BOUNDARY_I18N, APPEARANCE_CHANNEL_LABELS_I18N, APPEARANCE_OVERTIME_LABELS_I18N, APPEARANCE_RECORDING_LABELS_I18N, APPEARANCE_TRAVEL_LABELS_I18N, APPEARANCE_VARIANT_LABELS_I18N as APPEARANCE_VARIANT_LABELS_I18N3, AppearanceMode, AppearanceRecording, BRAND_ASSET_LABELS_I18N as BRAND_ASSET_LABELS_I18N2, BRAND_EXPRESSION_LABELS_I18N, BRAND_LEGAL_USE_LABELS_I18N as BRAND_LEGAL_USE_LABELS_I18N2, CO_BRANDING_ARCHIVE_BOUNDARY_I18N, CO_BRANDING_ASSET_LABELS_I18N, CO_BRANDING_BOUNDARY_I18N, CO_BRANDING_CHANNEL_LABELS_I18N, CO_BRANDING_EXCLUSIONS_I18N, CO_BRANDING_EXPIRY_LABELS_I18N, classifyOfferChange, DEFAULT_LANG as DEFAULT_LANG2, EXCLUSIVITY_LABELS_I18N as EXCLUSIVITY_LABELS_I18N2, FORBIDDEN_INDUSTRY_LABELS_I18N, IP_RIGHT_LABELS_I18N, IpRightType as IpRightType5, ListingStatus, MAX_CUSTOM_FORBIDDEN_INDUSTRIES, MAX_FORBIDDEN_INDUSTRY_LENGTH, MEDIA_USAGE_DESCRIPTION_I18N, MERCHANDISE_ASSET_LABELS_I18N, MERCHANDISE_CHANNEL_LABELS_I18N, MERCHANDISE_DISTRIBUTION_LABELS_I18N, MERCHANDISE_INVENTORY_LABELS_I18N, MERCHANDISE_MAX_QUANTITY as MERCHANDISE_MAX_QUANTITY2, MERCHANDISE_PRODUCT_LABELS_I18N, MERCHANDISE_QUANTITY_BASIS_I18N, MERCHANDISE_REPRODUCTION_LABELS_I18N, MERCHANDISE_USAGE_BOUNDARY_I18N, MODIFICATION_RIGHT_LABELS_I18N as MODIFICATION_RIGHT_LABELS_I18N2, OFFER_DURATION_MONTHS, PERSONAL_USAGE_BOUNDARY_I18N, PRICING_MODEL_LABELS_I18N as PRICING_MODEL_LABELS_I18N2, PricingModel as PricingModel2, RIGHT_TYPE_FORM_CONFIG as RIGHT_TYPE_FORM_CONFIG2, RIGHT_TYPE_REGION_LABELS_I18N as RIGHT_TYPE_REGION_LABELS_I18N2, USAGE_CHANNEL_LABELS_I18N, USAGE_PLACEMENT_LABELS_I18N as USAGE_PLACEMENT_LABELS_I18N2, USAGE_PURPOSE_LABELS_I18N, USAGE_REGION_LABELS_I18N as USAGE_REGION_LABELS_I18N2, UsagePurpose as UsagePurpose2, UsageRegion as UsageRegion2, VIOLATION_POLICY_LABELS_I18N as VIOLATION_POLICY_LABELS_I18N2, VOICE_GENERATION_EXPIRY_I18N, VOICE_GENERATION_METHOD_LABELS_I18N, VOICE_OFFERING_LABELS_I18N, VOICE_SERVICE_COST_LABELS_I18N, VOICE_SOURCE_LABELS_I18N, appearanceActivityLabel, appearanceActivityLabels, appearanceActivityRecordings, appearanceAllowsPublicRecording, appearanceMinimumPrice, appearancePackageMinimum, appearancePublicRecordingLabel, appearanceVariantMode as appearanceVariantMode2, appearanceVariantScope, appearanceVariants, forbiddenIndustryLabel as forbiddenIndustryLabel2, getUsagePurpose as getUsagePurpose2, isAdultIndustryForbidden as isAdultIndustryForbidden2, licenseDraftFormOf, isGiveawayOnly as isGiveawayOnly2, isPersonalUsage, mediaUsageChannels, monthlyAddonLabel as monthlyAddonLabel2, numberedNoteText, supportsUsagePurpose as supportsUsagePurpose2, usagePriceBasis, USAGE_SCOPE_ROW_KEYS, usageScopeRows as usageScopeRows2, usesAppearanceSessionRecording, voiceUsageBoundary, withAppearanceActivityRecordings, withAppearancePackages as withAppearancePackages2, withAppearanceRecordingPolicy, formatWon as formatWon2, tr as tr2 } from "@inflip/shared";
import { z as z11 } from "zod";
var offerDraftSchema = sentAsReceived(listingOfferInputSchema.catch((ctx) => ctx.input));
var optionsOf = /* @__PURE__ */ __name((labels2) => Object.entries(labels2).map(([code, label]) => ({
  code,
  label
})), "optionsOf");
var listingFormRightSchema = z11.object({
  rightType: z11.nativeEnum(IpRightType5),
  label: z11.string(),
  /** 사용 기간을 고르는 권리인지 (출연권은 1회) */
  duration: z11.boolean(),
  exclusivity: z11.boolean(),
  modification: z11.boolean(),
  modificationOptions: z11.array(catalogOptionSchema),
  regionLabel: z11.string(),
  pricingModels: z11.array(z11.nativeEnum(PricingModel2)),
  /** 이름/브랜드 — 제공 표기·위치·상호 범위를 3상태로 */
  brandScope: z11.boolean(),
  /** 이용 목적(사업·개인 감상)을 고르는 권리 */
  usagePurpose: z11.boolean(),
  /** 처음 고를 때의 기본 조건 */
  defaultOffer: offerDraftSchema
});
var listingFormSpecSchema = z11.object({
  /** 새로 고를 수 있는 권리 (판매가 끝난 권리는 기존 상품에만) */
  rights: z11.array(listingFormRightSchema),
  /** 판매가 끝났지만 기존 상품에 남아 있을 수 있는 권리까지 — 이름·설정을 찾는 용 */
  allRights: z11.array(listingFormRightSchema),
  durations: z11.array(z11.number().int()),
  /** 선택지 이름 — 키는 shared 상수 이름 (USAGE_REGION_LABELS 등) */
  labels: z11.record(z11.string(), z11.array(catalogOptionSchema)),
  /** 고정 안내 문구 — 키는 shared 상수 이름 (PERSONAL_USAGE_BOUNDARY 등) */
  texts: z11.record(z11.string(), z11.string()),
  limits: z11.object({
    customForbiddenIndustries: z11.number().int(),
    forbiddenIndustryLength: z11.number().int(),
    merchandiseMaxQuantity: z11.number().int(),
    titleMax: z11.number().int(),
    descriptionMax: z11.number().int()
  })
});
function rightOf(rightType, lang) {
  const config = RIGHT_TYPE_FORM_CONFIG2[rightType];
  return {
    rightType,
    label: IP_RIGHT_LABELS_I18N[lang][rightType],
    duration: config.duration,
    exclusivity: config.exclusivity,
    modification: config.modification,
    modificationOptions: config.modificationOptions.map((code) => ({
      code,
      label: MODIFICATION_RIGHT_LABELS_I18N2[lang][code]
    })),
    regionLabel: RIGHT_TYPE_REGION_LABELS_I18N2[lang][rightType],
    pricingModels: [
      ...config.pricingModels
    ],
    brandScope: config.brandScope,
    usagePurpose: supportsUsagePurpose2(rightType),
    defaultOffer: defaultOffer(rightType)
  };
}
__name(rightOf, "rightOf");
function listingFormSpec(lang = DEFAULT_LANG2) {
  return {
    rights: ACTIVE_IP_RIGHT_TYPES5.map((rightType) => rightOf(rightType, lang)),
    allRights: Object.keys(IP_RIGHT_LABELS_I18N.ko).map((rightType) => rightOf(rightType, lang)),
    durations: [
      ...OFFER_DURATION_MONTHS
    ],
    labels: {
      USAGE_REGION_LABELS: optionsOf(USAGE_REGION_LABELS_I18N2[lang]),
      EXCLUSIVITY_LABELS: optionsOf(EXCLUSIVITY_LABELS_I18N2[lang]),
      VIOLATION_POLICY_LABELS: optionsOf(VIOLATION_POLICY_LABELS_I18N2[lang]),
      FORBIDDEN_INDUSTRY_LABELS: optionsOf(FORBIDDEN_INDUSTRY_LABELS_I18N[lang]),
      PRICING_MODEL_LABELS: optionsOf(PRICING_MODEL_LABELS_I18N2[lang]),
      USAGE_PURPOSE_LABELS: optionsOf(USAGE_PURPOSE_LABELS_I18N[lang]),
      BRAND_EXPRESSION_LABELS: optionsOf(BRAND_EXPRESSION_LABELS_I18N[lang]),
      USAGE_CHANNEL_LABELS: optionsOf(USAGE_CHANNEL_LABELS_I18N[lang]),
      VOICE_OFFERING_LABELS: optionsOf(VOICE_OFFERING_LABELS_I18N[lang]),
      VOICE_SOURCE_LABELS: optionsOf(VOICE_SOURCE_LABELS_I18N[lang]),
      VOICE_GENERATION_METHOD_LABELS: optionsOf(VOICE_GENERATION_METHOD_LABELS_I18N[lang]),
      VOICE_SERVICE_COST_LABELS: optionsOf(VOICE_SERVICE_COST_LABELS_I18N[lang]),
      MERCHANDISE_DISTRIBUTION_LABELS: optionsOf(MERCHANDISE_DISTRIBUTION_LABELS_I18N[lang]),
      MERCHANDISE_PRODUCT_LABELS: optionsOf(MERCHANDISE_PRODUCT_LABELS_I18N[lang]),
      MERCHANDISE_ASSET_LABELS: optionsOf(MERCHANDISE_ASSET_LABELS_I18N[lang]),
      MERCHANDISE_REPRODUCTION_LABELS: optionsOf(MERCHANDISE_REPRODUCTION_LABELS_I18N[lang]),
      MERCHANDISE_INVENTORY_LABELS: optionsOf(MERCHANDISE_INVENTORY_LABELS_I18N[lang]),
      MERCHANDISE_CHANNEL_LABELS: optionsOf(MERCHANDISE_CHANNEL_LABELS_I18N[lang]),
      CO_BRANDING_ASSET_LABELS: optionsOf(CO_BRANDING_ASSET_LABELS_I18N[lang]),
      CO_BRANDING_EXPIRY_LABELS: optionsOf(CO_BRANDING_EXPIRY_LABELS_I18N[lang]),
      CO_BRANDING_CHANNEL_LABELS: optionsOf(CO_BRANDING_CHANNEL_LABELS_I18N[lang]),
      APPEARANCE_VARIANT_LABELS: optionsOf(APPEARANCE_VARIANT_LABELS_I18N3[lang]),
      APPEARANCE_ACTIVITY_LABELS: optionsOf(APPEARANCE_ACTIVITY_LABELS_I18N[lang]),
      APPEARANCE_RECORDING_LABELS: optionsOf(APPEARANCE_RECORDING_LABELS_I18N[lang]),
      APPEARANCE_OVERTIME_LABELS: optionsOf(APPEARANCE_OVERTIME_LABELS_I18N[lang]),
      APPEARANCE_TRAVEL_LABELS: optionsOf(APPEARANCE_TRAVEL_LABELS_I18N[lang]),
      APPEARANCE_CHANNEL_LABELS: optionsOf(APPEARANCE_CHANNEL_LABELS_I18N[lang]),
      BRAND_ASSET_LABELS: optionsOf(BRAND_ASSET_LABELS_I18N2[lang]),
      USAGE_PLACEMENT_LABELS: optionsOf(USAGE_PLACEMENT_LABELS_I18N2[lang]),
      BRAND_LEGAL_USE_LABELS: optionsOf(BRAND_LEGAL_USE_LABELS_I18N2[lang])
    },
    texts: {
      MEDIA_USAGE_DESCRIPTION: MEDIA_USAGE_DESCRIPTION_I18N[lang],
      PERSONAL_USAGE_BOUNDARY: PERSONAL_USAGE_BOUNDARY_I18N[lang],
      VOICE_GENERATION_EXPIRY: VOICE_GENERATION_EXPIRY_I18N[lang],
      MERCHANDISE_USAGE_BOUNDARY: MERCHANDISE_USAGE_BOUNDARY_I18N[lang],
      MERCHANDISE_QUANTITY_BASIS: MERCHANDISE_QUANTITY_BASIS_I18N[lang],
      CO_BRANDING_BOUNDARY: CO_BRANDING_BOUNDARY_I18N[lang],
      CO_BRANDING_EXCLUSIONS: CO_BRANDING_EXCLUSIONS_I18N[lang],
      CO_BRANDING_ARCHIVE_BOUNDARY: CO_BRANDING_ARCHIVE_BOUNDARY_I18N[lang],
      APPEARANCE_BOUNDARY: APPEARANCE_BOUNDARY_I18N[lang]
    },
    limits: {
      customForbiddenIndustries: MAX_CUSTOM_FORBIDDEN_INDUSTRIES,
      forbiddenIndustryLength: MAX_FORBIDDEN_INDUSTRY_LENGTH,
      merchandiseMaxQuantity: MERCHANDISE_MAX_QUANTITY2,
      titleMax: 200,
      descriptionMax: 5e3
    }
  };
}
__name(listingFormSpec, "listingFormSpec");
function normalizeAppearanceVariant(variant) {
  if (variant.onsitePackages?.length) {
    return {
      ...withAppearancePackages2(variant, variant.onsitePackages),
      fixedAmount: appearancePackageMinimum(variant.onsitePackages)
    };
  }
  if (variant.activities.length > 0 || variant.customActivities?.length) {
    return {
      ...variant.activityRecordings ? withAppearanceActivityRecordings(variant, variant.activityRecordings, variant.activities) : withAppearanceActivityRecordings(variant, appearanceActivityRecordings(variant)),
      fixedAmount: variant.fixedAmount
    };
  }
  return {
    ...withAppearanceRecordingPolicy(variant, variant.recordingPolicy),
    fixedAmount: variant.fixedAmount
  };
}
__name(normalizeAppearanceVariant, "normalizeAppearanceVariant");
function normalizeListingOffer(input) {
  let offer = normalizeOfferDraft({
    offers: [
      input
    ],
    removed: {}
  }).offers[0] ?? input;
  const scope = offer.usageScope;
  if (scope?.kind === IpRightType5.APPEARANCE && scope.variants) {
    const variants = appearanceVariants(scope, offer.durationOptions[0]?.fixedAmount ?? null).map((variant) => normalizeAppearanceVariant(offer.region === UsageRegion2.GLOBAL ? {
      ...variant,
      serviceArea: ""
    } : variant));
    if (variants.length > 0) {
      offer = {
        ...offer,
        usageScope: {
          ...appearanceVariantScope(variants[0]),
          variants
        },
        durationOptions: [
          {
            months: 0,
            fixedAmount: appearanceMinimumPrice(variants)
          }
        ]
      };
    }
  }
  if ((offer.usageScope?.kind === IpRightType5.MERCHANDISE || offer.usageScope?.kind === IpRightType5.CO_BRANDING) && isAdultIndustryForbidden2(offer.forbiddenIndustries)) {
    const { adultUsage: _adult, ...rest } = offer.usageScope;
    offer = {
      ...offer,
      usageScope: rest
    };
  }
  const personal = isPersonalUsage(offer.usageScope);
  if (personal && offer.usageScope && "channels" in offer.usageScope) {
    offer = {
      ...offer,
      usageScope: {
        ...offer.usageScope,
        channels: [],
        channelAddons: []
      }
    };
  }
  if (personal || isGiveawayOnly2(offer.usageScope) || offer.pricingModel === PricingModel2.FIXED) {
    offer = {
      ...offer,
      pricingModel: PricingModel2.FIXED,
      royaltyRateBp: null,
      royaltyPaymentDay: null
    };
  }
  if (offer.pricingModel === PricingModel2.REVENUE_SHARE) {
    offer = {
      ...offer,
      durationOptions: offer.durationOptions.map((d) => ({
        ...d,
        fixedAmount: null
      }))
    };
  }
  return offer;
}
__name(normalizeListingOffer, "normalizeListingOffer");
var listingOfferIssueSchema = z11.object({
  message: z11.string(),
  field: z11.string().nullable()
});
var listingOfferChangeSchema = z11.object({
  label: z11.string(),
  before: z11.string(),
  after: z11.string()
});
var appearanceVariantHintSchema = z11.object({
  mode: z11.nativeEnum(AppearanceMode),
  label: z11.string(),
  /** 이 방식에 필요한 값을 다 넣었는지 — 방식 칩의 '작성 완료·입력 필요' */
  complete: z11.boolean(),
  /** 기본가에 넣을 수 있는 활동 (방식마다 이름이 다르다) */
  activityOptions: z11.array(catalogOptionSchema),
  /** 활동별 촬영·사용 허용 — 고른 활동 순서 */
  recordings: z11.array(z11.object({
    activity: z11.string(),
    label: z11.string(),
    policy: z11.nativeEnum(AppearanceRecording),
    /** false 면 판매자가 아직 범위를 고르지 않았다 (policy 는 촬영 불가로 채운 값 — 화면은 '선택해 주세요') */
    chosen: z11.boolean().optional()
  })),
  /** 활동 없이 출연 하나에 촬영 허용을 거는지 */
  sessionRecording: z11.boolean(),
  /** 공개 사용을 허용한 촬영물이 있는지 — 사용 기간·위치·추가금을 보인다 */
  allowsPublicRecording: z11.boolean(),
  publicRecordingLabel: z11.string()
});
var listingOfferHintsSchema = z11.object({
  /** 가격 기준 문구 — usagePriceBasis */
  priceBasis: z11.string().nullable(),
  personal: z11.boolean(),
  giveawayOnly: z11.boolean(),
  adultForbidden: z11.boolean(),
  /** 고를 수 있는 가격 방식 — 개인 감상·비매품 전용이면 고정가만 */
  pricingModels: z11.array(z11.nativeEnum(PricingModel2)),
  /** 사전 승인 버튼 문구 */
  preApprovalLabel: z11.string(),
  /** 이 권리의 특약 칸 이름 (위반 시 조치 안내) — licenseDraftFormOf */
  specialTermsLabel: z11.string(),
  /** 사진·영상·음성 — 이 조건에서 고를 수 있는 사용 위치 */
  mediaChannels: z11.array(z11.string()),
  /** 음성 — 사용 방식 안내 */
  voiceBoundary: z11.string().nullable(),
  appearanceVariants: z11.array(appearanceVariantHintSchema),
  /** 이름/브랜드 — 기본가 포함·추가 옵션 요약 */
  brandScopeIncluded: z11.array(z11.string()),
  brandScopeAddons: z11.array(z11.string()),
  /** 저장 전 확인 창의 새 권리 요약 */
  summaryPrice: z11.string(),
  summaryForbidden: z11.string(),
  summaryRows: z11.array(z11.object({
    label: z11.string(),
    value: z11.string()
  }))
});
var listingFormCheckRequestSchema = z11.object({
  /** 수정이면 그 상품 — 변경 내역·심사 필요 여부의 기준 */
  listingId: z11.string().uuid().optional(),
  title: z11.string().max(1e4).default(""),
  description: z11.string().max(1e5).default(""),
  usageNotes: z11.string().max(1e5).default(""),
  offers: z11.array(offerDraftSchema).max(20)
});
var listingFormOfferCheckSchema = z11.object({
  rightType: z11.nativeEnum(IpRightType5),
  /** 파생값을 맞춘 조건 — 화면은 이걸로 바꿔 그린다 */
  normalized: offerDraftSchema,
  /** 새로 추가 / 저장된 것에서 바뀜 / 그대로 */
  status: z11.enum([
    "added",
    "changed",
    "unchanged"
  ]),
  issues: z11.array(listingOfferIssueSchema),
  /** 저장된 조건(새 권리면 기본 조건)과 달라진 것 — 되돌리기·확인 창 */
  changes: z11.array(listingOfferChangeSchema),
  /** 진행 중인 거래가 있어 바꾸거나 뺄 수 없는 권리 */
  locked: z11.boolean(),
  hints: listingOfferHintsSchema
});
var listingCommonIssueSchema = z11.object({
  field: z11.string(),
  message: z11.string()
});
var listingFormCheckResponseSchema = z11.object({
  offers: z11.array(listingFormOfferCheckSchema),
  /** 저장된 조건 (수정이면) — 화면이 처음 채우는 값이자 되돌리기 기준. 새 상품이면 빈 목록 */
  saved: z11.array(offerDraftSchema),
  /** 저장된 권리 중 이번에 뺀 것 */
  removed: z11.array(z11.nativeEnum(IpRightType5)),
  /** 제목·설명·주의사항 — 칸 이름(title·description·usageNotes)과 오류 */
  commonIssues: z11.array(listingCommonIssueSchema),
  commonChanges: z11.array(listingOfferChangeSchema),
  /** 하나라도 바뀌었는지 (저장할 것이 있는지) */
  dirty: z11.boolean(),
  /** 저장하면 심사를 거치는지 — 공개 전 상품, 새 권리, 계약 조건을 바꾼 권리 */
  needsReview: z11.boolean(),
  published: z11.boolean()
});
var commonFieldsSchema = createListingRequestSchema.pick({
  title: true,
  description: true,
  usageNotes: true
});
function preApprovalLabel(offer, lang) {
  if (offer.rightType === IpRightType5.APPEARANCE) return tr2(lang, {
    ko: "\uCD9C\uC5F0 \uC804 \uC9C4\uD589 \uB0B4\uC6A9\xB7\uB300\uBCF8 \uD655\uC778 \uD544\uC694",
    en: "Review of plan and script required before appearance",
    ja: "\u51FA\u6F14\u524D\u306B\u9032\u884C\u5185\u5BB9\u30FB\u53F0\u672C\u306E\u78BA\u8A8D\u304C\u5FC5\u8981"
  });
  if (offer.rightType === IpRightType5.CO_BRANDING) return tr2(lang, {
    ko: "\uACF5\uAC1C \uC804 \uB450 \uBE0C\uB79C\uB4DC \uD45C\uC2DC \uC2DC\uC548 \uC2B9\uC778 \uD544\uC694",
    en: "Approval of co-brand mockups required before release",
    ja: "\u516C\u958B\u524D\u306B\u4E21\u30D6\u30E9\u30F3\u30C9\u306E\u8868\u793A\u6848\u306E\u627F\u8A8D\u304C\u5FC5\u8981"
  });
  if (offer.rightType === IpRightType5.MERCHANDISE) return tr2(lang, {
    ko: "\uC81C\uC791 \uC804 \uB514\uC790\uC778 \uC2DC\uC548 \uC2B9\uC778 \uD544\uC694",
    en: "Approval of design mockups required before production",
    ja: "\u5236\u4F5C\u524D\u306B\u30C7\u30B6\u30A4\u30F3\u6848\u306E\u627F\u8A8D\u304C\u5FC5\u8981"
  });
  return isPersonalUsage(offer.usageScope) ? tr2(lang, {
    ko: "\uC0AC\uC6A9 \uC804 \uD310\uB9E4\uC790 \uC0AC\uC804 \uC2B9\uC778 \uD544\uC694",
    en: "Seller pre-approval required before use",
    ja: "\u4F7F\u7528\u524D\u306B\u8CA9\u58F2\u8005\u306E\u4E8B\u524D\u627F\u8A8D\u304C\u5FC5\u8981"
  }) : tr2(lang, {
    ko: "\uC9D1\uD589 \uC804 \uC778\uD50C\uB8E8\uC5B8\uC11C \uC0AC\uC804 \uC2B9\uC778 \uD544\uC694",
    en: "Influencer pre-approval required before running",
    ja: "\u5B9F\u65BD\u524D\u306B\u30A4\u30F3\u30D5\u30EB\u30A8\u30F3\u30B5\u30FC\u306E\u4E8B\u524D\u627F\u8A8D\u304C\u5FC5\u8981"
  });
}
__name(preApprovalLabel, "preApprovalLabel");
var SUMMARY_ROW_KEYS = [
  USAGE_SCOPE_ROW_KEYS.PURPOSE,
  USAGE_SCOPE_ROW_KEYS.PERSONAL_SCOPE,
  USAGE_SCOPE_ROW_KEYS.ALLOWED_CHANNELS,
  USAGE_SCOPE_ROW_KEYS.ADDON_CHANNELS,
  USAGE_SCOPE_ROW_KEYS.ADDON_BASIS
];
function listingOfferHints(offer, lang = DEFAULT_LANG2) {
  const config = RIGHT_TYPE_FORM_CONFIG2[offer.rightType];
  const scope = offer.usageScope;
  const personal = isPersonalUsage(scope);
  const giveawayOnly = isGiveawayOnly2(scope);
  const appearance = scope?.kind === IpRightType5.APPEARANCE ? appearanceVariants(scope, offer.durationOptions[0]?.fixedAmount ?? null) : [];
  const brandIncluded = [];
  const brandAddons = [];
  const brandGroups = [
    [
      "assets",
      BRAND_ASSET_LABELS_I18N2[lang]
    ],
    [
      "placements",
      USAGE_PLACEMENT_LABELS_I18N2[lang]
    ],
    [
      "legalUses",
      BRAND_LEGAL_USE_LABELS_I18N2[lang]
    ]
  ];
  for (const [group, labels2] of brandGroups) {
    for (const item of offer.brandScope?.[group] ?? []) {
      const label = labels2[item.key] ?? item.key;
      if (item.addonAmount > 0) brandAddons.push(`${label} ${monthlyAddonLabel2(item.addonAmount, lang)}`);
      else brandIncluded.push(label);
    }
  }
  const rows = (() => {
    try {
      return scope && scope.kind !== IpRightType5.NAME_BRAND ? usageScopeRows2(scope, lang).filter((row) => scope.kind === IpRightType5.AI_VOICE || scope.kind === IpRightType5.MERCHANDISE || scope.kind === IpRightType5.CO_BRANDING || scope.kind === IpRightType5.APPEARANCE || !!row.key && SUMMARY_ROW_KEYS.includes(row.key)) : [];
    } catch {
      return [];
    }
  })();
  return {
    priceBasis: usagePriceBasis(scope, lang),
    personal,
    giveawayOnly,
    adultForbidden: isAdultIndustryForbidden2(offer.forbiddenIndustries),
    pricingModels: personal || giveawayOnly ? [
      PricingModel2.FIXED
    ] : [
      ...config.pricingModels
    ],
    preApprovalLabel: preApprovalLabel(offer, lang),
    specialTermsLabel: licenseDraftFormOf(offer.rightType, null, lang).specialTermsLabel,
    mediaChannels: scope && (scope.kind === IpRightType5.FACE_PHOTO || scope.kind === IpRightType5.CONTENT_SECONDARY || scope.kind === IpRightType5.AI_VOICE) ? mediaUsageChannels(scope) : [],
    voiceBoundary: scope?.kind === IpRightType5.AI_VOICE ? voiceUsageBoundary(scope, lang) : null,
    appearanceVariants: appearance.map((v) => ({
      mode: v.mode,
      label: APPEARANCE_VARIANT_LABELS_I18N3[lang][appearanceVariantMode2(v.mode)],
      complete: usageScopeSchema.safeParse(appearanceVariantScope(v)).success && (offer.region === UsageRegion2.GLOBAL || v.mode !== AppearanceMode.ONSITE || !!v.serviceArea.trim()) && (v.fixedAmount == null || v.fixedAmount >= 1e3),
      activityOptions: Object.entries(appearanceActivityLabels(v.mode, lang)).map(([code, label]) => ({
        code,
        label: label ?? code
      })),
      recordings: appearanceActivityRecordings(v).map((item) => ({
        activity: item.activity,
        label: appearanceActivityLabel(v.mode, item.activity, lang),
        policy: item.policy,
        chosen: !v.activityRecordings || v.activityRecordings.some((r) => r.activity === item.activity)
      })),
      sessionRecording: usesAppearanceSessionRecording(v),
      allowsPublicRecording: appearanceAllowsPublicRecording(v),
      publicRecordingLabel: appearancePublicRecordingLabel(v, lang)
    })),
    brandScopeIncluded: brandIncluded,
    brandScopeAddons: brandAddons,
    summaryPrice: [
      usagePriceBasis(scope, lang),
      offer.durationOptions.map((d) => `${d.months ? tr2(lang, {
        ko: `${d.months}\uAC1C\uC6D4`,
        en: d.months === 1 ? "1 month" : `${d.months} months`,
        ja: `${d.months}\u304B\u6708`
      }) : tr2(lang, {
        ko: "1\uD68C",
        en: "One-time",
        ja: "1\u56DE"
      })} \xB7 ${offer.pricingModel === PricingModel2.REVENUE_SHARE ? tr2(lang, {
        ko: "\uB9E4\uCD9C \uB85C\uC5F4\uD2F0",
        en: "Revenue royalty",
        ja: "\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3"
      }) : d.fixedAmount == null ? tr2(lang, {
        ko: "\uAC00\uACA9 \uD611\uC758",
        en: "Price negotiable",
        ja: "\u4FA1\u683C\u5FDC\u76F8\u8AC7"
      }) : formatWon2(d.fixedAmount, lang)}`).join(" / ")
    ].filter(Boolean).join(" \xB7 "),
    summaryForbidden: offer.forbiddenIndustries.map((value) => forbiddenIndustryLabel2(value, lang)).join(lang === "ja" ? "\u3001" : ", ") || tr2(lang, {
      ko: "\uC5C6\uC74C",
      en: "None",
      ja: "\u306A\u3057"
    }),
    summaryRows: rows.map((row) => ({
      label: row.label,
      value: row.value
    }))
  };
}
__name(listingOfferHints, "listingOfferHints");
function checkListingForm(input, initial, lang = DEFAULT_LANG2) {
  const baseline = toFormOffers(initial ?? void 0);
  const locked = new Set(initial?.lockedOfferIds ?? []);
  const offers = input.offers.map((raw) => {
    const offer = normalizeListingOffer(raw);
    const previous = baseline.find((o) => o.rightType === offer.rightType);
    const changes = getOfferChanges(previous ?? defaultOffer(offer.rightType), offer, lang);
    const changedFromSaved = previous ? getOfferChanges(previous, offer).length > 0 : false;
    return {
      rightType: offer.rightType,
      normalized: offer,
      status: !previous ? "added" : changedFromSaved ? "changed" : "unchanged",
      issues: getOfferIssueDetails(offer, lang).map((issue) => ({
        message: issue.message,
        field: issue.field ?? null
      })),
      changes,
      locked: !!offer.id && locked.has(offer.id),
      hints: listingOfferHints(offer, lang),
      previous
    };
  });
  const removed = baseline.filter((o) => !offers.some((x) => x.rightType === o.rightType)).map((o) => o.rightType);
  const common = commonFieldsSchema.safeParse({
    title: input.title.trim(),
    description: input.description.trim(),
    usageNotes: input.usageNotes
  });
  const commonIssues = common.success ? [] : common.error.issues.map((issue) => ({
    field: String(issue.path[0] ?? ""),
    message: localizeValidationMessage(issue.message, lang)
  }));
  const commonChanges = [
    {
      label: tr2(lang, {
        ko: "\uC81C\uBAA9",
        en: "Title",
        ja: "\u30BF\u30A4\u30C8\u30EB"
      }),
      before: initial?.title ?? "",
      after: input.title
    },
    {
      label: tr2(lang, {
        ko: "\uC124\uBA85",
        en: "Description",
        ja: "\u8AAC\u660E"
      }),
      before: initial?.description ?? "",
      after: input.description
    },
    {
      label: tr2(lang, {
        ko: "\uAE30\uD0C0 \uC8FC\uC758\xB7\uADDC\uCE59 \uC0AC\uD56D",
        en: "Other notes and rules",
        ja: "\u305D\u306E\u4ED6\u306E\u6CE8\u610F\u4E8B\u9805\u30FB\u30EB\u30FC\u30EB"
      }),
      before: numberedNoteText(initial?.usageNotes),
      after: numberedNoteText(input.usageNotes)
    }
  ].filter((change) => change.before !== change.after);
  const published = initial?.status === ListingStatus.PUBLISHED;
  const added = offers.filter((o) => o.status === "added");
  const changed = offers.filter((o) => o.status === "changed");
  const needsReview = !published || added.length > 0 || changed.some((o) => !!o.previous && classifyOfferChange(o.previous, o.normalized) === "terms");
  return {
    offers: offers.map(({ previous: _previous, ...rest }) => rest),
    saved: baseline,
    removed,
    commonIssues,
    commonChanges,
    dirty: commonChanges.length + added.length + changed.length + removed.length > 0,
    needsReview,
    published
  };
}
__name(checkListingForm, "checkListingForm");
function purposeOf(offers) {
  return offers.filter((offer) => supportsUsagePurpose2(offer.rightType)).map((offer) => getUsagePurpose2(offer.usageScope) ?? UsagePurpose2.BUSINESS).find(Boolean) ?? null;
}
__name(purposeOf, "purposeOf");
export {
  CHAT_ROOM_PAGE_SIZE,
  COMMUNITY_COMMENT_MAX,
  COMMUNITY_POST_CONTENT_MAX,
  COMMUNITY_POST_CONTENT_MIN,
  COMMUNITY_POST_TITLE_MAX,
  COMMUNITY_REPORT_REASONS,
  COMMUNITY_REPORT_REASONS_I18N,
  COMMUNITY_SEARCH_MAX,
  DEFAULT_PLATFORM_SETTINGS,
  DISPUTE_EVIDENCE_MAX_BYTES,
  DISPUTE_EVIDENCE_MAX_FILES,
  DISPUTE_EVIDENCE_MIME_TYPES,
  GUIDE_PAGES,
  GUIDE_SECTIONS,
  INBOX_NOTIFICATION_CATEGORIES,
  LICENSE_LIST_PAGE,
  LICENSE_VIEW_STATES,
  LISTING_RIGHTS_LIMIT,
  LISTING_THUMBNAIL_HEIGHT,
  LISTING_THUMBNAIL_MAX_BYTES,
  LISTING_THUMBNAIL_MIME_TYPES,
  LISTING_THUMBNAIL_WIDTH,
  NOTIFICATION_PAGE_SIZE,
  ORDER_LIST_PAGE,
  ORDER_STATUS_GROUPS,
  PAYOUT_GROUPS,
  PAYOUT_LIST_PAGE,
  PLATFORM_ASSET_KEYS,
  PLATFORM_ASSET_RULES,
  PLATFORM_SETTINGS_KEY,
  POLICY_COMPANY_PLACEHOLDERS,
  PROPOSAL_LIST_PAGE,
  SOCIAL_CHANNEL_APP_SCHEMES,
  SOCIAL_LINK_KEYS,
  SOCIAL_LINK_LABELS,
  SOCIAL_LINK_LABELS_I18N,
  SPONSORSHIP_BENEFIT_MAX,
  SPONSORSHIP_BUSINESS_NAME_MAX,
  SPONSORSHIP_DESCRIPTION_MAX,
  SPONSORSHIP_IMAGE_MAX_BYTES,
  SPONSORSHIP_IMAGE_MIME_TYPES,
  SPONSORSHIP_LOCATION_MAX,
  SPONSORSHIP_MESSAGE_MAX,
  SPONSORSHIP_MINE_FIRST_PAGE,
  SPONSORSHIP_MINE_PAGE,
  SPONSORSHIP_RECEIVED_PAGE,
  SPONSORSHIP_RECEIVED_STAGES,
  SPONSORSHIP_REJECT_REASON_MAX,
  SPONSORSHIP_SEARCH_MAX,
  SPONSORSHIP_TITLE_MAX,
  SPONSORSHIP_VISIT_MAX_DAYS_AHEAD,
  SUPPORT_INQUIRY_PAGE,
  TIKTOK_APP_REDIRECT_PATH,
  USER_AVATAR_MAX_BYTES,
  USER_AVATAR_MIME_TYPES,
  VALIDATION_MESSAGES_I18N,
  VERIFIABLE_SOCIAL_PLATFORMS,
  acceptProposalRequestSchema,
  acceptProposalResponseSchema,
  addonPaymentSchema,
  adjacentGuidePages,
  agreePoliciesRequestSchema,
  amendProposalRequestSchema,
  appSemverSchema,
  appVersionResponseSchema,
  appearanceVariantHintSchema,
  applySponsorshipRequestSchema,
  brandScopeIssue,
  brandScopeSchema,
  cancelMyOrderRequestSchema,
  catalogOptionSchema,
  changeSimplePinRequestSchema,
  channelMinFollowersSchema,
  chatAttachmentDownloadRequestSchema,
  chatAttachmentDownloadResponseSchema,
  chatBlockStateResponseSchema,
  chatMessageResponseSchema,
  chatParticipantResponseSchema,
  chatPresenceEventSchema,
  chatPresignRequestSchema,
  chatPresignResponseSchema,
  chatReadUpdateEventSchema,
  chatRoomActivityEventSchema,
  chatRoomCounterpartSchema,
  chatRoomJoinedEventSchema,
  chatRoomListingSummarySchema,
  chatRoomLookupResponseSchema,
  chatRoomOrderSummarySchema,
  chatRoomResponseSchema,
  chatTypingEventSchema,
  chatUnreadCountResponseSchema,
  checkListingForm,
  communityAuthorSchema,
  communityCommentSchema,
  communityEligibilityResponseSchema,
  communityHiddenCommentsSchema,
  communityHiddenPostsSchema,
  communityLikeStateSchema,
  communityMineResponseSchema,
  communityPostCategorySchema,
  communityPostDetailSchema,
  communityPostPageSchema,
  communityPostSummarySchema,
  communityScrapStateSchema,
  compareAppVersions,
  completeOauthSignupRequestSchema,
  confirmLicenseDraftRequestSchema,
  contractTermsSchema,
  counterProposalRequestSchema,
  createCommunityCommentRequestSchema,
  createCommunityCommentResponseSchema,
  createCommunityPostRequestSchema,
  createDirectRoomRequestSchema,
  createInquiryRoomRequestSchema,
  createListingRequestSchema,
  createOrderItemSchema,
  createOrderRequestSchema,
  createProposalRequestSchema,
  createRoyaltyReportRequestSchema,
  createSimplePinRequestSchema,
  createSocialChannelRequestSchema,
  createSupportInquiryRequestSchema,
  createSupportInquiryResponseSchema,
  declineLicenseAmendmentRequestSchema,
  defaultBrandScope,
  defaultOffer,
  deleteNotificationsRequestSchema,
  devSignInAccountsResponseSchema,
  devSignInRequestSchema,
  disputeEvidenceMimeSchema,
  disputeEvidencePresignRequestSchema,
  disputeEvidencePresignResponseSchema,
  disputeEvidenceSchema,
  disputeOrderRequestSchema,
  emailSchema,
  fillCompanyPlaceholders,
  fillGuideSections,
  fillGuideTokens,
  findGuidePage,
  forbiddenIndustriesInputSchema,
  formatFollowerBoundary,
  formatFollowerCount,
  getChatRoomHistoryQuerySchema,
  getOfferChanges,
  getOfferIssueDetails,
  getOfferIssues,
  guideBlockSchema,
  guidePageSchema,
  guidePages,
  guideResponseSchema,
  guideSectionSchema,
  guideSections,
  handoffSignInRequestSchema,
  inboxNotificationCategorySchema,
  instagramBioCodeRequestSchema,
  instagramBioCodeResponseSchema,
  instagramUsernameSchema,
  issueLicenseRequestSchema,
  issueLicenseResponseSchema,
  licenseAmendmentListResponseSchema,
  licenseAmendmentSchema,
  licenseAmendmentTermsSchema,
  licenseDraftFormSpecSchema,
  licenseDraftResponseSchema,
  licenseDraftSchema,
  licenseResponseSchema,
  licenseSuspensionListResponseSchema,
  licenseSuspensionSchema,
  licenseViewStateSchema,
  licensesSummarySchema,
  listChatRoomAttachmentsQuerySchema,
  listCommunityPostsQuerySchema,
  listLicensesQuerySchema,
  listListingsQuerySchema,
  listMyChatRoomsQuerySchema,
  listMyListingScrapsQuerySchema,
  listMyOrdersQuerySchema,
  listMyProposalsQuerySchema,
  listMySponsorshipsQuerySchema,
  listNotificationsQuerySchema,
  listReceivedApplicationsQuerySchema,
  listSponsorshipScrapsQuerySchema,
  listSponsorshipsQuerySchema,
  listSupportInquiriesQuerySchema,
  listingCommonIssueSchema,
  listingDetailSchema,
  listingFormCheckRequestSchema,
  listingFormCheckResponseSchema,
  listingFormOfferCheckSchema,
  listingFormRightSchema,
  listingFormSpec,
  listingFormSpecSchema,
  listingOfferChangeSchema,
  listingOfferHints,
  listingOfferHintsSchema,
  listingOfferInputSchema,
  listingOfferIssueSchema,
  listingOfferResponseSchema,
  listingOfferStateSchema,
  listingPageSchema,
  listingSummarySchema,
  listingThumbnailInputSchema,
  listingThumbnailPath,
  localizeValidationMessage,
  logoutOthersResponseSchema,
  lowestMinFollowers,
  manualSocialPlatformSchema,
  markChatReadRequestSchema,
  meResponseSchema,
  myCommunityCommentPageSchema,
  myCommunityCommentSchema,
  myListingSchema,
  myPayoutsQuerySchema,
  myPayoutsResponseSchema,
  myRoyaltiesResponseSchema,
  mySocialChannelRequestSchema,
  normalizeListingOffer,
  normalizeOfferDraft,
  noteItemsTextSchema,
  notificationPreferencesSchema,
  notificationResponseSchema,
  oauthNeedsAgreementResponseSchema,
  oauthProviderSchema,
  oauthReauthCredentialSchema,
  oauthSignInRequestSchema,
  oauthSignInResponseSchema,
  offerDraftReducer,
  offerDurationOptionSchema,
  offerDurationSchema,
  optionalPolicyConsentSchema,
  optionalPolicyConsentsResponseSchema,
  orderDepositReturnSchema,
  orderGroupMemberSchema,
  orderGroupResponseSchema,
  orderIssueRowSchema,
  orderRefundSummarySchema,
  orderResponseSchema,
  orderTerminationSummarySchema,
  orderTransitionActorSchema,
  orderViolationReportSummarySchema,
  ordersSummarySchema,
  paymentResponseSchema,
  payoutAccountSchema,
  payoutClawbackRequestSchema,
  payoutCursorOf,
  payoutItemKindSchema,
  payoutItemSchema,
  payoutItemStatusSchema,
  pendingPolicyConsentSchema,
  pendingPolicyConsentsResponseSchema,
  pendingRoyaltyReportSchema,
  platformAssetKeySchema,
  platformAssetMetaSchema,
  platformAssetPath,
  platformBankAccountSchema,
  platformCatalogSchema,
  platformCommunitySettingsSchema,
  platformCompanySettingsSchema,
  platformListingSettingsSchema,
  platformPaymentSettingsSchema,
  platformSettingsSchema,
  platformSiteSettingsSchema,
  platformSiteTextSchema,
  platformSocialLinksSchema,
  platformSponsorshipSettingsSchema,
  policyBlockSchema,
  policyInlineSchema,
  policyLanguageQuerySchema,
  policyTableCellSchema,
  policyTableRowSchema,
  proposalCounterpartySchema,
  proposalFormSpecSchema,
  proposalPendingCountResponseSchema,
  proposalPricingSchema,
  proposalResponseSchema,
  proposalTermsInputSchema,
  proposalsSummaryResponseSchema,
  publicPolicyDetailSchema,
  publicPolicySummarySchema,
  purchaseAddonsSchema,
  purposeOf,
  refreshRequestSchema,
  registerPushDeviceRequestSchema,
  rejectSponsorshipApplicationRequestSchema,
  reportChatRoomRequestSchema,
  reportCommunityRequestSchema,
  reportViolationRequestSchema,
  requestAddonPaymentSchema,
  requestRefundRequestSchema,
  resolveCommunityTier,
  royaltyContractSchema,
  royaltyDepositNoticeRequestSchema,
  royaltyDepositNoticeResponseSchema,
  royaltyObjectionSchema,
  royaltyReportFileSchema,
  royaltyReportResponseSchema,
  royaltyTodoSchema,
  saveSponsorshipRequestSchema,
  scrapStateSchema,
  searchChatMessagesQuerySchema,
  sellerOrderResponseSchema,
  sellerProfileSchema,
  sellerVoidRoyaltyReportRequestSchema,
  sendChatMessageRequestSchema,
  setChatBlockRequestSchema,
  signInRequestSchema,
  signUpRequestSchema,
  simplePinSchema,
  siteConfigResponseSchema,
  socialChannelAuthorizeQuerySchema,
  socialChannelAuthorizeResponseSchema,
  socialChannelRequestStatusSchema,
  socialChannelSchema,
  socialChannelsResponseSchema,
  socialLinksSchema,
  socialPlatformSchema,
  sponsorshipAddressSchema,
  sponsorshipAddressSearchQuerySchema,
  sponsorshipAddressSearchResponseSchema,
  sponsorshipApplicationDetailSchema,
  sponsorshipApplicationResponseSchema,
  sponsorshipCategoryListSchema,
  sponsorshipCategorySchema,
  sponsorshipCoordsSchema,
  sponsorshipEligibilitySchema,
  sponsorshipImageInputSchema,
  sponsorshipMineSummarySchema,
  sponsorshipMyStateSchema,
  sponsorshipPageSchema,
  sponsorshipReceivedStageOf,
  sponsorshipReceivedStageSchema,
  sponsorshipReceivedTodoSchema,
  sponsorshipRequirementsSchema,
  sponsorshipResponseSchema,
  sponsorshipScrapStateSchema,
  sponsorshipSummarySchema,
  sponsorshipUnseenApprovalsSchema,
  submitSponsorshipMissionSchema,
  supportInquiryDetailSchema,
  supportInquiryMessageSchema,
  supportInquiryOrderSchema,
  supportInquiryReplyRequestSchema,
  supportInquirySummarySchema,
  supportUnseenCountSchema,
  tiktokAppVerifyRequestSchema,
  toFormOffers,
  tokenPairResponseSchema,
  tradeWithMeEntrySchema,
  tradesWithMeResponseSchema,
  unblockUserResponseSchema,
  unreadCountResponseSchema,
  updateAppVersionRequestSchema,
  updateAvatarResponseSchema,
  updateCommunityCommentRequestSchema,
  updateCommunityPostRequestSchema,
  updateCommunitySettingsRequestSchema,
  updateCompanySettingsRequestSchema,
  updateDepositorNameRequestSchema,
  updateDepositorNameResponseSchema,
  updateListingRequestSchema,
  updateListingSettingsRequestSchema,
  updateMyProfileRequestSchema,
  updateNotificationPreferencesRequestSchema,
  updateOptionalPolicyConsentRequestSchema,
  updatePaymentSettingsRequestSchema,
  updatePayoutAccountRequestSchema,
  updatePlatformSocialLinksRequestSchema,
  updateRefundAccountRequestSchema,
  updateRoyaltyReportRequestSchema,
  updateSiteSettingsRequestSchema,
  updateSocialLinksRequestSchema,
  updateSponsorshipSettingsRequestSchema,
  upsertLicenseDraftRequestSchema,
  usageScopeSchema,
  verifiableSocialPlatformSchema,
  withdrawMeRequestSchema,
  withdrawalEligibilityResponseSchema,
  zodErrorMap
};
//# sourceMappingURL=index.js.map